'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = require('prop-types');
var PropTypes__default = _interopDefault(PropTypes);
var pickers = require('@material-ui/pickers');
var LuxonUtils = _interopDefault(require('@date-io/luxon'));
var reactIs = require('react-is');
var reactIs__default = _interopDefault(reactIs);
var uuid = require('uuid');
var MaskedInput = _interopDefault(require('react-text-mask'));
var Select = require('react-select');
var Select__default = _interopDefault(Select);
var ReactDOMServer = _interopDefault(require('react-dom/server'));
var reactRouterDom = require('react-router-dom');
var axios = _interopDefault(require('axios'));
var formik = require('formik');
var ReactModal = _interopDefault(require('react-modal'));
var ReactDOM = require('react-dom');
var ReactDOM__default = _interopDefault(ReactDOM);
var TextareaAutosize = _interopDefault(require('react-textarea-autosize'));
var TooltipTrigger = _interopDefault(require('react-popper-tooltip'));
var throttle = _interopDefault(require('lodash.throttle'));
var reactGoogleMaps = require('react-google-maps');

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty$1;

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();

function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};
var removeLabel = function removeLabel(context, content) {
  if (context === 1 && // charcode for l
  content.charCodeAt(0) === 108 && // charcode for b
  content.charCodeAt(2) === 98 // this ignores label
  ) {
      return '';
    }
};

var isBrowser = typeof document !== 'undefined';
var rootServerStylisCache = {};
var getServerStylisCache = isBrowser ? undefined : weakMemoize(function () {
  var getCache = weakMemoize(function () {
    return {};
  });
  var prefixTrueCache = {};
  var prefixFalseCache = {};
  return function (prefix) {
    if (prefix === undefined || prefix === true) {
      return prefixTrueCache;
    }

    if (prefix === false) {
      return prefixFalseCache;
    }

    return getCache(prefix);
  };
});

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new stylis_min(stylisOptions);

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;

  if (isBrowser) {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  if (isBrowser) {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        var map = serialized.map;
        Sheet.current = {
          insert: function insert(rule) {
            sheet.insert(rule + map);
          }
        };
      }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  } else {
    stylis.use(removeLabel);
    var serverStylisCache = rootServerStylisCache;

    if (options.stylisPlugins || options.prefix !== undefined) {
      stylis.use(options.stylisPlugins); // $FlowFixMe

      serverStylisCache = getServerStylisCache(options.stylisPlugins || rootServerStylisCache)(options.prefix);
    }

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = stylis(selector, serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        if ( // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
          return rules + serialized.map;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  if (process.env.NODE_ENV !== 'production') {
    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
    var commentStart = /\/\*/g;
    var commentEnd = /\*\//g;
    stylis.use(function (context, content) {
      switch (context) {
        case -1:
          {
            while (commentStart.test(content)) {
              commentEnd.lastIndex = commentStart.lastIndex;

              if (commentEnd.test(content)) {
                commentStart.lastIndex = commentEnd.lastIndex;
                continue;
              }

              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            }

            commentStart.lastIndex = 0;
            break;
          }
      }
    });
    stylis.use(function (context, content, selectors) {
      switch (context) {
        case -1:
          {
            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);

            if (unsafePseudoClasses && cache.compat !== true) {
              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
                var ignore = ignoreRegExp.test(content);

                if (unsafePseudoClass && !ignore) {
                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
                }
              });
            }

            break;
          }
      }
    });
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

var isBrowser$1 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$1 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      if (!isBrowser$1 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$1 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];

  if (process.env.NODE_ENV !== 'production' && couldBeSelectorInterpolation && shouldWarnAboutInterpolatingClassNameFromCss && cached !== undefined) {
    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
    shouldWarnAboutInterpolatingClassNameFromCss = false;
  }

  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var isBrowser$2 = typeof document !== 'undefined';
var hasOwnProperty = Object.prototype.hasOwnProperty;

var EmotionCacheContext = /*#__PURE__*/React.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? createCache() : null);
var ThemeContext = /*#__PURE__*/React.createContext({});
var CacheProvider = EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  var render = function render(props, ref) {
    return /*#__PURE__*/React.createElement(EmotionCacheContext.Consumer, null, function (cache) {
      return func(props, cache, ref);
    });
  }; // $FlowFixMe


  return /*#__PURE__*/React.forwardRef(render);
};

if (!isBrowser$2) {
  var BasicProvider = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(BasicProvider, _React$Component);

    function BasicProvider(props, context, updater) {
      var _this;

      _this = _React$Component.call(this, props, context, updater) || this;
      _this.state = {
        value: createCache()
      };
      return _this;
    }

    var _proto = BasicProvider.prototype;

    _proto.render = function render() {
      return /*#__PURE__*/React.createElement(EmotionCacheContext.Provider, this.state, this.props.children(this.state.value));
    };

    return BasicProvider;
  }(React.Component);

  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      return /*#__PURE__*/React.createElement(EmotionCacheContext.Consumer, null, function (context) {
        if (context === null) {
          return /*#__PURE__*/React.createElement(BasicProvider, null, function (newContext) {
            return func(props, newContext);
          });
        } else {
          return func(props, context);
        }
      });
    };
  };
}

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';

var render = function render(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles);

  if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  var rules = insertStyles(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = /*#__PURE__*/React.createElement(type, newProps);

  if (!isBrowser$2 && rules !== undefined) {
    var _ref;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", (_ref = {}, _ref["data-emotion-" + cache.key] = serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref)), ele);
  }

  return ele;
}; // eslint-disable-next-line no-undef


var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  if (typeof props.css === 'function') {
    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      return render(cache, props, theme, ref);
    });
  }

  return render(cache, props, null, ref);
});

if (process.env.NODE_ENV !== 'production') {
  Emotion.displayName = 'EmotionCssPropInternal';
}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles(args);
}

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var ClassNames = withEmotionCache(function (props, context) {
  return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
    var rules = '';
    var serializedHashes = '';
    var hasRendered = false;

    var css = function css() {
      if (hasRendered && process.env.NODE_ENV !== 'production') {
        throw new Error('css can only be used during render');
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = serializeStyles(args, context.registered);

      if (isBrowser$2) {
        insertStyles(context, serialized, false);
      } else {
        var res = insertStyles(context, serialized, false);

        if (res !== undefined) {
          rules += res;
        }
      }

      if (!isBrowser$2) {
        serializedHashes += " " + serialized.name;
      }

      return context.key + "-" + serialized.name;
    };

    var cx = function cx() {
      if (hasRendered && process.env.NODE_ENV !== 'production') {
        throw new Error('cx can only be used during render');
      }

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return merge(context.registered, css, classnames(args));
    };

    var content = {
      css: css,
      cx: cx,
      theme: theme
    };
    var ele = props.children(content);
    hasRendered = true;

    if (!isBrowser$2 && rules.length !== 0) {
      var _ref;

      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", (_ref = {}, _ref["data-emotion-" + context.key] = serializedHashes.substring(1), _ref.dangerouslySetInnerHTML = {
        __html: rules
      }, _ref.nonce = context.sheet.nonce, _ref)), ele);
    }

    return ele;
  });
});

var testOmitPropsOnStringTag = index;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme' && key !== 'innerRef';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(source, true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ILLEGAL_ESCAPE_SEQUENCE_ERROR$1 = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var isBrowser$3 = typeof document !== 'undefined';

var createStyled = function createStyled(tag, options) {
  if (process.env.NODE_ENV !== 'production') {
    if (tag === undefined) {
      throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
    }
  }

  var identifierName;
  var shouldForwardProp;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
    shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && // $FlowFixMe
      options.shouldForwardProp(propName);
    } : options.shouldForwardProp;
  }

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (process.env.NODE_ENV !== 'production' && args[0][0] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
      }

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (process.env.NODE_ENV !== 'production' && args[0][i] === undefined) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
        }

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = withEmotionCache(function (props, context, ref) {
      return React.createElement(ThemeContext.Consumer, null, function (theme) {
        var finalTag = shouldUseAs && props.as || baseTag;
        var className = '';
        var classInterpolations = [];
        var mergedProps = props;

        if (props.theme == null) {
          mergedProps = {};

          for (var key in props) {
            mergedProps[key] = props[key];
          }

          mergedProps.theme = theme;
        }

        if (typeof props.className === 'string') {
          className = getRegisteredStyles(context.registered, classInterpolations, props.className);
        } else if (props.className != null) {
          className = props.className + " ";
        }

        var serialized = serializeStyles(styles.concat(classInterpolations), context.registered, mergedProps);
        var rules = insertStyles(context, serialized, typeof finalTag === 'string');
        className += context.key + "-" + serialized.name;

        if (targetClassName !== undefined) {
          className += " " + targetClassName;
        }

        var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
        var newProps = {};

        for (var _key in props) {
          if (shouldUseAs && _key === 'as') continue;

          if ( // $FlowFixMe
          finalShouldForwardProp(_key)) {
            newProps[_key] = props[_key];
          }
        }

        newProps.className = className;
        newProps.ref = ref || props.innerRef;

        if (process.env.NODE_ENV !== 'production' && props.innerRef) {
          console.error('`innerRef` is deprecated and will be removed in a future major version of Emotion, please use the `ref` prop instead' + (identifierName === undefined ? '' : " in the usage of `" + identifierName + "`"));
        }

        var ele = React.createElement(finalTag, newProps);

        if (!isBrowser$3 && rules !== undefined) {
          var _ref;

          var serializedNames = serialized.name;
          var next = serialized.next;

          while (next !== undefined) {
            serializedNames += ' ' + next.name;
            next = next.next;
          }

          return React.createElement(React.Fragment, null, React.createElement("style", (_ref = {}, _ref["data-emotion-" + context.key] = serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
          }, _ref.nonce = context.sheet.nonce, _ref)), ele);
        }

        return ele;
      });
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && process.env.NODE_ENV !== 'production') {
          return 'NO_COMPONENT_SELECTOR';
        } // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, nextOptions !== undefined ? _objectSpread({}, options || {}, {}, nextOptions) : options).apply(void 0, styles);
    };

    return Styled;
  };
};

var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = createStyled.bind();
tags.forEach(function (tagName) {
  newStyled[tagName] = newStyled(tagName);
});

var noop = (function () {});

var YELLOW_COLOR = '#FFD45C';
var LIGHT_BLUE_OPAQUE = 'rgba(0, 135, 255, 0.15)'; // buttons
var DEFAULT_TEXT_COLOR = '#4a4a4a';

var SUN_BACKGROUND = YELLOW_COLOR;
/* Text colors */

var TEXT_DARK_COLOR = '#333333';
var TEXT_NEUTRAL_COLOR = '#5B5A5A';
var TEXT_LIGHT_COLOR = '#848688';
/* Brand colors */

var NEUTRAL_COLOR_LEVEL_4 = '#F7F7F6';
var NEUTRAL_COLOR_LEVEL_3 = '#F0EFED';
var NEUTRAL_COLOR_LEVEL_2 = '#DEDBD6';
var NEUTRAL_COLOR_LEVEL_1 = '#B2ADA6';
var WHITE_COLOR = '#FFFFFF';
var BLACK_COLOR = '#000000'; // Keep the convention from neutral colors, where the lightest is the highest level

var PRIMARY_COLOR = '#00B085';
var PRIMARY_COLOR_LEVEL_2 = '#009C76';
var PRIMARY_COLOR_LEVEL_1 = '#008C6A'; // Putting this here because it's very similar looking to primary,
// even though it doesn't appear to be an actual _shade_ of primary.

var LIST_HOVER_COLOR = '#EBFAF6'; // Keep the convention from neutral colors, where the lightest is the highest level

var SECONDARY_COLOR = '#0087FF';
var SECONDARY_COLOR_LEVEL_2 = '#007AE6';
var SECONDARY_COLOR_LEVEL_1 = '#006CCC';
var SECONDARY_GRADIENT_COLOR = '#58B1FF'; // Keep the convention from neutral colors, where the lightest is the highest level

var IMPORTANT_COLOR = '#FFD45C';
var IMPORTANT_COLOR_LEVEL_4 = '#F2E8C2';
var IMPORTANT_COLOR_LEVEL_2 = '#FFCB38';
var IMPORTANT_COLOR_LEVEL_1 = '#FFBE0A';
var DARK_BLUE_COLOR = '#001A3C';
var DARK_BLUE_COLOR_HIGH_TRANSPARENCY = 'rgba(0, 26, 60, 0.3)';
var DARK_BLUE_COLOR_LOW_TRANSPARENCY = 'rgba(0,26,60, 0.9)'; // Note: These are defined in Figma using opacity; however, in order to properly
// use them in SVGs with a different color background, it is necessary to convert
// them to non-opaque colors

var WHITE_TINTED_DARK_BLUE_COLOR_1 = '#4B5C72';
var WHITE_TINTED_DARK_BLUE_COLOR_2 = '#677689';
var DESTRUCTIVE_COLOR = '#CC0000';
var DESTRUCTIVE_COLOR_2 = '#B30000'; // Informational colors

var SUCCESS_COLOR = '#3AD165';
var ERROR_COLOR = '#CC0000';
var ERROR_COLOR_LEVEL_2 = '#E8BFBF';
var ERROR_COLOR_MUTED = '#FAE6E6';
var WARNING_COLOR = '#F48503';
var INFO_COLOR = '#0087FF'; // Toggle Icon Colors

var DISABLED_TOGGLE_BACKGROUND_COLOR = '#EEECEA';
var DISABLED_TOGGLE_TEXT_COLOR = '#ADB4BD';
var BOX_SHADOW_COLOR = '0px 15px 12px rgba(178, 173, 166, 0.21)';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border: 1px solid ", ";\n  color: ", ";\n  cursor: pointer;\n  font-family: 'Nunito';\n  font-size: 1em;\n  font-weight: normal;\n  padding: .5em 2em;\n\n  ", "\n\n  &:disabled, &:disabled:hover, &:disabled:focus {\n    ", "\n  }\n\n  &:hover {\n    ", "\n  }\n\n  &:focus {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var StyledButton = newStyled.button(_templateObject(), NEUTRAL_COLOR_LEVEL_1, NEUTRAL_COLOR_LEVEL_1, WHITE_COLOR, function (props) {
  var extraButtonStyles;

  if (props.primary) {
    extraButtonStyles = {
      backgroundColor: PRIMARY_COLOR,
      borderColor: PRIMARY_COLOR,
      color: WHITE_COLOR
    };
  } else if (props.secondary) {
    extraButtonStyles = {
      backgroundColor: WHITE_COLOR,
      color: TEXT_DARK_COLOR,
      borderColor: NEUTRAL_COLOR_LEVEL_2
    };
  } else if (props.tertiary) {
    extraButtonStyles = {
      backgroundColor: SECONDARY_COLOR,
      borderColor: SECONDARY_COLOR,
      color: WHITE_COLOR,
      fontWeight: 'normal'
    };
  } else if (props.destructive) {
    extraButtonStyles = {
      backgroundColor: DESTRUCTIVE_COLOR,
      borderColor: DESTRUCTIVE_COLOR,
      color: WHITE_COLOR,
      fontWeight: 'normal'
    };
  } else if (props.important) {
    extraButtonStyles = {
      backgroundColor: IMPORTANT_COLOR,
      borderColor: IMPORTANT_COLOR,
      color: TEXT_DARK_COLOR
    };
  }

  return extraButtonStyles;
}, function () {
  return {
    color: WHITE_COLOR,
    borderColor: NEUTRAL_COLOR_LEVEL_1,
    backgroundColor: NEUTRAL_COLOR_LEVEL_1
  };
}, function (props) {
  var hoverStyles;

  if (props.primary) {
    hoverStyles = {
      backgroundColor: PRIMARY_COLOR_LEVEL_2,
      borderColor: PRIMARY_COLOR_LEVEL_2
    };
  } else if (props.secondary) {
    hoverStyles = {
      backgroundColor: NEUTRAL_COLOR_LEVEL_3
    };
  } else if (props.tertiary) {
    hoverStyles = {
      backgroundColor: SECONDARY_COLOR_LEVEL_2,
      borderColor: SECONDARY_COLOR_LEVEL_2
    };
  } else if (props.destructive) {
    hoverStyles = {
      backgroundColor: DESTRUCTIVE_COLOR_2,
      borderColor: DESTRUCTIVE_COLOR_2
    };
  } else if (props.important) {
    hoverStyles = {
      backgroundColor: IMPORTANT_COLOR_LEVEL_2,
      borderColor: IMPORTANT_COLOR_LEVEL_2
    };
  }

  return hoverStyles;
}, function (props) {
  var focusStyles;

  if (props.primary) {
    focusStyles = {
      backgroundColor: PRIMARY_COLOR_LEVEL_1,
      borderColor: PRIMARY_COLOR_LEVEL_1
    };
  } else if (props.secondary) {
    focusStyles = {
      backgroundColor: NEUTRAL_COLOR_LEVEL_2,
      borderColor: NEUTRAL_COLOR_LEVEL_2
    };
  } else if (props.tertiary) {
    focusStyles = {
      backgroundColor: SECONDARY_COLOR_LEVEL_1,
      borderColor: SECONDARY_COLOR_LEVEL_1
    };
  } else if (props.important) {
    focusStyles = {
      backgroundColor: IMPORTANT_COLOR_LEVEL_1
    };
  }

  return focusStyles;
});

var Button = function Button(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      type = _ref.type,
      rest = _objectWithoutProperties(_ref, ["children", "onClick", "type"]);

  return /*#__PURE__*/React__default.createElement(StyledButton, _extends({
    onClick: onClick,
    type: type
  }, rest), children);
};

Button.propTypes = {
  /** The display content passed to the button */
  children: PropTypes__default.node.isRequired,

  /** The event to trigger a function call on the button */
  onClick: PropTypes__default.func,

  /** String to define type of button */
  type: PropTypes__default.string,

  /** Boolean to define primary style of button */
  primary: PropTypes__default.bool,

  /** Boolean to define secondary style of button */
  secondary: PropTypes__default.bool,

  /** Boolean to define tertiary style of button */
  tertiary: PropTypes__default.bool,

  /** Boolean to define destructive style of button */
  destructive: PropTypes__default.bool,

  /** Boolean to define an important style of button */
  important: PropTypes__default.bool
};
Button.defaultProps = {
  onClick: noop,
  type: 'button',
  primary: false,
  secondary: false,
  tertiary: false,
  destructive: false,
  important: false
};

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  padding: 0.5em;\n  ", "\n\n  font-family: 'Nunito';\n  font-weight: normal;\n  font-size: 1em;\n  margin-bottom: 15px;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var cardBackgroundColor = function cardBackgroundColor(_ref) {
  var isDark = _ref.isDark,
      hasError = _ref.hasError;

  if (isDark) {
    return NEUTRAL_COLOR_LEVEL_3;
  }

  if (hasError) {
    return ERROR_COLOR_MUTED;
  }

  return WHITE_COLOR;
}; // Margin on bottom is to account for the shadow. Without out it the shadow
// will get chopped off when used as part of a horizontal scrolling group


var StyledCard = newStyled.div(_templateObject$1(), function (props) {
  return cardBackgroundColor(props);
}, function (_ref2) {
  var isDark = _ref2.isDark,
      hasError = _ref2.hasError;
  if (isDark || hasError) return '';
  return 'box-shadow: 0px 10px 5px rgba(178,173,166,0.21);';
});

var Card = function Card(_ref3) {
  var children = _ref3.children,
      isDark = _ref3.isDark,
      hasError = _ref3.hasError,
      rest = _objectWithoutProperties(_ref3, ["children", "isDark", "hasError"]);

  return /*#__PURE__*/React__default.createElement(StyledCard, _extends({
    isDark: isDark,
    hasError: hasError
  }, rest), children);
};

Card.propTypes = {
  children: PropTypes__default.node.isRequired,
  isDark: PropTypes__default.bool,
  hasError: PropTypes__default.bool
};
Card.defaultProps = {
  isDark: false,
  hasError: false
};

function chainPropTypes(propType1, propType2) {
  if (process.env.NODE_ENV === 'production') {
    return function () {
      return null;
    };
  }

  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function isPlainObject(item) {
  return item && _typeof(item) === 'object' && item.constructor === Object;
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? _extends$1({}, target) : target;

  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isPlainObject(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}

function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
function exactProp(propTypes) {
  if (process.env.NODE_ENV === 'production') {
    return propTypes;
  }

  return _extends$1({}, propTypes, _defineProperty$2({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unsupportedProps.length > 0) {
      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }

    return null;
  }));
}

/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose

  /* eslint-disable prefer-template */
  var url = 'https://material-ui.com/production-error/?code=' + code;

  for (var i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }

  return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3

var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}
/**
 * @param {function} Component
 * @param {string} fallback
 * @returns {string | undefined}
 */

function getFunctionComponentName(Component) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE 11 support
 *
 * @param {React.ReactType} Component
 * @returns {string | undefined}
 */


function getDisplayName(Component) {
  if (Component == null) {
    return undefined;
  }

  if (typeof Component === 'string') {
    return Component;
  }

  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }

  if (_typeof(Component) === 'object') {
    switch (Component.$$typeof) {
      case reactIs.ForwardRef:
        return getWrappedName(Component, Component.render, 'ForwardRef');

      case reactIs.Memo:
        return getWrappedName(Component, Component.type, 'memo');

      default:
        return undefined;
    }
  }

  return undefined;
}

/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (process.env.NODE_ENV !== 'production') {
    if (value < min || value > max) {
      console.error("Material-UI: The value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
    }
  }

  return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', '), ")") : '';
}
/**
 * Converts a color from hsl format to rgb format.
 *
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */

function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color,
      values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);

  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };

  var type = 'rgb';
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor({
    type: type,
    values: rgb
  });
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */

function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: Unsupported `".concat(color, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().") : formatMuiErrorMessage(3, color));
  }

  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });
  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */

function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */

function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */

function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function (val) {
    val /= 255; // normalized

    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = _objectWithoutProperties$1(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end);

    if (endIndex === keys.length - 1) {
      return up(start);
    }

    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return _extends$1({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return _extends$1({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // To deprecate in v4.1
      //       warning(
      //         false,
      //         [
      //           'Material-UI: Theme.mixins.gutters() is deprecated.',
      //           'You can use the source of the mixin directly:',
      //           `
      // paddingLeft: theme.spacing(2),
      // paddingRight: theme.spacing(2),
      // [theme.breakpoints.up('sm')]: {
      //   paddingLeft: theme.spacing(3),
      //   paddingRight: theme.spacing(3),
      // },
      // `,
      //         ].join('\n'),
      //       );
      return _extends$1({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles, _defineProperty$2({}, breakpoints.up('sm'), _extends$1({
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, _defineProperty$2(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), _defineProperty$2(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

var common = {
  black: '#000',
  white: '#fff'
};

var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};

var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};

var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};

var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};

var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};

var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};

var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};

var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common.white,
    default: grey[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
var dark = {
  text: {
    primary: common.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: grey[800],
    default: '#303030'
  },
  action: {
    active: common.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  var tonalOffsetLight = tonalOffset.light || tonalOffset;
  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;

  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = lighten(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = darken(intent.main, tonalOffsetDark);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: indigo[300],
    main: indigo[500],
    dark: indigo[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: pink.A200,
    main: pink.A400,
    dark: pink.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: red[300],
    main: red[500],
    dark: red[700]
  } : _palette$error,
      _palette$warning = palette.warning,
      warning = _palette$warning === void 0 ? {
    light: orange[300],
    main: orange[500],
    dark: orange[700]
  } : _palette$warning,
      _palette$info = palette.info,
      info = _palette$info === void 0 ? {
    light: blue[300],
    main: blue[500],
    dark: blue[700]
  } : _palette$info,
      _palette$success = palette.success,
      success = _palette$success === void 0 ? {
    light: green[300],
    main: green[500],
    dark: green[700]
  } : _palette$success,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = _objectWithoutProperties$1(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54


  function getContrastText(background) {
    var contrastText = getContrastRatio(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (process.env.NODE_ENV !== 'production') {
      var contrast = getContrastRatio(background, contrastText);

      if (contrast < 3) {
        console.error(["Material-UI: The contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
      }
    }

    return contrastText;
  }

  var augmentColor = function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
    color = _extends$1({}, color);

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (!color.main) {
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(mainShade, "` property.") : formatMuiErrorMessage(4, mainShade));
    }

    if (typeof color.main !== 'string') {
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify(color.main), "` was provided instead.\n\nDid you intend to use one of the following approaches?\n\nimport {\xA0green } from \"@material-ui/core/colors\";\n\nconst theme1 = createMuiTheme({ palette: {\n  primary: green,\n} });\n\nconst theme2 = createMuiTheme({ palette: {\n  primary: { main: green[500] },\n} });") : formatMuiErrorMessage(5, JSON.stringify(color.main)));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  };

  var types = {
    dark: dark,
    light: light
  };

  if (process.env.NODE_ENV !== 'production') {
    if (!types[type]) {
      console.error("Material-UI: The palette type `".concat(type, "` is not supported."));
    }
  }

  var paletteOutput = deepmerge(_extends$1({
    // A collection of common colors.
    common: common,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor(primary),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor(error),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor(warning),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor(info),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor(success),
    // The grey colors.
    grey: grey,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other);
  return paletteOutput;
}

function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$fontWeightBold = _ref.fontWeightBold,
      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      allVariants = _ref.allVariants,
      pxToRem2 = _ref.pxToRem,
      other = _objectWithoutProperties$1(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof fontSize !== 'number') {
      console.error('Material-UI: `fontSize` is required to be a number.');
    }

    if (typeof htmlFontSize !== 'number') {
      console.error('Material-UI: `htmlFontSize` is required to be a number.');
    }
  }

  var coef = fontSize / 14;

  var pxToRem = pxToRem2 || function (size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return _extends$1({
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };

  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return deepmerge(_extends$1({
    htmlFontSize: htmlFontSize,
    pxToRem: pxToRem,
    round: round,
    // TODO v5: remove
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontWeightBold: fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep

  });
}

var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];

var shape = {
  borderRadius: 4
};

var responsivePropType = process.env.NODE_ENV !== 'production' ? PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.string, PropTypes__default.object, PropTypes__default.array]) : {};

function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
}

function _iterableToArray$1(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}

function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1();
}

function merge$1(acc, item) {
  if (!item) {
    return acc;
  }

  return deepmerge(acc, item, {
    clone: false // No need to clone deep, it's way faster.

  });
}

// For instance with the first breakpoint xs: [xs, sm[.

var values = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
};
var defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: function up(key) {
    return "@media (min-width:".concat(values[key], "px)");
  }
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  if (process.env.NODE_ENV !== 'production') {
    if (!props.theme) {
      console.error('Material-UI: You are calling a style function without a theme value.');
    }
  }

  if (Array.isArray(propValue)) {
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    return propValue.reduce(function (acc, item, index) {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }

  if (_typeof(propValue) === 'object') {
    var _themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;

    return Object.keys(propValue).reduce(function (acc, breakpoint) {
      acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
      return acc;
    }, {});
  }

  var output = styleFromPropValue(propValue);
  return output;
}

function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit$1(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1();
}

function memoize$1(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }

    return cache[arg];
  };
}

var properties = {
  m: 'margin',
  p: 'padding'
};
var directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
var aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec

var getCssProperties = memoize$1(function (prop) {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }

  var _prop$split = prop.split(''),
      _prop$split2 = _slicedToArray$1(_prop$split, 2),
      a = _prop$split2[0],
      b = _prop$split2[1];

  var property = properties[a];
  var direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(function (dir) {
    return property + dir;
  }) : [property + direction];
});
var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];
function createUnarySpacing(theme) {
  var themeSpacing = theme.spacing || 8;

  if (typeof themeSpacing === 'number') {
    return function (abs) {
      if (process.env.NODE_ENV !== 'production') {
        if (typeof abs !== 'number') {
          console.error("Material-UI: Expected spacing argument to be a number, got ".concat(abs, "."));
        }
      }

      return themeSpacing * abs;
    };
  }

  if (Array.isArray(themeSpacing)) {
    return function (abs) {
      if (process.env.NODE_ENV !== 'production') {
        if (abs > themeSpacing.length - 1) {
          console.error(["Material-UI: The value provided (".concat(abs, ") overflows."), "The supported values are: ".concat(JSON.stringify(themeSpacing), "."), "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")].join('\n'));
        }
      }

      return themeSpacing[abs];
    };
  }

  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }

  if (process.env.NODE_ENV !== 'production') {
    console.error(["Material-UI: The `theme.spacing` value (".concat(themeSpacing, ") is invalid."), 'It should be a number, an array or a function.'].join('\n'));
  }

  return function () {
    return undefined;
  };
}

function getValue(transformer, propValue) {
  if (typeof propValue === 'string') {
    return propValue;
  }

  var abs = Math.abs(propValue);
  var transformed = transformer(abs);

  if (propValue >= 0) {
    return transformed;
  }

  if (typeof transformed === 'number') {
    return -transformed;
  }

  return "-".concat(transformed);
}

function getStyleFromPropValue(cssProperties, transformer) {
  return function (propValue) {
    return cssProperties.reduce(function (acc, cssProperty) {
      acc[cssProperty] = getValue(transformer, propValue);
      return acc;
    }, {});
  };
}

function spacing(props) {
  var theme = props.theme;
  var transformer = createUnarySpacing(theme);
  return Object.keys(props).map(function (prop) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (spacingKeys.indexOf(prop) === -1) {
      return null;
    }

    var cssProperties = getCssProperties(prop);
    var styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
    var propValue = props[prop];
    return handleBreakpoints(props, propValue, styleFromPropValue);
  }).reduce(merge$1, {});
}

spacing.propTypes = process.env.NODE_ENV !== 'production' ? spacingKeys.reduce(function (obj, key) {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
spacing.filterProps = spacingKeys;

var warnOnce;
function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
  // Smaller components, such as icons and type, can align to a 4dp grid.
  // https://material.io/design/layout/understanding-layout.html#usage


  var transform = createUnarySpacing({
    spacing: spacingInput
  });

  var spacing = function spacing() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (process.env.NODE_ENV !== 'production') {
      if (!(args.length <= 4)) {
        console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
      }
    }

    if (args.length === 0) {
      return transform(1);
    }

    if (args.length === 1) {
      return transform(args[0]);
    }

    return args.map(function (argument) {
      if (typeof argument === 'string') {
        return argument;
      }

      var output = transform(argument);
      return typeof output === 'number' ? "".concat(output, "px") : output;
    }).join(' ');
  }; // Backward compatibility, to remove in v5.


  Object.defineProperty(spacing, 'unit', {
    get: function get() {
      if (process.env.NODE_ENV !== 'production') {
        if (!warnOnce || process.env.NODE_ENV === 'test') {
          console.error(['Material-UI: theme.spacing.unit usage has been deprecated.', 'It will be removed in v5.', 'You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.', '', 'You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother.'].join('\n'));
        }

        warnOnce = true;
      }

      return spacingInput;
    }
  });
  spacing.mui = true;
  return spacing;
}

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


var transitions = {
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = _objectWithoutProperties$1(options, ["duration", "easing", "delay"]);

    if (process.env.NODE_ENV !== 'production') {
      var isString = function isString(value) {
        return typeof value === 'string';
      };

      var isNumber = function isNumber(value) {
        return !isNaN(parseFloat(value));
      };

      if (!isString(props) && !Array.isArray(props)) {
        console.error('Material-UI: Argument "props" must be a string or Array.');
      }

      if (!isNumber(durationOption) && !isString(durationOption)) {
        console.error("Material-UI: Argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
      }

      if (!isString(easingOption)) {
        console.error('Material-UI: Argument "easing" must be a string.');
      }

      if (!isNumber(delay) && !isString(delay)) {
        console.error('Material-UI: Argument "delay" must be a number or a string.');
      }

      if (Object.keys(other).length !== 0) {
        console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(other).join(','), "]."));
      }
    }

    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};

// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};

function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      spacingInput = options.spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = _objectWithoutProperties$1(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);

  var palette = createPalette(paletteInput);
  var breakpoints = createBreakpoints(breakpointsInput);
  var spacing = createSpacing(spacingInput);
  var muiTheme = deepmerge({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: createMixins(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Provide default props
    shadows: shadows,
    typography: createTypography(palette, typographyInput),
    spacing: spacing,
    shape: shape,
    transitions: transitions,
    zIndex: zIndex
  }, other);

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  muiTheme = args.reduce(function (acc, argument) {
    return deepmerge(acc, argument);
  }, muiTheme);

  if (process.env.NODE_ENV !== 'production') {
    var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];

    var traverse = function traverse(node, parentKey) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax

      for (key in node) {
        var child = node[key];

        if (depth === 1) {
          if (key.indexOf('Mui') === 0 && child) {
            traverse(child, key, depth + 1);
          }
        } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== 'production') {
            console.error(["Material-UI: The `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify({
              root: _defineProperty$2({}, "&$".concat(key), child)
            }, null, 2), '', 'https://material-ui.com/r/pseudo-classes-guide'].join('\n'));
          } // Remove the style to prevent global conflicts.


          node[key] = {};
        }
      }
    };

    traverse(muiTheme.overrides);
  }

  return muiTheme;
}

var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var nested = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */

var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js

function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal,
      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
  var ruleCounter = 0;

  var getNextCounterId = function getNextCounterId() {
    ruleCounter += 1;

    if (process.env.NODE_ENV !== 'production') {
      if (ruleCounter >= 1e10) {
        console.warn(['Material-UI: You might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join(''));
      }
    }

    return ruleCounter;
  };

  return function (rule, styleSheet) {
    var name = styleSheet.options.name; // Is a global static MUI style?

    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
      // We can use a shorthand class name, we never use the keys to style the components.
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return "Mui-".concat(rule.key);
      }

      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);

      if (!styleSheet.options.theme[nested] || seed !== '') {
        return prefix;
      }

      return "".concat(prefix, "-").concat(getNextCounterId());
    }

    if (process.env.NODE_ENV === 'production') {
      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    }

    var suffix = "".concat(rule.key, "-").concat(getNextCounterId()); // Help with debuggability.

    if (styleSheet.options.classNamePrefix) {
      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
    }

    return "".concat(seedPrefix).concat(suffix);
  };
}

/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme || !theme.props || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}

var isProduction = process.env.NODE_ENV === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

var _typeof$1 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser$4 = (typeof window === "undefined" ? "undefined" : _typeof$1(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof$1(document)) === 'object' && document.nodeType === 9;

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== 'object') return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};

  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }

  return newStyle;
}

/**
 * Create a rule instance.
 */

function createRule(name, decl, options) {
  if (name === void 0) {
    name = 'unnamed';
  }

  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule; // It is an at-rule and it has no instance.

  if (name[0] === '@') {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Unknown rule " + name) : void 0;
  }

  return null;
}

var join = function join(value, by) {
  var result = '';

  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }

  return result;
};

/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */
var toCssValue = function toCssValue(value, ignoreImportant) {
  if (ignoreImportant === void 0) {
    ignoreImportant = false;
  }

  if (!Array.isArray(value)) return value;
  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.

  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', '); // Add !important, because it was ignored.


  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
};

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */
function indentStr(str, indent) {
  var result = '';

  for (var index = 0; index < indent; index++) {
    result += '  ';
  }

  return result + str;
}
/**
 * Converts a Rule to CSS string.
 */


function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }

  var result = '';
  if (!style) return result;
  var _options = options,
      _options$indent = _options.indent,
      indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;
  if (selector) indent++; // Apply fallbacks first.

  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];

        for (var prop in fallback) {
          var value = fallback[prop];

          if (value != null) {
            if (result) result += '\n';
            result += "" + indentStr(prop + ": " + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];

        if (_value != null) {
          if (result) result += '\n';
          result += "" + indentStr(_prop + ": " + toCssValue(_value) + ";", indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];

    if (_value2 != null && _prop2 !== 'fallbacks') {
      if (result) result += '\n';
      result += "" + indentStr(_prop2 + ": " + toCssValue(_value2) + ";", indent);
    }
  } // Allow empty style in this case, because properties will be added dynamically.


  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.

  if (!selector) return result;
  indent--;
  if (result) result = "\n" + result + "\n";
  return indentStr(selector + " {" + result, indent) + indentStr('}', indent);
}

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = (function (str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
});

var BaseStyleRule =
/*#__PURE__*/
function () {
  function BaseStyleRule(key, style, options) {
    this.type = 'style';
    this.key = void 0;
    this.isProcessed = false;
    this.style = void 0;
    this.renderer = void 0;
    this.renderable = void 0;
    this.options = void 0;
    var sheet = options.sheet,
        Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }
  /**
   * Get or set a style property.
   */


  var _proto = BaseStyleRule.prototype;

  _proto.prop = function prop(name, value, options) {
    // It's a getter.
    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;

    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }

    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style; // Value is empty and wasn't defined before.

    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.

    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.

    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }

    var sheet = this.options.sheet;

    if (sheet && sheet.attached) {
      process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
    }

    return this;
  };

  return BaseStyleRule;
}();
var StyleRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  _inheritsLoose(StyleRule, _BaseStyleRule);

  function StyleRule(key, style, options) {
    var _this;

    _this = _BaseStyleRule.call(this, key, style, options) || this;
    _this.selectorText = void 0;
    _this.id = void 0;
    _this.renderable = void 0;
    var selector = options.selector,
        scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;

    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId(_assertThisInitialized(_assertThisInitialized(_this)), sheet);
      _this.selectorText = "." + escape(_this.id);
    }

    return _this;
  }
  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  var _proto2 = StyleRule.prototype;

  /**
   * Apply rule to an element inline.
   */
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;

    if (renderer) {
      var json = this.toJSON();

      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }

    return this;
  }
  /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */
  ;

  _proto2.toJSON = function toJSON() {
    var json = {};

    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }

    return json;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends$1({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };

  _createClass(StyleRule, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer,
          renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.

      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    }
    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(name, style, options) {
    if (name[0] === '@' || options.parent && options.parent.type === 'keyframes') {
      return null;
    }

    return new StyleRule(name, style, options);
  }
};

var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */

var ConditionalRule =
/*#__PURE__*/
function () {
  function ConditionalRule(key, styles, options) {
    this.type = 'conditional';
    this.at = void 0;
    this.key = void 0;
    this.query = void 0;
    this.rules = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.

    this.query = options.name || "@" + this.at;
    this.options = options;
    this.rules = new RuleList(_extends$1({}, options, {
      parent: this
    }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = ConditionalRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }

    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;

    if (options.children === false) {
      return this.query + " {}";
    }

    var children = this.rules.toString(options);
    return children ? this.query + " {\n" + children + "\n}" : '';
  };

  return ConditionalRule;
}();
var keyRegExp = /@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule(key, styles, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
  }
};

var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */

var KeyframesRule =
/*#__PURE__*/
function () {
  function KeyframesRule(key, frames, options) {
    this.type = 'keyframes';
    this.at = '@keyframes';
    this.key = void 0;
    this.name = void 0;
    this.id = void 0;
    this.rules = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    var nameMatch = key.match(nameRegExp);

    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = 'noname';
      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Bad keyframes name " + key) : void 0;
    }

    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;
    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
    this.rules = new RuleList(_extends$1({}, options, {
      parent: this
    }));

    for (var name in frames) {
      this.rules.add(name, frames[name], _extends$1({}, options, {
        parent: this
      }));
    }

    this.rules.process();
  }
  /**
   * Generates a CSS string.
   */


  var _proto = KeyframesRule.prototype;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }

    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;

    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }

    var children = this.rules.toString(options);
    if (children) children = "\n" + children + "\n";
    return this.at + " " + this.id + " {" + children + "}";
  };

  return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;

var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
  if (typeof val === 'string') {
    return val.replace(refRegExp, function (match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }

      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.") : void 0;
      return match;
    });
  }

  return val;
};
/**
 * Replace the reference for a animation name.
 */


var replaceRef = function replaceRef(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);

  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};

var plugin = {
  onCreateRule: function onCreateRule(key, frames, options) {
    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style' || !sheet) return style;
    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;

    if (!sheet) {
      return val;
    }

    switch (prop) {
      case 'animation':
        return findReferencedKeyframe(val, sheet.keyframes);

      case 'animation-name':
        return findReferencedKeyframe(val, sheet.keyframes);

      default:
        return val;
    }
  }
};

var KeyframeRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  _inheritsLoose(KeyframeRule, _BaseStyleRule);

  function KeyframeRule() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _BaseStyleRule.call.apply(_BaseStyleRule, [this].concat(args)) || this;
    _this.renderable = void 0;
    return _this;
  }

  var _proto = KeyframeRule.prototype;

  /**
   * Generates a CSS string.
   */
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends$1({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };

  return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (options.parent && options.parent.type === 'keyframes') {
      return new KeyframeRule(key, style, options);
    }

    return null;
  }
};

var FontFaceRule =
/*#__PURE__*/
function () {
  function FontFaceRule(key, style, options) {
    this.type = 'font-face';
    this.at = '@font-face';
    this.key = void 0;
    this.style = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = FontFaceRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.style)) {
      var str = '';

      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.at, this.style[index]);
        if (this.style[index + 1]) str += '\n';
      }

      return str;
    }

    return toCss(this.at, this.style, options);
  };

  return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
  }
};

var ViewportRule =
/*#__PURE__*/
function () {
  function ViewportRule(key, style, options) {
    this.type = 'viewport';
    this.at = '@viewport';
    this.key = void 0;
    this.style = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = ViewportRule.prototype;

  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };

  return ViewportRule;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
  }
};

var SimpleRule =
/*#__PURE__*/
function () {
  function SimpleRule(key, value, options) {
    this.type = 'simple';
    this.key = void 0;
    this.value = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  var _proto = SimpleRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = '';

      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1]) str += '\n';
      }

      return str;
    }

    return this.key + " " + this.value + ";";
  };

  return SimpleRule;
}();
var keysMap = {
  '@charset': true,
  '@import': true,
  '@namespace': true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};

var plugins = [pluginStyleRule, pluginConditionalRule, plugin, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];

var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */

};

var RuleList =
/*#__PURE__*/
function () {
  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.
  // Original styles object.
  // Used to ensure correct rules order.
  function RuleList(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.counter = 0;
    this.options = void 0;
    this.classes = void 0;
    this.keyframes = void 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  var _proto = RuleList.prototype;

  _proto.add = function add(name, decl, ruleOptions) {
    var _this$options = this.options,
        parent = _this$options.parent,
        sheet = _this$options.sheet,
        jss = _this$options.jss,
        Renderer = _this$options.Renderer,
        generateId = _this$options.generateId,
        scoped = _this$options.scoped;

    var options = _extends$1({
      classes: this.classes,
      parent: parent,
      sheet: sheet,
      jss: jss,
      Renderer: Renderer,
      generateId: generateId,
      scoped: scoped,
      name: name,
      keyframes: this.keyframes,
      selector: undefined
    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
    // we need to make the key unique within this RuleList instance scope.


    var key = name;

    if (name in this.raw) {
      key = name + "-d" + this.counter++;
    } // We need to save the original decl before creating the rule
    // because cache plugin needs to use it as a key to return a cached rule.


    this.raw[key] = decl;

    if (key in this.classes) {
      // E.g. rules inside of @media container
      options.selector = "." + escape(this.classes[key]);
    }

    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index = options.index === undefined ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  }
  /**
   * Get a rule.
   */
  ;

  _proto.get = function get(name) {
    return this.map[name];
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.index.indexOf(rule), 1);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  }
  /**
   * Run `onProcessRule()` plugins on every rule.
   */
  ;

  _proto.process = function process() {
    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
    // we end up with very hard-to-track-down side effects.

    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
  }
  /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */
  ;

  _proto.register = function register(rule) {
    this.map[rule.key] = rule;

    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  }
  /**
   * Unregister a rule.
   */
  ;

  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];

    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var name;
    var data;
    var options;

    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
      name = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe[invalid-tuple-index]

      data = arguments.length <= 1 ? undefined : arguments[1]; // $FlowFixMe[invalid-tuple-index]

      options = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      data = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe[invalid-tuple-index]

      options = arguments.length <= 1 ? undefined : arguments[1];
      name = null;
    }

    if (name) {
      this.updateOne(this.map[name], data, options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.updateOne(this.index[index], data, options);
      }
    }
  }
  /**
   * Execute plugins, update rule props.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }

    var _this$options2 = this.options,
        plugins = _this$options2.jss.plugins,
        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.

    if (rule.rules instanceof RuleList) {
      rule.rules.update(data, options);
      return;
    }

    var styleRule = rule;
    var style = styleRule.style;
    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.

    if (options.process && style && style !== styleRule.style) {
      // We need to run the plugins in case new `style` relies on syntax plugins.
      plugins.onProcessStyle(styleRule.style, styleRule, sheet); // Update and add props.

      for (var prop in styleRule.style) {
        var nextValue = styleRule.style[prop];
        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (nextValue !== prevValue) {
          styleRule.prop(prop, nextValue, forceUpdateOptions);
        }
      } // Remove props.


      for (var _prop in style) {
        var _nextValue = styleRule.style[_prop];
        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (_nextValue == null && _nextValue !== _prevValue) {
          styleRule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    var str = '';
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;

    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css = rule.toString(options); // No need to render an empty rule.

      if (!css && !link) continue;
      if (str) str += '\n';
      str += css;
    }

    return str;
  };

  return RuleList;
}();

var StyleSheet$1 =
/*#__PURE__*/
function () {
  function StyleSheet(styles, options) {
    this.options = void 0;
    this.deployed = void 0;
    this.attached = void 0;
    this.rules = void 0;
    this.renderer = void 0;
    this.classes = void 0;
    this.keyframes = void 0;
    this.queue = void 0;
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = _extends$1({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });

    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }

    this.rules = new RuleList(this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Attach renderable to the render tree.
   */


  var _proto = StyleSheet.prototype;

  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.

    if (!this.deployed) this.deploy();
    return this;
  }
  /**
   * Remove renderable from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  }
  /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */
  ;

  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue; // Plugins can create rules.
    // In order to preserve the right order, we need to queue all `.addRule` calls,
    // which happen after the first `rules.add()` call.

    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);

    if (this.attached) {
      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (queue) queue.push(rule);else {
        this.insertRule(rule);

        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = undefined;
        }
      }
      return rule;
    } // We can't add rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return rule;
  }
  /**
   * Insert rule into the StyleSheet
   */
  ;

  _proto.insertRule = function insertRule(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  }
  /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */
  ;

  _proto.addRules = function addRules(styles, options) {
    var added = [];

    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }

    return added;
  }
  /**
   * Get a rule by name.
   */
  ;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */
  ;

  _proto.deleteRule = function deleteRule(name) {
    var rule = typeof name === 'object' ? name : this.rules.get(name);

    if (!rule || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !rule.renderable) {
      return false;
    }

    this.rules.remove(rule);

    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }

    return true;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Deploy pure CSS string to a renderable.
   */
  ;

  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var _this$rules;

    (_this$rules = this.rules).update.apply(_this$rules, arguments);

    return this;
  }
  /**
   * Updates a single rule.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    this.rules.updateOne(rule, data, options);
    return this;
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return StyleSheet;
}();

var PluginsRegistry =
/*#__PURE__*/
function () {
  function PluginsRegistry() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = void 0;
  }

  var _proto = PluginsRegistry.prototype;

  /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */
  _proto.onCreateRule = function onCreateRule(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }

    return null;
  }
  /**
   * Call `onProcessRule` hooks.
   */
  ;

  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;

    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }

    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  }
  /**
   * Call `onProcessStyle` hooks.
   */
  ;

  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      // $FlowFixMe[prop-missing]
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  }
  /**
   * Call `onProcessSheet` hooks.
   */
  ;

  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  }
  /**
   * Call `onUpdate` hooks.
   */
  ;

  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  }
  /**
   * Call `onChangeValue` hooks.
   */
  ;

  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
    var processedValue = value;

    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }

    return processedValue;
  }
  /**
   * Register a plugin.
   */
  ;

  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: 'external'
      };
    }

    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.

    if (plugins.indexOf(newPlugin) !== -1) {
      return;
    }

    plugins.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        } else {
          process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Unknown hook \"" + name + "\".") : void 0;
        }
      }

      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };

  return PluginsRegistry;
}();

/**
 * Sheets registry to access them all at one place.
 */
var SheetsRegistry =
/*#__PURE__*/
function () {
  function SheetsRegistry() {
    this.registry = [];
  }

  var _proto = SheetsRegistry.prototype;

  /**
   * Register a Style Sheet.
   */
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;

    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    } // Find a position.


    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  }
  /**
   * Reset the registry.
   */
  ;

  _proto.reset = function reset() {
    this.registry = [];
  }
  /**
   * Remove a Style Sheet.
   */
  ;

  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  }
  /**
   * Convert all attached sheets to a CSS string.
   */
  ;

  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        attached = _ref.attached,
        options = _objectWithoutPropertiesLoose$1(_ref, ["attached"]);

    var css = '';

    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];

      if (attached != null && sheet.attached !== attached) {
        continue;
      }

      if (css) css += '\n';
      css += sheet.toString(options);
    }

    return css;
  };

  _createClass(SheetsRegistry, [{
    key: "index",

    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */

var registry = new SheetsRegistry();

/* eslint-disable */
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var globalThis$1 = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();

var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.

var moduleId = globalThis$1[ns]++;

var maxRules = 1e10;

/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */
var createGenerateId = function createGenerateId(options) {
  if (options === void 0) {
    options = {};
  }

  var ruleCounter = 0;
  return function (rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
    }

    var jssId = '';
    var prefix = '';

    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }

      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }

    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
    }

    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
  };
};

/**
 * Cache the value from the first time a function is called.
 */
var memoize$2 = function memoize(fn) {
  var value;
  return function () {
    if (!value) value = fn();
    return value;
  };
};

/**
 * Get a style property value.
 */
var getPropertyValue = function getPropertyValue(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }

    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
};

/**
 * Set a style property.
 */
var setProperty = function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = toCssValue(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    } // Support CSSTOM.


    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      cssRule.style.setProperty(prop, cssValue);
    }
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }

  return true;
};

/**
 * Remove a style property.
 */
var removeProperty = function removeProperty(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".") : void 0;
  }
};

/**
 * Set the selector.
 */
var setSelector = function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText; // Return false if setter was not successful.
  // Currently works in chrome only.

  return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */


var getHead = memoize$2(function () {
  return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */

function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find attached sheet with the highest index.
 */


function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find a comment with "jss" inside.
 */


function findCommentNode(text) {
  var head = getHead();

  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];

    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }

  return null;
}

/**
 * Find a node before which we can insert the sheet.
 */
function findPrevNode(options) {
  var registry$1 = registry.registry;

  if (registry$1.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry$1, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    } // Otherwise insert after the last attached.


    sheet = findHighestSheet(registry$1, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  } // Try to find a comment placeholder if registry is empty.


  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);

    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    } // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.


    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.") : void 0;
  }

  return false;
}
/**
 * Insert style element into the DOM.
 */


function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);

  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  } // Works with iframes and any node types.


  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Insertion point is not in the DOM.') : void 0;
    return;
  }

  getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */


var getNonce = memoize$2(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var _insertRule = function insertRule(container, rule, index) {
  try {
    if ('insertRule' in container) {
      var c = container;
      c.insertRule(rule, index);
    } // Keyframes rule.
    else if ('appendRule' in container) {
        var _c = container;

        _c.appendRule(rule);
      }
  } catch (err) {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] " + err.message) : void 0;
    return false;
  }

  return container.cssRules[index];
};

var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong

  if (index === undefined || index > maxIndex) {
    // eslint-disable-next-line no-param-reassign
    return maxIndex;
  }

  return index;
};

var createStyle = function createStyle() {
  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
  // insert rules after we insert the style tag.
  // It seems to kick-off the source order specificity algorithm.

  el.textContent = '\n';
  return el;
};

var DomRenderer =
/*#__PURE__*/
function () {
  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696
  // Will be empty if link: true option is not set, because
  // it is only for use together with insertRule API.
  function DomRenderer(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.element = void 0;
    this.sheet = void 0;
    this.hasInsertedRules = false;
    this.cssRules = [];
    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) registry.add(sheet);
    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || createStyle();
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }
  /**
   * Insert style element into render tree.
   */


  var _proto = DomRenderer.prototype;

  _proto.attach = function attach() {
    // In the case the element node is external and it is already in the DOM.
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
    // most browsers create a new CSSStyleSheet, except of all IEs.

    var deployed = Boolean(this.sheet && this.sheet.deployed);

    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  }
  /**
   * Remove style element from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.sheet) return;
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
    // Though IE will keep them and we need a consistent behavior.

    if (this.sheet.options.link) {
      this.cssRules = [];
      this.element.textContent = '\n';
    }
  }
  /**
   * Inject CSS string into element.
   */
  ;

  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;

    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }

    this.element.textContent = "\n" + sheet.toString() + "\n";
  }
  /**
   * Insert RuleList into an element.
   */
  ;

  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  }
  /**
   * Insert a rule into element.
   */
  ;

  _proto.insertRule = function insertRule(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }

    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;

      if (rule.type === 'conditional' || rule.type === 'keyframes') {
        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.


        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), _insertionIndex);

        if (latestNativeParent === false) {
          return false;
        }

        this.refCssRule(rule, _insertionIndex, latestNativeParent);
      }

      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    }

    var ruleStr = rule.toString();
    if (!ruleStr) return false;
    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);

    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);

    if (nativeRule === false) {
      return false;
    }

    this.hasInsertedRules = true;
    this.refCssRule(rule, insertionIndex, nativeRule);
    return nativeRule;
  };

  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
    rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
    // like rules inside media queries or keyframes

    if (rule.options.parent instanceof StyleSheet$1) {
      this.cssRules[index] = cssRule;
    }
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return true;
  }
  /**
   * Get index of a CSS Rule.
   */
  ;

  _proto.indexOf = function indexOf(cssRule) {
    return this.cssRules.indexOf(cssRule);
  }
  /**
   * Generate a new CSS rule and replace the existing one.
   *
   * Only used for some old browsers because they can't set a selector.
   */
  ;

  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    this.element.sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return this.insertRule(rule, index);
  }
  /**
   * Get all rules elements.
   */
  ;

  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };

  return DomRenderer;
}();

var instanceCounter = 0;

var Jss =
/*#__PURE__*/
function () {
  function Jss(options) {
    this.id = instanceCounter++;
    this.version = "10.5.0";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId: createGenerateId,
      Renderer: isBrowser$4 ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });

    for (var i = 0; i < plugins.length; i++) {
      this.plugins.use(plugins[i], {
        queue: 'internal'
      });
    }

    this.setup(options);
  }
  /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */


  var _proto = Jss.prototype;

  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }

    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }

    if (options.id) {
      this.options.id = _extends$1({}, this.options.id, options.id);
    }

    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }

    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;

    if ('Renderer' in options) {
      this.options.Renderer = options.Renderer;
    } // eslint-disable-next-line prefer-spread


    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  }
  /**
   * Create a Style Sheet.
   */
  ;

  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        index = _options.index;

    if (typeof index !== 'number') {
      index = registry.index === 0 ? 0 : registry.index + 1;
    }

    var sheet = new StyleSheet$1(styles, _extends$1({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  }
  /**
   * Detach the Style Sheet and remove it from the registry.
   */
  ;

  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    registry.remove(sheet);
    return this;
  }
  /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */
  ;

  _proto.createRule = function createRule$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }

    if (options === void 0) {
      options = {};
    }

    // Enable rule without name for inline styles.
    if (typeof name === 'object') {
      // $FlowFixMe[incompatible-call]
      return this.createRule(undefined, name, style);
    } // $FlowFixMe[incompatible-type]


    var ruleOptions = _extends$1({}, options, {
      name: name,
      jss: this,
      Renderer: this.options.Renderer
    });

    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};

    var rule = createRule(name, style, ruleOptions);

    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */
  ;

  _proto.use = function use() {
    var _this = this;

    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }

    plugins.forEach(function (plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };

  return Jss;
}();

/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value;

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);

      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */

/**
 * Export a constant indicating if this browser has CSSTOM support.
 * https://developers.google.com/web/updates/2018/03/cssom
 */
var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;
/**
 * Creates a new instance of Jss.
 */

var create = function create(options) {
  return new Jss(options);
};
/**
 * A global Jss instance.
 */

var jss = create();

var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;

var functionPlugin = function functionPlugin() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = createRule(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      // We need to extract function values from the declaration, so that we can keep core unaware of them.
      // We need to do that only once.
      // We don't need to extract functions on each style update, since this can happen only once.
      // We don't support function values inside of function rules.
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};

      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fnValues[prop] = value;
      } // $FlowFixMe[prop-missing]


      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule; // $FlowFixMe[prop-missing]

      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
      // will be returned from that function.

      if (fnRule) {
        // Empty object will remove all currently defined props
        // in case function rule returns a falsy value.
        styleRule.style = fnRule(data) || {};

        if (process.env.NODE_ENV === 'development') {
          for (var prop in styleRule.style) {
            if (typeof styleRule.style[prop] === 'function') {
              process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Function values inside function rules are not supported.') : void 0;
              break;
            }
          }
        }
      } // $FlowFixMe[prop-missing]


      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.

      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
};

var at = '@global';
var atPrefix = '@global ';

var GlobalContainerRule =
/*#__PURE__*/
function () {
  function GlobalContainerRule(key, styles, options) {
    this.type = 'global';
    this.at = at;
    this.rules = void 0;
    this.options = void 0;
    this.key = void 0;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new RuleList(_extends$1({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = GlobalContainerRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (rule) this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString() {
    return this.rules.toString();
  };

  return GlobalContainerRule;
}();

var GlobalPrefixedRule =
/*#__PURE__*/
function () {
  function GlobalPrefixedRule(key, style, options) {
    this.type = 'global';
    this.at = at;
    this.options = void 0;
    this.rule = void 0;
    this.isProcessed = false;
    this.key = void 0;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, _extends$1({}, options, {
      parent: this
    }));
  }

  var _proto2 = GlobalPrefixedRule.prototype;

  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : '';
  };

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';

  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }

  return scoped;
}

function handleNestedGlobalContainerRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules) return;

  for (var name in rules) {
    sheet.addRule(name, rules[name], _extends$1({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[at];
}

function handlePrefixedGlobalRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    sheet.addRule(selector, style[prop], _extends$1({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */


function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;

    if (name === at) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;

    if (parent) {
      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
        options.scoped = false;
      }
    }

    if (options.scoped === false) {
      options.selector = name;
    }

    return null;
  }

  function onProcessRule(rule, sheet) {
    if (rule.type !== 'style' || !sheet) return;
    handleNestedGlobalContainerRule(rule, sheet);
    handlePrefixedGlobalRule(rule, sheet);
  }

  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}

var separatorRegExp$1 = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp$1 = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */

function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container, sheet) {
    return function (match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);

      if (rule) {
        rule = rule;
        return rule.selector;
      }

      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".") : void 0;
      return key;
    };
  }

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp$1);
    var nestedSelectors = nestedProp.split(separatorRegExp$1);
    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, prevOptions) {
    // Options has been already created, now we only increase index.
    if (prevOptions) return _extends$1({}, prevOptions, {
      index: prevOptions.index + 1 // $FlowFixMe[prop-missing]

    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    var options = _extends$1({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.

    });

    delete options.name;
    return options;
  }

  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style') return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;

    for (var prop in style) {
      var isNested = prop.indexOf('&') !== -1;
      var isNestedConditional = prop[0] === '@';
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.

        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.

        selector = selector.replace(refRegExp$1, replaceRef);
        container.addRule(selector, style[prop], _extends$1({}, options, {
          selector: selector
        }));
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, {}, options) // Flow expects more options but they aren't required
        // And flow doesn't know this will always be a StyleRule which has the addRule method
        // $FlowFixMe[incompatible-use]
        // $FlowFixMe[prop-missing]
        .addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }

      delete style[prop];
    }

    return style;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g;
var msPattern$1 = /^ms-/;
var cache = {};

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower);
  return (cache[name] = msPattern$1.test(hName) ? '-' + hName : hName)
}

/**
 * Convert camel cased property names to dash separated.
 *
 * @param {Object} style
 * @return {Object}
 */

function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    var key = prop.indexOf('--') === 0 ? prop : hyphenateStyleName(prop);
    converted[key] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 *
 * @param {Rule} rule
 */


function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }

      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    if (prop.indexOf('--') === 0) {
      return value;
    }

    var hyphenatedProp = hyphenateStyleName(prop); // There was no camel case in place

    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

    return null;
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

var px = hasCSSTOMSupport && CSS ? CSS.px : 'px';
var ms = hasCSSTOMSupport && CSS ? CSS.ms : 'ms';
var percent = hasCSSTOMSupport && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 *
 * @type object
 */

var defaultUnits = {
  // Animation properties
  'animation-delay': ms,
  'animation-duration': ms,
  // Background properties
  'background-position': px,
  'background-position-x': px,
  'background-position-y': px,
  'background-size': px,
  // Border Properties
  border: px,
  'border-bottom': px,
  'border-bottom-left-radius': px,
  'border-bottom-right-radius': px,
  'border-bottom-width': px,
  'border-left': px,
  'border-left-width': px,
  'border-radius': px,
  'border-right': px,
  'border-right-width': px,
  'border-top': px,
  'border-top-left-radius': px,
  'border-top-right-radius': px,
  'border-top-width': px,
  'border-width': px,
  'border-block': px,
  'border-block-end': px,
  'border-block-end-width': px,
  'border-block-start': px,
  'border-block-start-width': px,
  'border-block-width': px,
  'border-inline': px,
  'border-inline-end': px,
  'border-inline-end-width': px,
  'border-inline-start': px,
  'border-inline-start-width': px,
  'border-inline-width': px,
  'border-start-start-radius': px,
  'border-start-end-radius': px,
  'border-end-start-radius': px,
  'border-end-end-radius': px,
  // Margin properties
  margin: px,
  'margin-bottom': px,
  'margin-left': px,
  'margin-right': px,
  'margin-top': px,
  'margin-block': px,
  'margin-block-end': px,
  'margin-block-start': px,
  'margin-inline': px,
  'margin-inline-end': px,
  'margin-inline-start': px,
  // Padding properties
  padding: px,
  'padding-bottom': px,
  'padding-left': px,
  'padding-right': px,
  'padding-top': px,
  'padding-block': px,
  'padding-block-end': px,
  'padding-block-start': px,
  'padding-inline': px,
  'padding-inline-end': px,
  'padding-inline-start': px,
  // Mask properties
  'mask-position-x': px,
  'mask-position-y': px,
  'mask-size': px,
  // Width and height properties
  height: px,
  width: px,
  'min-height': px,
  'max-height': px,
  'min-width': px,
  'max-width': px,
  // Position properties
  bottom: px,
  left: px,
  top: px,
  right: px,
  inset: px,
  'inset-block': px,
  'inset-block-end': px,
  'inset-block-start': px,
  'inset-inline': px,
  'inset-inline-end': px,
  'inset-inline-start': px,
  // Shadow properties
  'box-shadow': px,
  'text-shadow': px,
  // Column properties
  'column-gap': px,
  'column-rule': px,
  'column-rule-width': px,
  'column-width': px,
  // Font and text properties
  'font-size': px,
  'font-size-delta': px,
  'letter-spacing': px,
  'text-indent': px,
  'text-stroke': px,
  'text-stroke-width': px,
  'word-spacing': px,
  // Motion properties
  motion: px,
  'motion-offset': px,
  // Outline properties
  outline: px,
  'outline-offset': px,
  'outline-width': px,
  // Perspective properties
  perspective: px,
  'perspective-origin-x': percent,
  'perspective-origin-y': percent,
  // Transform properties
  'transform-origin': percent,
  'transform-origin-x': percent,
  'transform-origin-y': percent,
  'transform-origin-z': percent,
  // Transition properties
  'transition-delay': ms,
  'transition-duration': ms,
  // Alignment properties
  'vertical-align': px,
  'flex-basis': px,
  // Some random properties
  'shape-margin': px,
  size: px,
  gap: px,
  // Grid properties
  grid: px,
  'grid-gap': px,
  'grid-row-gap': px,
  'grid-column-gap': px,
  'grid-template-rows': px,
  'grid-template-columns': px,
  'grid-auto-rows': px,
  'grid-auto-columns': px,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  'box-shadow-x': px,
  'box-shadow-y': px,
  'box-shadow-blur': px,
  'box-shadow-spread': px,
  'font-line-height': px,
  'text-shadow-x': px,
  'text-shadow-y': px,
  'text-shadow-blur': px
};

/**
 * Clones the object and adds a camel cased property version.
 */
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;

  var replace = function replace(str) {
    return str[1].toUpperCase();
  };

  var newObj = {};

  for (var _key in obj) {
    newObj[_key] = obj[_key];
    newObj[_key.replace(regExp, replace)] = obj[_key];
  }

  return newObj;
}

var units = addCamelCasedVersion(defaultUnits);
/**
 * Recursive deep style passing function
 */

function iterate(prop, value, options) {
  if (value == null) return value;

  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === 'object') {
    if (prop === 'fallbacks') {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    }
  } else if (typeof value === 'number') {
    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.

    if (unit && !(value === 0 && unit === px)) {
      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
    }

    return value.toString();
  }

  return value;
}
/**
 * Add unit to numeric values.
 */


function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

// Export javascript style and css style vendor prefixes.
var js = '';
var css$1 = '';
var vendor = '';
var browser = '';
var isTouch = isBrowser$4 && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.

if (isBrowser$4) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };

  var _document$createEleme = document.createElement('p'),
      style = _document$createEleme.style;

  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css$1 = jsCssMap[key];
      break;
    }
  } // Correctly detect the Edge browser.


  if (js === 'Webkit' && 'msHyphens' in style) {
    js = 'ms';
    css$1 = jsCssMap.ms;
    browser = 'edge';
  } // Correctly detect the Safari browser.


  if (js === 'Webkit' && '-apple-trailing-word' in style) {
    vendor = 'apple';
  }
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */


var prefix = {
  js: js,
  css: css$1,
  vendor: vendor,
  browser: browser,
  isTouch: isTouch
};

/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */

function supportedKeyframes(key) {
  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
  // https://caniuse.com/#search=keyframes

  if (prefix.js === 'ms') return key;
  return "@" + prefix.css + "keyframes" + key.substr(10);
}

// https://caniuse.com/#search=appearance

var appearence = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (prefix.js === 'ms') return "-webkit-" + prop;
    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=color-adjust

var colorAdjust = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
    return prop;
  }
};

var regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */


function camelize(str) {
  return str.replace(regExp, toUpper);
}

/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function pascalize(str) {
  return camelize("-" + str);
}

// but we can use a longhand property instead.
// https://caniuse.com/#search=mask

var mask = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var longhand = 'mask-image';

      if (camelize(longhand) in style) {
        return prop;
      }

      if (prefix.js + pascalize(longhand) in style) {
        return prefix.css + prop;
      }
    }

    return prop;
  }
};

// https://caniuse.com/#search=text-orientation

var textOrientation = {
  noPrefill: ['text-orientation'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'text-orientation') return false;

    if (prefix.vendor === 'apple' && !prefix.isTouch) {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=transform

var transform = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;

    if (options.transform) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=transition

var transition = {
  noPrefill: ['transition'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transition') return false;

    if (options.transition) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=writing-mode

var writingMode = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;

    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=user-select

var userSelect = {
  noPrefill: ['user-select'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'user-select') return false;

    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177

var breakPropsOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? prefix.css + "column-" + prop : false;
    }

    if (prefix.js === 'Moz') {
      var _jsProp = "page" + pascalize(prop);

      return _jsProp in style ? "page-" + prop : false;
    }

    return false;
  }
};

// See https://github.com/postcss/autoprefixer/issues/324.

var inlineLogicalOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (prefix.js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.

var unprefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};

var prefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.

    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.

    if (prop[0] === '-' && prop[1] === '-') return prop;
    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.

    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
    return false;
  }
};

// https://caniuse.com/#search=scroll-snap

var scrollSnap = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;

    if (prefix.js === 'ms') {
      return "" + prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=overscroll-behavior

var overscrollBehavior = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;

    if (prefix.js === 'ms') {
      return prefix.css + "scroll-chaining";
    }

    return prop;
  }
};

var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.

}; // Support old flex spec from 2012.

var flex2012 = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

var propMap$1 = {
  flex: 'box-flex',
  'flex-grow': 'box-flex',
  'flex-direction': ['box-orient', 'box-direction'],
  order: 'box-ordinal-group',
  'align-items': 'box-align',
  'flex-flow': ['box-orient', 'box-direction'],
  'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);

var prefixCss = function prefixCss(p) {
  return prefix.css + p;
}; // Support old flex spec from 2009.


var flex2009 = {
  supportedProperty: function supportedProperty(prop, style, _ref) {
    var multiple = _ref.multiple;

    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];

      if (!Array.isArray(newProp)) {
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
      }

      if (!multiple) return false;

      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }

      return newProp.map(prefixCss);
    }

    return false;
  }
};

// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'

var plugins$1 = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = plugins$1.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});
var noPrefill = plugins$1.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, _toConsumableArray$1(p.noPrefill));
  return a;
}, []);

var el;
var cache$1 = {};

if (isBrowser$4) {
  el = document.createElement('p'); // We test every property on vendor prefix requirement.
  // Once tested, result is cached. It gives us up to 70% perf boost.
  // http://jsperf.com/element-style-object-access-vs-plain-object
  //
  // Prefill cache with known css properties to reduce amount of
  // properties we need to feature test at runtime.
  // http://davidwalsh.name/vendor-prefix

  var computed = window.getComputedStyle(document.documentElement, '');

  for (var key$1 in computed) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1)) cache$1[computed[key$1]] = computed[key$1];
  } // Properties that cannot be correctly detected using the
  // cache prefill method.


  noPrefill.forEach(function (x) {
    return delete cache$1[x];
  });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */


function supportedProperty(prop, options) {
  if (options === void 0) {
    options = {};
  }

  // For server-side rendering.
  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.

  if (process.env.NODE_ENV !== 'benchmark' && cache$1[prop] != null) {
    return cache$1[prop];
  } // Check if 'transition' or 'transform' natively supported in browser.


  if (prop === 'transition' || prop === 'transform') {
    options[prop] = prop in el.style;
  } // Find a plugin for current prefix property.


  for (var i = 0; i < propertyDetectors.length; i++) {
    cache$1[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.

    if (cache$1[prop]) break;
  } // Reset styles for current property.
  // Firefox can even throw an error for invalid properties, e.g., "0".


  try {
    el.style[prop] = '';
  } catch (err) {
    return false;
  }

  return cache$1[prop];
}

var cache$1$1 = {};
var transitionProperties = {
  transition: 1,
  'transition-property': 1,
  '-webkit-transition': 1,
  '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */

function prefixTransitionCallback(match, p1, p2) {
  if (p1 === 'var') return 'var';
  if (p1 === 'all') return 'all';
  if (p2 === 'all') return ', all';
  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}

if (isBrowser$4) el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */

function supportedValue(property, value) {
  // For server-side rendering.
  var prefixedValue = value;
  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  // eslint-disable-next-line no-restricted-globals

  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  } // Create cache key for current value.


  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.

  if (process.env.NODE_ENV !== 'benchmark' && cache$1$1[cacheKey] != null) {
    return cache$1$1[cacheKey];
  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.


  try {
    // Test value as it is.
    el$1.style[property] = prefixedValue;
  } catch (err) {
    // Return false if value not supported.
    cache$1$1[cacheKey] = false;
    return false;
  } // If 'transition' or 'transition-property' property.


  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === '') {
    // Value with a vendor prefix.
    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.

    el$1.style[property] = prefixedValue; // Return false if value not supported.

    if (el$1.style[property] === '') {
      cache$1$1[cacheKey] = false;
      return false;
    }
  } // Reset styles for current property.


  el$1.style[property] = ''; // Write current value to cache.

  cache$1$1[cacheKey] = prefixedValue;
  return cache$1$1[cacheKey];
}

/**
 * Add vendor prefix to a property name when needed.
 *
 * @api public
 */

function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      var atRule = rule;
      atRule.at = supportedKeyframes(atRule.at);
    }
  }

  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];

      if (prop === 'fallbacks' && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }

      var changeProp = false;
      var supportedProp = supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$1 = supportedValue(supportedProp, toCssValue(value));
      if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }

    return style;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    return prefixStyle(style);
  }

  function onChangeValue(value, prop) {
    return supportedValue(prop, toCssValue(value)) || value;
  }

  return {
    onProcessRule: onProcessRule,
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/**
 * Sort props by length.
 */
function jssPropsSort() {
  var sort = function sort(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }

    return prop0.length - prop1.length;
  };

  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);

      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }

      return newStyle;
    }
  };
}

function jssPreset() {
  return {
    plugins: [functionPlugin(), jssGlobal(), jssNested(), camelCase(), defaultUnit(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : jssVendorPrefixer(), jssPropsSort()]
  };
}

function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = _extends$1({}, baseClasses);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof newClasses === 'string') {
      console.error(["Material-UI: The value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat(getDisplayName(Component), " is incorrect."), 'You might want to use the className prop instead.'].join('\n'));
      return baseClasses;
    }
  }

  Object.keys(newClasses).forEach(function (key) {
    if (process.env.NODE_ENV !== 'production') {
      if (!baseClasses[key] && newClasses[key]) {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat(getDisplayName(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n'));
      }

      if (newClasses[key] && typeof newClasses[key] !== 'string') {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat(getDisplayName(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n'));
      }
    }

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};

var ThemeContext$1 = React__default.createContext(null);

if (process.env.NODE_ENV !== 'production') {
  ThemeContext$1.displayName = 'ThemeContext';
}

function useTheme() {
  var theme = React__default.useContext(ThemeContext$1);

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React__default.useDebugValue(theme);
  }

  return theme;
}

var jss$1 = create(jssPreset()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName = createGenerateClassName(); // Exported for test purposes

var sheetsManager = new Map();
var defaultOptions = {
  disableGeneration: false,
  generateClassName: generateClassName,
  jss: jss$1,
  sheetsCache: null,
  sheetsManager: sheetsManager,
  sheetsRegistry: null
};
var StylesContext = React__default.createContext(defaultOptions);

if (process.env.NODE_ENV !== 'production') {
  StylesContext.displayName = 'StylesContext';
}

var injectFirstNode;
function StylesProvider(props) {
  var children = props.children,
      _props$injectFirst = props.injectFirst,
      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
      _props$disableGenerat = props.disableGeneration,
      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
      localOptions = _objectWithoutProperties$1(props, ["children", "injectFirst", "disableGeneration"]);

  var outerOptions = React__default.useContext(StylesContext);

  var context = _extends$1({}, outerOptions, {
    disableGeneration: disableGeneration
  }, localOptions);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof window === 'undefined' && !context.sheetsManager) {
      console.error('Material-UI: You need to use the ServerStyleSheets API when rendering on the server.');
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    if (context.jss.options.insertionPoint && injectFirst) {
      console.error('Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.');
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    if (injectFirst && localOptions.jss) {
      console.error('Material-UI: You cannot use the jss and injectFirst props at the same time.');
    }
  }

  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
    if (!injectFirstNode) {
      var head = document.head;
      injectFirstNode = document.createComment('mui-inject-first');
      head.insertBefore(injectFirstNode, head.firstChild);
    }

    context.jss = create({
      plugins: jssPreset().plugins,
      insertionPoint: injectFirstNode
    });
  }

  return /*#__PURE__*/React__default.createElement(StylesContext.Provider, {
    value: context
  }, children);
}
process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes__default.node.isRequired,

  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */
  disableGeneration: PropTypes__default.bool,

  /**
   * JSS's class name generator.
   */
  generateClassName: PropTypes__default.func,

  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override Material-UI's styles, set this prop.
   */
  injectFirst: PropTypes__default.bool,

  /**
   * JSS's instance.
   */
  jss: PropTypes__default.object,

  /**
   * @ignore
   */
  serverGenerateClassName: PropTypes__default.func,

  /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */
  sheetsCache: PropTypes__default.object,

  /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: PropTypes__default.object,

  /**
   * @ignore
   *
   * Collect the sheets.
   */
  sheetsRegistry: PropTypes__default.object
} : void 0;

if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = exactProp(StylesProvider.propTypes) : void 0;
}

/* eslint-disable import/prefer-default-export */
// Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = -1e9;
function increment() {
  indexCounter += 1;

  if (process.env.NODE_ENV !== 'production') {
    if (indexCounter >= 0) {
      console.warn(['Material-UI: You might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n'));
    }
  }

  return indexCounter;
}

// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};

function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';

  if (process.env.NODE_ENV !== 'production') {
    if (_typeof(stylesOrCreator) !== 'object' && !themingEnabled) {
      console.error(['Material-UI: The `styles` argument provided is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n'));
    }
  }

  return {
    create: function create(theme, name) {
      var styles;

      try {
        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
      } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
          if (themingEnabled === true && theme === noopTheme) {
            // TODO: prepend error message/name instead
            console.error(['Material-UI: The `styles` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
          }
        }

        throw err;
      }

      if (!name || !theme.overrides || !theme.overrides[name]) {
        return styles;
      }

      var overrides = theme.overrides[name];

      var stylesWithOverrides = _extends$1({}, styles);

      Object.keys(overrides).forEach(function (key) {
        if (process.env.NODE_ENV !== 'production') {
          if (!stylesWithOverrides[key]) {
            console.warn(['Material-UI: You are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n'));
          }
        }

        stylesWithOverrides[key] = deepmerge(stylesWithOverrides[key], overrides[key]);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}

function getClasses(_ref, classes, Component) {
  var state = _ref.state,
      stylesOptions = _ref.stylesOptions;

  if (stylesOptions.disableGeneration) {
    return classes || {};
  }

  if (!state.cacheClasses) {
    state.cacheClasses = {
      // Cache for the finalized classes value.
      value: null,
      // Cache for the last used classes prop pointer.
      lastProp: null,
      // Cache for the last used rendered classes pointer.
      lastJSS: {}
    };
  } // Tracks if either the rendered classes or classes prop has changed,
  // requiring the generation of a new finalized classes object.


  var generate = false;

  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }

  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }

  if (generate) {
    state.cacheClasses.value = mergeClasses({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component: Component
    });
  }

  return state.cacheClasses.value;
}

function attach(_ref2, props) {
  var state = _ref2.state,
      theme = _ref2.theme,
      stylesOptions = _ref2.stylesOptions,
      stylesCreator = _ref2.stylesCreator,
      name = _ref2.name;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = multiKeyStore.get(stylesOptions.sheetsManager, stylesCreator, theme);

  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    multiKeyStore.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
  }

  var options = _extends$1({}, stylesCreator.options, stylesOptions, {
    theme: theme,
    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
  });

  options.generateId = options.serverGenerateClassName || options.generateClassName;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    var staticSheet;

    if (stylesOptions.sheetsCache) {
      staticSheet = multiKeyStore.get(stylesOptions.sheetsCache, stylesCreator, theme);
    }

    var styles = stylesCreator.create(theme, name);

    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles, _extends$1({
        link: false
      }, options));
      staticSheet.attach();

      if (stylesOptions.sheetsCache) {
        multiKeyStore.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
      }
    }

    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }

    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = getDynamicStyles(styles);
  }

  if (sheetManager.dynamicStyles) {
    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, _extends$1({
      link: true
    }, options));
    dynamicSheet.update(props);
    dynamicSheet.attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = mergeClasses({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });

    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }

  sheetManager.refs += 1;
}

function update(_ref3, props) {
  var state = _ref3.state;

  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}

function detach(_ref4) {
  var state = _ref4.state,
      theme = _ref4.theme,
      stylesOptions = _ref4.stylesOptions,
      stylesCreator = _ref4.stylesCreator;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = multiKeyStore.get(stylesOptions.sheetsManager, stylesCreator, theme);
  sheetManager.refs -= 1;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    multiKeyStore.delete(stylesOptions.sheetsManager, stylesCreator, theme);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }

  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}

function useSynchronousEffect(func, values) {
  var key = React__default.useRef([]);
  var output; // Store "generation" key. Just returns a new object every time

  var currentKey = React__default.useMemo(function () {
    return {};
  }, values); // eslint-disable-line react-hooks/exhaustive-deps
  // "the first render", or "memo dropped the value"

  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }

  React__default.useEffect(function () {
    return function () {
      if (output) {
        output();
      }
    };
  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
  );
}

function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var name = options.name,
      classNamePrefixOption = options.classNamePrefix,
      Component = options.Component,
      _options$defaultTheme = options.defaultTheme,
      defaultTheme = _options$defaultTheme === void 0 ? noopTheme : _options$defaultTheme,
      stylesOptions2 = _objectWithoutProperties$1(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);

  var stylesCreator = getStylesCreator(stylesOrCreator);
  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
  stylesCreator.options = {
    index: increment(),
    name: name,
    meta: classNamePrefix,
    classNamePrefix: classNamePrefix
  };

  var useStyles = function useStyles() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = useTheme() || defaultTheme;

    var stylesOptions = _extends$1({}, React__default.useContext(StylesContext), stylesOptions2);

    var instance = React__default.useRef();
    var shouldUpdate = React__default.useRef();
    useSynchronousEffect(function () {
      var current = {
        name: name,
        state: {},
        stylesCreator: stylesCreator,
        stylesOptions: stylesOptions,
        theme: theme
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return function () {
        detach(current);
      };
    }, [theme, stylesCreator]);
    React__default.useEffect(function () {
      if (shouldUpdate.current) {
        update(instance.current, props);
      }

      shouldUpdate.current = true;
    });
    var classes = getClasses(instance.current, props.classes, Component);

    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      React__default.useDebugValue(classes);
    }

    return classes;
  };

  return useStyles;
}

function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs__default.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs__default.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs__default.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$1(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === 'function') {
    var mergedTheme = localTheme(outerTheme);

    if (process.env.NODE_ENV !== 'production') {
      if (!mergedTheme) {
        console.error(['Material-UI: You should return an object from your theme function, i.e.', '<ThemeProvider theme={() => ({})} />'].join('\n'));
      }
    }

    return mergedTheme;
  }

  return _extends$1({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */


function ThemeProvider(props) {
  var children = props.children,
      localTheme = props.theme;
  var outerTheme = useTheme();

  if (process.env.NODE_ENV !== 'production') {
    if (outerTheme === null && typeof localTheme === 'function') {
      console.error(['Material-UI: You are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
    }
  }

  var theme = React__default.useMemo(function () {
    var output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);

    if (output != null) {
      output[nested] = outerTheme !== null;
    }

    return output;
  }, [localTheme, outerTheme]);
  return /*#__PURE__*/React__default.createElement(ThemeContext$1.Provider, {
    value: theme
  }, children);
}

process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes__default.node.isRequired,

  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes__default.oneOfType([PropTypes__default.object, PropTypes__default.func]).isRequired
} : void 0;

if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = exactProp(ThemeProvider.propTypes) : void 0;
}

// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStyles = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var defaultTheme = options.defaultTheme,
        _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        name = options.name,
        stylesOptions = _objectWithoutProperties$1(options, ["defaultTheme", "withTheme", "name"]);

    if (process.env.NODE_ENV !== 'production') {
      if (Component === undefined) {
        throw new Error(['You are calling withStyles(styles)(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
      }
    }

    var classNamePrefix = name;

    if (process.env.NODE_ENV !== 'production') {
      if (!name) {
        // Provide a better DX outside production.
        var displayName = getDisplayName(Component);

        if (displayName !== undefined) {
          classNamePrefix = displayName;
        }
      }
    }

    var useStyles = makeStyles(stylesOrCreator, _extends$1({
      defaultTheme: defaultTheme,
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var WithStyles = /*#__PURE__*/React__default.forwardRef(function WithStyles(props, ref) {
      var classesProp = props.classes,
          innerRef = props.innerRef,
          other = _objectWithoutProperties$1(props, ["classes", "innerRef"]); // The wrapper receives only user supplied props, which could be a subset of
      // the actual props Component might receive due to merging with defaultProps.
      // So copying it here would give us the same result in the wrapper as well.


      var classes = useStyles(_extends$1({}, Component.defaultProps, props));
      var theme;
      var more = other;

      if (typeof name === 'string' || withTheme) {
        // name and withTheme are invariant in the outer scope
        // eslint-disable-next-line react-hooks/rules-of-hooks
        theme = useTheme() || defaultTheme;

        if (name) {
          more = getThemeProps({
            theme: theme,
            name: name,
            props: other
          });
        } // Provide the theme to the wrapped component.
        // So we don't have to use the `withTheme()` Higher-order Component.


        if (withTheme && !more.theme) {
          more.theme = theme;
        }
      }

      return /*#__PURE__*/React__default.createElement(Component, _extends$1({
        ref: innerRef || ref,
        classes: classes
      }, more));
    });
    process.env.NODE_ENV !== "production" ? WithStyles.propTypes = {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: PropTypes__default.object,

      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: chainPropTypes(PropTypes__default.oneOfType([PropTypes__default.func, PropTypes__default.object]), function (props) {
        if (props.innerRef == null) {
          return null;
        }

        return null; // return new Error(
        //   'Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' +
        //     'Refs are now automatically forwarded to the inner component.',
        // );
      })
    } : void 0;

    if (process.env.NODE_ENV !== 'production') {
      WithStyles.displayName = "WithStyles(".concat(getDisplayName(Component), ")");
    }

    hoistNonReactStatics_cjs(WithStyles, Component);

    if (process.env.NODE_ENV !== 'production') {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
      WithStyles.useStyles = useStyles;
    }

    return WithStyles;
  };
};

var defaultTheme = createMuiTheme();

function useTheme$1() {
  var theme = useTheme() || defaultTheme;

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React__default.useDebugValue(theme);
  }

  return theme;
}

function withStyles$1(stylesOrCreator, options) {
  return withStyles(stylesOrCreator, _extends$1({
    defaultTheme: defaultTheme
  }, options));
}

var theme = createMuiTheme({
  // override MUI theme with sunrun branding colors
  palette: {
    primary: {
      main: SECONDARY_COLOR
    },
    secondary: {
      main: PRIMARY_COLOR
    },
    error: {
      main: ERROR_COLOR
    },
    warning: {
      main: WARNING_COLOR
    },
    info: {
      main: INFO_COLOR
    },
    success: {
      main: SUCCESS_COLOR
    }
  }
});

var DatePickerContainer = function DatePickerContainer(_ref) {
  var onChange = _ref.onChange,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, ["onChange", "value"]);

  return /*#__PURE__*/React__default.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(pickers.MuiPickersUtilsProvider, {
    utils: LuxonUtils
  }, /*#__PURE__*/React__default.createElement(pickers.DatePicker
  /* some standard styles */
  // removes large toolbar in calendar view
  , _extends({
    disableToolbar: true // opens the calendar beneath the input field
    ,
    variant: "inline" // closes the calendar view after selection
    ,
    autoOk: true // fill width of parent container
    ,
    fullWidth: true
    /* required */
    ,
    onChange: onChange,
    value: value
    /* rest (formatting, label and helper text, disableFuture, etc.) */

  }, rest))));
};

DatePickerContainer.propTypes = {
  onChange: PropTypes__default.func.isRequired,
  value: PropTypes__default.oneOfType([PropTypes__default.shape({}), PropTypes__default.string]).isRequired
};

var KeyboardDatePickerContainer = function KeyboardDatePickerContainer(_ref) {
  var onChange = _ref.onChange,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, ["onChange", "value"]);

  return /*#__PURE__*/React__default.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(pickers.MuiPickersUtilsProvider, {
    utils: LuxonUtils
  }, /*#__PURE__*/React__default.createElement(pickers.KeyboardDatePicker
  /* some standard styles */
  // removes large toolbar in calendar view
  , _extends({
    disableToolbar: true // opens the calendar beneath the input field
    ,
    variant: "inline" // closes the calendar view after selection
    ,
    autoOk: true // fill width of parent container
    ,
    fullWidth: true
    /* required */
    ,
    onChange: onChange,
    value: value
    /* rest (formatting, label and helper text, disableFuture, etc.) */

  }, rest))));
};

KeyboardDatePickerContainer.propTypes = {
  onChange: PropTypes__default.func.isRequired,
  value: PropTypes__default.shape({}).isRequired
};

var Check = function Check(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "14",
    height: "11",
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M6.59778 10.1838C6.09614 10.79 5.21826 10.8318 4.65392 10.2674L1.30966 6.98586C0.745311 6.44241 0.703513 5.56454 1.18425 5.0629C1.66499 4.56126 2.54285 4.60307 3.10719 5.14651L4.4658 6.48422C5.03014 7.02766 5.90802 6.98586 6.40966 6.40061L10.9244 1.02888C11.4261 0.422736 12.283 0.297326 12.8265 0.757163C13.3699 1.217 13.3908 2.07397 12.8892 2.68011L6.59778 10.1838Z",
    fill: color
  }));
};

Check.propTypes = {
  color: PropTypes__default.string
};
Check.defaultProps = {
  color: SUCCESS_COLOR
};

var Clear = function Clear(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "13",
    height: "13",
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.3516 11.1754C10.7718 11.7757 9.74695 11.7415 9.09362 11.1105L1.20073 3.48771C0.529748 2.83969 0.477508 1.83367 1.05732 1.23332C1.63713 0.632962 2.66201 0.66721 3.31534 1.29818L11.2082 8.92098C11.8616 9.55196 11.9315 10.575 11.3516 11.1754Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.1755 1.0568C11.7759 1.63661 11.7416 2.6615 11.1106 3.31483L3.48784 11.2077C2.83981 11.8787 1.83379 11.9309 1.23344 11.3511C0.633084 10.7713 0.667332 9.74643 1.2983 9.09311L8.92111 1.20022C9.55208 0.546889 10.5751 0.476992 11.1755 1.0568Z",
    fill: color
  }));
};

Clear.propTypes = {
  color: PropTypes__default.string
};
Clear.defaultProps = {
  color: ERROR_COLOR
};

var svgComponentAsDataUri = function svgComponentAsDataUri(SvgComponent, props) {
  var svgAsString = encodeURIComponent(ReactDOMServer.renderToStaticMarkup( /*#__PURE__*/React__default.createElement(SvgComponent, props)));
  return "data:image/svg+xml,".concat(svgAsString);
};

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  display: inline-block;\n  font-family: 'Nunito';\n  font-weight: normal;\n  font-size: 0.875em;\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledLabel = newStyled.label(_templateObject$2(), function (_ref) {
  var color = _ref.color;
  return "color: ".concat(color, ";");
});

var Label = function Label(_ref2) {
  var htmlFor = _ref2.htmlFor,
      rest = _objectWithoutProperties(_ref2, ["htmlFor"]);

  return /*#__PURE__*/React__default.createElement(StyledLabel, _extends({
    htmlFor: htmlFor
  }, rest));
};

Label.propTypes = {
  /** The ID string of the element which is associated with the label */
  htmlFor: PropTypes__default.string.isRequired,

  /** The text color for the label. Defaults to the dark text color */
  color: PropTypes__default.string
};
Label.defaultProps = {
  color: TEXT_DARK_COLOR
};

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  position: relative;\n  padding-top: 1em;\n\n  & label {\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * Helper functions
 */

var borderColor = function borderColor(_ref) {
  var isSuccessful = _ref.isSuccessful,
      hasError = _ref.hasError;

  if (isSuccessful) {
    return SUCCESS_COLOR;
  }

  if (hasError) {
    return ERROR_COLOR;
  }

  return TEXT_DARK_COLOR;
};

var backgroundImage = function backgroundImage(_ref2) {
  var isSuccessful = _ref2.isSuccessful,
      hasError = _ref2.hasError;

  if (!isSuccessful && !hasError) {
    return '';
  }

  var icon = isSuccessful ? Check : Clear;
  var iconAsUri = svgComponentAsDataUri(icon);
  return "\n    background-image: url(".concat(iconAsUri, ");\n    background-size: 1em 1em;\n    background-repeat: no-repeat;\n    background-position: right center;\n    padding-right: 1em;\n  ");
};

var focusedBorderColor = function focusedBorderColor(_ref3) {
  var hasError = _ref3.hasError,
      isSuccessful = _ref3.isSuccessful;

  if (hasError) {
    return ERROR_COLOR;
  }

  if (isSuccessful) {
    return SUCCESS_COLOR;
  }

  return SECONDARY_COLOR;
};

var focusedLabelColor = function focusedLabelColor(_ref4) {
  var hasError = _ref4.hasError,
      isSuccessful = _ref4.isSuccessful;

  if (hasError) {
    return ERROR_COLOR;
  }

  if (isSuccessful) {
    return TEXT_DARK_COLOR;
  }

  return SECONDARY_COLOR;
};

var labelColor = function labelColor(_ref5) {
  var hasError = _ref5.hasError;

  if (hasError) {
    return ERROR_COLOR;
  }

  return TEXT_DARK_COLOR;
};
/**
 * Container comonent
 */
// Place the label after the textarea in the markup and move it above via CSS
// so that it can be colored based when the textarea receives focus


var Container = newStyled('span')(_templateObject$3());
/**
 * Helper text component
 */

var StyledHelperText = newStyled('span')(_templateObject2(), function (_ref6) {
  var hasError = _ref6.hasError;
  return "\n      color: ".concat(hasError ? ERROR_COLOR : TEXT_DARK_COLOR, ";\n      display: block;\n      font-family: 'Nunito';\n      font-weight: normal;\n      font-size: 0.875em;\n      text-align: left;\n    ");
});
/**
 * react-select specific styles
 */

var customStyles = {
  container: function container(provided) {
    return _objectSpread2(_objectSpread2({}, provided), {}, {
      padding: '4px 0',
      fontFamily: 'Nunito'
    });
  },
  control: function control(provided, state) {
    return _objectSpread2(_objectSpread2({}, provided), {}, {
      borderRadius: '0px',
      borderTop: '0',
      borderLeft: '0',
      borderRight: '0',
      boxShadow: 'none',
      borderColor: borderColor(state.selectProps),
      '&:hover': {
        borderColor: NEUTRAL_COLOR_LEVEL_2
      }
    });
  },
  option: function option(provided, state) {
    return _objectSpread2(_objectSpread2({}, provided), {}, {
      padding: '10px',
      backgroundColor: state.isSelected ? NEUTRAL_COLOR_LEVEL_3 : '#fff',
      '&:hover, &:focus': {
        backgroundColor: NEUTRAL_COLOR_LEVEL_3
      },
      color: '#000000'
    });
  },
  dropdownIndicator: function dropdownIndicator(provided, state) {
    return {
      color: borderColor(state.selectProps)
    };
  },
  indicatorSeparator: function indicatorSeparator() {
    return {
      display: 'none'
    };
  }
};
/**
 * Input, MaskedInput components
 */

var InputStyles = function InputStyles(props) {
  return "\n  box-sizing: border-box;\n  width: 100%;\n  border: none;\n  border-bottom: 1px solid ".concat(borderColor(props), ";\n  padding: .5em 0;\n  font-size: 1em;\n  font-family: 'Nunito';\n  font-weight: bold;\n  color: ").concat(TEXT_DARK_COLOR, ";\n  ").concat(backgroundImage(props), "\n\n  &:focus {\n    outline: none;\n    border-bottom: 1px solid ").concat(focusedBorderColor(props), "\n  }\n\n  &:disabled, &:disabled:focus {\n    color: ").concat(TEXT_NEUTRAL_COLOR, ";\n    border-bottom: 1px solid ").concat(NEUTRAL_COLOR_LEVEL_1, ";\n  }\n\n  &:focus + label {\n    color: ").concat(focusedLabelColor(props), ";\n  }\n");
};

var StyledInput = newStyled('input', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return index(prop);
  }
})(_templateObject3(), function (props) {
  return InputStyles(props);
});
var StyledMaskedInput = newStyled(MaskedInput, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return index(prop);
  }
})(_templateObject4(), function (props) {
  return InputStyles(props);
});

var BaseInput = function BaseInput(props, InputComponent) {
  var label = props.label,
      id = props.id,
      helperText = props.helperText,
      rest = _objectWithoutProperties(props, ["label", "id", "helperText"]);

  var uniqueId = id || uuid.v4();
  var content = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(InputComponent, _extends({
    id: uniqueId
  }, rest)), label && /*#__PURE__*/React__default.createElement(Label, _extends({
    htmlFor: uniqueId,
    color: labelColor(props)
  }, rest), label), helperText && /*#__PURE__*/React__default.createElement(StyledHelperText, rest, helperText));
  return label || helperText ? /*#__PURE__*/React__default.createElement(Container, null, content) : content;
};

var Input = function Input(props) {
  return BaseInput(props, StyledInput);
};

var InputMasked = function InputMasked(props) {
  return BaseInput(props, StyledMaskedInput);
};

var SelectInput = function SelectInput(props) {
  return BaseInput(props, function (selectProps) {
    return /*#__PURE__*/React__default.createElement(Select__default, _extends({
      styles: customStyles
    }, selectProps));
  });
};

BaseInput.propTypes = {
  label: PropTypes__default.string,
  id: PropTypes__default.string,
  helperText: PropTypes__default.string
}; // just added this for documentation in storybook

Input.propTypes = {
  /** Optional prop to override a generated unique ID for each input */
  id: PropTypes__default.string,

  /** Specifies the type of input element to display, e.g. text, email, phone */
  type: PropTypes__default.string,

  /** Specifies the value of an input element.
   * For this component, it defines the initial value of the field
   * */
  value: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),

  /** Show styling to indicate success */
  isSuccessful: PropTypes__default.bool,

  /** Show styling to indicate an error */
  hasError: PropTypes__default.bool,

  /** Label text to go with the input */
  label: PropTypes__default.string,

  /** Helper text displayed below the input */
  helperText: PropTypes__default.string
};
Input.defaultProps = {
  type: 'text',
  value: undefined,
  isSuccessful: false,
  hasError: false,
  label: undefined,
  id: undefined,
  helperText: undefined
}; // NOTE: There's a particularly weird issue with masking US phone numbers.
// Namely, if the mask matches a digit in the string fed into the input, the
// mask will "eat" a character. An example would be a mask of:
// +1 (XXX) XXX-XXXX
// If you input a string of "3125551234", the mask will see the "1" in "312"
// as the country code, and display
// +1 (325) 551-234_
// More details here:
// https://github.com/text-mask/text-mask/issues/689
// just added this for documentation in storybook

InputMasked.propTypes = {
  /** Optional prop to override a generated unique ID for each input */
  id: PropTypes__default.string,

  /** Specifies the type of input element to display */
  type: PropTypes__default.string,

  /** Specifies the value of an input element.
   * For this component, it defines the initial value of the field
   * */
  value: PropTypes__default.string,

  /** Specifies the mask pattern for the input element to display when a user types */
  mask: PropTypes__default.oneOfType([PropTypes__default.func, PropTypes__default.array]),

  /** Show styling to indicate success */
  isSuccessful: PropTypes__default.bool,

  /** Show styling to indicate an error */
  hasError: PropTypes__default.bool,

  /** Label text to go with the input */
  label: PropTypes__default.string,

  /** Helper text displayed below the input */
  helperText: PropTypes__default.string
};
InputMasked.defaultProps = {
  type: 'text',
  value: undefined,
  isSuccessful: false,
  hasError: false,
  label: undefined,
  id: undefined,
  helperText: undefined
};
SelectInput.propTypes = {
  options: PropTypes__default.arrayOf(PropTypes__default.shape({
    value: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
    label: PropTypes__default.string
  }))
};
SelectInput.defaultProps = {
  options: []
};

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n\n  & li {\n    border-top: 1px solid ", ";\n  }\n\n  & li:last-child {\n    border-bottom: 1px solid ", ";\n  }\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledUl = newStyled.ul(_templateObject$4(), NEUTRAL_COLOR_LEVEL_1, NEUTRAL_COLOR_LEVEL_1);

var List = function List(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement(StyledUl, null, children);
};

List.propTypes = {
  children: PropTypes__default.node.isRequired
};

var ChevronRight = function ChevronRight(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "10",
    height: "16",
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M1 1L8 8L1 15",
    stroke: color,
    strokeWidth: "2"
  }));
};

ChevronRight.propTypes = {
  color: PropTypes__default.string
};
ChevronRight.defaultProps = {
  color: TEXT_DARK_COLOR
};

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  text-decoration: none;\n  display: inline;\n  margin: 0;\n  padding: 0;\n\n  font-size: 1em;\n\n  ", "\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}

var commonStyles = function commonStyles() {
  return "\n  color: ".concat(SECONDARY_COLOR, ";\n  font-family: 'Nunito';\n  font-weight: bold;\n  text-decoration: none;\n\n  &:hover {\n    color: ").concat(SECONDARY_COLOR, ";\n    text-decoration: underline;\n  }\n\n  &:focus {\n    color: ").concat(TEXT_DARK_COLOR, ";\n    text-decoration: none;\n  }\n\n  &.disabled, &.disabled:hover, &.disabled:focus {\n    color: ").concat(TEXT_NEUTRAL_COLOR, ";\n    text-decoration: none;\n    pointer-events: none;\n    cursor: default;\n  }\n");
};

var StyledLink = newStyled.a(_templateObject$5(), commonStyles());
var StyledRouterLink = StyledLink.withComponent(reactRouterDom.Link);
var StyledButton$1 = newStyled.button(_templateObject2$1(), commonStyles());
/**
 * Component to generate an anchor tag.
 * If the prop `to` is passed in, it will return a react-router link.
 * If the prop `href` is passed in, it will return a native HTML anchor tag.
 * If anything else is passed in, like an `onClick`, it will return a button.
 * Spread props will be passed through.
 */

var Link = function Link(props) {
  var children = props.children,
      href = props.href,
      to = props.to,
      disabled = props.disabled,
      rest = _objectWithoutProperties(props, ["children", "href", "to", "disabled"]);

  var className = disabled ? 'disabled' : '';

  if (to) {
    return /*#__PURE__*/React__default.createElement(StyledRouterLink, _extends({
      to: to,
      className: className
    }, rest), children);
  }

  if (href) {
    return /*#__PURE__*/React__default.createElement(StyledLink, _extends({
      href: href,
      className: className
    }, rest), children);
  }

  return /*#__PURE__*/React__default.createElement(StyledButton$1, _extends({
    className: className
  }, rest), children);
};

Link.propTypes = {
  /** Display content passed to the link. */
  children: PropTypes__default.node.isRequired,

  /** Specifies the path for the html anchor tag */
  href: PropTypes__default.string,

  /** Specifies the router for the react-router link.
   * Accepts string for the pathname, or object to include passed props, too */
  to: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.object]),

  /** Specifies whether the link is disabled */
  disabled: PropTypes__default.bool
};
Link.defaultProps = {
  href: null,
  to: null,
  disabled: false
};

var useHover = function useHover(element) {
  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var onMouseEnter = function onMouseEnter(originalOnMouseEnter) {
    return function (event) {
      (originalOnMouseEnter || noop)(event);
      setState(true);
    };
  };

  var onMouseLeave = function onMouseLeave(originalOnMouseLeave) {
    return function (event) {
      (originalOnMouseLeave || noop)(event);
      setState(false);
    };
  };

  var elementWithState = typeof element === 'function' ? element(state) : element;
  var el = /*#__PURE__*/React__default.cloneElement(elementWithState, {
    onMouseEnter: onMouseEnter(elementWithState.props.onMouseEnter),
    onMouseLeave: onMouseLeave(elementWithState.props.onMouseLeave)
  });
  return [el, state];
};

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  font-family: 'Nunito';\n  font-weight: ", ";\n  color: ", ";\n  font-size: 1em;\n  display: block;\n  flex-grow: 1;\n  text-align: right;\n  padding-left: 0.5em;\n  padding-right: ", ";;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  font-family: 'Nunito';\n  font-weight: normal;\n  color: ", ";\n  font-size: 1em;\n  display: block;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  font-size: 1.125em;\n  line-height: 1.75em;\n  font-weight: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  padding-right: 1em;\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n  font-family: 'Nunito';\n  font-weight: normal;\n  font-size: 1em;\n  padding: 0.375em 0;\n\n  ", "\n\n  > button {\n    width: 100%;\n  }\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledLi = newStyled.li(_templateObject$6(), function (_ref) {
  var hasLink = _ref.hasLink,
      disabled = _ref.disabled;
  return hasLink ? "cursor: ".concat(disabled ? 'auto' : 'pointer', ";") : '';
});

var contentStyles = function contentStyles(_ref2) {
  var active = _ref2.active,
      disabled = _ref2.disabled,
      hasLink = _ref2.hasLink;
  return "\n  align-items: center;\n  display: flex;\n  padding: 0.75em 1em;\n  text-align: left;\n  text-decoration: none;\n\n  /* Overwrite Link styles */\n  &:hover, &:active, &:focus {\n    color: ".concat(disabled ? TEXT_NEUTRAL_COLOR : TEXT_DARK_COLOR, ";\n    text-decoration: none;\n  }\n  \n  ").concat(hasLink ? "\n      position: relative;\n      color: ".concat(disabled ? TEXT_NEUTRAL_COLOR : TEXT_DARK_COLOR, ";\n      ").concat(disabled ? '' : "\n          &:hover {\n            background-color: ".concat(LIST_HOVER_COLOR, ";\n          }\n      "), "\n      ") : "color: ".concat(TEXT_DARK_COLOR, ";"), "\n\n  ").concat(active ? "background-color: ".concat(NEUTRAL_COLOR_LEVEL_3, ";") : '', "\n  ");
};

var StyledContentContainer = newStyled.span(_templateObject2$2(), function (props) {
  return contentStyles(props);
});
var StyledLink$1 = newStyled(Link, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['active', 'hasLink'].includes(prop);
  }
})(_templateObject3$1(), function (props) {
  return contentStyles(props);
});
var StyledMainTextContainer = newStyled.span(_templateObject4$1());
var StyledPrimaryText = newStyled.span(_templateObject5(), function (_ref3) {
  var active = _ref3.active,
      hovered = _ref3.hovered,
      hasLink = _ref3.hasLink,
      disabled = _ref3.disabled;
  return (active || hovered) && hasLink && !disabled ? 'bold' : 'normal';
});
var StyledSecondaryContent = newStyled.span(_templateObject6(), TEXT_NEUTRAL_COLOR);
var StyledTertiaryContent = newStyled.span(_templateObject7(), function (_ref4) {
  var hasLink = _ref4.hasLink;
  return hasLink ? 'normal' : 'bold';
}, function (_ref5) {
  var hasLink = _ref5.hasLink;
  return hasLink ? TEXT_NEUTRAL_COLOR : TEXT_DARK_COLOR;
}, function (_ref6) {
  var hasLink = _ref6.hasLink;
  return hasLink ? '1em' : '1.6em';
});

var ListItem = function ListItem(_ref7) {
  var active = _ref7.active,
      children = _ref7.children,
      disabled = _ref7.disabled,
      href = _ref7.href,
      onClick = _ref7.onClick,
      secondaryContent = _ref7.secondaryContent,
      tertiaryContent = _ref7.tertiaryContent,
      to = _ref7.to,
      rest = _objectWithoutProperties(_ref7, ["active", "children", "disabled", "href", "onClick", "secondaryContent", "tertiaryContent", "to"]);

  // Don't want to actually pass the onClick handler to tertiaryContent
  var hasLink = typeof onClick !== 'undefined' || typeof href !== 'undefined' || typeof to !== 'undefined';
  var ContentContainer = hasLink ? StyledLink$1 : StyledContentContainer;

  var element = function element(hovered) {
    return /*#__PURE__*/React__default.createElement(StyledLi, {
      hasLink: hasLink,
      disabled: disabled
    }, /*#__PURE__*/React__default.createElement(ContentContainer, _extends({
      active: active,
      disabled: disabled,
      hasLink: hasLink,
      href: href,
      onClick: disabled ? undefined : onClick,
      to: to
    }, rest), /*#__PURE__*/React__default.createElement(StyledMainTextContainer, {
      active: active,
      hovered: hovered
    }, /*#__PURE__*/React__default.createElement(StyledPrimaryText, {
      hovered: hovered,
      active: active,
      hasLink: hasLink,
      disabled: disabled
    }, children), secondaryContent && /*#__PURE__*/React__default.createElement(StyledSecondaryContent, null, secondaryContent)), tertiaryContent && /*#__PURE__*/React__default.createElement(StyledTertiaryContent, {
      hasLink: hasLink
    }, tertiaryContent), hasLink && /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(ChevronRight, {
      color: TEXT_DARK_COLOR
    }))));
  };

  var _useHover = useHover(element),
      _useHover2 = _slicedToArray(_useHover, 1),
      hoverable = _useHover2[0];

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, hoverable);
};

ListItem.propTypes = {
  active: PropTypes__default.bool,
  children: PropTypes__default.node.isRequired,
  disabled: PropTypes__default.bool,
  href: PropTypes__default.string,
  onClick: PropTypes__default.func,
  secondaryContent: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.node]),
  tertiaryContent: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.node]),
  to: PropTypes__default.string
};
ListItem.defaultProps = {
  active: false,
  disabled: false,
  href: undefined,
  onClick: undefined,
  secondaryContent: undefined,
  tertiaryContent: undefined,
  to: undefined
};

function _templateObject$7() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  font-family: 'Untitled Sans';  \n  color: ", ";\n  display: inline-block;\n  max-width: 20em;\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledContainer = newStyled.div(_templateObject$7(), DEFAULT_TEXT_COLOR);
/** An input with an associated label */

var InputGroup = function InputGroup(_ref) {
  var label = _ref.label,
      rest = _objectWithoutProperties(_ref, ["label"]);

  var id = uuid.v4();
  return /*#__PURE__*/React__default.createElement(StyledContainer, null, label && /*#__PURE__*/React__default.createElement(Label, {
    htmlFor: id
  }, label), /*#__PURE__*/React__default.createElement(Input, _extends({
    id: id
  }, rest)));
};

InputGroup.propTypes = {
  /** Specifies the label for the input */
  label: PropTypes__default.string
};
InputGroup.defaultProps = {
  label: null
};

var CheckmarkCircle = function CheckmarkCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    r: "11",
    cx: "11.5",
    cy: "11.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9918 11.4957C22.9918 17.8447 17.8449 22.9916 11.4959 22.9916C5.14689 22.9916 0 17.8447 0 11.4957C0 5.14665 5.14689 -0.000244141 11.4959 -0.000244141C17.8449 -0.000244141 22.9918 5.14665 22.9918 11.4957ZM9.65396 16.2672C10.2183 16.8316 11.0962 16.7897 11.5978 16.1836L17.8892 8.67991C18.3909 8.07376 18.3699 7.21679 17.8265 6.75695C17.2831 6.29712 16.4261 6.42253 15.9245 7.02868L11.4097 12.4004C10.9081 12.9856 10.0302 13.0275 9.46584 12.484L8.10724 11.1463C7.54289 10.6029 6.66503 10.5611 6.18429 11.0627C5.70356 11.5643 5.74535 12.4422 6.3097 12.9856L9.65396 16.2672Z",
    fill: backgroundColor
  }));
};

CheckmarkCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
CheckmarkCircle.defaultProps = {
  backgroundColor: PRIMARY_COLOR,
  color: WHITE_COLOR
};

var ExclamationmarkCircle = function ExclamationmarkCircle(_ref) {
  var color = _ref.color,
      backgroundColor = _ref.backgroundColor,
      props = _objectWithoutProperties(_ref, ["color", "backgroundColor"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("rect", {
    x: "7",
    y: "3",
    width: "6",
    height: "14",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 20C15.7467 20 20 15.7467 20 10.5C20 5.25329 15.7467 1 10.5 1C5.25329 1 1 5.25329 1 10.5C1 15.7467 5.25329 20 10.5 20ZM11.7391 11.7192C11.7391 12.1837 11.3138 12.5652 10.8144 12.5652H10.1856C9.66775 12.5652 9.26087 12.1837 9.26087 11.7192V5.13375C9.26087 4.66929 9.68624 4.30435 10.1856 4.30435H10.8144C11.3323 4.30435 11.7391 4.68587 11.7391 5.13375V11.7192ZM10.5 16.6957C11.1844 16.6957 11.7391 16.1409 11.7391 15.4565C11.7391 14.7722 11.1844 14.2174 10.5 14.2174C9.81565 14.2174 9.26087 14.7722 9.26087 15.4565C9.26087 16.1409 9.81565 16.6957 10.5 16.6957Z",
    fill: backgroundColor
  }));
};

ExclamationmarkCircle.propTypes = {
  color: PropTypes__default.string,
  backgroundColor: PropTypes__default.string
};
ExclamationmarkCircle.defaultProps = {
  color: WHITE_COLOR,
  backgroundColor: WARNING_COLOR
};

function _templateObject4$2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 12px;\n  height: 12px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  ", ";\n\n  @keyframes ball-spin-fade-loader {\n    50% {\n      opacity: 0.3;\n      transform: scale(0.3);\n    }\n    100% {\n      opacity: 1;\n      transform: scale(1);\n    }\n  }\n"]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteral(["\n  top: ", ";\n  left: ", ";\n  animation: ball-spin-fade-loader 1s ", " infinite linear;\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$3() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: 0px;\n  margin: auto;\n\n  div {\n    ", "\n  }\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$8() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}

var dotColor = function dotColor(props) {
  return css(_templateObject$8(), props.spinnerColor);
};

var SpinnerContainer = newStyled.div(_templateObject2$3(), dotColor);

var dotFade = function dotFade(props) {
  return css(_templateObject3$2(), props.top, props.left, props.delay);
};

var SpinnerDot = newStyled.div(_templateObject4$2(), dotFade);

var Spinner = function Spinner(_ref) {
  var spinnerColor = _ref.spinnerColor;
  return /*#__PURE__*/React__default.createElement(SpinnerContainer, {
    spinnerColor: spinnerColor
  }, /*#__PURE__*/React__default.createElement(SpinnerDot, {
    top: "25px",
    left: "0",
    delay: "-0.96s"
  }), /*#__PURE__*/React__default.createElement(SpinnerDot, {
    top: "17px",
    left: "17px",
    delay: "-0.84s"
  }), /*#__PURE__*/React__default.createElement(SpinnerDot, {
    top: "0",
    left: "25px",
    delay: "-0.72s"
  }), /*#__PURE__*/React__default.createElement(SpinnerDot, {
    top: "-17px",
    left: "17px",
    delay: "-0.6s"
  }), /*#__PURE__*/React__default.createElement(SpinnerDot, {
    top: "-25px",
    left: "0",
    delay: "-0.48s"
  }), /*#__PURE__*/React__default.createElement(SpinnerDot, {
    top: "-17px",
    left: "-17px",
    delay: "-0.36s"
  }), /*#__PURE__*/React__default.createElement(SpinnerDot, {
    top: "0",
    left: "-25px",
    delay: "-0.24s"
  }), /*#__PURE__*/React__default.createElement(SpinnerDot, {
    top: "17px",
    left: "-17px",
    delay: "-0.12s"
  }));
};

Spinner.propTypes = {
  /** Color of dots in spinner */
  spinnerColor: PropTypes__default.string
};
Spinner.defaultProps = {
  spinnerColor: '#000'
};

var Sunglasses = function Sunglasses() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "150",
    height: "52",
    fill: "none"
  }, /*#__PURE__*/React__default.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "#0087FF",
    d: "M146.481 1.85149C144.807 1.63433 143.12 1.41717 141.434 1.23444C139.933 1.07431 138.431 0.937131 136.928 0.822904C135.276 0.685723 133.637 0.571499 131.985 0.457092C131.027 0.388591 130.067 0.342861 129.109 0.308611C126.07 0.182907 123.033 0.0572037 119.995 0.0342506C119.902 0.0342506 119.81 0.0114765 119.717 0C116.679 0 113.63 0 110.592 0C109.98 0.0572033 109.356 0.114226 108.744 0.159952C107.346 0.274359 105.948 0.445788 104.551 0.628516C101.929 0.982854 99.3179 1.41717 96.7189 1.97719C93.9695 2.57164 91.232 3.26884 88.6098 4.33167C87.755 4.67453 86.9464 5.09737 86.1378 5.54317C84.1511 6.61748 82.0372 7.24618 79.7962 7.39465C76.9545 7.58904 74.1131 7.55478 71.2714 7.49758C69.839 7.4748 68.395 7.40612 66.9859 7.08604C65.6112 6.7776 64.2828 6.33182 63.0583 5.63462C60.8751 4.38888 58.5419 3.57727 56.1391 2.9258C52.8585 2.02292 49.5204 1.3944 46.1705 0.880104C44.1144 0.571493 42.0466 0.320085 39.9789 0.125702C39.4707 0.079975 38.9509 0.0457268 38.4311 0C35.3932 0 32.3436 0 29.3056 0C29.19 0.0114765 29.0861 0.0342506 28.9707 0.0342506C26.8798 0.0227741 24.789 0.102932 22.7098 0.182909C20.1916 0.274363 17.6735 0.411539 15.1554 0.571493C13.0992 0.708674 11.0315 0.880105 8.97533 1.08579C6.30707 1.34867 3.65025 1.65728 1.00489 2.08012C0.669925 2.13732 0.323514 2.14862 0 2.25155C0 2.69734 0 3.15443 0 3.60023C0.0347141 4.12599 0.0692471 4.65176 0.0923293 5.16605C0.161758 6.89184 0.242638 8.61761 0.288802 10.3434C0.300252 10.9378 0.438924 11.292 1.05124 11.5549C3.30366 12.515 4.49339 14.4009 4.94395 16.8009C5.35979 19.0182 5.70639 21.2583 6.13368 23.4756C7.00008 27.9902 8.05132 32.459 9.66834 36.7679C10.4077 38.7336 11.2855 40.6195 12.3599 42.4138C13.85 44.9055 15.9407 46.7227 18.2856 48.2656C21.0811 50.1058 24.1421 51.1801 27.4111 51.6716C29.3865 51.9688 31.3732 52.0373 33.3485 51.9688C38.3618 51.8086 43.2942 51.0659 48.0649 49.3971C50.9527 48.38 53.6788 47.0313 56.093 45.0655C57.5946 43.8425 58.7959 42.3568 59.9395 40.8023C63.324 36.1964 65.9461 31.1676 67.7137 25.6701C68.2796 23.9214 68.6955 22.1269 69.0651 20.3212C69.4694 18.344 70.4628 16.7781 72.3803 16.1037C74.4595 15.361 76.4694 15.5437 78.2137 17.0753C79.2417 17.9782 79.7269 19.2011 79.981 20.5383C81.0784 26.2759 83.2616 31.5676 86.2187 36.5393C87.4086 38.5394 88.7484 40.4366 90.1808 42.2654C92.0174 44.6084 94.3161 46.3341 96.9037 47.6713C99.8955 49.2142 103.072 50.2085 106.341 50.8944C108.432 51.3288 110.534 51.6144 112.66 51.8086C114.508 51.9688 116.356 52.0373 118.204 51.9801C121.762 51.8658 125.216 51.2144 128.45 49.58C130.796 48.4028 132.944 46.9169 134.756 44.9625C136.109 43.5111 137.103 41.8081 137.968 40.0138C139.562 36.7222 140.625 33.2362 141.516 29.6932C142.508 25.7729 143.235 21.7841 143.882 17.7839C144.056 16.6982 144.298 15.6351 144.76 14.6408C145.5 13.0865 146.69 12.0579 148.215 11.4179C148.538 11.2807 148.687 11.1206 148.687 10.7549C148.687 10.1607 148.746 9.55493 148.769 8.96048C148.838 7.26895 148.907 5.57741 148.965 3.88588C148.965 3.79443 148.989 3.69168 149 3.60023C149 3.15443 149 2.69734 149 2.25155C148.18 2.06864 147.324 1.9659 146.481 1.85149Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#000",
    d: "M52.3936 9.19478C47.9087 8.02682 47.145 8.04594 44.4885 7.66021 42.8579 7.42863 41.2183 7.24012 39.5786 7.09434 39.1757 7.05998 38.7634 7.03436 38.3512 7 35.9421 7 33.5238 7 31.1148 7 31.0232 7.00854 30.9407 7.02563 30.8491 7.02563 29.1912 7.01709 27.5332 7.07707 25.8844 7.13724 23.8874 7.20577 21.8906 7.30865 19.8935 7.42862 18.2632 7.53151 19.2278 7.28396 14.993 7.81436 10.758 8.34494 10.2576 11.8499 11.796 19.6024 12.1259 21.2657 12.4006 22.9458 12.7395 24.6091 13.4266 27.9954 14.26 31.3476 15.5425 34.5795 16.1288 36.0541 16.825 37.4687 17.6769 38.8146 18.8584 40.6836 20.5165 42.0467 22.376 43.2041 24.5928 44.5844 27.0202 45.3902 29.6125 45.7588 31.1789 45.9817 32.7545 46.0331 34.3207 45.9817 38.2963 45.8617 42.2077 45.3044 45.9908 44.0528 53.0073 41.7151 56.9529 36.1574 60.1385 29.8914 63.9546 22.3853 62.155 11.7367 52.3936 9.19478zM97.4179 9.19478C101.815 8.02682 102.564 8.04594 105.168 7.66021 106.767 7.42863 108.374 7.24012 109.982 7.09434 110.377 7.05998 110.781 7.03436 111.185 7 113.547 7 115.918 7 118.279 7 118.369 7.00854 118.45 7.02563 118.54 7.02563 120.165 7.01709 121.791 7.07707 123.407 7.13724 125.366 7.20577 127.323 7.30865 129.28 7.42862 130.878 7.53151 129.934 7.28396 134.085 7.81436 138.237 8.34494 138.728 11.8499 137.219 19.6024 136.896 21.2657 136.626 22.9458 136.294 24.6091 135.621 27.9954 134.803 31.3476 133.546 34.5795 132.971 36.0541 132.289 37.4687 131.453 38.8146 130.296 40.6836 128.669 42.0467 126.846 43.2041 124.673 44.5844 122.294 45.3902 119.752 45.7588 118.217 45.9817 116.672 46.0331 115.136 45.9817 111.239 45.8617 107.404 45.3044 103.695 44.0528 96.8163 41.7151 92.9481 36.1574 89.825 29.8914 86.0837 22.3853 87.848 11.7367 97.4179 9.19478z"
  })), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "#fff",
    d: "M0 0H150V150H0z",
    transform: "translate(0 -33)"
  }))));
};

function _templateObject3$3() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 1;\n  top: ", "%;\n  animation: drop 500ms linear;\n  transition-timing-function: cubic-bezier(0.310, 0.440, 0.445, 1.650);\n  \n  @keyframes drop {\n    0%   { opacity: 0; top: -50%}\n    100%  { opacity: 1; top: ", "%}\n  }\n\n  svg {\n    position: absolute;\n    left: 50%;\n    transform: translate(-50%) scale(calc(", " * 7 / 100));\n  }\n"]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin: -", "em;\n  width: ", "em;\n  height: ", "em;\n  transform:\n    rotate(", "deg)\n    translate(", "em)\n    rotate(-", "deg);\n\n  &:after {\n    content: '';\n    position: absolute;\n    left: 25%;\n    width: ", "em;\n    height: 100%;\n    transform: rotate(calc(", "deg + 90deg));\n    border-radius: ", "em;\n    ", "\n\n    @keyframes rayOfSunshine {\n      0%   { opacity: 0.25; background-color: white; }\n      50%  { opacity: 1; background-color: ", "; }\n    }\n  }\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$9() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: ", "em;\n  height: ", "em;\n  border-radius: 50%;\n  padding: 0;\n  list-style: none;\n  margin: 50px auto;\n  background-color: ", ";\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}
var Sun = newStyled.div(_templateObject$9(), function (props) {
  return props.sunSize * (2 / 3);
}, function (props) {
  return props.sunSize * (2 / 3);
}, SUN_BACKGROUND);
var Ray = newStyled.div(_templateObject2$4(), function (props) {
  return props.raySize / 2;
}, function (props) {
  return props.raySize;
}, function (props) {
  return props.raySize;
}, function (props) {
  return props.rotate;
}, function (props) {
  return props.sunSize / 2;
}, function (props) {
  return props.rotate;
}, function (props) {
  return props.raySize / 2;
}, function (props) {
  return props.rotate;
}, function (props) {
  return props.raySize;
}, function (props) {
  var animationState;

  if (!props.sunglasses) {
    animationState = {
      animation: "rayOfSunshine 2s ".concat(props.delay * 2, "s steps(1) infinite")
    };
  } else {
    animationState = {
      opacity: 1,
      backgroundColor: SUN_BACKGROUND
    };
  }

  return animationState;
}, SUN_BACKGROUND);
var StyledSunglasses = newStyled.div(_templateObject3$3(), function (props) {
  return props.sunSize * 2;
}, function (props) {
  return props.sunSize * 2;
}, function (props) {
  return props.sunSize;
});

var SunSpinner = function SunSpinner(_ref) {
  var sunSize = _ref.sunSize,
      raySize = _ref.raySize,
      sunglasses = _ref.sunglasses;
  return /*#__PURE__*/React__default.createElement(Sun, {
    sunSize: sunSize,
    sunglasses: true
  }, sunglasses && /*#__PURE__*/React__default.createElement(StyledSunglasses, {
    sunSize: sunSize
  }, /*#__PURE__*/React__default.createElement(Sunglasses, null)), /*#__PURE__*/React__default.createElement(Ray, {
    rotate: "0",
    sunSize: sunSize,
    raySize: raySize,
    delay: "-0.96",
    sunglasses: sunglasses
  }), /*#__PURE__*/React__default.createElement(Ray, {
    rotate: "45",
    sunSize: sunSize,
    raySize: raySize,
    delay: "-0.84",
    sunglasses: sunglasses
  }), /*#__PURE__*/React__default.createElement(Ray, {
    rotate: "90",
    sunSize: sunSize,
    raySize: raySize,
    delay: "-0.72",
    sunglasses: sunglasses
  }), /*#__PURE__*/React__default.createElement(Ray, {
    rotate: "135",
    sunSize: sunSize,
    raySize: raySize,
    delay: "-0.6",
    sunglasses: sunglasses
  }), /*#__PURE__*/React__default.createElement(Ray, {
    rotate: "180",
    sunSize: sunSize,
    raySize: raySize,
    delay: "-0.48",
    sunglasses: sunglasses
  }), /*#__PURE__*/React__default.createElement(Ray, {
    rotate: "225",
    sunSize: sunSize,
    raySize: raySize,
    delay: "-0.36",
    sunglasses: sunglasses
  }), /*#__PURE__*/React__default.createElement(Ray, {
    rotate: "270",
    sunSize: sunSize,
    raySize: raySize,
    delay: "-0.24",
    sunglasses: sunglasses
  }), /*#__PURE__*/React__default.createElement(Ray, {
    rotate: "315",
    sunSize: sunSize,
    raySize: raySize,
    delay: "-0.12",
    sunglasses: sunglasses
  }));
};

SunSpinner.propTypes = {
  /** Size of the spinner */
  sunSize: PropTypes__default.string,

  /** Size of the ray */
  raySize: PropTypes__default.string,

  /** Add sunglasses and stop loading animation, usually on a success state */
  sunglasses: PropTypes__default.bool
};
SunSpinner.defaultProps = {
  sunSize: '10',
  raySize: '1.5',
  sunglasses: false
};

function _templateObject5$1() {
  var data = _taggedTemplateLiteral(["\n  margin: 10px auto 0 auto;\n  font-family: 'Untitled Sans';\n  font-size: 12px;\n  max-width: 300px;\n  color: ", ";\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$3() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  font-family: 'Nunito';\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 16px;\n  text-transform: uppercase;\n  ", "\n"]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$4() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 5px;\n  font-size: 0; // removes invisible bottom margin on svg, centering it with main copy\n\n  svg {\n    height: 20px;\n    width: 20px;\n  }\n\n  div {\n    height: 20px;\n    width: 20px;\n    transform: scale(0.3);\n    margin-right: 8px;\n  }\n"]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$5() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  padding: 5px 10px;\n  border-radius: 20px;\n  background-color: ", ";\n\n  > div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$a() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}
var Container$1 = newStyled.div(_templateObject$a());
var StyledBadge = newStyled.div(_templateObject2$5(), function (props) {
  return props.backgroundColor;
});
var Icon = newStyled.div(_templateObject3$4());

var changeColorBasedOnType = function changeColorBasedOnType(type) {
  switch (type) {
    case 'success':
      return PRIMARY_COLOR;

    case 'warning':
      return WARNING_COLOR;

    case 'error':
      return ERROR_COLOR;

    case 'loading':
      return TEXT_NEUTRAL_COLOR;

    default:
      return SECONDARY_COLOR;
  }
};

var MainCopy = newStyled.p(_templateObject4$3(), function (_ref) {
  var color = _ref.color;
  return "color: ".concat(color, ";");
});
var SmallCopy = newStyled.div(_templateObject5$1(), function (props) {
  return props.smallTextColor ? props.smallTextColor : TEXT_NEUTRAL_COLOR;
});

var displayIcon = function displayIcon(type, icon) {
  switch (type) {
    case 'success':
      return /*#__PURE__*/React__default.createElement(CheckmarkCircle, {
        backgroundColor: PRIMARY_COLOR
      });

    case 'warning':
      return /*#__PURE__*/React__default.createElement(ExclamationmarkCircle, {
        backgroundColor: WARNING_COLOR
      });

    case 'error':
      return /*#__PURE__*/React__default.createElement(ExclamationmarkCircle, {
        backgroundColor: ERROR_COLOR
      });

    case 'loading':
      return /*#__PURE__*/React__default.createElement(Spinner, null);

    default:
      return icon;
  }
};

var Badge = function Badge(_ref2) {
  var type = _ref2.type,
      copy = _ref2.copy,
      children = _ref2.children,
      backgroundColor = _ref2.backgroundColor,
      icon = _ref2.icon,
      smallTextColor = _ref2.smallTextColor;
  return /*#__PURE__*/React__default.createElement(Container$1, null, /*#__PURE__*/React__default.createElement(StyledBadge, {
    backgroundColor: backgroundColor
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Icon, null, displayIcon(type, icon)), /*#__PURE__*/React__default.createElement(MainCopy, {
    color: changeColorBasedOnType(type)
  }, copy))), children && /*#__PURE__*/React__default.createElement(SmallCopy, {
    smallTextColor: smallTextColor
  }, children));
};

Badge.propTypes = {
  /** The type of the badge determines the color and icon */
  type: PropTypes__default.oneOf(['success', 'warning', 'error', 'loading', 'default']).isRequired,

  /** The content displayed inside the badge */
  copy: PropTypes__default.string.isRequired,

  /** The content in small font size displayed below the badge */
  children: PropTypes__default.node,

  /** The backgroud color for the badge */
  backgroundColor: PropTypes__default.string,

  /** The icon displayed inside the badge. Will display only if the type is default */
  icon: PropTypes__default.node,
  smallTextColor: PropTypes__default.string
};
Badge.defaultProps = {
  children: '',
  backgroundColor: '#fff',
  icon: '',
  smallTextColor: TEXT_NEUTRAL_COLOR
};

function _templateObject$b() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n  -webkit-overflow-scrolling: touch;\n\n  & > div {\n    flex-shrink: 0;\n    margin-left: 0.25em;\n    margin-right: 0.25em;\n  }\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}
var StyledHorizontalScrollingGroup = newStyled.div(_templateObject$b());

var HorizontalScrollingGroup = function HorizontalScrollingGroup(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React__default.createElement(StyledHorizontalScrollingGroup, props, children);
};

HorizontalScrollingGroup.propTypes = {
  children: PropTypes__default.node.isRequired
};

function _templateObject4$4() {
  var data = _taggedTemplateLiteral(["\n  vertical-align: middle;\n  line-height: 1.5em;\n  flex-grow: 1;\n"]);

  _templateObject4$4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$5() {
  var data = _taggedTemplateLiteral(["\n  vertical-align: middle;\n  margin-right: 0.5em;\n  position: relative;\n  display: inline-block;\n  height: 1.75em;\n  border-radius: 6px;\n  &:before {\n    content: \"\";\n    display: inline-block;\n    height: 1.75em;\n    width: 1.75em;\n    border: 2px solid ", ";\n    box-sizing: border-box;\n    border-radius: 6px;\n  }\n"]);

  _templateObject3$5 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$6() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: -9999px;\n\n  &:checked + span:before {\n    border: 2px solid ", ";\n    background: ", ";\n  }\n\n  &:disabled + span:before {\n    border: 2px solid ", ";\n  }\n\n  &:checked + span:after {\n    content: \"\";\n    display: inline-block;\n    height: 0.7em;\n    width: 0.9em;\n    background-image: url(", ");\n    background-size: cover;\n    position: absolute;\n    top: calc(50% - 0.35em);\n    left: calc(50% - 0.45em);\n    box-sizing: border-box;\n  }\n\n  &:checked:disabled + span:after {\n    background-image: url(", ");\n  }\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$c() {
  var data = _taggedTemplateLiteral(["\n  label {\n    display: flex;\n  }\n\n  input:not(:disabled) ~ span {\n    cursor: pointer;\n  }\n\n  &:hover input:not(:disabled):not(:checked) + span:before {\n    border: 2px solid ", ";\n  }\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}
var StyledContainer$1 = newStyled.div(_templateObject$c(), function (_ref) {
  var boxBackgroundColor = _ref.boxBackgroundColor;
  return boxBackgroundColor || PRIMARY_COLOR;
});

var getBoxBackgroundColor = function getBoxBackgroundColor(_ref2) {
  var checkColor = _ref2.checkColor;
  return {
    color: checkColor || PRIMARY_COLOR
  };
};

var StyledCheckbox = newStyled.input(_templateObject2$6(), function (_ref3) {
  var boxBackgroundColor = _ref3.boxBackgroundColor;
  return boxBackgroundColor || PRIMARY_COLOR;
}, function (_ref4) {
  var boxBackgroundColor = _ref4.boxBackgroundColor;
  return boxBackgroundColor || 'none';
}, NEUTRAL_COLOR_LEVEL_2, function (props) {
  return svgComponentAsDataUri(Check, getBoxBackgroundColor(props));
}, svgComponentAsDataUri(Check, {
  color: NEUTRAL_COLOR_LEVEL_2
}));
var FakeCheckbox = newStyled.span(_templateObject3$5(), function (_ref5) {
  var boxBackgroundColor = _ref5.boxBackgroundColor;
  return boxBackgroundColor || NEUTRAL_COLOR_LEVEL_1;
}); // Smaller line height bumps the text up enough to appear vertically centered

var StyledLabelText = newStyled.span(_templateObject4$4());

var Checkbox = function Checkbox(_ref6) {
  var id = _ref6.id,
      label = _ref6.label,
      labelStyles = _ref6.labelStyles,
      boxBackgroundColor = _ref6.boxBackgroundColor,
      checkColor = _ref6.checkColor,
      rest = _objectWithoutProperties(_ref6, ["id", "label", "labelStyles", "boxBackgroundColor", "checkColor"]);

  var htmlId = id || uuid.v4();
  return /*#__PURE__*/React__default.createElement(StyledContainer$1, {
    boxBackgroundColor: boxBackgroundColor
  }, /*#__PURE__*/React__default.createElement(Label, {
    htmlFor: htmlId
  }, /*#__PURE__*/React__default.createElement(StyledCheckbox, _extends({
    type: "checkbox",
    id: htmlId,
    boxBackgroundColor: boxBackgroundColor,
    checkColor: checkColor
  }, rest)), /*#__PURE__*/React__default.createElement(FakeCheckbox, {
    boxBackgroundColor: boxBackgroundColor
  }), /*#__PURE__*/React__default.createElement(StyledLabelText, {
    style: labelStyles
  }, label)));
};

Checkbox.propTypes = {
  /** The ID string of the element which is associated with the label */
  // htmlFor: PropTypes.string.isRequired,

  /** The text color for the label. Defaults to the dark text color */
  // color: PropTypes.string,

  /** Text to display after the checkbox */
  label: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.node]),
  labelStyles: PropTypes__default.shape({}),

  /** An optional id for the checkbox. If not supplied, a UUID is generated internally */
  id: PropTypes__default.string,
  boxBackgroundColor: PropTypes__default.string,
  checkColor: PropTypes__default.string
};
Label.defaultProps = {
  color: TEXT_DARK_COLOR,
  boxBackgroundColor: null,
  checkColor: null,
  labelStyles: {}
};

function makeCancelable(promise) {
  var isCanceled = false;
  var wrappedPromise = new Promise(function (resolve, reject) {
    promise.then(function (val) {
      return isCanceled ? reject(new Error('PromiseCanceled')) : resolve(val);
    })["catch"](function (error) {
      return isCanceled ? reject(new Error('PromiseCanceled')) : reject(error);
    });
  });
  return {
    promise: wrappedPromise,
    cancel: function cancel() {
      isCanceled = true;
    }
  };
}
function useCancelablePromise() {
  var cancelable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : makeCancelable;
  var emptyPromise = Promise.resolve(true); // test if the input argument is a cancelable promise generator

  if (cancelable(emptyPromise).cancel === undefined) {
    throw new Error('promise wrapper argument must provide a cancel() function');
  }

  var promises = React.useRef();
  React.useEffect(function () {
    promises.current = promises.current || [];
    return function cancel() {
      promises.current.forEach(function (p) {
        return p.cancel();
      });
      promises.current = [];
    };
  }, []);

  function cancelablePromise(p) {
    var cPromise = cancelable(p);
    promises.current.push(cPromise);
    return cPromise.promise;
  }

  return {
    cancelablePromise: cancelablePromise
  };
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var interopRequireDefault = createCommonjsModule(function (module) {
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
});

unwrapExports(interopRequireDefault);

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty$1.call(object, key);
}

var _baseHas = baseHas;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

var isArray_1 = isArray;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$1.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$1.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$2.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$2.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag);
}

var isSymbol_1 = isSymbol;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray_1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol_1(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];

var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$3 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$3).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$1;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$4.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$4.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$5.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$5.call(data, key);
}

var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

var _Hash = Hash;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

var _ListCache = ListCache;

/* Built-in method references that are verified to be native. */
var Map$1 = _getNative(_root, 'Map');

var _Map = Map$1;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

var _MapCache = MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$3(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$3.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize$3.Cache = _MapCache;

var memoize_1 = memoize$3;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize_1(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

var _baseToString = baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray_1(value)) {
    return value;
  }
  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
}

var _castPath = castPath;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return isObjectLike_1(value) && hasOwnProperty$6.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

var isArguments_1 = isArguments;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

var isLength_1 = isLength;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol_1(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _toKey = toKey;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = _castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = _toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength_1(length) && _isIndex(key, length) &&
    (isArray_1(object) || isArguments_1(object));
}

var _hasPath = hasPath;

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && _hasPath(object, path, _baseHas);
}

var has_1 = has;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

var _stackClear = stackClear;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

var _Stack = Stack;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach;

var defineProperty$2 = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty$3 = defineProperty$2;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty$3) {
    _defineProperty$3(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$7.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$7.call(object, key) && eq_1(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

var _assignValue = assignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse_1;

module.exports = isBuffer;
});

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) &&
    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

var isTypedArray_1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$8.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$8.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$9;

  return value === proto;
}

var _isPrototype = isPrototype;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$a.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$9.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$1(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

var keys_1 = keys$1;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && _copyObject(source, keys_1(source), object);
}

var _baseAssign = baseAssign;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn;

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$b.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject_1(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$a.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

var keysIn_1 = keysIn;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && _copyObject(source, keysIn_1(source), object);
}

var _baseAssignIn = baseAssignIn;

var _cloneBuffer = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
});

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

var stubArray_1 = stubArray;

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$c.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray_1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};

var _getSymbols = getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return _copyObject(source, _getSymbols(source), object);
}

var _copySymbols = copySymbols;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush;

/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols$1 ? stubArray_1 : function(object) {
  var result = [];
  while (object) {
    _arrayPush(result, _getSymbols(object));
    object = _getPrototype(object);
  }
  return result;
};

var _getSymbolsIn = getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return _copyObject(source, _getSymbolsIn(source), object);
}

var _copySymbolsIn = copySymbolsIn;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, keys_1, _getSymbols);
}

var _getAllKeys = getAllKeys;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return _baseGetAllKeys(object, keysIn_1, _getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn;

/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root, 'DataView');

var _DataView = DataView;

/* Built-in method references that are verified to be native. */
var Promise$1 = _getNative(_root, 'Promise');

var _Promise = Promise$1;

/* Built-in method references that are verified to be native. */
var Set$1 = _getNative(_root, 'Set');

var _Set = Set$1;

/* Built-in method references that are verified to be native. */
var WeakMap$1 = _getNative(_root, 'WeakMap');

var _WeakMap = WeakMap$1;

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$1 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$1 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$1) ||
    (_Map && getTag(new _Map) != mapTag$1) ||
    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag(new _Set) != setTag$1) ||
    (_WeakMap && getTag(new _WeakMap) != weakMapTag$1)) {
  getTag = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$1;
        case mapCtorString: return mapTag$1;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$1;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var _getTag = getTag;

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$d.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$b.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var _initCloneArray = initCloneArray;

/** Built-in value references. */
var Uint8Array = _root.Uint8Array;

var _Uint8Array = Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$1 = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return _cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$2:
      return _cloneDataView(object, isDeep);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return _cloneTypedArray(object, isDeep);

    case mapTag$2:
      return new Ctor;

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return _cloneRegExp(object);

    case setTag$2:
      return new Ctor;

    case symbolTag$1:
      return _cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject_1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !_isPrototype(object))
    ? _baseCreate(_getPrototype(object))
    : {};
}

var _initCloneObject = initCloneObject;

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike_1(value) && _getTag(value) == mapTag$3;
}

var _baseIsMap = baseIsMap;

/* Node.js helper references. */
var nodeIsMap = _nodeUtil && _nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? _baseUnary(nodeIsMap) : _baseIsMap;

var isMap_1 = isMap;

/** `Object#toString` result references. */
var setTag$3 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike_1(value) && _getTag(value) == setTag$3;
}

var _baseIsSet = baseIsSet;

/* Node.js helper references. */
var nodeIsSet = _nodeUtil && _nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? _baseUnary(nodeIsSet) : _baseIsSet;

var isSet_1 = isSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    mapTag$4 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$4 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag$2 = '[object Symbol]',
    weakMapTag$2 = '[object WeakMap]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag$2] = cloneableTags[arrayTag$1] =
cloneableTags[arrayBufferTag$2] = cloneableTags[dataViewTag$3] =
cloneableTags[boolTag$2] = cloneableTags[dateTag$2] =
cloneableTags[float32Tag$2] = cloneableTags[float64Tag$2] =
cloneableTags[int8Tag$2] = cloneableTags[int16Tag$2] =
cloneableTags[int32Tag$2] = cloneableTags[mapTag$4] =
cloneableTags[numberTag$2] = cloneableTags[objectTag$2] =
cloneableTags[regexpTag$2] = cloneableTags[setTag$4] =
cloneableTags[stringTag$2] = cloneableTags[symbolTag$2] =
cloneableTags[uint8Tag$2] = cloneableTags[uint8ClampedTag$2] =
cloneableTags[uint16Tag$2] = cloneableTags[uint32Tag$2] = true;
cloneableTags[errorTag$1] = cloneableTags[funcTag$2] =
cloneableTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject_1(value)) {
    return value;
  }
  var isArr = isArray_1(value);
  if (isArr) {
    result = _initCloneArray(value);
    if (!isDeep) {
      return _copyArray(value, result);
    }
  } else {
    var tag = _getTag(value),
        isFunc = tag == funcTag$2 || tag == genTag$1;

    if (isBuffer_1(value)) {
      return _cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$2 || tag == argsTag$2 || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : _initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? _copySymbolsIn(value, _baseAssignIn(result, value))
          : _copySymbols(value, _baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = _initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new _Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet_1(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap_1(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? _getAllKeysIn : _getAllKeys)
    : (isFlat ? keysIn_1 : keys_1);

  var props = isArr ? undefined : keysFunc(value);
  _arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    _assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
    CLONE_SYMBOLS_FLAG$1 = 4;

/**
 * This method is like `_.cloneWith` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the deep cloned value.
 * @see _.cloneWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * }
 *
 * var el = _.cloneDeepWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 20
 */
function cloneDeepWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return _baseClone(value, CLONE_DEEP_FLAG$1 | CLONE_SYMBOLS_FLAG$1, customizer);
}

var cloneDeepWith_1 = cloneDeepWith;

/** `Object#toString` result references. */
var stringTag$3 = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray_1(value) && isObjectLike_1(value) && _baseGetTag(value) == stringTag$3);
}

var isString_1 = isString;

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

var _iteratorToArray = iteratorToArray;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray;

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

var _asciiToArray = asciiToArray;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

var _hasUnicode = hasUnicode;

/** Used to compose unicode character classes. */
var rsAstralRange$1 = '\\ud800-\\udfff',
    rsComboMarksRange$1 = '\\u0300-\\u036f',
    reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$1 = '\\u20d0-\\u20ff',
    rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1,
    rsVarRange$1 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange$1 + ']',
    rsCombo = '[' + rsComboRange$1 + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange$1 + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ$1 = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange$1 + ']?',
    rsOptJoin = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

var _unicodeToArray = unicodeToArray;

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return _hasUnicode(string)
    ? _unicodeToArray(string)
    : _asciiToArray(string);
}

var _stringToArray = stringToArray;

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return _arrayMap(props, function(key) {
    return object[key];
  });
}

var _baseValues = baseValues;

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values$1(object) {
  return object == null ? [] : _baseValues(object, keys_1(object));
}

var values_1 = values$1;

/** `Object#toString` result references. */
var mapTag$5 = '[object Map]',
    setTag$5 = '[object Set]';

/** Built-in value references. */
var symIterator = _Symbol ? _Symbol.iterator : undefined;

/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */
function toArray(value) {
  if (!value) {
    return [];
  }
  if (isArrayLike_1(value)) {
    return isString_1(value) ? _stringToArray(value) : _copyArray(value);
  }
  if (symIterator && value[symIterator]) {
    return _iteratorToArray(value[symIterator]());
  }
  var tag = _getTag(value),
      func = tag == mapTag$5 ? _mapToArray : (tag == setTag$5 ? _setToArray : values_1);

  return func(value);
}

var toArray_1 = toArray;

var printValue_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = printValue;
var toString = Object.prototype.toString;
var errorToString = Error.prototype.toString;
var regExpToString = RegExp.prototype.toString;
var symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : function () {
  return '';
};
var SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;

function printNumber(val) {
  if (val != +val) return 'NaN';
  var isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}

function printSimpleValue(val, quoteStrings) {
  if (quoteStrings === void 0) {
    quoteStrings = false;
  }

  if (val == null || val === true || val === false) return '' + val;
  var typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? "\"" + val + "\"" : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  var tag = toString.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}

function printValue(value, quoteStrings) {
  var result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    var result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}

module.exports = exports["default"];
});

unwrapExports(printValue_1);

var locale = createCommonjsModule(function (module, exports) {



exports.__esModule = true;
exports.default = exports.array = exports.object = exports.boolean = exports.date = exports.number = exports.string = exports.mixed = void 0;

var _printValue = interopRequireDefault(printValue_1);

var mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = path + " must be a `" + type + "` type, " + ("but the final value was: `" + (0, _printValue.default)(value, true) + "`") + (isCast ? " (cast from the value `" + (0, _printValue.default)(originalValue, true) + "`)." : '.');

    if (value === null) {
      msg += "\n If \"null\" is intended as an empty value be sure to mark the schema as `.nullable()`";
    }

    return msg;
  }
};
exports.mixed = mixed;
var string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
exports.string = string;
var number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  notEqual: '${path} must be not equal to ${notEqual}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
exports.number = number;
var date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
exports.date = date;
var boolean = {};
exports.boolean = boolean;
var object = {
  noUnknown: '${path} field cannot have keys not specified in the object shape'
};
exports.object = object;
var array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items'
};
exports.array = array;
var _default = {
  mixed: mixed,
  string: string,
  number: number,
  date: date,
  object: object,
  array: array,
  boolean: boolean
};
exports.default = _default;
});

unwrapExports(locale);
var locale_1 = locale.array;
var locale_2 = locale.object;
var locale_3 = locale.date;
var locale_4 = locale.number;
var locale_5 = locale.string;
var locale_6 = locale.mixed;

var isSchema = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var _default = function _default(obj) {
  return obj && obj.__isYupSchema__;
};

exports.default = _default;
module.exports = exports["default"];
});

unwrapExports(isSchema);

var Condition_1 = createCommonjsModule(function (module, exports) {



exports.__esModule = true;
exports.default = void 0;

var _has = interopRequireDefault(has_1);

var _isSchema = interopRequireDefault(isSchema);

var Condition =
/*#__PURE__*/
function () {
  function Condition(refs, options) {
    this.refs = refs;

    if (typeof options === 'function') {
      this.fn = options;
      return;
    }

    if (!(0, _has.default)(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
    if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    var is = options.is,
        then = options.then,
        otherwise = options.otherwise;
    var check = typeof is === 'function' ? is : function () {
      for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
        values[_key] = arguments[_key];
      }

      return values.every(function (value) {
        return value === is;
      });
    };

    this.fn = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var options = args.pop();
      var schema = args.pop();
      var branch = check.apply(void 0, args) ? then : otherwise;
      if (!branch) return undefined;
      if (typeof branch === 'function') return branch(schema);
      return schema.concat(branch.resolve(options));
    };
  }

  var _proto = Condition.prototype;

  _proto.resolve = function resolve(base, options) {
    var values = this.refs.map(function (ref) {
      return ref.getValue(options);
    });
    var schema = this.fn.apply(base, values.concat(base, options));
    if (schema === undefined || schema === base) return base;
    if (!(0, _isSchema.default)(schema)) throw new TypeError('conditions must return a schema object');
    return schema.resolve(options);
  };

  return Condition;
}();

var _default = Condition;
exports.default = _default;
module.exports = exports["default"];
});

unwrapExports(Condition_1);

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose$2;

/* jshint node: true */

function makeArrayFrom(obj) {
  return Array.prototype.slice.apply(obj);
}

var
  PENDING = "pending",
  RESOLVED = "resolved",
  REJECTED = "rejected";

function SynchronousPromise(handler) {
  this.status = PENDING;
  this._continuations = [];
  this._parent = null;
  this._paused = false;
  if (handler) {
    handler.call(
      this,
      this._continueWith.bind(this),
      this._failWith.bind(this)
    );
  }
}

function looksLikeAPromise(obj) {
  return obj && typeof (obj.then) === "function";
}

function passThrough(value) {
  return value;
}

SynchronousPromise.prototype = {
  then: function (nextFn, catchFn) {
    var next = SynchronousPromise.unresolved()._setParent(this);
    if (this._isRejected()) {
      if (this._paused) {
        this._continuations.push({
          promise: next,
          nextFn: nextFn,
          catchFn: catchFn
        });
        return next;
      }
      if (catchFn) {
        try {
          var catchResult = catchFn(this._error);
          if (looksLikeAPromise(catchResult)) {
            this._chainPromiseData(catchResult, next);
            return next;
          } else {
            return SynchronousPromise.resolve(catchResult)._setParent(this);
          }
        } catch (e) {
          return SynchronousPromise.reject(e)._setParent(this);
        }
      }
      return SynchronousPromise.reject(this._error)._setParent(this);
    }
    this._continuations.push({
      promise: next,
      nextFn: nextFn,
      catchFn: catchFn
    });
    this._runResolutions();
    return next;
  },
  catch: function (handler) {
    if (this._isResolved()) {
      return SynchronousPromise.resolve(this._data)._setParent(this);
    }
    var next = SynchronousPromise.unresolved()._setParent(this);
    this._continuations.push({
      promise: next,
      catchFn: handler
    });
    this._runRejections();
    return next;
  },
  finally: function (callback) {
    var ran = false;

    function runFinally(result, err) {
      if (!ran) {
        ran = true;
        if (!callback) {
          callback = passThrough;
        }
        var callbackResult = callback(result);
        if (looksLikeAPromise(callbackResult)) {
          return callbackResult.then(function () {
            if (err) {
              throw err;
            }
            return result;
          });
        } else {
          return result;
        }
      }
    }

    return this
      .then(function (result) {
        return runFinally(result);
      })
      .catch(function (err) {
        return runFinally(null, err);
      });
  },
  pause: function () {
    this._paused = true;
    return this;
  },
  resume: function () {
    var firstPaused = this._findFirstPaused();
    if (firstPaused) {
      firstPaused._paused = false;
      firstPaused._runResolutions();
      firstPaused._runRejections();
    }
    return this;
  },
  _findAncestry: function () {
    return this._continuations.reduce(function (acc, cur) {
      if (cur.promise) {
        var node = {
          promise: cur.promise,
          children: cur.promise._findAncestry()
        };
        acc.push(node);
      }
      return acc;
    }, []);
  },
  _setParent: function (parent) {
    if (this._parent) {
      throw new Error("parent already set");
    }
    this._parent = parent;
    return this;
  },
  _continueWith: function (data) {
    var firstPending = this._findFirstPending();
    if (firstPending) {
      firstPending._data = data;
      firstPending._setResolved();
    }
  },
  _findFirstPending: function () {
    return this._findFirstAncestor(function (test) {
      return test._isPending && test._isPending();
    });
  },
  _findFirstPaused: function () {
    return this._findFirstAncestor(function (test) {
      return test._paused;
    });
  },
  _findFirstAncestor: function (matching) {
    var test = this;
    var result;
    while (test) {
      if (matching(test)) {
        result = test;
      }
      test = test._parent;
    }
    return result;
  },
  _failWith: function (error) {
    var firstRejected = this._findFirstPending();
    if (firstRejected) {
      firstRejected._error = error;
      firstRejected._setRejected();
    }
  },
  _takeContinuations: function () {
    return this._continuations.splice(0, this._continuations.length);
  },
  _runRejections: function () {
    if (this._paused || !this._isRejected()) {
      return;
    }
    var
      error = this._error,
      continuations = this._takeContinuations(),
      self = this;
    continuations.forEach(function (cont) {
      if (cont.catchFn) {
        try {
          var catchResult = cont.catchFn(error);
          self._handleUserFunctionResult(catchResult, cont.promise);
        } catch (e) {
          cont.promise.reject(e);
        }
      } else {
        cont.promise.reject(error);
      }
    });
  },
  _runResolutions: function () {
    if (this._paused || !this._isResolved() || this._isPending()) {
      return;
    }
    var continuations = this._takeContinuations();
    if (looksLikeAPromise(this._data)) {
      return this._handleWhenResolvedDataIsPromise(this._data);
    }
    var data = this._data;
    var self = this;
    continuations.forEach(function (cont) {
      if (cont.nextFn) {
        try {
          var result = cont.nextFn(data);
          self._handleUserFunctionResult(result, cont.promise);
        } catch (e) {
          self._handleResolutionError(e, cont);
        }
      } else if (cont.promise) {
        cont.promise.resolve(data);
      }
    });
  },
  _handleResolutionError: function (e, continuation) {
    this._setRejected();
    if (continuation.catchFn) {
      try {
        continuation.catchFn(e);
        return;
      } catch (e2) {
        e = e2;
      }
    }
    if (continuation.promise) {
      continuation.promise.reject(e);
    }
  },
  _handleWhenResolvedDataIsPromise: function (data) {
    var self = this;
    return data.then(function (result) {
      self._data = result;
      self._runResolutions();
    }).catch(function (error) {
      self._error = error;
      self._setRejected();
      self._runRejections();
    });
  },
  _handleUserFunctionResult: function (data, nextSynchronousPromise) {
    if (looksLikeAPromise(data)) {
      this._chainPromiseData(data, nextSynchronousPromise);
    } else {
      nextSynchronousPromise.resolve(data);
    }
  },
  _chainPromiseData: function (promiseData, nextSynchronousPromise) {
    promiseData.then(function (newData) {
      nextSynchronousPromise.resolve(newData);
    }).catch(function (newError) {
      nextSynchronousPromise.reject(newError);
    });
  },
  _setResolved: function () {
    this.status = RESOLVED;
    if (!this._paused) {
      this._runResolutions();
    }
  },
  _setRejected: function () {
    this.status = REJECTED;
    if (!this._paused) {
      this._runRejections();
    }
  },
  _isPending: function () {
    return this.status === PENDING;
  },
  _isResolved: function () {
    return this.status === RESOLVED;
  },
  _isRejected: function () {
    return this.status === REJECTED;
  }
};

SynchronousPromise.resolve = function (result) {
  return new SynchronousPromise(function (resolve, reject) {
    if (looksLikeAPromise(result)) {
      result.then(function (newResult) {
        resolve(newResult);
      }).catch(function (error) {
        reject(error);
      });
    } else {
      resolve(result);
    }
  });
};

SynchronousPromise.reject = function (result) {
  return new SynchronousPromise(function (resolve, reject) {
    reject(result);
  });
};

SynchronousPromise.unresolved = function () {
  return new SynchronousPromise(function (resolve, reject) {
    this.resolve = resolve;
    this.reject = reject;
  });
};

SynchronousPromise.all = function () {
  var args = makeArrayFrom(arguments);
  if (Array.isArray(args[0])) {
    args = args[0];
  }
  if (!args.length) {
    return SynchronousPromise.resolve([]);
  }
  return new SynchronousPromise(function (resolve, reject) {
    var
      allData = [],
      numResolved = 0,
      doResolve = function () {
        if (numResolved === args.length) {
          resolve(allData);
        }
      },
      rejected = false,
      doReject = function (err) {
        if (rejected) {
          return;
        }
        rejected = true;
        reject(err);
      };
    args.forEach(function (arg, idx) {
      SynchronousPromise.resolve(arg).then(function (thisResult) {
        allData[idx] = thisResult;
        numResolved += 1;
        doResolve();
      }).catch(function (err) {
        doReject(err);
      });
    });
  });
};

function createAggregateErrorFrom(errors) {
  /* jshint ignore:start */
  if (typeof window !== "undefined" && "AggregateError" in window) {
    return new window.AggregateError(errors);
  }
  /* jshint ignore:end */

  return { errors: errors };
}

SynchronousPromise.any = function () {
  var args = makeArrayFrom(arguments);
  if (Array.isArray(args[0])) {
    args = args[0];
  }
  if (!args.length) {
    return SynchronousPromise.reject(createAggregateErrorFrom([]));
  }
  return new SynchronousPromise(function (resolve, reject) {
    var
      allErrors = [],
      numRejected = 0,
      doReject = function () {
        if (numRejected === args.length) {
          reject(createAggregateErrorFrom(allErrors));
        }
      },
      resolved = false,
      doResolve = function (result) {
        if (resolved) {
          return;
        }
        resolved = true;
        resolve(result);
      };
    args.forEach(function (arg, idx) {
      SynchronousPromise.resolve(arg).then(function (thisResult) {
        doResolve(thisResult);
      }).catch(function (err) {
        allErrors[idx] = err;
        numRejected += 1;
        doReject();
      });
    });
  });
};

SynchronousPromise.allSettled = function () {
  var args = makeArrayFrom(arguments);
  if (Array.isArray(args[0])) {
    args = args[0];
  }
  if (!args.length) {
    return SynchronousPromise.resolve([]);
  }
  return new SynchronousPromise(function (resolve) {
    var
      allData = [],
      numSettled = 0,
      doSettled = function () {
        numSettled += 1;
        if (numSettled === args.length) {
          resolve(allData);
        }
      };
    args.forEach(function (arg, idx) {
      SynchronousPromise.resolve(arg).then(function (thisResult) {
        allData[idx] = {
          status: "fulfilled",
          value: thisResult
        };
        doSettled();
      }).catch(function (err) {
        allData[idx] = {
          status: "rejected",
          reason: err
        };
        doSettled();
      });
    });
  });
};

/* jshint ignore:start */
if (Promise === SynchronousPromise) {
  throw new Error("Please use SynchronousPromise.installGlobally() to install globally");
}
var RealPromise = Promise;
SynchronousPromise.installGlobally = function (__awaiter) {
  if (Promise === SynchronousPromise) {
    return __awaiter;
  }
  var result = patchAwaiterIfRequired(__awaiter);
  Promise = SynchronousPromise;
  return result;
};

SynchronousPromise.uninstallGlobally = function () {
  if (Promise === SynchronousPromise) {
    Promise = RealPromise;
  }
};

function patchAwaiterIfRequired(__awaiter) {
  if (typeof (__awaiter) === "undefined" || __awaiter.__patched) {
    return __awaiter;
  }
  var originalAwaiter = __awaiter;
  __awaiter = function () {
    originalAwaiter.apply(this, makeArrayFrom(arguments));
  };
  __awaiter.__patched = true;
  return __awaiter;
}

/* jshint ignore:end */

var synchronousPromise = {
  SynchronousPromise: SynchronousPromise
};

var ValidationError_1 = createCommonjsModule(function (module, exports) {



exports.__esModule = true;
exports.default = ValidationError;

var _printValue = interopRequireDefault(printValue_1);

var strReg = /\$\{\s*(\w+)\s*\}/g;

var replace = function replace(str) {
  return function (params) {
    return str.replace(strReg, function (_, key) {
      return (0, _printValue.default)(params[key]);
    });
  };
};

function ValidationError(errors, value, field, type) {
  var _this = this;

  this.name = 'ValidationError';
  this.value = value;
  this.path = field;
  this.type = type;
  this.errors = [];
  this.inner = [];
  if (errors) [].concat(errors).forEach(function (err) {
    _this.errors = _this.errors.concat(err.errors || err);
    if (err.inner) _this.inner = _this.inner.concat(err.inner.length ? err.inner : err);
  });
  this.message = this.errors.length > 1 ? this.errors.length + " errors occurred" : this.errors[0];
  if (Error.captureStackTrace) Error.captureStackTrace(this, ValidationError);
}

ValidationError.prototype = Object.create(Error.prototype);
ValidationError.prototype.constructor = ValidationError;

ValidationError.isError = function (err) {
  return err && err.name === 'ValidationError';
};

ValidationError.formatError = function (message, params) {
  if (typeof message === 'string') message = replace(message);

  var fn = function fn(params) {
    params.path = params.label || params.path || 'this';
    return typeof message === 'function' ? message(params) : message;
  };

  return arguments.length === 1 ? fn : fn(params);
};

module.exports = exports["default"];
});

unwrapExports(ValidationError_1);

var runValidations_1 = createCommonjsModule(function (module, exports) {



exports.__esModule = true;
exports.propagateErrors = propagateErrors;
exports.settled = settled;
exports.collectErrors = collectErrors;
exports.default = runValidations;

var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);



var _ValidationError = interopRequireDefault(ValidationError_1);

var promise = function promise(sync) {
  return sync ? synchronousPromise.SynchronousPromise : Promise;
};

var unwrapError = function unwrapError(errors) {
  if (errors === void 0) {
    errors = [];
  }

  return errors.inner && errors.inner.length ? errors.inner : [].concat(errors);
};

function scopeToValue(promises, value, sync) {
  //console.log('scopeToValue', promises, value)
  var p = promise(sync).all(promises); //console.log('scopeToValue B', p)

  var b = p.catch(function (err) {
    if (err.name === 'ValidationError') err.value = value;
    throw err;
  }); //console.log('scopeToValue c', b)

  var c = b.then(function () {
    return value;
  }); //console.log('scopeToValue d', c)

  return c;
}
/**
 * If not failing on the first error, catch the errors
 * and collect them in an array
 */


function propagateErrors(endEarly, errors) {
  return endEarly ? null : function (err) {
    errors.push(err);
    return err.value;
  };
}

function settled(promises, sync) {
  var Promise = promise(sync);
  return Promise.all(promises.map(function (p) {
    return Promise.resolve(p).then(function (value) {
      return {
        fulfilled: true,
        value: value
      };
    }, function (value) {
      return {
        fulfilled: false,
        value: value
      };
    });
  }));
}

function collectErrors(_ref) {
  var validations = _ref.validations,
      value = _ref.value,
      path = _ref.path,
      sync = _ref.sync,
      errors = _ref.errors,
      sort = _ref.sort;
  errors = unwrapError(errors);
  return settled(validations, sync).then(function (results) {
    var nestedErrors = results.filter(function (r) {
      return !r.fulfilled;
    }).reduce(function (arr, _ref2) {
      var error = _ref2.value;

      // we are only collecting validation errors
      if (!_ValidationError.default.isError(error)) {
        throw error;
      }

      return arr.concat(error);
    }, []);
    if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name

    errors = nestedErrors.concat(errors);
    if (errors.length) throw new _ValidationError.default(errors, value, path);
    return value;
  });
}

function runValidations(_ref3) {
  var endEarly = _ref3.endEarly,
      options = (0, _objectWithoutPropertiesLoose2.default)(_ref3, ["endEarly"]);
  if (endEarly) return scopeToValue(options.validations, options.value, options.sync);
  return collectErrors(options);
}
});

unwrapExports(runValidations_1);
var runValidations_2 = runValidations_1.propagateErrors;
var runValidations_3 = runValidations_1.settled;
var runValidations_4 = runValidations_1.collectErrors;

var prependDeep_1 = createCommonjsModule(function (module, exports) {



exports.__esModule = true;
exports.default = prependDeep;

var _has = interopRequireDefault(has_1);

var _isSchema = interopRequireDefault(isSchema);

var isObject = function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};

function prependDeep(target, source) {
  for (var key in source) {
    if ((0, _has.default)(source, key)) {
      var sourceVal = source[key],
          targetVal = target[key];

      if (targetVal === undefined) {
        target[key] = sourceVal;
      } else if (targetVal === sourceVal) {
        continue;
      } else if ((0, _isSchema.default)(targetVal)) {
        if ((0, _isSchema.default)(sourceVal)) target[key] = sourceVal.concat(targetVal);
      } else if (isObject(targetVal)) {
        if (isObject(sourceVal)) target[key] = prependDeep(targetVal, sourceVal);
      } else if (Array.isArray(targetVal)) {
        if (Array.isArray(sourceVal)) target[key] = sourceVal.concat(targetVal);
      }
    }
  }

  return target;
}

module.exports = exports["default"];
});

unwrapExports(prependDeep_1);

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = _createBaseFor();

var _baseFor = baseFor;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && _baseFor(object, iteratee, keys_1);
}

var _baseForOwn = baseForOwn;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED$2);
  return this;
}

var _setCacheAdd = setCacheAdd;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new _MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
SetCache.prototype.has = _setCacheHas;

var _SetCache = SetCache;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new _SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!_arraySome(other, function(othValue, othIndex) {
            if (!_cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/** `Object#toString` result references. */
var boolTag$3 = '[object Boolean]',
    dateTag$3 = '[object Date]',
    errorTag$2 = '[object Error]',
    mapTag$6 = '[object Map]',
    numberTag$3 = '[object Number]',
    regexpTag$3 = '[object RegExp]',
    setTag$6 = '[object Set]',
    stringTag$4 = '[object String]',
    symbolTag$3 = '[object Symbol]';

var arrayBufferTag$3 = '[object ArrayBuffer]',
    dataViewTag$4 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$4:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$3:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag$3:
    case dateTag$3:
    case numberTag$3:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq_1(+object, +other);

    case errorTag$2:
      return object.name == other.name && object.message == other.message;

    case regexpTag$3:
    case stringTag$4:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$6:
      var convert = _mapToArray;

    case setTag$6:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1;
      convert || (convert = _setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$1;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$3:
      if (symbolValueOf$1) {
        return symbolValueOf$1.call(object) == symbolValueOf$1.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$e.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2,
      objProps = _getAllKeys(object),
      objLength = objProps.length,
      othProps = _getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$c.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]',
    arrayTag$2 = '[object Array]',
    objectTag$3 = '[object Object]';

/** Used for built-in method references. */
var objectProto$f = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$f.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray_1(object),
      othIsArr = isArray_1(other),
      objTag = objIsArr ? arrayTag$2 : _getTag(object),
      othTag = othIsArr ? arrayTag$2 : _getTag(other);

  objTag = objTag == argsTag$3 ? objectTag$3 : objTag;
  othTag = othTag == argsTag$3 ? objectTag$3 : othTag;

  var objIsObj = objTag == objectTag$3,
      othIsObj = othTag == objectTag$3,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer_1(object)) {
    if (!isBuffer_1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new _Stack);
    return (objIsArr || isTypedArray_1(object))
      ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$3)) {
    var objIsWrapped = objIsObj && hasOwnProperty$d.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$d.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new _Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new _Stack);
  return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike_1(value) && !isObjectLike_1(other))) {
    return value !== value && other !== other;
  }
  return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

var _baseIsEqual = baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new _Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$4 | COMPARE_UNORDERED_FLAG$2, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

var _baseIsMatch = baseIsMatch;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject_1(value);
}

var _isStrictComparable = isStrictComparable;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys_1(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, _isStrictComparable(value)];
  }
  return result;
}

var _getMatchData = getMatchData;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

var _matchesStrictComparable = matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = _getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return _matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || _baseIsMatch(object, source, matchData);
  };
}

var _baseMatches = baseMatches;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = _castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : _baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && _hasPath(object, path, _baseHasIn);
}

var hasIn_1 = hasIn;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (_isKey(path) && _isStrictComparable(srcValue)) {
    return _matchesStrictComparable(_toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get_1(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn_1(object, path)
      : _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$5 | COMPARE_UNORDERED_FLAG$3);
  };
}

var _baseMatchesProperty = baseMatchesProperty;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

var identity_1 = identity;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return _baseGet(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return _isKey(path) ? _baseProperty(_toKey(path)) : _basePropertyDeep(path);
}

var property_1 = property;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity_1;
  }
  if (typeof value == 'object') {
    return isArray_1(value)
      ? _baseMatchesProperty(value[0], value[1])
      : _baseMatches(value);
  }
  return property_1(value);
}

var _baseIteratee = baseIteratee;

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = _baseIteratee(iteratee);

  _baseForOwn(object, function(value, key, object) {
    _baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

var mapValues_1 = mapValues;

/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */

function Cache(maxSize) {
  this._maxSize = maxSize;
  this.clear();
}
Cache.prototype.clear = function() {
  this._size = 0;
  this._values = {};
};
Cache.prototype.get = function(key) {
  return this._values[key]
};
Cache.prototype.set = function(key, value) {
  this._size >= this._maxSize && this.clear();
  if (!this._values.hasOwnProperty(key)) {
    this._size++;
  }
  return this._values[key] = value
};

var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
  DIGIT_REGEX = /^\d+$/,
  LEAD_DIGIT_REGEX = /^\d/,
  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
  MAX_CACHE_SIZE = 512;

var contentSecurityPolicy = false,
  pathCache = new Cache(MAX_CACHE_SIZE),
  setCache = new Cache(MAX_CACHE_SIZE),
  getCache = new Cache(MAX_CACHE_SIZE);

try {
  new Function('');
} catch (error) {
  contentSecurityPolicy = true;
}

var propertyExpr = {
  Cache: Cache,

  expr: expr,

  split: split,

  normalizePath: normalizePath,

  setter: contentSecurityPolicy
    ? function(path) {
      var parts = normalizePath(path);
      return function(data, value) {
        return setterFallback(parts, data, value)
      }
    }
    : function(path) {
      return setCache.get(path) || setCache.set(
        path,
        new Function(
          'data, value',
          expr(path, 'data') + ' = value'
        )
      )
    },

  getter: contentSecurityPolicy
    ? function(path, safe) {
      var parts = normalizePath(path);
      return function(data) {
        return getterFallback(parts, safe, data)
      }
    }
    : function(path, safe) {
      var key = path + '_' + safe;
      return getCache.get(key) || getCache.set(
        key,
        new Function('data', 'return ' + expr(path, safe, 'data'))
      )
    },

  join: function(segments) {
    return segments.reduce(function(path, part) {
      return (
        path +
        (isQuoted(part) || DIGIT_REGEX.test(part)
          ? '[' + part + ']'
          : (path ? '.' : '') + part)
      )
    }, '')
  },

  forEach: function(path, cb, thisArg) {
    forEach(split(path), cb, thisArg);
  }
};

function setterFallback(parts, data, value) {
  var index = 0,
    len = parts.length;
  while (index < len - 1) {
    data = data[parts[index++]];
  }
  data[parts[index]] = value;
}

function getterFallback(parts, safe, data) {
  var index = 0,
    len = parts.length;
  while (index < len) {
    if (data != null || !safe) {
      data = data[parts[index++]];
    } else {
      return
    }
  }
  return data
}

function normalizePath(path) {
  return pathCache.get(path) || pathCache.set(
    path,
    split(path).map(function(part) {
      return part.replace(CLEAN_QUOTES_REGEX, '$2')
    })
  )
}

function split(path) {
  return path.match(SPLIT_REGEX)
}

function expr(expression, safe, param) {
  expression = expression || '';

  if (typeof safe === 'string') {
    param = safe;
    safe = false;
  }

  param = param || 'data';

  if (expression && expression.charAt(0) !== '[') expression = '.' + expression;

  return safe ? makeSafe(expression, param) : param + expression
}

function forEach(parts, iter, thisArg) {
  var len = parts.length,
    part,
    idx,
    isArray,
    isBracket;

  for (idx = 0; idx < len; idx++) {
    part = parts[idx];

    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"';
      }

      isBracket = isQuoted(part);
      isArray = !isBracket && /^\d+$/.test(part);

      iter.call(thisArg, part, isBracket, isArray, idx, parts);
    }
  }
}

function isQuoted(str) {
  return (
    typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1
  )
}

function makeSafe(path, param) {
  var result = param,
    parts = split(path),
    isLast;

  forEach(parts, function(part, isBracket, isArray, idx, parts) {
    isLast = idx === parts.length - 1;

    part = isBracket || isArray ? '[' + part + ']' : '.' + part;

    result += part + (!isLast ? ' || {})' : ')');
  });

  return new Array(parts.length + 1).join('(') + result
}

function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX)
}

function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part)
}

function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part))
}

var Reference_1 = createCommonjsModule(function (module, exports) {



exports.__esModule = true;
exports.default = void 0;

var _extends2 = interopRequireDefault(_extends_1);



var prefixes = {
  context: '$',
  value: '.'
};

var Reference =
/*#__PURE__*/
function () {
  function Reference(key, options) {
    if (options === void 0) {
      options = {};
    }

    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    var prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && (0, propertyExpr.getter)(this.path, true);
    this.map = options.map;
  }

  var _proto = Reference.prototype;

  _proto.getValue = function getValue(options) {
    var result = this.isContext ? options.context : this.isValue ? options.value : options.parent;
    if (this.getter) result = this.getter(result || {});
    if (this.map) result = this.map(result);
    return result;
  };

  _proto.cast = function cast(value, options) {
    return this.getValue((0, _extends2.default)({}, options, {
      value: value
    }));
  };

  _proto.resolve = function resolve() {
    return this;
  };

  _proto.describe = function describe() {
    return {
      type: 'ref',
      key: this.key
    };
  };

  _proto.toString = function toString() {
    return "Ref(" + this.key + ")";
  };

  Reference.isRef = function isRef(value) {
    return value && value.__isYupRef;
  };

  return Reference;
}();

exports.default = Reference;
Reference.prototype.__isYupRef = true;
module.exports = exports["default"];
});

unwrapExports(Reference_1);

var createValidation_1 = createCommonjsModule(function (module, exports) {



exports.__esModule = true;
exports.createErrorFactory = createErrorFactory;
exports.default = createValidation;

var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);

var _extends2 = interopRequireDefault(_extends_1);

var _mapValues = interopRequireDefault(mapValues_1);

var _ValidationError = interopRequireDefault(ValidationError_1);

var _Reference = interopRequireDefault(Reference_1);



var formatError = _ValidationError.default.formatError;

var thenable = function thenable(p) {
  return p && typeof p.then === 'function' && typeof p.catch === 'function';
};

function runTest(testFn, ctx, value, sync) {
  var result = testFn.call(ctx, value);
  if (!sync) return Promise.resolve(result);

  if (thenable(result)) {
    throw new Error("Validation test of type: \"" + ctx.type + "\" returned a Promise during a synchronous validate. " + "This test will finish after the validate call has returned");
  }

  return synchronousPromise.SynchronousPromise.resolve(result);
}

function resolveParams(oldParams, newParams, resolve) {
  return (0, _mapValues.default)((0, _extends2.default)({}, oldParams, newParams), resolve);
}

function createErrorFactory(_ref) {
  var value = _ref.value,
      label = _ref.label,
      resolve = _ref.resolve,
      originalValue = _ref.originalValue,
      opts = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["value", "label", "resolve", "originalValue"]);
  return function createError(_temp) {
    var _ref2 = _temp === void 0 ? {} : _temp,
        _ref2$path = _ref2.path,
        path = _ref2$path === void 0 ? opts.path : _ref2$path,
        _ref2$message = _ref2.message,
        message = _ref2$message === void 0 ? opts.message : _ref2$message,
        _ref2$type = _ref2.type,
        type = _ref2$type === void 0 ? opts.name : _ref2$type,
        params = _ref2.params;

    params = (0, _extends2.default)({
      path: path,
      value: value,
      originalValue: originalValue,
      label: label
    }, resolveParams(opts.params, params, resolve));
    return (0, _extends2.default)(new _ValidationError.default(formatError(message, params), value, path, type), {
      params: params
    });
  };
}

function createValidation(options) {
  var name = options.name,
      message = options.message,
      test = options.test,
      params = options.params;

  function validate(_ref3) {
    var value = _ref3.value,
        path = _ref3.path,
        label = _ref3.label,
        options = _ref3.options,
        originalValue = _ref3.originalValue,
        sync = _ref3.sync,
        rest = (0, _objectWithoutPropertiesLoose2.default)(_ref3, ["value", "path", "label", "options", "originalValue", "sync"]);
    var parent = options.parent;

    var resolve = function resolve(item) {
      return _Reference.default.isRef(item) ? item.getValue({
        value: value,
        parent: parent,
        context: options.context
      }) : item;
    };

    var createError = createErrorFactory({
      message: message,
      path: path,
      value: value,
      originalValue: originalValue,
      params: params,
      label: label,
      resolve: resolve,
      name: name
    });
    var ctx = (0, _extends2.default)({
      path: path,
      parent: parent,
      type: name,
      createError: createError,
      resolve: resolve,
      options: options
    }, rest);
    return runTest(test, ctx, value, sync).then(function (validOrError) {
      if (_ValidationError.default.isError(validOrError)) throw validOrError;else if (!validOrError) throw createError();
    });
  }

  validate.OPTIONS = options;
  return validate;
}
});

unwrapExports(createValidation_1);
var createValidation_2 = createValidation_1.createErrorFactory;

var reach_1 = createCommonjsModule(function (module, exports) {



exports.__esModule = true;
exports.getIn = getIn;
exports.default = void 0;



var _has = interopRequireDefault(has_1);

var trim = function trim(part) {
  return part.substr(0, part.length - 1).substr(1);
};

function getIn(schema, path, value, context) {
  var parent, lastPart, lastPartDebug; // if only one "value" arg then use it for both

  context = context || value;
  if (!path) return {
    parent: parent,
    parentPath: path,
    schema: schema
  };
  (0, propertyExpr.forEach)(path, function (_part, isBracket, isArray) {
    var part = isBracket ? trim(_part) : _part;

    if (isArray || (0, _has.default)(schema, '_subType')) {
      // we skipped an array: foo[].bar
      var idx = isArray ? parseInt(part, 10) : 0;
      schema = schema.resolve({
        context: context,
        parent: parent,
        value: value
      })._subType;

      if (value) {
        if (isArray && idx >= value.length) {
          throw new Error("Yup.reach cannot resolve an array item at index: " + _part + ", in the path: " + path + ". " + "because there is no value at that index. ");
        }

        value = value[idx];
      }
    }

    if (!isArray) {
      schema = schema.resolve({
        context: context,
        parent: parent,
        value: value
      });
      if (!(0, _has.default)(schema, 'fields') || !(0, _has.default)(schema.fields, part)) throw new Error("The schema does not contain the path: " + path + ". " + ("(failed at: " + lastPartDebug + " which is a type: \"" + schema._type + "\") "));
      schema = schema.fields[part];
      parent = value;
      value = value && value[part];
      lastPart = part;
      lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
    }
  });
  return {
    schema: schema,
    parent: parent,
    parentPath: lastPart
  };
}

var reach = function reach(obj, path, value, context) {
  return getIn(obj, path, value, context).schema;
};

var _default = reach;
exports.default = _default;
});

unwrapExports(reach_1);
var reach_2 = reach_1.getIn;

var mixed = createCommonjsModule(function (module, exports) {



exports.__esModule = true;
exports.default = SchemaType;

var _extends2 = interopRequireDefault(_extends_1);

var _has = interopRequireDefault(has_1);

var _cloneDeepWith = interopRequireDefault(cloneDeepWith_1);

var _toArray2 = interopRequireDefault(toArray_1);



var _Condition = interopRequireDefault(Condition_1);

var _runValidations = interopRequireDefault(runValidations_1);

var _prependDeep = interopRequireDefault(prependDeep_1);

var _isSchema = interopRequireDefault(isSchema);

var _createValidation = interopRequireDefault(createValidation_1);

var _printValue = interopRequireDefault(printValue_1);

var _Reference = interopRequireDefault(Reference_1);



var RefSet =
/*#__PURE__*/
function () {
  function RefSet() {
    this.list = new Set();
    this.refs = new Map();
  }

  var _proto = RefSet.prototype;

  _proto.toArray = function toArray() {
    return (0, _toArray2.default)(this.list).concat((0, _toArray2.default)(this.refs.values()));
  };

  _proto.add = function add(value) {
    _Reference.default.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
  };

  _proto.delete = function _delete(value) {
    _Reference.default.isRef(value) ? this.refs.delete(value.key, value) : this.list.delete(value);
  };

  _proto.has = function has(value, resolve) {
    if (this.list.has(value)) return true;
    var item,
        values = this.refs.values();

    while (item = values.next(), !item.done) {
      if (resolve(item.value) === value) return true;
    }

    return false;
  };

  return RefSet;
}();

function SchemaType(options) {
  var _this = this;

  if (options === void 0) {
    options = {};
  }

  if (!(this instanceof SchemaType)) return new SchemaType();
  this._deps = [];
  this._conditions = [];
  this._options = {
    abortEarly: true,
    recursive: true
  };
  this._exclusive = Object.create(null);
  this._whitelist = new RefSet();
  this._blacklist = new RefSet();
  this.tests = [];
  this.transforms = [];
  this.withMutation(function () {
    _this.typeError(locale.mixed.notType);
  });
  if ((0, _has.default)(options, 'default')) this._defaultDefault = options.default;
  this._type = options.type || 'mixed';
}

var proto = SchemaType.prototype = {
  __isYupSchema__: true,
  constructor: SchemaType,
  clone: function clone() {
    var _this2 = this;

    if (this._mutate) return this; // if the nested value is a schema we can skip cloning, since
    // they are already immutable

    return (0, _cloneDeepWith.default)(this, function (value) {
      if ((0, _isSchema.default)(value) && value !== _this2) return value;
    });
  },
  label: function label(_label) {
    var next = this.clone();
    next._label = _label;
    return next;
  },
  meta: function meta(obj) {
    if (arguments.length === 0) return this._meta;
    var next = this.clone();
    next._meta = (0, _extends2.default)(next._meta || {}, obj);
    return next;
  },
  withMutation: function withMutation(fn) {
    var before = this._mutate;
    this._mutate = true;
    var result = fn(this);
    this._mutate = before;
    return result;
  },
  concat: function concat(schema) {
    if (!schema || schema === this) return this;
    if (schema._type !== this._type && this._type !== 'mixed') throw new TypeError("You cannot `concat()` schema's of different types: " + this._type + " and " + schema._type);
    var next = (0, _prependDeep.default)(schema.clone(), this); // new undefined default is overriden by old non-undefined one, revert

    if ((0, _has.default)(schema, '_default')) next._default = schema._default;
    next.tests = this.tests;
    next._exclusive = this._exclusive; // manually add the new tests to ensure
    // the deduping logic is consistent

    next.withMutation(function (next) {
      schema.tests.forEach(function (fn) {
        next.test(fn.OPTIONS);
      });
    });
    return next;
  },
  isType: function isType(v) {
    if (this._nullable && v === null) return true;
    return !this._typeCheck || this._typeCheck(v);
  },
  resolve: function resolve(options) {
    var schema = this;

    if (schema._conditions.length) {
      var conditions = schema._conditions;
      schema = schema.clone();
      schema._conditions = [];
      schema = conditions.reduce(function (schema, condition) {
        return condition.resolve(schema, options);
      }, schema);
      schema = schema.resolve(options);
    }

    return schema;
  },
  cast: function cast(value, options) {
    if (options === void 0) {
      options = {};
    }

    var resolvedSchema = this.resolve((0, _extends2.default)({}, options, {
      value: value
    }));

    var result = resolvedSchema._cast(value, options);

    if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
      var formattedValue = (0, _printValue.default)(value);
      var formattedResult = (0, _printValue.default)(result);
      throw new TypeError("The value of " + (options.path || 'field') + " could not be cast to a value " + ("that satisfies the schema type: \"" + resolvedSchema._type + "\". \n\n") + ("attempted value: " + formattedValue + " \n") + (formattedResult !== formattedValue ? "result of cast: " + formattedResult : ''));
    }

    return result;
  },
  _cast: function _cast(rawValue) {
    var _this3 = this;

    var value = rawValue === undefined ? rawValue : this.transforms.reduce(function (value, fn) {
      return fn.call(_this3, value, rawValue);
    }, rawValue);

    if (value === undefined && (0, _has.default)(this, '_default')) {
      value = this.default();
    }

    return value;
  },
  _validate: function _validate(_value, options) {
    var _this4 = this;

    if (options === void 0) {
      options = {};
    }

    var value = _value;
    var originalValue = options.originalValue != null ? options.originalValue : _value;

    var isStrict = this._option('strict', options);

    var endEarly = this._option('abortEarly', options);

    var sync = options.sync;
    var path = options.path;
    var label = this._label;

    if (!isStrict) {
      value = this._cast(value, (0, _extends2.default)({
        assert: false
      }, options));
    } // value is cast, we can check if it meets type requirements


    var validationParams = {
      value: value,
      path: path,
      schema: this,
      options: options,
      label: label,
      originalValue: originalValue,
      sync: sync
    };
    var initialTests = [];
    if (this._typeError) initialTests.push(this._typeError(validationParams));
    if (this._whitelistError) initialTests.push(this._whitelistError(validationParams));
    if (this._blacklistError) initialTests.push(this._blacklistError(validationParams));
    return (0, _runValidations.default)({
      validations: initialTests,
      endEarly: endEarly,
      value: value,
      path: path,
      sync: sync
    }).then(function (value) {
      return (0, _runValidations.default)({
        path: path,
        sync: sync,
        value: value,
        endEarly: endEarly,
        validations: _this4.tests.map(function (fn) {
          return fn(validationParams);
        })
      });
    });
  },
  validate: function validate(value, options) {
    if (options === void 0) {
      options = {};
    }

    var schema = this.resolve((0, _extends2.default)({}, options, {
      value: value
    }));
    return schema._validate(value, options);
  },
  validateSync: function validateSync(value, options) {
    if (options === void 0) {
      options = {};
    }

    var schema = this.resolve((0, _extends2.default)({}, options, {
      value: value
    }));
    var result, err;

    schema._validate(value, (0, _extends2.default)({}, options, {
      sync: true
    })).then(function (r) {
      return result = r;
    }).catch(function (e) {
      return err = e;
    });

    if (err) throw err;
    return result;
  },
  isValid: function isValid(value, options) {
    return this.validate(value, options).then(function () {
      return true;
    }).catch(function (err) {
      if (err.name === 'ValidationError') return false;
      throw err;
    });
  },
  isValidSync: function isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (err.name === 'ValidationError') return false;
      throw err;
    }
  },
  getDefault: function getDefault(options) {
    if (options === void 0) {
      options = {};
    }

    var schema = this.resolve(options);
    return schema.default();
  },
  default: function _default(def) {
    if (arguments.length === 0) {
      var defaultValue = (0, _has.default)(this, '_default') ? this._default : this._defaultDefault;
      return typeof defaultValue === 'function' ? defaultValue.call(this) : (0, _cloneDeepWith.default)(defaultValue);
    }

    var next = this.clone();
    next._default = def;
    return next;
  },
  strict: function strict(isStrict) {
    if (isStrict === void 0) {
      isStrict = true;
    }

    var next = this.clone();
    next._options.strict = isStrict;
    return next;
  },
  _isPresent: function _isPresent(value) {
    return value != null;
  },
  required: function required(message) {
    if (message === void 0) {
      message = locale.mixed.required;
    }

    return this.test({
      message: message,
      name: 'required',
      exclusive: true,
      test: function test(value) {
        return this.schema._isPresent(value);
      }
    });
  },
  notRequired: function notRequired() {
    var next = this.clone();
    next.tests = next.tests.filter(function (test) {
      return test.OPTIONS.name !== 'required';
    });
    return next;
  },
  nullable: function nullable(isNullable) {
    if (isNullable === void 0) {
      isNullable = true;
    }

    var next = this.clone();
    next._nullable = isNullable;
    return next;
  },
  transform: function transform(fn) {
    var next = this.clone();
    next.transforms.push(fn);
    return next;
  },

  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test: function test() {
    var opts;

    if (arguments.length === 1) {
      if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'function') {
        opts = {
          test: arguments.length <= 0 ? undefined : arguments[0]
        };
      } else {
        opts = arguments.length <= 0 ? undefined : arguments[0];
      }
    } else if (arguments.length === 2) {
      opts = {
        name: arguments.length <= 0 ? undefined : arguments[0],
        test: arguments.length <= 1 ? undefined : arguments[1]
      };
    } else {
      opts = {
        name: arguments.length <= 0 ? undefined : arguments[0],
        message: arguments.length <= 1 ? undefined : arguments[1],
        test: arguments.length <= 2 ? undefined : arguments[2]
      };
    }

    if (opts.message === undefined) opts.message = locale.mixed.default;
    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    var next = this.clone();
    var validate = (0, _createValidation.default)(opts);
    var isExclusive = opts.exclusive || opts.name && next._exclusive[opts.name] === true;

    if (opts.exclusive && !opts.name) {
      throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }

    next._exclusive[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(function (fn) {
      if (fn.OPTIONS.name === opts.name) {
        if (isExclusive) return false;
        if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
      }

      return true;
    });
    next.tests.push(validate);
    return next;
  },
  when: function when(keys, options) {
    if (arguments.length === 1) {
      options = keys;
      keys = '.';
    }

    var next = this.clone(),
        deps = [].concat(keys).map(function (key) {
      return new _Reference.default(key);
    });
    deps.forEach(function (dep) {
      if (dep.isSibling) next._deps.push(dep.key);
    });

    next._conditions.push(new _Condition.default(deps, options));

    return next;
  },
  typeError: function typeError(message) {
    var next = this.clone();
    next._typeError = (0, _createValidation.default)({
      message: message,
      name: 'typeError',
      test: function test(value) {
        if (value !== undefined && !this.schema.isType(value)) return this.createError({
          params: {
            type: this.schema._type
          }
        });
        return true;
      }
    });
    return next;
  },
  oneOf: function oneOf(enums, message) {
    if (message === void 0) {
      message = locale.mixed.oneOf;
    }

    var next = this.clone();
    enums.forEach(function (val) {
      next._whitelist.add(val);

      next._blacklist.delete(val);
    });
    next._whitelistError = (0, _createValidation.default)({
      message: message,
      name: 'oneOf',
      test: function test(value) {
        if (value === undefined) return true;
        var valids = this.schema._whitelist;
        return valids.has(value, this.resolve) ? true : this.createError({
          params: {
            values: valids.toArray().join(', ')
          }
        });
      }
    });
    return next;
  },
  notOneOf: function notOneOf(enums, message) {
    if (message === void 0) {
      message = locale.mixed.notOneOf;
    }

    var next = this.clone();
    enums.forEach(function (val) {
      next._blacklist.add(val);

      next._whitelist.delete(val);
    });
    next._blacklistError = (0, _createValidation.default)({
      message: message,
      name: 'notOneOf',
      test: function test(value) {
        var invalids = this.schema._blacklist;
        if (invalids.has(value, this.resolve)) return this.createError({
          params: {
            values: invalids.toArray().join(', ')
          }
        });
        return true;
      }
    });
    return next;
  },
  strip: function strip(_strip) {
    if (_strip === void 0) {
      _strip = true;
    }

    var next = this.clone();
    next._strip = _strip;
    return next;
  },
  _option: function _option(key, overrides) {
    return (0, _has.default)(overrides, key) ? overrides[key] : this._options[key];
  },
  describe: function describe() {
    var next = this.clone();
    return {
      type: next._type,
      meta: next._meta,
      label: next._label,
      tests: next.tests.map(function (fn) {
        return {
          name: fn.OPTIONS.name,
          params: fn.OPTIONS.params
        };
      }).filter(function (n, idx, list) {
        return list.findIndex(function (c) {
          return c.name === n.name;
        }) === idx;
      })
    };
  }
};
var _arr = ['validate', 'validateSync'];

var _loop = function _loop() {
  var method = _arr[_i];

  proto[method + "At"] = function (path, value, options) {
    if (options === void 0) {
      options = {};
    }

    var _getIn = (0, reach_1.getIn)(this, path, value, options.context),
        parent = _getIn.parent,
        parentPath = _getIn.parentPath,
        schema = _getIn.schema;

    return schema[method](parent && parent[parentPath], (0, _extends2.default)({}, options, {
      parent: parent,
      path: path
    }));
  };
};

for (var _i = 0; _i < _arr.length; _i++) {
  _loop();
}

var _arr2 = ['equals', 'is'];

for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
  var alias = _arr2[_i2];
  proto[alias] = proto.oneOf;
}

var _arr3 = ['not', 'nope'];

for (var _i3 = 0; _i3 < _arr3.length; _i3++) {
  var _alias = _arr3[_i3];
  proto[_alias] = proto.notOneOf;
}

proto.optional = proto.notRequired;
module.exports = exports["default"];
});

unwrapExports(mixed);

var inherits_1 = createCommonjsModule(function (module, exports) {



exports.__esModule = true;
exports.default = inherits;

var _extends2 = interopRequireDefault(_extends_1);

function inherits(ctor, superCtor, spec) {
  ctor.prototype = Object.create(superCtor.prototype, {
    constructor: {
      value: ctor,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  (0, _extends2.default)(ctor.prototype, spec);
}

module.exports = exports["default"];
});

unwrapExports(inherits_1);

var boolean_1 = createCommonjsModule(function (module, exports) {



exports.__esModule = true;
exports.default = void 0;

var _inherits = interopRequireDefault(inherits_1);

var _mixed = interopRequireDefault(mixed);

var _default = BooleanSchema;
exports.default = _default;

function BooleanSchema() {
  var _this = this;

  if (!(this instanceof BooleanSchema)) return new BooleanSchema();

  _mixed.default.call(this, {
    type: 'boolean'
  });

  this.withMutation(function () {
    _this.transform(function (value) {
      if (!this.isType(value)) {
        if (/^(true|1)$/i.test(value)) return true;
        if (/^(false|0)$/i.test(value)) return false;
      }

      return value;
    });
  });
}

(0, _inherits.default)(BooleanSchema, _mixed.default, {
  _typeCheck: function _typeCheck(v) {
    if (v instanceof Boolean) v = v.valueOf();
    return typeof v === 'boolean';
  }
});
module.exports = exports["default"];
});

unwrapExports(boolean_1);

var isAbsent = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var _default = function _default(value) {
  return value == null;
};

exports.default = _default;
module.exports = exports["default"];
});

unwrapExports(isAbsent);

var string = createCommonjsModule(function (module, exports) {



exports.__esModule = true;
exports.default = StringSchema;

var _inherits = interopRequireDefault(inherits_1);

var _mixed = interopRequireDefault(mixed);



var _isAbsent = interopRequireDefault(isAbsent);

// eslint-disable-next-line
var rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line

var rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;

var isTrimmed = function isTrimmed(value) {
  return (0, _isAbsent.default)(value) || value === value.trim();
};

function StringSchema() {
  var _this = this;

  if (!(this instanceof StringSchema)) return new StringSchema();

  _mixed.default.call(this, {
    type: 'string'
  });

  this.withMutation(function () {
    _this.transform(function (value) {
      if (this.isType(value)) return value;
      return value != null && value.toString ? value.toString() : value;
    });
  });
}

(0, _inherits.default)(StringSchema, _mixed.default, {
  _typeCheck: function _typeCheck(value) {
    if (value instanceof String) value = value.valueOf();
    return typeof value === 'string';
  },
  _isPresent: function _isPresent(value) {
    return _mixed.default.prototype._cast.call(this, value) && value.length > 0;
  },
  length: function length(_length, message) {
    if (message === void 0) {
      message = locale.string.length;
    }

    return this.test({
      message: message,
      name: 'length',
      exclusive: true,
      params: {
        length: _length
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length === this.resolve(_length);
      }
    });
  },
  min: function min(_min, message) {
    if (message === void 0) {
      message = locale.string.min;
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length >= this.resolve(_min);
      }
    });
  },
  max: function max(_max, message) {
    if (message === void 0) {
      message = locale.string.max;
    }

    return this.test({
      name: 'max',
      exclusive: true,
      message: message,
      params: {
        max: _max
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length <= this.resolve(_max);
      }
    });
  },
  matches: function matches(regex, options) {
    var excludeEmptyString = false;
    var message;

    if (options) {
      if (options.message || options.hasOwnProperty('excludeEmptyString')) {
        excludeEmptyString = options.excludeEmptyString;
        message = options.message;
      } else message = options;
    }

    return this.test({
      message: message || locale.string.matches,
      params: {
        regex: regex
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value === '' && excludeEmptyString || regex.test(value);
      }
    });
  },
  email: function email(message) {
    if (message === void 0) {
      message = locale.string.email;
    }

    return this.matches(rEmail, {
      message: message,
      excludeEmptyString: true
    });
  },
  url: function url(message) {
    if (message === void 0) {
      message = locale.string.url;
    }

    return this.matches(rUrl, {
      message: message,
      excludeEmptyString: true
    });
  },
  //-- transforms --
  ensure: function ensure() {
    return this.default('').transform(function (val) {
      return val === null ? '' : val;
    });
  },
  trim: function trim(message) {
    if (message === void 0) {
      message = locale.string.trim;
    }

    return this.transform(function (val) {
      return val != null ? val.trim() : val;
    }).test({
      message: message,
      name: 'trim',
      test: isTrimmed
    });
  },
  lowercase: function lowercase(message) {
    if (message === void 0) {
      message = locale.string.lowercase;
    }

    return this.transform(function (value) {
      return !(0, _isAbsent.default)(value) ? value.toLowerCase() : value;
    }).test({
      message: message,
      name: 'string_case',
      exclusive: true,
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value === value.toLowerCase();
      }
    });
  },
  uppercase: function uppercase(message) {
    if (message === void 0) {
      message = locale.string.uppercase;
    }

    return this.transform(function (value) {
      return !(0, _isAbsent.default)(value) ? value.toUpperCase() : value;
    }).test({
      message: message,
      name: 'string_case',
      exclusive: true,
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value === value.toUpperCase();
      }
    });
  }
});
module.exports = exports["default"];
});

unwrapExports(string);

var number = createCommonjsModule(function (module, exports) {



exports.__esModule = true;
exports.default = NumberSchema;

var _inherits = interopRequireDefault(inherits_1);

var _mixed = interopRequireDefault(mixed);



var _isAbsent = interopRequireDefault(isAbsent);

var isNaN = function isNaN(value) {
  return value != +value;
};

var isInteger = function isInteger(val) {
  return (0, _isAbsent.default)(val) || val === (val | 0);
};

function NumberSchema() {
  var _this = this;

  if (!(this instanceof NumberSchema)) return new NumberSchema();

  _mixed.default.call(this, {
    type: 'number'
  });

  this.withMutation(function () {
    _this.transform(function (value) {
      var parsed = value;

      if (typeof parsed === 'string') {
        parsed = parsed.replace(/\s/g, '');
        if (parsed === '') return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings

        parsed = +parsed;
      }

      if (this.isType(parsed)) return parsed;
      return parseFloat(parsed);
    });
  });
}

(0, _inherits.default)(NumberSchema, _mixed.default, {
  _typeCheck: function _typeCheck(value) {
    if (value instanceof Number) value = value.valueOf();
    return typeof value === 'number' && !isNaN(value);
  },
  min: function min(_min, message) {
    if (message === void 0) {
      message = locale.number.min;
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value >= this.resolve(_min);
      }
    });
  },
  max: function max(_max, message) {
    if (message === void 0) {
      message = locale.number.max;
    }

    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        max: _max
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value <= this.resolve(_max);
      }
    });
  },
  lessThan: function lessThan(less, message) {
    if (message === void 0) {
      message = locale.number.lessThan;
    }

    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        less: less
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value < this.resolve(less);
      }
    });
  },
  moreThan: function moreThan(more, message) {
    if (message === void 0) {
      message = locale.number.moreThan;
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        more: more
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value > this.resolve(more);
      }
    });
  },
  positive: function positive(msg) {
    if (msg === void 0) {
      msg = locale.number.positive;
    }

    return this.moreThan(0, msg);
  },
  negative: function negative(msg) {
    if (msg === void 0) {
      msg = locale.number.negative;
    }

    return this.lessThan(0, msg);
  },
  integer: function integer(message) {
    if (message === void 0) {
      message = locale.number.integer;
    }

    return this.test({
      name: 'integer',
      message: message,
      test: isInteger
    });
  },
  truncate: function truncate() {
    return this.transform(function (value) {
      return !(0, _isAbsent.default)(value) ? value | 0 : value;
    });
  },
  round: function round(method) {
    var avail = ['ceil', 'floor', 'round', 'trunc'];
    method = method && method.toLowerCase() || 'round'; // this exists for symemtry with the new Math.trunc

    if (method === 'trunc') return this.truncate();
    if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
    return this.transform(function (value) {
      return !(0, _isAbsent.default)(value) ? Math[method](value) : value;
    });
  }
});
module.exports = exports["default"];
});

unwrapExports(number);

var isodate = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = parseIsoDate;

/* eslint-disable */

/**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */
//              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;

function parseIsoDate(date) {
  var numericKeys = [1, 4, 5, 6, 7, 10, 11],
      minutesOffset = 0,
      timestamp,
      struct;

  if (struct = isoReg.exec(date)) {
    // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
    for (var i = 0, k; k = numericKeys[i]; ++i) {
      struct[k] = +struct[k] || 0;
    } // allow undefined days and months


    struct[2] = (+struct[2] || 1) - 1;
    struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds

    struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time

    if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);else {
      if (struct[8] !== 'Z' && struct[9] !== undefined) {
        minutesOffset = struct[10] * 60 + struct[11];
        if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
      }

      timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
    }
  } else timestamp = Date.parse ? Date.parse(date) : NaN;

  return timestamp;
}

module.exports = exports["default"];
});

unwrapExports(isodate);

var date = createCommonjsModule(function (module, exports) {



exports.__esModule = true;
exports.default = void 0;

var _mixed = interopRequireDefault(mixed);

var _inherits = interopRequireDefault(inherits_1);

var _isodate = interopRequireDefault(isodate);



var _isAbsent = interopRequireDefault(isAbsent);

var _Reference = interopRequireDefault(Reference_1);

var invalidDate = new Date('');

var isDate = function isDate(obj) {
  return Object.prototype.toString.call(obj) === '[object Date]';
};

var _default = DateSchema;
exports.default = _default;

function DateSchema() {
  var _this = this;

  if (!(this instanceof DateSchema)) return new DateSchema();

  _mixed.default.call(this, {
    type: 'date'
  });

  this.withMutation(function () {
    _this.transform(function (value) {
      if (this.isType(value)) return value;
      value = (0, _isodate.default)(value);
      return value ? new Date(value) : invalidDate;
    });
  });
}

(0, _inherits.default)(DateSchema, _mixed.default, {
  _typeCheck: function _typeCheck(v) {
    return isDate(v) && !isNaN(v.getTime());
  },
  min: function min(_min, message) {
    if (message === void 0) {
      message = locale.date.min;
    }

    var limit = _min;

    if (!_Reference.default.isRef(limit)) {
      limit = this.cast(_min);
      if (!this._typeCheck(limit)) throw new TypeError('`min` must be a Date or a value that can be `cast()` to a Date');
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value >= this.resolve(limit);
      }
    });
  },
  max: function max(_max, message) {
    if (message === void 0) {
      message = locale.date.max;
    }

    var limit = _max;

    if (!_Reference.default.isRef(limit)) {
      limit = this.cast(_max);
      if (!this._typeCheck(limit)) throw new TypeError('`max` must be a Date or a value that can be `cast()` to a Date');
    }

    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        max: _max
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value <= this.resolve(limit);
      }
    });
  }
});
module.exports = exports["default"];
});

unwrapExports(date);

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;
});

var interopRequireWildcard = createCommonjsModule(function (module) {
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof_1(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

module.exports = _interopRequireWildcard;
});

unwrapExports(interopRequireWildcard);

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var taggedTemplateLiteralLoose = _taggedTemplateLiteralLoose;

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

var _arrayReduce = arrayReduce;

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

var _basePropertyOf = basePropertyOf;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = _basePropertyOf(deburredLetters);

var _deburrLetter = deburrLetter;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange$2 = '\\u0300-\\u036f',
    reComboHalfMarksRange$2 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$2 = '\\u20d0-\\u20ff',
    rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2;

/** Used to compose unicode capture groups. */
var rsCombo$1 = '[' + rsComboRange$2 + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo$1, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString_1(string);
  return string && string.replace(reLatin, _deburrLetter).replace(reComboMark, '');
}

var deburr_1 = deburr;

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

var _asciiWords = asciiWords;

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

var _hasUnicodeWord = hasUnicodeWord;

/** Used to compose unicode character classes. */
var rsAstralRange$2 = '\\ud800-\\udfff',
    rsComboMarksRange$3 = '\\u0300-\\u036f',
    reComboHalfMarksRange$3 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$3 = '\\u20d0-\\u20ff',
    rsComboRange$3 = rsComboMarksRange$3 + reComboHalfMarksRange$3 + rsComboSymbolsRange$3,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange$2 = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo$2 = '[' + rsComboRange$3 + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange$2 + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz$1 = '\\ud83c[\\udffb-\\udfff]',
    rsModifier$1 = '(?:' + rsCombo$2 + '|' + rsFitz$1 + ')',
    rsNonAstral$1 = '[^' + rsAstralRange$2 + ']',
    rsRegional$1 = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair$1 = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ$2 = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod$1 = rsModifier$1 + '?',
    rsOptVar$1 = '[' + rsVarRange$2 + ']?',
    rsOptJoin$1 = '(?:' + rsZWJ$2 + '(?:' + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsOptVar$1 + reOptMod$1 + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1,
    rsEmoji = '(?:' + [rsDingbat, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsSeq$1;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

var _unicodeWords = unicodeWords;

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString_1(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return _hasUnicodeWord(string) ? _unicodeWords(string) : _asciiWords(string);
  }
  return string.match(pattern) || [];
}

var words_1 = words;

/** Used to compose unicode capture groups. */
var rsApos$1 = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos$1, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return _arrayReduce(words_1(deburr_1(string).replace(reApos, '')), callback, '');
  };
}

var _createCompounder = createCompounder;

/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = _createCompounder(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

var snakeCase_1 = snakeCase;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

var _baseSlice = baseSlice;

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : _baseSlice(array, start, end);
}

var _castSlice = castSlice;

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString_1(string);

    var strSymbols = _hasUnicode(string)
      ? _stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? _castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

var _createCaseFirst = createCaseFirst;

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = _createCaseFirst('toUpperCase');

var upperFirst_1 = upperFirst;

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst_1(toString_1(string).toLowerCase());
}

var capitalize_1 = capitalize;

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase$1 = _createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize_1(word) : word);
});

var camelCase_1 = camelCase$1;

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = _baseIteratee(iteratee);

  _baseForOwn(object, function(value, key, object) {
    _baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

var mapKeys_1 = mapKeys;

/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */

var toposort_1 = function(edges) {
  return toposort(uniqueNodes(edges), edges)
};

var array = toposort;

function toposort(nodes, edges) {
  var cursor = nodes.length
    , sorted = new Array(cursor)
    , visited = {}
    , i = cursor
    // Better data structures make algorithm much faster.
    , outgoingEdges = makeOutgoingEdges(edges)
    , nodesHash = makeNodesHash(nodes);

  // check for unknown nodes
  edges.forEach(function(edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error('Unknown node. There is an unknown node in the supplied edges.')
    }
  });

  while (i--) {
    if (!visited[i]) visit(nodes[i], i, new Set());
  }

  return sorted

  function visit(node, i, predecessors) {
    if(predecessors.has(node)) {
      var nodeRep;
      try {
        nodeRep = ", node was:" + JSON.stringify(node);
      } catch(e) {
        nodeRep = "";
      }
      throw new Error('Cyclic dependency' + nodeRep)
    }

    if (!nodesHash.has(node)) {
      throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: '+JSON.stringify(node))
    }

    if (visited[i]) return;
    visited[i] = true;

    var outgoing = outgoingEdges.get(node) || new Set();
    outgoing = Array.from(outgoing);

    if (i = outgoing.length) {
      predecessors.add(node);
      do {
        var child = outgoing[--i];
        visit(child, nodesHash.get(child), predecessors);
      } while (i)
      predecessors.delete(node);
    }

    sorted[--cursor] = node;
  }
}

function uniqueNodes(arr){
  var res = new Set();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    res.add(edge[0]);
    res.add(edge[1]);
  }
  return Array.from(res)
}

function makeOutgoingEdges(arr){
  var edges = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    if (!edges.has(edge[0])) edges.set(edge[0], new Set());
    if (!edges.has(edge[1])) edges.set(edge[1], new Set());
    edges.get(edge[0]).add(edge[1]);
  }
  return edges
}

function makeNodesHash(arr){
  var res = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    res.set(arr[i], i);
  }
  return res
}
toposort_1.array = array;

var sortFields_1 = createCommonjsModule(function (module, exports) {



exports.__esModule = true;
exports.default = sortFields;

var _has = interopRequireDefault(has_1);

var _toposort = interopRequireDefault(toposort_1);



var _Reference = interopRequireDefault(Reference_1);

var _isSchema = interopRequireDefault(isSchema);

function sortFields(fields, excludes) {
  if (excludes === void 0) {
    excludes = [];
  }

  var edges = [],
      nodes = [];

  function addNode(depPath, key) {
    var node = (0, propertyExpr.split)(depPath)[0];
    if (!~nodes.indexOf(node)) nodes.push(node);
    if (!~excludes.indexOf(key + "-" + node)) edges.push([key, node]);
  }

  for (var key in fields) {
    if ((0, _has.default)(fields, key)) {
      var value = fields[key];
      if (!~nodes.indexOf(key)) nodes.push(key);
      if (_Reference.default.isRef(value) && value.isSibling) addNode(value.path, key);else if ((0, _isSchema.default)(value) && value._deps) value._deps.forEach(function (path) {
        return addNode(path, key);
      });
    }
  }

  return _toposort.default.array(nodes, edges).reverse();
}

module.exports = exports["default"];
});

unwrapExports(sortFields_1);

var sortByKeyOrder_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = sortByKeyOrder;

function findIndex(arr, err) {
  var idx = Infinity;
  arr.some(function (key, ii) {
    if (err.path.indexOf(key) !== -1) {
      idx = ii;
      return true;
    }
  });
  return idx;
}

function sortByKeyOrder(fields) {
  var keys = Object.keys(fields);
  return function (a, b) {
    return findIndex(keys, a) - findIndex(keys, b);
  };
}

module.exports = exports["default"];
});

unwrapExports(sortByKeyOrder_1);

var makePath_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = makePath;

function makePath(strings) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  var path = strings.reduce(function (str, next) {
    var value = values.shift();
    return str + (value == null ? '' : value) + next;
  });
  return path.replace(/^\./, '');
}

module.exports = exports["default"];
});

unwrapExports(makePath_1);

var object = createCommonjsModule(function (module, exports) {





exports.__esModule = true;
exports.default = ObjectSchema;

var _taggedTemplateLiteralLoose2 = interopRequireDefault(taggedTemplateLiteralLoose);

var _extends2 = interopRequireDefault(_extends_1);

var _has = interopRequireDefault(has_1);

var _snakeCase2 = interopRequireDefault(snakeCase_1);

var _camelCase2 = interopRequireDefault(camelCase_1);

var _mapKeys = interopRequireDefault(mapKeys_1);

var _mapValues = interopRequireDefault(mapValues_1);



var _mixed = interopRequireDefault(mixed);



var _sortFields = interopRequireDefault(sortFields_1);

var _sortByKeyOrder = interopRequireDefault(sortByKeyOrder_1);

var _inherits = interopRequireDefault(inherits_1);

var _makePath = interopRequireDefault(makePath_1);

var _runValidations = interopRequireWildcard(runValidations_1);

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["", ".", ""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["", ".", ""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var isObject = function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};

function unknown(ctx, value) {
  var known = Object.keys(ctx.fields);
  return Object.keys(value).filter(function (key) {
    return known.indexOf(key) === -1;
  });
}

function ObjectSchema(spec) {
  var _this2 = this;

  if (!(this instanceof ObjectSchema)) return new ObjectSchema(spec);

  _mixed.default.call(this, {
    type: 'object',
    default: function _default() {
      var _this = this;

      if (!this._nodes.length) return undefined;
      var dft = {};

      this._nodes.forEach(function (key) {
        dft[key] = _this.fields[key].default ? _this.fields[key].default() : undefined;
      });

      return dft;
    }
  });

  this.fields = Object.create(null);
  this._nodes = [];
  this._excludedEdges = [];
  this.withMutation(function () {
    _this2.transform(function coerce(value) {
      if (typeof value === 'string') {
        try {
          value = JSON.parse(value);
        } catch (err) {
          value = null;
        }
      }

      if (this.isType(value)) return value;
      return null;
    });

    if (spec) {
      _this2.shape(spec);
    }
  });
}

(0, _inherits.default)(ObjectSchema, _mixed.default, {
  _typeCheck: function _typeCheck(value) {
    return isObject(value) || typeof value === 'function';
  },
  _cast: function _cast(_value, options) {
    var _this3 = this;

    if (options === void 0) {
      options = {};
    }

    var value = _mixed.default.prototype._cast.call(this, _value, options); //should ignore nulls here


    if (value === undefined) return this.default();
    if (!this._typeCheck(value)) return value;
    var fields = this.fields;
    var strip = this._option('stripUnknown', options) === true;

    var props = this._nodes.concat(Object.keys(value).filter(function (v) {
      return _this3._nodes.indexOf(v) === -1;
    }));

    var intermediateValue = {}; // is filled during the transform below

    var innerOptions = (0, _extends2.default)({}, options, {
      parent: intermediateValue,
      __validating: false
    });
    var isChanged = false;
    props.forEach(function (prop) {
      var field = fields[prop];
      var exists = (0, _has.default)(value, prop);

      if (field) {
        var fieldValue;
        var strict = field._options && field._options.strict; // safe to mutate since this is fired in sequence

        innerOptions.path = (0, _makePath.default)(_templateObject(), options.path, prop);
        innerOptions.value = value[prop];
        field = field.resolve(innerOptions);

        if (field._strip === true) {
          isChanged = isChanged || prop in value;
          return;
        }

        fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
        if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
      } else if (exists && !strip) intermediateValue[prop] = value[prop];

      if (intermediateValue[prop] !== value[prop]) isChanged = true;
    });
    return isChanged ? intermediateValue : value;
  },
  _validate: function _validate(_value, opts) {
    var _this4 = this;

    if (opts === void 0) {
      opts = {};
    }

    var endEarly, recursive;
    var sync = opts.sync;
    var errors = [];
    var originalValue = opts.originalValue != null ? opts.originalValue : _value;
    endEarly = this._option('abortEarly', opts);
    recursive = this._option('recursive', opts);
    opts = (0, _extends2.default)({}, opts, {
      __validating: true,
      originalValue: originalValue
    });
    return _mixed.default.prototype._validate.call(this, _value, opts).catch((0, _runValidations.propagateErrors)(endEarly, errors)).then(function (value) {
      if (!recursive || !isObject(value)) {
        // only iterate though actual objects
        if (errors.length) throw errors[0];
        return value;
      }

      originalValue = originalValue || value;

      var validations = _this4._nodes.map(function (key) {
        var path = (0, _makePath.default)(_templateObject2(), opts.path, key);
        var field = _this4.fields[key];
        var innerOptions = (0, _extends2.default)({}, opts, {
          path: path,
          parent: value,
          originalValue: originalValue[key]
        });

        if (field && field.validate) {
          // inner fields are always strict:
          // 1. this isn't strict so the casting will also have cast inner values
          // 2. this is strict in which case the nested values weren't cast either
          innerOptions.strict = true;
          return field.validate(value[key], innerOptions);
        }

        return Promise.resolve(true);
      });

      return (0, _runValidations.default)({
        sync: sync,
        validations: validations,
        value: value,
        errors: errors,
        endEarly: endEarly,
        path: opts.path,
        sort: (0, _sortByKeyOrder.default)(_this4.fields)
      });
    });
  },
  concat: function concat(schema) {
    var next = _mixed.default.prototype.concat.call(this, schema);

    next._nodes = (0, _sortFields.default)(next.fields, next._excludedEdges);
    return next;
  },
  shape: function shape(schema, excludes) {
    if (excludes === void 0) {
      excludes = [];
    }

    var next = this.clone();
    var fields = (0, _extends2.default)(next.fields, schema);
    next.fields = fields;

    if (excludes.length) {
      if (!Array.isArray(excludes[0])) excludes = [excludes];
      var keys = excludes.map(function (_ref) {
        var first = _ref[0],
            second = _ref[1];
        return first + "-" + second;
      });
      next._excludedEdges = next._excludedEdges.concat(keys);
    }

    next._nodes = (0, _sortFields.default)(fields, next._excludedEdges);
    return next;
  },
  from: function from(_from, to, alias) {
    var fromGetter = (0, propertyExpr.getter)(_from, true);
    return this.transform(function (obj) {
      if (obj == null) return obj;
      var newObj = obj;

      if ((0, _has.default)(obj, _from)) {
        newObj = (0, _extends2.default)({}, obj);
        if (!alias) delete newObj[_from];
        newObj[to] = fromGetter(obj);
      }

      return newObj;
    });
  },
  noUnknown: function noUnknown(noAllow, message) {
    if (noAllow === void 0) {
      noAllow = true;
    }

    if (message === void 0) {
      message = locale.object.noUnknown;
    }

    if (typeof noAllow === 'string') {
      message = noAllow;
      noAllow = true;
    }

    var next = this.test({
      name: 'noUnknown',
      exclusive: true,
      message: message,
      test: function test(value) {
        return value == null || !noAllow || unknown(this.schema, value).length === 0;
      }
    });
    next._options.stripUnknown = noAllow;
    return next;
  },
  unknown: function unknown(allow, message) {
    if (allow === void 0) {
      allow = true;
    }

    if (message === void 0) {
      message = locale.object.noUnknown;
    }

    return this.noUnknown(!allow, message);
  },
  transformKeys: function transformKeys(fn) {
    return this.transform(function (obj) {
      return obj && (0, _mapKeys.default)(obj, function (_, key) {
        return fn(key);
      });
    });
  },
  camelCase: function camelCase() {
    return this.transformKeys(_camelCase2.default);
  },
  snakeCase: function snakeCase() {
    return this.transformKeys(_snakeCase2.default);
  },
  constantCase: function constantCase() {
    return this.transformKeys(function (key) {
      return (0, _snakeCase2.default)(key).toUpperCase();
    });
  },
  describe: function describe() {
    var base = _mixed.default.prototype.describe.call(this);

    base.fields = (0, _mapValues.default)(this.fields, function (value) {
      return value.describe();
    });
    return base;
  }
});
module.exports = exports["default"];
});

unwrapExports(object);

var array$1 = createCommonjsModule(function (module, exports) {





exports.__esModule = true;
exports.default = void 0;

var _extends2 = interopRequireDefault(_extends_1);

var _taggedTemplateLiteralLoose2 = interopRequireDefault(taggedTemplateLiteralLoose);

var _inherits = interopRequireDefault(inherits_1);

var _isAbsent = interopRequireDefault(isAbsent);

var _isSchema = interopRequireDefault(isSchema);

var _makePath = interopRequireDefault(makePath_1);

var _printValue = interopRequireDefault(printValue_1);

var _mixed = interopRequireDefault(mixed);



var _runValidations = interopRequireWildcard(runValidations_1);

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["", "[", "]"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _default = ArraySchema;
exports.default = _default;

function ArraySchema(type) {
  var _this = this;

  if (!(this instanceof ArraySchema)) return new ArraySchema(type);

  _mixed.default.call(this, {
    type: 'array'
  }); // `undefined` specifically means uninitialized, as opposed to
  // "no subtype"


  this._subType = undefined;
  this.withMutation(function () {
    _this.transform(function (values) {
      if (typeof values === 'string') try {
        values = JSON.parse(values);
      } catch (err) {
        values = null;
      }
      return this.isType(values) ? values : null;
    });

    if (type) _this.of(type);
  });
}

(0, _inherits.default)(ArraySchema, _mixed.default, {
  _typeCheck: function _typeCheck(v) {
    return Array.isArray(v);
  },
  _cast: function _cast(_value, _opts) {
    var _this2 = this;

    var value = _mixed.default.prototype._cast.call(this, _value, _opts); //should ignore nulls here


    if (!this._typeCheck(value) || !this._subType) return value;
    var isChanged = false;
    var castArray = value.map(function (v) {
      var castElement = _this2._subType.cast(v, _opts);

      if (castElement !== v) {
        isChanged = true;
      }

      return castElement;
    });
    return isChanged ? castArray : value;
  },
  _validate: function _validate(_value, options) {
    var _this3 = this;

    if (options === void 0) {
      options = {};
    }

    var errors = [];
    var sync = options.sync;
    var path = options.path;
    var subType = this._subType;

    var endEarly = this._option('abortEarly', options);

    var recursive = this._option('recursive', options);

    var originalValue = options.originalValue != null ? options.originalValue : _value;
    return _mixed.default.prototype._validate.call(this, _value, options).catch((0, _runValidations.propagateErrors)(endEarly, errors)).then(function (value) {
      if (!recursive || !subType || !_this3._typeCheck(value)) {
        if (errors.length) throw errors[0];
        return value;
      }

      originalValue = originalValue || value;
      var validations = value.map(function (item, idx) {
        var path = (0, _makePath.default)(_templateObject(), options.path, idx); // object._validate note for isStrict explanation

        var innerOptions = (0, _extends2.default)({}, options, {
          path: path,
          strict: true,
          parent: value,
          originalValue: originalValue[idx]
        });
        if (subType.validate) return subType.validate(item, innerOptions);
        return true;
      });
      return (0, _runValidations.default)({
        sync: sync,
        path: path,
        value: value,
        errors: errors,
        endEarly: endEarly,
        validations: validations
      });
    });
  },
  _isPresent: function _isPresent(value) {
    return _mixed.default.prototype._cast.call(this, value) && value.length > 0;
  },
  of: function of(schema) {
    var next = this.clone();
    if (schema !== false && !(0, _isSchema.default)(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema, or `false` to negate a current sub-schema. ' + 'not: ' + (0, _printValue.default)(schema));
    next._subType = schema;
    return next;
  },
  min: function min(_min, message) {
    message = message || locale.array.min;
    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length >= this.resolve(_min);
      }
    });
  },
  max: function max(_max, message) {
    message = message || locale.array.max;
    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        max: _max
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length <= this.resolve(_max);
      }
    });
  },
  ensure: function ensure() {
    var _this4 = this;

    return this.default(function () {
      return [];
    }).transform(function (val) {
      if (_this4.isType(val)) return val;
      return val === null ? [] : [].concat(val);
    });
  },
  compact: function compact(rejector) {
    var reject = !rejector ? function (v) {
      return !!v;
    } : function (v, i, a) {
      return !rejector(v, i, a);
    };
    return this.transform(function (values) {
      return values != null ? values.filter(reject) : values;
    });
  },
  describe: function describe() {
    var base = _mixed.default.prototype.describe.call(this);

    if (this._subType) base.innerType = this._subType.describe();
    return base;
  }
});
module.exports = exports["default"];
});

unwrapExports(array$1);

var Lazy_1 = createCommonjsModule(function (module, exports) {



exports.__esModule = true;
exports.default = void 0;

var _isSchema = interopRequireDefault(isSchema);

var Lazy =
/*#__PURE__*/
function () {
  function Lazy(mapFn) {
    this._resolve = function (value, options) {
      var schema = mapFn(value, options);
      if (!(0, _isSchema.default)(schema)) throw new TypeError('lazy() functions must return a valid schema');
      return schema.resolve(options);
    };
  }

  var _proto = Lazy.prototype;

  _proto.resolve = function resolve(options) {
    return this._resolve(options.value, options);
  };

  _proto.cast = function cast(value, options) {
    return this._resolve(value, options).cast(value, options);
  };

  _proto.validate = function validate(value, options) {
    return this._resolve(value, options).validate(value, options);
  };

  _proto.validateSync = function validateSync(value, options) {
    return this._resolve(value, options).validateSync(value, options);
  };

  _proto.validateAt = function validateAt(path, value, options) {
    return this._resolve(value, options).validateAt(path, value, options);
  };

  _proto.validateSyncAt = function validateSyncAt(path, value, options) {
    return this._resolve(value, options).validateSyncAt(path, value, options);
  };

  return Lazy;
}();

Lazy.prototype.__isYupSchema__ = true;
var _default = Lazy;
exports.default = _default;
module.exports = exports["default"];
});

unwrapExports(Lazy_1);

var setLocale_1 = createCommonjsModule(function (module, exports) {



exports.__esModule = true;
exports.default = setLocale;

var _locale = interopRequireDefault(locale);

function setLocale(custom) {
  Object.keys(custom).forEach(function (type) {
    Object.keys(custom[type]).forEach(function (method) {
      _locale.default[type][method] = custom[type][method];
    });
  });
}

module.exports = exports["default"];
});

unwrapExports(setLocale_1);

var lib = createCommonjsModule(function (module, exports) {



exports.__esModule = true;
exports.addMethod = addMethod;
exports.lazy = exports.ref = exports.boolean = void 0;

var _mixed = interopRequireDefault(mixed);

exports.mixed = _mixed.default;

var _boolean = interopRequireDefault(boolean_1);

exports.bool = _boolean.default;

var _string = interopRequireDefault(string);

exports.string = _string.default;

var _number = interopRequireDefault(number);

exports.number = _number.default;

var _date = interopRequireDefault(date);

exports.date = _date.default;

var _object = interopRequireDefault(object);

exports.object = _object.default;

var _array = interopRequireDefault(array$1);

exports.array = _array.default;

var _Reference = interopRequireDefault(Reference_1);

var _Lazy = interopRequireDefault(Lazy_1);

var _ValidationError = interopRequireDefault(ValidationError_1);

exports.ValidationError = _ValidationError.default;

var _reach = interopRequireDefault(reach_1);

exports.reach = _reach.default;

var _isSchema = interopRequireDefault(isSchema);

exports.isSchema = _isSchema.default;

var _setLocale = interopRequireDefault(setLocale_1);

exports.setLocale = _setLocale.default;
var boolean = _boolean.default;
exports.boolean = boolean;

var ref = function ref(key, options) {
  return new _Reference.default(key, options);
};

exports.ref = ref;

var lazy = function lazy(fn) {
  return new _Lazy.default(fn);
};

exports.lazy = lazy;

function addMethod(schemaType, name, fn) {
  if (!schemaType || !(0, _isSchema.default)(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
  if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
  if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
  schemaType.prototype[name] = fn;
}
});

unwrapExports(lib);
var lib_1 = lib.addMethod;
var lib_2 = lib.lazy;
var lib_3 = lib.ref;
var lib_4 = lib.mixed;
var lib_5 = lib.bool;
var lib_6 = lib.string;
var lib_7 = lib.number;
var lib_8 = lib.date;
var lib_9 = lib.object;
var lib_10 = lib.array;
var lib_11 = lib.ValidationError;
var lib_12 = lib.reach;
var lib_13 = lib.isSchema;
var lib_14 = lib.setLocale;

var FormikInput = function FormikInput(_ref) {
  var field = _ref.field,
      form = _ref.form,
      required = _ref.required,
      inputProps = _objectWithoutProperties(_ref, ["field", "form", "required"]);

  var error = form.touched[field.name] && form.errors[field.name]; // if input is required, only set valid as true if there is a value, too

  var valid = required ? form.touched[field.name] && !error && field.value : form.touched[field.name] && !error;
  var validationProps = {
    isSuccessful: !!valid,
    hasError: !!error,
    helperText: error
  };
  return /*#__PURE__*/React__default.createElement(Input, _extends({}, field, inputProps, validationProps));
};

FormikInput.propTypes = {
  field: PropTypes__default.shape({
    name: PropTypes__default.string,
    value: PropTypes__default.string
  }).isRequired,
  form: PropTypes__default.shape({
    touched: PropTypes__default.arrayOf(PropTypes__default.shape({})),
    errors: PropTypes__default.arrayOf(PropTypes__default.shape({}))
  }).isRequired,
  required: PropTypes__default.bool
};
FormikInput.defaultProps = {
  required: null
};

var House = (function (_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "343",
    height: "154",
    viewBox: "0 0 343 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M307.5 86C318.281 86 327 83.5216 327 80.5C327 77.4444 318.258 75 307.5 75C296.719 75 288 77.4784 288 80.5C288 83.5556 296.719 86 307.5 86Z",
    fill: "#00B085"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M152 154C236.039 154 304 142.059 304 127.5C304 112.778 235.856 101 152 101C67.9616 101 0 112.941 0 127.5C0 142.222 67.9616 154 152 154Z",
    fill: "#00B085"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M331 52C337.625 52 343 50.2316 343 48C343 45.8105 337.625 44 331 44C324.375 44 319 45.7684 319 48C319 50.2316 324.375 52 331 52Z",
    fill: "#00B085"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M252.097 5.12109C252.097 5.12109 265.208 33.4313 298.598 16.6336",
    stroke: "#0087FF",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M299.95 16.3877C299.95 16.3877 305.44 31.2598 325.802 20.4027",
    stroke: "#0087FF",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M318.714 15.8553C318.714 15.7324 318.714 15.5685 318.632 15.4456C318.468 15.0769 318.14 14.8311 317.73 14.8311C317.239 14.8311 316.829 15.1998 316.747 15.6914H315.928C315.887 15.1998 315.436 14.8311 314.945 14.8311C314.453 14.8311 314.043 15.1998 313.961 15.6914H301.506C301.465 15.1998 301.015 14.8311 300.523 14.8311C300.031 14.8311 299.622 15.1998 299.54 15.6914H298.72C298.679 15.1998 298.229 14.8311 297.737 14.8311C297.246 14.8311 296.836 15.1998 296.754 15.6505V15.6914V16.7976H301.343L307.201 21.1404V80.26H308.348V21.2224L314.207 16.8795H318.796L318.714 15.8553ZM307.693 20.2391L303.186 16.9205H312.2L307.693 20.2391Z",
    fill: "#001A3C"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M319.124 15.8553C319.124 15.7324 319.124 15.5685 319.042 15.4456C318.878 15.0769 318.55 14.8311 318.141 14.8311C317.649 14.8311 317.239 15.1998 317.157 15.6914H316.338C316.297 15.1998 315.846 14.8311 315.355 14.8311C314.863 14.8311 314.453 15.1998 314.371 15.6914H301.917C301.876 15.1998 301.425 14.8311 300.933 14.8311C300.442 14.8311 300.032 15.1998 299.95 15.6914H299.131C299.09 15.1998 298.639 14.8311 298.147 14.8311C297.656 14.8311 297.246 15.1998 297.164 15.6505V15.6914V16.7976H301.753L307.611 21.1404V80.26H308.759V21.2224L314.617 16.8795H319.206L319.124 15.8553ZM308.103 20.2391L303.596 16.9205H312.61L308.103 20.2391Z",
    fill: "#003768"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M298.885 5.12109C298.885 5.12109 303.924 21.3042 316.502 16.6336",
    stroke: "#0087FF",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M304.088 2.54013C304.088 2.21237 304.047 1.84364 303.924 1.51588C303.514 0.614547 302.613 0 301.589 0C300.278 0 299.253 0.942309 299.089 2.17141H296.959C296.795 0.942309 295.73 0 294.419 0C293.149 0 292.084 0.942309 291.92 2.17141H260.168C260.004 0.942309 258.939 0 257.669 0C256.358 0 255.334 0.942309 255.129 2.17141H252.998C252.834 0.942309 251.769 0 250.499 0C249.229 0 248.205 0.901337 248 2.08946C248 2.13043 248 2.21237 248 2.25334V5.08027H259.717L274.63 16.1421V124.63H277.539V16.1421L292.452 5.08027H304.129L304.088 2.54013ZM276.064 13.602L264.593 5.08027H287.577L276.064 13.602Z",
    fill: "#001A3C"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M304.743 2.54013C304.743 2.21237 304.702 1.84364 304.579 1.51588C304.169 0.614547 303.268 0 302.244 0C300.933 0 299.909 0.942309 299.745 2.17141H297.614C297.45 0.942309 296.385 0 295.074 0C293.804 0 292.739 0.942309 292.575 2.17141H260.823C260.659 0.942309 259.594 0 258.324 0C257.013 0 255.989 0.942309 255.784 2.17141H253.654C253.49 0.942309 252.424 0 251.154 0C249.884 0 248.86 0.901337 248.655 2.08946C248.655 2.13043 248.655 2.21237 248.655 2.25334V5.08027H260.373L275.286 16.1421V124.63H278.195V16.1421L293.108 5.08027H304.784L304.743 2.54013ZM276.72 13.602L265.248 5.08027H288.232L276.72 13.602Z",
    fill: "#003768"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M337.683 19.9114C337.683 19.8295 337.683 19.7475 337.642 19.6656C337.56 19.4608 337.314 19.2969 337.068 19.2969C336.741 19.2969 336.495 19.5427 336.454 19.8295H335.921C335.88 19.5427 335.634 19.2969 335.307 19.2969C334.979 19.2969 334.733 19.5427 334.692 19.8295H326.867C326.826 19.5427 326.58 19.2969 326.252 19.2969C325.924 19.2969 325.679 19.5427 325.638 19.8295H325.105C325.064 19.5427 324.818 19.2969 324.491 19.2969C324.204 19.2969 323.917 19.5017 323.876 19.8295C323.876 19.8295 323.876 19.8295 323.876 19.8705V20.5669H326.744L330.431 23.271V47.5251H331.128V23.23L334.815 20.526H337.683V19.9114ZM330.8 22.6154L327.973 20.526H333.627L330.8 22.6154Z",
    fill: "#001A3C"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M337.929 19.9114C337.929 19.8295 337.929 19.7475 337.888 19.6656C337.806 19.4608 337.56 19.2969 337.314 19.2969C336.987 19.2969 336.741 19.5427 336.7 19.8295H336.167C336.126 19.5427 335.88 19.2969 335.553 19.2969C335.225 19.2969 334.979 19.5427 334.938 19.8295H327.113C327.072 19.5427 326.826 19.2969 326.498 19.2969C326.171 19.2969 325.925 19.5427 325.884 19.8295H325.351C325.31 19.5427 325.064 19.2969 324.737 19.2969C324.45 19.2969 324.163 19.5017 324.122 19.8295C324.122 19.8295 324.122 19.8295 324.122 19.8705V20.5669H326.99L330.677 23.271V47.5251H331.374V23.23L335.061 20.526H337.929V19.9114ZM331.046 22.6154L328.219 20.526H333.873L331.046 22.6154Z",
    fill: "#003768"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M316.338 16.5928C316.338 16.5928 325.761 28.4331 336.495 20.2391",
    stroke: "#0087FF",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M198.929 117.81H198.954",
    stroke: "#001A3C",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.081 124.812H240.006V60.0816L119.081 59.3702V124.812Z",
    fill: "#DEDBD6"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.637 60.4883V125.357H41.9736V60.7816L84.8356 11L122.637 60.4883Z",
    fill: "#D3D0CA"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.006 60.0815L205.049 11H84.8359L119.504 60.4886L240.006 60.0815Z",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.637 60.0815C122.637 85.5733 122.637 99.8654 122.637 125.357L97.306 125.444L41.9736 60.7819L84.8356 11L122.637 60.0815Z",
    fill: "#D3D0CA"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.5845 125.357H117.111V84.4502H87.5845V125.357Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8188 84.6346V125.357H87.5838V84.4497L60.8483 53.2416L33.8188 84.6346Z",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.111 84.4497L90.4121 53.2415H60.8486L87.5839 84.45L117.111 84.4497Z",
    fill: "#DEDBD6"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.6851 125.229H110.009V89.9953H94.6851V125.229Z",
    fill: "#FFD35C"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M102.347 89.9948V125.229",
    stroke: "#F4F4F4",
    strokeWidth: "2"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M110.029 107.612H94.665",
    stroke: "#F4F4F4",
    strokeWidth: "2"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5342 125.327H72.0046V90.4588H49.5342V125.327Z",
    fill: "#D3D0CA"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.571 36.0273C93.571 41.014 89.6599 45.0561 84.8353 45.0561C80.0108 45.0561 76.0996 41.014 76.0996 36.0273C76.0996 31.0406 80.0108 26.9985 84.8353 26.9985C89.6599 26.9985 93.571 31.0406 93.571 36.0273Z",
    fill: "#EEEDEA"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M106.349 16.6906H197.149L223.884 52.4477H133.122L106.349 16.6906Z",
    fill: "#0087FF"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M196.892 17.0617L223.388 52.4974H133.021L106.485 17.0617H196.881H196.892ZM197.042 16.7402H105.853L132.86 52.8189H224.023L197.054 16.7402H197.042Z",
    fill: "#E2E1DE"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M105.852 16.7402L104.854 18.317L131.867 54.3956L132.866 52.8188L105.852 16.7402Z",
    fill: "#00589D"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M132.865 52.819H224.029L223.03 54.3958H131.867L132.865 52.819Z",
    fill: "#00589D"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M143.871 16.7402L170.883 52.8189",
    stroke: "#E2E1DE",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M157.354 16.7402L184.367 52.8189",
    stroke: "#E2E1DE",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M170.834 16.7402L197.848 52.8189",
    stroke: "#E2E1DE",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M184.318 16.7402L211.332 52.8189",
    stroke: "#E2E1DE",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M116.906 16.7402L143.919 52.8189",
    stroke: "#E2E1DE",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M130.388 16.7402L157.401 52.8189",
    stroke: "#E2E1DE",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M111.32 24.1631H202.522",
    stroke: "#E2E1DE",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M117.861 32.7418H209.061",
    stroke: "#E2E1DE",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M125.234 42.7313H216.436",
    stroke: "#E2E1DE",
    strokeMiterlimit: "10"
  }));
});

function _templateObject$d() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n\n  p {\n    position: absolute;\n    top: 56%;\n    left: 0;\n    right: 0;\n    margin: auto;\n    color: white;\n    font-family: 'Nunito';\n    text-align: center;\n    text-transform: uppercase;\n    width: 250px;\n    height: 100px;\n    overflow: hidden;\n  }\n\n  svg {\n    width: 275px;\n    height: 275px;\n  }\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}
var StyledIllustration = newStyled.div(_templateObject$d());

var HouseWithCircle = function HouseWithCircle(_ref) {
  var copy = _ref.copy;
  return /*#__PURE__*/React__default.createElement(StyledIllustration, null, /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 302 303"
  }, /*#__PURE__*/React__default.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "#00AD80",
    d: "M150.929 303.132C67.3385 303.132 -0.424749 235.466 -0.424749 151.997L302.282 151.997C302.282 235.466 234.519 303.132 150.929 303.132Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#FFD45C",
    d: "M150.929 0.862274C234.519 0.862274 302.282 68.5276 302.282 151.997L-0.424728 151.997C-0.424728 68.5276 67.3385 0.862274 150.929 0.862274Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: "#001A3C",
    strokeLinecap: "round",
    strokeWidth: "3",
    d: "M224.702 143.914H224.73"
  })), /*#__PURE__*/React__default.createElement("path", {
    fill: "#DEDBD6",
    fillRule: "evenodd",
    d: "M132.41 152.235H249.863V89.301L132.41 88.6095V152.235Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#D3D0CA",
    fillRule: "evenodd",
    d: "M136.037 89.6677V152.15H57.7146V89.9503L99.3327 42L136.037 89.6677Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#EEEDEA",
    fillRule: "evenodd",
    d: "M250 89.2762L216.058 42.0002H99.3333L132.995 89.6683L250 89.2762Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#D3D0CA",
    fillRule: "evenodd",
    d: "M135.821 89.1984C135.821 113.639 135.821 127.342 135.821 151.784L111.321 151.867L57.8019 89.8699L99.259 42.1398L135.821 89.1984Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#F9F9F9",
    fillRule: "evenodd",
    d: "M102.013 152.234H130.62V113.225H102.013V152.234Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#EEEDEA",
    fillRule: "evenodd",
    d: "M50 113.073V152.234H102.013V112.895L76.1487 82.8834L50 113.073Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#DEDBD6",
    fillRule: "evenodd",
    d: "M130.671 112.984L104.747 82.8235H76.0415L102.001 112.985L130.671 112.984Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#0087FF",
    d: "M119.264 46.7453H207.429L233.388 81.4146H145.259L119.264 46.7453Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#E2E1DE",
    d: "M207.178 47.1053L232.905 81.4629H145.161L119.395 47.1053H207.167H207.178ZM207.324 46.7937H118.781L145.004 81.7746H233.522L207.336 46.7937H207.324Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#00589D",
    d: "M118.781 46.7941L117.811 48.323L144.041 83.3039L145.011 81.7751L118.781 46.7941Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#00589D",
    d: "M145.011 81.7744H233.528L232.559 83.3033H144.041L145.011 81.7744Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: "#E2E1DE",
    strokeMiterlimit: "10",
    d: "M155.697 46.7937L181.925 81.7746M168.788 46.7937L195.017 81.7746M181.878 46.7937L208.108 81.7746M194.97 46.7937L221.2 81.7746M129.514 46.7937L155.743 81.7746M142.604 46.7937L168.834 81.7746M124.09 53.9903H212.646M130.441 62.3086H218.995M137.601 71.9936H226.156"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#EEEDEA",
    d: "M184.208 87.2181L173.902 72.4434L154.762 46.5877L154.026 44.7408H167.644L193.446 83.1194L195.636 83.8646L184.208 87.2181Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#00589D",
    d: "M168.854 47.3416L167.896 48.8662L193.811 83.7507L194.769 82.226L168.854 47.3416Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#B1B1B1",
    fillRule: "evenodd",
    d: "M107.214 66.4127C107.214 71.2006 103.527 75.0815 98.9788 75.0815C94.4306 75.0815 90.7434 71.2006 90.7434 66.4127C90.7434 61.6248 94.4306 57.7439 98.9788 57.7439C103.527 57.7439 107.214 61.6248 107.214 66.4127",
    clipRule: "evenodd"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#C6C6C6",
    fillRule: "evenodd",
    d: "M108.081 134.896H115.016V118.426H108.081V134.896zM116.75 134.896H123.685V118.426H116.75V134.896zM116.75 152.234H123.685V136.63H116.75V152.234zM108.081 152.234H115.016V136.63H108.081V152.234zM57 152H83V113H57V152z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#00AD80",
    d: "M256 139H258.6V152.7H256zM286 139H288.6V152.7H286z"
  }), /*#__PURE__*/React__default.createElement("ellipse", {
    cx: "257.1",
    cy: "120.1",
    fill: "#00AD80",
    rx: "11.2",
    ry: "21.3"
  }), /*#__PURE__*/React__default.createElement("ellipse", {
    cx: "257.1",
    cy: "120.1",
    fill: "#00AD80",
    rx: "11.2",
    ry: "21.3"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#32CAA2",
    d: "M268.278 120.07C268.278 131.859 263.284 141.417 257.124 141.417V98.7232C263.284 98.7232 268.278 108.28 268.278 120.07Z"
  }), /*#__PURE__*/React__default.createElement("ellipse", {
    cx: "287.3",
    cy: "106.1",
    fill: "#00AD80",
    rx: "11.2",
    ry: "33.4"
  }), /*#__PURE__*/React__default.createElement("ellipse", {
    cx: "287.3",
    cy: "106.1",
    fill: "#00AD80",
    rx: "11.2",
    ry: "33.4"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#32CAA2",
    d: "M298.412 106.065C298.412 124.518 293.418 139.477 287.258 139.477V72.6523C293.418 72.6523 298.412 87.6115 298.412 106.065Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#00AD80",
    d: "M16 139H19.4V152.7H16z"
  }), /*#__PURE__*/React__default.createElement("ellipse", {
    cx: "17.6",
    cy: "100",
    fill: "#00AD80",
    rx: "11.2",
    ry: "41.8"
  }), /*#__PURE__*/React__default.createElement("ellipse", {
    cx: "17.6",
    cy: "100",
    fill: "#00AD80",
    rx: "11.2",
    ry: "41.8"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#32CAA2",
    d: "M28.7426 99.9988C28.7426 123.065 23.749 141.764 17.5891 141.764V58.2334C23.749 58.2334 28.7426 76.9324 28.7426 99.9988Z"
  }), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "#fff",
    d: "M0 0H319V572H0z",
    transform: "translate(-9 -137)"
  })))), /*#__PURE__*/React__default.createElement("p", null, copy));
};

HouseWithCircle.propTypes = {
  copy: PropTypes__default.string
};
HouseWithCircle.defaultProps = {
  copy: 'Payment Processing...'
};

function _templateObject$e() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  margin: 10px auto;\n  width: 375px;\n  font-size: 14px;\n  color: ", ";\n  text-align: center;\n\n  a {\n    color: ", ";\n    font-weight: normal;\n  }\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}
var FinePrintContainer = newStyled.div(_templateObject$e(), TEXT_LIGHT_COLOR, SECONDARY_COLOR);

var FinePrint = function FinePrint() {
  return /*#__PURE__*/React__default.createElement(FinePrintContainer, null, "We don\u2019t share your utility data outside of Sunrun, or your solar production with the utility company. View our", ' ', /*#__PURE__*/React__default.createElement(Link, {
    href: " https://www.sunrun.com/privacy-policy",
    target: "_blank"
  }, "Privacy Policy"));
};

var BarChartCircle = function BarChartCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    r: "11",
    cx: "11.5",
    cy: "11.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9917 11.4963C22.9917 17.8453 17.8448 22.9922 11.4958 22.9922C5.14677 22.9922 -0.00012207 17.8453 -0.00012207 11.4963C-0.00012207 5.14726 5.14677 0.000366211 11.4958 0.000366211C17.8448 0.000366211 22.9917 5.14726 22.9917 11.4963ZM7.39913 16.6797C7.96348 16.6797 8.44421 16.199 8.44421 15.6137V11.8723C8.44421 11.308 7.98438 10.8273 7.39913 10.8273H6.68848C6.12413 10.8273 5.64339 11.2871 5.64339 11.8723V15.6137C5.64339 16.199 6.10323 16.6797 6.68848 16.6797H7.39913ZM12.8544 15.6141C12.8544 16.1993 12.3736 16.68 11.8093 16.68H11.0986C10.5134 16.68 10.0535 16.1993 10.0535 15.6141V9.59438C10.0535 9.00913 10.5343 8.54929 11.0986 8.54929H11.8093C12.3945 8.54929 12.8544 9.03003 12.8544 9.59438V15.6141ZM16.2407 16.6798C16.805 16.6798 17.2857 16.1991 17.2857 15.6139V7.31591C17.2857 6.75157 16.8259 6.27083 16.2407 6.27083H15.53C14.9657 6.27083 14.4849 6.73066 14.4849 7.31591V15.6139C14.4849 16.1991 14.9447 16.6798 15.53 16.6798H16.2407Z",
    fill: backgroundColor
  }));
};

BarChartCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
BarChartCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var Battery = function Battery(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: "20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10 16"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M7.37661 1.40448H9.62337C9.83376 1.40448 10 1.51201 10 1.66343V15.7455C9.99517 15.7831 9.98155 15.8195 9.95994 15.8525C9.93833 15.8856 9.90916 15.9148 9.87412 15.9382C9.83909 15.9617 9.79889 15.9791 9.75585 15.9893C9.7128 15.9996 9.62337 15.9979 9.62337 15.9979H0.376627C0.332236 16.0025 0.287203 15.9996 0.244156 15.9893C0.20111 15.9791 0.160898 15.9617 0.125859 15.9382C0.0908207 15.9148 0.0616522 15.8856 0.0400454 15.8525C0.0184386 15.8195 0.00483022 15.7831 0 15.7455V1.65684C0 1.51201 0.161042 1.40448 0.376627 1.40448H2.62337V0.252373C2.62337 0.107536 2.78441 0 3 0H7C7.21559 0 7.37661 0.107536 7.37661 0.252373V1.40448ZM8.88888 2.52631H1.1111V15.1579H8.88888V2.52631Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M2 5H7.6V14.3H2z"
  }));
};

Battery.propTypes = {
  color: PropTypes__default.string
};
Battery.defaultProps = {
  color: SECONDARY_COLOR
};

var BatteryCircle = function BatteryCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: "20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: backgroundColor,
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M15.57 5.25049H7.42971C7.31571 5.25057 7.20642 5.2959 7.12584 5.37653 7.04526 5.45717 7 5.56649 7 5.68048V18.4119C7 18.5258 7.04527 18.6351 7.12586 18.7157 7.20644 18.7963 7.31574 18.8416 7.42971 18.8416H15.57C15.684 18.8416 15.7933 18.7963 15.874 18.7157 15.9546 18.6352 15.9999 18.5259 16 18.4119V5.68048C16 5.56644 15.9547 5.45707 15.8741 5.37643 15.7934 5.29579 15.684 5.25049 15.57 5.25049V5.25049zM14.4017 17.1814C14.4017 17.275 14.3646 17.3648 14.2985 17.4309 14.2323 17.4971 14.1426 17.5344 14.049 17.5344H8.8333C8.78694 17.5344 8.74104 17.5253 8.69821 17.5076 8.65538 17.4898 8.61646 17.4638 8.58368 17.431 8.5509 17.3983 8.5249 17.3594 8.50716 17.3165 8.48942 17.2737 8.48029 17.2278 8.48029 17.1814V10.4793C8.48037 10.3857 8.51759 10.296 8.58379 10.2299 8.64998 10.1637 8.73972 10.1266 8.8333 10.1266H14.049C14.1426 10.1267 14.2322 10.1639 14.2984 10.23 14.3645 10.2961 14.4017 10.3858 14.4017 10.4793V17.1814zM14.1554 3.28153C14.1554 3.24457 14.1481 3.20797 14.134 3.17382 14.1199 3.13966 14.0992 3.10862 14.0731 3.08248 14.047 3.05633 14.0159 3.03559 13.9818 3.02144 13.9477 3.00728 13.9111 3 13.8741 3H9.25455C9.17989 3 9.10828 3.02966 9.05548 3.08246 9.00268 3.13526 8.97302 3.20686 8.97302 3.28153V4.29987H14.1554V3.28153z"
  }));
};

BatteryCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
BatteryCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var BubbleQuestionCircle = function BubbleQuestionCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    r: "11",
    cx: "11.5",
    cy: "11.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 11.5C23 17.8513 17.8513 23 11.5 23C5.14873 23 0 17.8513 0 11.5C0 5.14873 5.14873 0 11.5 0C17.8513 0 23 5.14873 23 11.5ZM17.9998 10.9067C17.9998 12.8086 16.7236 14.4115 14.9998 14.8692V16.7932C14.9998 17.2387 14.4612 17.4618 14.1462 17.1468L11.9998 15.0003H8.00818C5.79766 15.0003 3.99977 13.1642 3.99977 10.9067V10.094C3.99977 7.83644 5.79766 6.00033 8.00818 6.00033H13.9914C16.2019 6.00033 17.9998 7.83644 17.9998 10.094V10.9067Z",
    fill: backgroundColor
  }));
};

BubbleQuestionCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
BubbleQuestionCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var Calendar = function Calendar(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "13",
    height: "14",
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M10.9589 1.7843C9.98543 1.50617 10.1991 1.68005 8.57955 1.65683H5.13801C3.47744 1.6798 3.99993 1.42983 2.75868 1.7843C1.56901 2.12421 0.676758 3.2289 0.676758 4.54603V11.1317C0.676758 12.725 1.97265 13.9996 3.54471 13.9996H10.1304C11.7237 13.9996 12.9983 12.7038 12.9983 11.1317V4.54603C13.0408 3.2289 12.1486 2.12421 10.9589 1.7843ZM11.9361 11.1317C11.9361 12.1089 11.1288 12.9162 10.1516 12.9162H3.56595C2.58872 12.9162 1.78145 12.1089 1.78145 11.1317V5.8844H11.9574V11.1317H11.9361Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M9.40792 2.76173C9.51414 2.82546 9.6416 2.84671 9.76907 2.84671C9.89653 2.84671 10.024 2.80422 10.1302 2.76173C10.2152 2.71924 10.3002 2.6555 10.3851 2.57053C10.4914 2.42182 10.5763 2.25187 10.5763 2.06068V1.69953V0.807272C10.5763 0.361147 10.2152 0 9.76907 0C9.32294 0 8.96179 0.361147 8.96179 0.807272V1.67829V2.06068C8.96179 2.23063 9.02552 2.40058 9.1105 2.52805C9.19548 2.61302 9.3017 2.698 9.40792 2.76173Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M3.56551 2.76173C3.67173 2.82546 3.7992 2.84671 3.92666 2.84671C4.05413 2.84671 4.18159 2.80422 4.28781 2.76173C4.39403 2.698 4.47901 2.63427 4.56399 2.52805C4.67021 2.40058 4.71269 2.23063 4.71269 2.06068V1.67829V0.807272C4.71269 0.361147 4.35154 0 3.90542 0C3.45929 0 3.09814 0.361147 3.09814 0.807272V1.69953V2.03942C3.09814 2.23062 3.16188 2.42182 3.28934 2.54929C3.39556 2.63426 3.48054 2.71924 3.56551 2.76173Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "3",
    y: "7",
    width: "1.85714",
    height: "1.85714",
    rx: "0.25",
    fill: color
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "6",
    y: "7",
    width: "1.85714",
    height: "1.85714",
    rx: "0.25",
    fill: color
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "3",
    y: "10",
    width: "1.85714",
    height: "1.85714",
    rx: "0.25",
    fill: color
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "6",
    y: "10",
    width: "1.85714",
    height: "1.85714",
    rx: "0.25",
    fill: color
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "9",
    y: "10",
    width: "1.85714",
    height: "1.85714",
    rx: "0.25",
    fill: color
  }));
};

Calendar.propTypes = {
  color: PropTypes__default.string
};
Calendar.defaultProps = {
  color: SECONDARY_COLOR
};

var Calculator = function Calculator(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "12",
    height: "13",
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 0.89543 0.895431 0 2 0H9.14286C10.2474 0 11.1429 0.895431 11.1429 2V11C11.1429 12.1046 10.2474 13 9.14286 13H2C0.895431 13 0 12.1046 0 11V2ZM2.02581 3.00042C2.02581 2.44813 2.47352 2.00042 3.02581 2.00042H8.11672C8.669 2.00042 9.11672 2.44813 9.11672 3.00042V4.00042C9.11672 4.5527 8.669 5.00042 8.11672 5.00042H3.02581C2.47352 5.00042 2.02581 4.5527 2.02581 4.00042V3.00042ZM2.10714 6.5C1.96907 6.5 1.85714 6.61193 1.85714 6.75V8.10714C1.85714 8.24521 1.96907 8.35714 2.10714 8.35714H3.46429C3.60236 8.35714 3.71429 8.24521 3.71429 8.10714V6.75C3.71429 6.61193 3.60236 6.5 3.46429 6.5H2.10714ZM4.64307 6.75C4.64307 6.61193 4.755 6.5 4.89307 6.5H6.25021C6.38828 6.5 6.50021 6.61193 6.50021 6.75V8.10714C6.50021 8.24521 6.38828 8.35714 6.25021 8.35714H4.89307C4.75499 8.35714 4.64307 8.24521 4.64307 8.10714V6.75ZM2.10735 9.28571C1.96928 9.28571 1.85735 9.39764 1.85735 9.53571V10.8929C1.85735 11.0309 1.96928 11.1429 2.10735 11.1429H3.46449C3.60257 11.1429 3.71449 11.0309 3.71449 10.8929V9.53571C3.71449 9.39764 3.60257 9.28571 3.46449 9.28571H2.10735ZM4.64307 9.53571C4.64307 9.39764 4.755 9.28571 4.89307 9.28571H6.25021C6.38828 9.28571 6.50021 9.39764 6.50021 9.53571V10.8929C6.50021 11.0309 6.38828 11.1429 6.25021 11.1429H4.89307C4.75499 11.1429 4.64307 11.0309 4.64307 10.8929V9.53571ZM7.67878 6.5C7.54071 6.5 7.42878 6.61193 7.42878 6.75V10.8929C7.42878 11.0309 7.54071 11.1429 7.67878 11.1429H9.03592C9.17399 11.1429 9.28592 11.0309 9.28592 10.8929V6.75C9.28592 6.61193 9.17399 6.5 9.03592 6.5H7.67878Z",
    fill: color
  }));
};

Calculator.propTypes = {
  color: PropTypes__default.string
};
Calculator.defaultProps = {
  color: SECONDARY_COLOR
};

var CheckmarkCircleEmpty = function CheckmarkCircleEmpty(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: "20",
    height: "20",
    viewBox: "0 0 64 64"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    stroke: color,
    strokeWidth: "2.5",
    d: "M62.75 32c0 16.983-13.767 30.75-30.75 30.75S1.25 48.983 1.25 32 15.017 1.25 32 1.25 62.75 15.017 62.75 32z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M28.001 34.345l-5.172-5.172a3.996 3.996 0 00-5.656 0 3.996 3.996 0 000 5.656l8 8a3.989 3.989 0 002.828 1.172 3.989 3.989 0 002.828-1.172l16-16a3.996 3.996 0 000-5.656 3.996 3.996 0 00-5.656 0L28.001 34.345z",
    clipRule: "evenodd"
  }));
};

CheckmarkCircleEmpty.propTypes = {
  color: PropTypes__default.string
};
CheckmarkCircleEmpty.defaultProps = {
  color: PRIMARY_COLOR
};

var CreditCard = function CreditCard(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: "20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 20"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M23 7.43866e-05H2.99998C1.61248 7.43866e-05 0.512481 1.11257 0.512481 2.50007L0.499981 17.5001C0.499981 18.8876 1.61248 20.0001 2.99998 20.0001H23C24.3875 20.0001 25.5 18.8876 25.5 17.5001V2.50007C25.5 1.11257 24.3875 7.43866e-05 23 7.43866e-05ZM23 17.5H2.99996V10H23V17.5ZM2.99996 5H23V2.5H2.99996V5Z",
    clipRule: "evenodd"
  }));
};

CreditCard.propTypes = {
  color: PropTypes__default.string
};
CreditCard.defaultProps = {
  color: SECONDARY_COLOR
};

var CogWheelCircle = function CogWheelCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: "20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: backgroundColor,
    d: "M11.4959 22.9918C17.8449 22.9918 22.9918 17.8449 22.9918 11.4959C22.9918 5.14689 17.8449 0 11.4959 0C5.14689 0 0 5.14689 0 11.4959C0 17.8449 5.14689 22.9918 11.4959 22.9918Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M16.7422 11.5583C16.7422 11.3075 16.7213 11.0776 16.7004 10.8268L17.7664 9.42636C17.5156 8.6948 17.1394 8.02595 16.6586 7.4198L14.9029 7.58701C14.4849 7.25259 14.025 6.95996 13.5234 6.75095L12.8336 5.14152C12.4365 5.05791 12.0185 5.01611 11.6004 5.01611C11.2451 5.01611 10.8898 5.03701 10.5554 5.09972L9.8238 6.68825C9.32216 6.87636 8.84142 7.14808 8.42338 7.48251L6.68855 7.27349C6.18691 7.85874 5.78978 8.50669 5.51805 9.23824L6.54223 10.6596C6.50043 10.9522 6.45863 11.2448 6.45863 11.5374C6.45863 11.7882 6.47953 12.0182 6.50043 12.269L5.43445 13.6694C5.68527 14.401 6.0615 15.0698 6.54223 15.676L8.29797 15.5087C8.716 15.8432 9.17584 16.1358 9.67748 16.3448L10.3672 17.9542C10.7644 18.0378 11.1824 18.0796 11.6004 18.0796C11.9558 18.0796 12.3111 18.0587 12.6455 17.996L13.3771 16.4075C13.8787 16.2194 14.3595 15.9477 14.7775 15.6132L16.5123 15.8223C17.014 15.237 17.4111 14.5891 17.6828 13.8575L16.6586 12.4362C16.7213 12.1436 16.7422 11.851 16.7422 11.5583ZM14.7984 11.5583C14.7984 13.335 13.3562 14.7772 11.5795 14.7772C9.80289 14.7772 8.36068 13.335 8.36068 11.5583C8.36068 9.78169 9.80289 8.33947 11.5795 8.33947C13.3562 8.33947 14.7984 9.78169 14.7984 11.5583Z"
  }));
};

CogWheelCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
CogWheelCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var DocumentCircle = function DocumentCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: "20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: backgroundColor,
    d: "M11.4959 22.9918C17.8449 22.9918 22.9918 17.8449 22.9918 11.4959C22.9918 5.14689 17.8449 0 11.4959 0C5.14689 0 0 5.14689 0 11.4959C0 17.8449 5.14689 22.9918 11.4959 22.9918Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M7.47949 5.85229C6.92721 5.85229 6.47949 6.30001 6.47949 6.85229V16.0556C6.47949 16.6079 6.92721 17.0556 7.47949 17.0556H15.4287C15.981 17.0556 16.4287 16.6079 16.4287 16.0556V6.85229C16.4287 6.30001 15.981 5.85229 15.4287 5.85229H7.47949ZM8.17255 8.09922C8.17255 7.79332 8.42053 7.54534 8.72643 7.54534H11.2764C11.5824 7.54534 11.8303 7.79332 11.8303 8.09922V8.09922C11.8303 8.40513 11.5824 8.65311 11.2764 8.65311H8.72643C8.42053 8.65311 8.17255 8.40513 8.17255 8.09922V8.09922ZM14.7984 14.3906C14.7984 14.6965 14.5504 14.9445 14.2445 14.9445H8.72643C8.42053 14.9445 8.17255 14.6965 8.17255 14.3906V14.3906C8.17255 14.0847 8.42053 13.8367 8.72643 13.8367H14.2445C14.5504 13.8367 14.7984 14.0847 14.7984 14.3906V14.3906ZM14.7984 11.2345C14.7984 11.5404 14.5504 11.7884 14.2445 11.7884H8.72643C8.42053 11.7884 8.17255 11.5404 8.17255 11.2345V11.2345C8.17255 10.9286 8.42053 10.6806 8.72643 10.6806H14.2445C14.5504 10.6806 14.7984 10.9286 14.7984 11.2345V11.2345Z"
  }));
};

DocumentCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
DocumentCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var DownloadCircle = function DownloadCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: "20",
    width: "20"
  }, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: backgroundColor,
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M17.6239 6.6036C17.1513 6.15315 16.3573 6.15315 15.8847 6.6036L12.6897 9.64863V4.17117C12.6897 3.52252 12.1414 3 11.4609 3 10.7803 3 10.232 3.52252 10.232 4.17117V9.59459L7.09375 6.6036C6.62112 6.15315 5.8271 6.15315 5.35447 6.6036 4.88184 7.05405 4.88184 7.8108 5.35447 8.26125L9.47581 12.1892C10.0241 12.7117 10.7425 13 11.5176 13 12.2927 13 13.0111 12.7117 13.5593 12.1892L17.6806 8.26125C18.1155 7.8108 18.1155 7.05405 17.6239 6.6036zM18 16.5C18 17.3226 17.3087 18 16.4837 18H6.5163C5.66896 18 5 17.3226 5 16.5 5 15.6774 5.69126 15 6.5163 15H16.4837C17.3087 15 18 15.6774 18 16.5z"
  }));
};

DownloadCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
DownloadCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var Electronics = function Electronics(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: "27",
    height: "20",
    viewBox: "0 0 27 20"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M21.64 8.775h1.396m-11.53 6.778h3.151s-.071.83.072 1.624c.107.613.573 1.154 1.217 1.515.18.108.108.324-.107.324H7.137c-.215 0-.322-.216-.107-.324.644-.325 1.11-.902 1.217-1.515.144-.794.072-1.623.072-1.623h3.187z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M11.506 14.471a.216.216 0 00.215-.216.216.216 0 00-.215-.216.216.216 0 00-.215.216c0 .12.096.216.215.216z"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M18.811 15.554H1.73A1.059 1.059 0 01.656 14.47v-1.55h4.19"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M18.776 12.956H.655V1.81c0-.613.537-1.154 1.146-1.154h19.373c.644 0 1.146.54 1.146 1.154v5.41"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: color,
    strokeMiterlimit: "10",
    d: "M25.574 16.721h-6.558m6.349 2.295h-6.016a.553.553 0 01-.538-.54V7.797c0-.289.251-.541.538-.541h6.016c.286 0 .537.252.537.54V18.44c0 .325-.251.577-.538.577z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    stroke: color,
    strokeMiterlimit: "10",
    d: "M22.356 18.006a.18.18 0 00.18-.18.18.18 0 10-.358 0c0 .1.08.18.178.18z"
  }));
};

Electronics.propTypes = {
  color: PropTypes__default.string
};
Electronics.defaultProps = {
  color: TEXT_DARK_COLOR
};

var ExclamationmarkEmpty = function ExclamationmarkEmpty(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: "20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M9 0C7.21997 0 5.47991 0.527841 3.99987 1.51677C2.51983 2.50571 1.36628 3.91131 0.685088 5.55585C0.00389957 7.20038 -0.17433 9.00998 0.172937 10.7558C0.520204 12.5016 1.37737 14.1053 2.63604 15.364C3.89472 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4442 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948211 11.387 0 9 0V0ZM9 17.3333C7.35183 17.3333 5.74066 16.8446 4.37025 15.9289C2.99984 15.0132 1.93174 13.7117 1.30101 12.189C0.670278 10.6663 0.50525 8.99076 0.826793 7.37425C1.14834 5.75774 1.94201 4.27288 3.10745 3.10744C4.27289 1.94201 5.75774 1.14833 7.37425 0.826789C8.99076 0.505246 10.6663 0.670274 12.189 1.301C13.7118 1.93173 15.0132 2.99984 15.9289 4.37025C16.8446 5.74066 17.3333 7.35182 17.3333 9C17.331 11.2094 16.4523 13.3277 14.89 14.89C13.3277 16.4523 11.2094 17.331 9 17.3333V17.3333ZM10.5889 13.7178C10.5893 14.0321 10.4965 14.3395 10.3222 14.6011C10.1479 14.8627 9.89988 15.0667 9.60959 15.1873C9.31929 15.3079 8.99975 15.3397 8.69139 15.2786C8.38303 15.2176 8.09971 15.0664 7.87728 14.8443C7.65485 14.6222 7.5033 14.3391 7.44181 14.0308C7.38032 13.7225 7.41166 13.4029 7.53185 13.1125C7.65204 12.822 7.85569 12.5737 8.11703 12.399C8.37837 12.2244 8.68566 12.1311 9 12.1311C9.42102 12.1311 9.82482 12.2982 10.1227 12.5957C10.4206 12.8932 10.5883 13.2968 10.5889 13.7178V13.7178ZM7.68889 9.88889V3.40889C7.70297 3.21922 7.78645 3.04139 7.92337 2.90938C8.06029 2.77738 8.24106 2.70046 8.43112 2.69333H9.56889C9.6672 2.69303 9.76458 2.71231 9.85535 2.75006C9.94613 2.78781 10.0285 2.84327 10.0976 2.91319C10.1667 2.98312 10.2211 3.06611 10.2578 3.15733C10.2945 3.24854 10.3126 3.34615 10.3111 3.44444V9.88889C10.3114 9.98644 10.2924 10.0831 10.2552 10.1733C10.218 10.2635 10.1634 10.3454 10.0944 10.4144C10.0254 10.4834 9.94346 10.538 9.85328 10.5752C9.76309 10.6124 9.66645 10.6314 9.56889 10.6311H8.43112C8.33356 10.6314 8.23692 10.6124 8.14673 10.5752C8.05655 10.538 7.97461 10.4834 7.90563 10.4144C7.83665 10.3454 7.78199 10.2635 7.74479 10.1733C7.7076 10.0831 7.6886 9.98644 7.68889 9.88889V9.88889Z"
  }));
};

ExclamationmarkEmpty.propTypes = {
  color: PropTypes__default.string
};
ExclamationmarkEmpty.defaultProps = {
  color: WARNING_COLOR
};

var GraduationCapCircle = function GraduationCapCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: "20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: backgroundColor,
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M6.84961 13.915V14.3893V16.0127C6.84961 17.8044 9.13966 19.1084 11.9652 19.1084C14.7908 19.1084 17.0809 17.8851 17.0809 16.0127V13.915C15.2991 15.1898 14.2705 15.9436 12.1315 16.8C11.9001 16.8927 11.6408 16.8923 11.4103 16.7974C9.64482 16.0704 8.60242 15.3488 6.84961 13.915Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M11.2719 15.7326C11.5912 15.9396 11.999 15.9438 12.3224 15.7433 14.1355 14.6191 19.9901 10.9175 19.9506 10.0182 19.9112 9.11919 14.1802 5.45297 12.3901 4.3291 12.0675 4.12657 11.6586 4.12799 11.338 4.33353 9.58095 5.4597 4.00822 9.10152 3.979 10.0071 3.94976 10.913 9.5182 14.5957 11.2719 15.7326zM5.78732 14.7612L4.71274 12.6891C4.68275 12.6312 4.63959 12.5831 4.5876 12.5497 4.53562 12.5163 4.47664 12.4987 4.41659 12.4987 4.35655 12.4987 4.29757 12.5163 4.24558 12.5497 4.1936 12.5831 4.15044 12.6312 4.12045 12.6891L3.04586 14.7612C3.01583 14.8191 3.00001 14.8847 3 14.9515 2.99999 15.0182 3.0158 15.0839 3.04583 15.1417 3.07586 15.1995 3.11904 15.2475 3.17104 15.2808 3.22304 15.3142 3.28201 15.3317 3.34201 15.3315H5.49118C5.55113 15.3315 5.61002 15.3139 5.66194 15.2806 5.71387 15.2472 5.75699 15.1992 5.78699 15.1414 5.817 15.0837 5.83282 15.0181 5.83288 14.9514 5.83294 14.8847 5.81723 14.8191 5.78732 14.7612V14.7612z"
  }), /*#__PURE__*/React__default.createElement("rect", {
    width: ".9",
    height: "3.8",
    x: "4",
    y: "10",
    fill: color,
    rx: ".5"
  }));
};

GraduationCapCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
GraduationCapCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var Headset = function Headset(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, props), /*#__PURE__*/React__default.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M12.6 22.64c.442 0 .803.353.803.786a.797.797 0 01-.803.787.797.797 0 01-.802-.787c0-.433.36-.787.802-.787zm0-.788c-.883 0-1.605.709-1.605 1.574 0 .866.722 1.574 1.605 1.574s1.605-.708 1.605-1.574c0-.905-.722-1.574-1.605-1.574z"
  })), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M12.6 22.64c.442 0 .803.353.803.786a.797.797 0 01-.803.787.797.797 0 01-.802-.787c0-.433.36-.787.802-.787zm0-.788c-.883 0-1.605.709-1.605 1.574 0 .866.722 1.574 1.605 1.574s1.605-.708 1.605-1.574c0-.905-.722-1.574-1.605-1.574z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M12.6 23.64a.203.203 0 01-.197-.214h2c0-1.003-.828-1.787-1.803-1.787v2zm-.197-.214c0-.138.105-.213.197-.213v2c.975 0 1.803-.783 1.803-1.787h-2zm.197-.213c.092 0 .198.075.198.213h-2c0 1.004.827 1.787 1.802 1.787v-2zm.198.213a.203.203 0 01-.198.213v-2c-.975 0-1.802.784-1.802 1.787h2zm-.198-2.574c-1.416 0-2.605 1.138-2.605 2.574h2c0-.295.256-.574.605-.574v-2zm-2.605 2.574C9.995 24.863 11.184 26 12.6 26v-2a.595.595 0 01-.605-.574h-2zM12.6 26c1.417 0 2.605-1.137 2.605-2.574h-2A.595.595 0 0112.6 24v2zm2.605-2.574c0-1.492-1.205-2.574-2.605-2.574v2c.366 0 .605.256.605.574h2z",
    mask: "url(#a)"
  }), /*#__PURE__*/React__default.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M23.154 16.698c-.482 4.604-2.368 6.217-7.384 6.65-.601.039-1.284.078-1.966.078"
  })), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M15.77 23.348l.066.998.01-.001.01-.001-.086-.996zm6.39-6.754c-.23 2.2-.776 3.456-1.663 4.246-.91.812-2.362 1.3-4.813 1.511l.172 1.993c2.566-.221 4.565-.756 5.972-2.01 1.431-1.276 2.07-3.129 2.32-5.532l-1.989-.208zm-6.455 5.756c-.599.039-1.254.076-1.9.076v2c.716 0 1.426-.04 2.03-.08l-.13-1.996z",
    mask: "url(#b)"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    stroke: color,
    strokeWidth: "0.5",
    d: "M15.878 7.48h0l-.007-.005c-.895-.673-2.044-1.027-3.382-1.027-1.333 0-2.532.352-3.38.977h0l-.003.002c-.962.736-1.49 1.886-1.49 3.13 0 .386.315.69.697.69a.692.692 0 00.698-.69c0-.858.33-1.542.914-2.016.59-.48 1.461-.763 2.564-.763 1.08 0 1.94.272 2.532.73.585.453.923 1.101.947 1.906 0 .807-.199 1.324-.495 1.713-.303.396-.722.679-1.218.996-.234.117-.474.292-.713.466-.084.062-.168.123-.252.182l-.009.006-.008.008c-.747.632-1.141 1.207-1.34 1.844-.19.616-.19 1.272-.19 2.033V18.47c0 .21.107.386.243.502a.787.787 0 00.503.187.692.692 0 00.698-.69v-.829c0-.696.002-1.154.13-1.554.124-.384.372-.737.921-1.183h0c.287-.235.574-.423.815-.565l.008-.005.008-.005c1.061-.745 2.294-1.787 2.294-3.868 0-1.109-.587-2.252-1.485-2.978zm-7.114-.34h0l.002-.001c.944-.742 2.23-1.168 3.723-1.168 1.45 0 2.73.38 3.668 1.163h0l.005.004c.987.785 1.646 2.082 1.646 3.37 0 2.477-1.655 3.634-2.505 4.223-.273.114-.536.32-.764.5l-.016.013-.008.006-.007.006c-.381.35-.61.62-.723.99-.104.342-.104.754-.104 1.349v.874c0 .64-.53 1.166-1.191 1.166-.717 0-1.242-.532-1.242-1.166v-.733c0-.813.002-1.506.213-2.184.206-.666.62-1.333 1.48-2.062.345-.243.686-.482.978-.673h0l.003-.002.042-.028c.442-.297.814-.547 1.067-.875.274-.357.393-.784.393-1.404h0V10.5c-.014-.492-.168-.883-.412-1.189a2.244 2.244 0 00-.883-.646c-.643-.276-1.355-.313-1.69-.313-.334 0-1.06.037-1.713.334-.329.15-.649.37-.886.696-.24.327-.385.746-.385 1.271 0 .64-.53 1.167-1.191 1.167a1.18 1.18 0 01-1.192-1.167c0-1.439.612-2.683 1.692-3.513z"
  }), /*#__PURE__*/React__default.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M1.766 9.734c.12-.668.36-1.298.602-1.927l-.602 1.927z"
  })), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M2.75 9.912c.1-.562.305-1.104.552-1.748l-1.868-.715C1.198 8.064.92 8.781.78 9.557l1.969.355z",
    mask: "url(#c)"
  }), /*#__PURE__*/React__default.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M2.568 10.128c.16 0 .321.118.321.315v5.587c0 .157-.12.314-.32.314H1.123a.314.314 0 01-.321-.314v-5.627c0-.157.12-.314.32-.314h1.445v.039zm0-.787H1.124C.522 9.341 0 9.813 0 10.443v5.587c0 .59.482 1.101 1.124 1.101h1.444c.602 0 1.124-.472 1.124-1.101v-5.627c0-.59-.522-1.062-1.124-1.062z"
  })), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M2.568 10.128c.16 0 .321.118.321.315v5.587c0 .157-.12.314-.32.314H1.123a.314.314 0 01-.321-.314v-5.627c0-.157.12-.314.32-.314h1.445v.039zm0-.787H1.124C.522 9.341 0 9.813 0 10.443v5.587c0 .59.482 1.101 1.124 1.101h1.444c.602 0 1.124-.472 1.124-1.101v-5.627c0-.59-.522-1.062-1.124-1.062z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M2.568 10.128h-1v1h1v-1zm0-.04h1v-1h-1v1zm0 1.04a.667.667 0 01-.448-.173.697.697 0 01-.23-.512h2c0-.847-.712-1.315-1.322-1.315v2zm-.679-.685v5.587h2v-5.587h-2zm0 5.587a.685.685 0 01.679-.685v2c.815 0 1.321-.67 1.321-1.315h-2zm.68-.686H1.123v2h1.444v-2zm-1.445 0c.157 0 .317.056.447.173.144.13.232.318.232.513h-2c0 .846.71 1.314 1.32 1.314v-2zm.679.686v-5.627h-2v5.627h2zm0-5.627a.685.685 0 01-.679.685v-2c-.816 0-1.321.67-1.321 1.315h2zm-.68.686h1.445v-2H1.124v2zm.445-1v.039h2v-.04h-2zm1-1.748H1.124v2h1.444v-2zm-1.444 0C.012 8.341-1 9.22-1 10.443h2c0-.018.003-.028.007-.036a.09.09 0 01.02-.028.14.14 0 01.097-.038v-2zM-1 10.443v5.587h2v-5.587h-2zm0 5.587a2.11 2.11 0 002.124 2.101v-2a.124.124 0 01-.094-.035.096.096 0 01-.03-.066h-2zm2.124 2.101h1.444v-2H1.124v2zm1.444 0c1.112 0 2.124-.878 2.124-2.101h-2a.085.085 0 01-.007.035.09.09 0 01-.02.029.14.14 0 01-.097.037v2zm2.124-2.101v-5.627h-2v5.627h2zm0-5.627c0-1.207-1.036-2.062-2.124-2.062v2c.04 0 .08.017.106.041.012.011.016.02.018.023 0 .001 0 .001 0 0v-.002h2z",
    mask: "url(#d)"
  }), /*#__PURE__*/React__default.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M23.876 10.128c.16 0 .321.118.321.315v5.587c0 .157-.12.314-.32.314h-1.445a.314.314 0 01-.321-.314v-5.627c0-.157.12-.314.32-.314h1.445v.039zm0-.787h-1.444c-.602 0-1.124.472-1.124 1.102v5.587c0 .59.482 1.101 1.124 1.101h1.444c.602 0 1.124-.472 1.124-1.101v-5.627a1.13 1.13 0 00-1.124-1.062z"
  })), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M23.876 10.128c.16 0 .321.118.321.315v5.587c0 .157-.12.314-.32.314h-1.445a.314.314 0 01-.321-.314v-5.627c0-.157.12-.314.32-.314h1.445v.039zm0-.787h-1.444c-.602 0-1.124.472-1.124 1.102v5.587c0 .59.482 1.101 1.124 1.101h1.444c.602 0 1.124-.472 1.124-1.101v-5.627a1.13 1.13 0 00-1.124-1.062z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M23.876 10.128h-1v1h1v-1zm0-.04h1v-1h-1v1zm1.124.315h1v-.034l-.002-.034-.998.068zm-1.124.725a.667.667 0 01-.447-.173.697.697 0 01-.232-.512h2c0-.847-.71-1.315-1.32-1.315v2zm-.679-.685v5.587h2v-5.587h-2zm0 5.587a.685.685 0 01.679-.685v2c.816 0 1.321-.67 1.321-1.315h-2zm.68-.686h-1.445v2h1.444v-2zm-1.445 0c.157 0 .317.056.448.173.143.13.23.318.23.513h-2c0 .846.712 1.314 1.322 1.314v-2zm.679.686v-5.627h-2v5.627h2zm0-5.627a.685.685 0 01-.679.685v-2c-.815 0-1.321.67-1.321 1.315h2zm-.68.686h1.445v-2h-1.444v2zm.445-1v.039h2v-.04h-2zm1-1.748h-1.444v2h1.444v-2zm-1.444 0c-1.112 0-2.124.879-2.124 2.102h2c0-.018.003-.028.007-.036a.09.09 0 01.02-.028.14.14 0 01.097-.038v-2zm-2.124 2.102v5.587h2v-5.587h-2zm0 5.587a2.11 2.11 0 002.124 2.101v-2a.124.124 0 01-.094-.035.096.096 0 01-.03-.066h-2zm2.124 2.101h1.444v-2h-1.444v2zm1.444 0c1.112 0 2.124-.878 2.124-2.101h-2a.084.084 0 01-.006.035.09.09 0 01-.021.029.14.14 0 01-.097.037v2zM26 16.03v-5.627h-2v5.627h2zm-.002-5.695a2.13 2.13 0 00-2.122-1.994v2c.056 0 .12.044.126.13l1.996-.136z",
    mask: "url(#e)"
  }), /*#__PURE__*/React__default.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M1.806 9.46C3.41 3.163 8.628.802 12.64 1c5.337 0 9.79 3.816 10.714 8.813"
  })), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M12.64 1l-.048.999.024.001h.025V1zM2.776 9.706C4.245 3.941 8.978 1.822 12.592 2L12.69 0C8.278-.215 2.577 2.386.837 9.212l1.938.494zM12.64 2c4.854 0 8.895 3.472 9.73 7.995l1.967-.363C23.328 4.16 18.46 0 12.641 0v2z",
    mask: "url(#f)"
  }));
};

Headset.propTypes = {
  color: PropTypes__default.string
};
Headset.defaultProps = {
  color: TEXT_DARK_COLOR
};

var HandMail = function HandMail(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 58 52",
    width: "20",
    height: "18"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    stroke: color,
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M11.43 2.3l7.11 9.43h30.764l7.11-9.43M20.938 46.049v-2.396s3.556-2.628 3.556-5.952v-4.715M11.43 18.84L5.48 23.556c-1.701 1.546-2.397 2.396-2.397 4.715V46.05"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: color,
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M2 52v-5.952h21.256V52M7.951 31.904l9.43-9.43c2.164-2.165 5.565 3.246 2.937 6.492l-2.937 2.938v3.555c0 4.638-4.02 4.715-4.715 4.715"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: color,
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M11.43 28.193V2.3h44.985v30.763H17.38"
  }));
};

HandMail.propTypes = {
  color: PropTypes__default.string
};
HandMail.defaultProps = {
  color: SECONDARY_COLOR
};

var HamburgerMenu = function HamburgerMenu(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "34",
    height: "20",
    viewBox: "0 0 34 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("rect", {
    width: "34",
    height: "4",
    y: "8",
    fill: color,
    rx: "2"
  }), /*#__PURE__*/React__default.createElement("rect", {
    width: "34",
    height: "4",
    fill: color,
    rx: "2"
  }), /*#__PURE__*/React__default.createElement("rect", {
    width: "34",
    height: "4",
    y: "16",
    fill: color,
    rx: "2"
  }));
};

HamburgerMenu.propTypes = {
  color: PropTypes__default.string
};
HamburgerMenu.defaultProps = {
  color: TEXT_DARK_COLOR
};

var HouseCircle = function HouseCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: "20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: backgroundColor,
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M5.04101 8.98051C5.04411 8.4903 5.28656 8.03254 5.69032 7.75453L10.7592 4.26449C11.276 3.90861 11.9598 3.9121 12.4731 4.27325L17.623 7.89725C18.0233 8.17892 18.2609 8.63816 18.2598 9.1276L18.2444 15.4516C18.2424 16.2778 17.5727 16.9468 16.7466 16.948L13.505 16.9526H9.7609L6.5042 16.9617C5.67044 16.964 4.99478 16.286 5.00006 15.4522L5.04101 8.98051Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: backgroundColor,
    d: "M10.0032 13.1093C10.0032 12.557 10.4509 12.1093 11.0032 12.1093H12.0032C12.5555 12.1093 13.0032 12.557 13.0032 13.1093V18.1093H10.0032V13.1093Z"
  }), /*#__PURE__*/React__default.createElement("rect", {
    width: "2",
    height: "11",
    x: "15",
    y: "4",
    fill: color,
    rx: ".5"
  }));
};

HouseCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
HouseCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var HouseAltCircle = function HouseAltCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: "20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: backgroundColor,
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M16.8258 12.1739C16.5322 12.1739 16.214 12.0761 15.9693 11.8558L11.7174 8.04812C11.3376 7.70805 10.7629 7.70805 10.3831 8.04812L6.13121 11.8558C5.59281 12.3208 4.7852 12.2718 4.32021 11.7579C3.85523 11.244 3.90417 10.4364 4.4181 9.94692L10.3568 4.60207C10.7371 4.25979 11.3144 4.25979 11.6947 4.60207L17.6335 9.94692C18.1474 10.4119 18.1963 11.2195 17.7313 11.7579C17.5355 12.0271 17.1929 12.1739 16.8258 12.1739Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M11.6731 9.58281C11.2956 9.24966 10.7293 9.24907 10.3512 9.58141L5.33985 13.9857C5.12383 14.1756 5 14.4492 5 14.7368V16.1437C5 16.6086 5.40764 17 5.89172 17H8.10191C8.65419 17 9.10191 16.5523 9.10191 16V15.1621C9.10191 14.6098 9.54962 14.1621 10.1019 14.1621H11.8981C12.4504 14.1621 12.8981 14.6098 12.8981 15.1621V16C12.8981 16.5523 13.3458 17 13.8981 17H16.1083C16.5924 17 17 16.6086 17 16.1437V14.7356C17 14.4487 16.8768 14.1757 16.6617 13.9858L11.6731 9.58281Z"
  }));
};

HouseAltCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
HouseAltCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var InverterCircle = function InverterCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: "20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    cx: "11.5",
    cy: "11.5",
    r: "11.5",
    fill: backgroundColor
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M9.71011 14V14.7221H13.2899V14H15V19H8V14H9.71011zM11.4996 16.5381C11.8259 16.5388 12.0903 16.3123 12.0911 16.0329 12.0919 15.7535 11.8275 15.5271 11.5012 15.5264 11.1749 15.5257 10.9105 15.7521 10.9097 16.0315V16.0322C10.9097 16.3117 11.1733 16.5374 11.4996 16.5381zM8 4H15V13H8V4z"
  }));
};

InverterCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
InverterCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var LightningBoltCircle = function LightningBoltCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: "20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: backgroundColor,
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M16.2581 11.8898C16.6064 11.4721 16.4082 10.8341 15.8845 10.6874L11.7628 9.53227C11.3485 9.41614 11.1166 8.97588 11.2552 8.56848L12.869 3.82608C13.1369 3.03891 12.1154 2.46554 11.5829 3.1042L5.74186 10.1102C5.39358 10.5279 5.59183 11.1659 6.11553 11.3126L10.2372 12.4677C10.6515 12.5839 10.8834 13.0241 10.7448 13.4315L9.13099 18.1739C8.86312 18.9611 9.8846 19.5345 10.4171 18.8958L16.2581 11.8898Z"
  }));
};

LightningBoltCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
LightningBoltCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var LightningBoltConnectCircle = function LightningBoltConnectCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: "20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: backgroundColor,
    d: "M12.55 24.59C19.2271 24.59 24.64 19.1772 24.64 12.5C24.64 5.82291 19.2271 0.410034 12.55 0.410034C5.87284 0.410034 0.459961 5.82291 0.459961 12.5C0.459961 19.1772 5.87284 24.59 12.55 24.59Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M14.27 11.9801L12.65 11.5801L15.22 7.58006L15.2 7.56006L10.28 11.6001L8.88 12.7501L10.8 13.2301L12.41 13.6301L10.05 17.4501L10.07 17.4801L14.79 13.7001L16.31 12.4901L14.27 11.9801Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M7.85998 8.16C8.44846 7.56601 9.14964 7.09551 9.92237 6.77611 10.6951 6.45671 11.5239 6.29485 12.36 6.3V7.83L15 6 12.41 4V5.44C11.4498 5.42197 10.4957 5.59677 9.60419 5.95404 8.71272 6.31132 7.90199 6.84381 7.21998 7.52 5.86066 8.88122 5.09717 10.7263 5.09717 12.65 5.09717 14.5737 5.86066 16.4188 7.21998 17.78 7.74089 18.3101 8.34148 18.7555 8.99998 19.1L9.40998 18.29C8.52288 17.8306 7.75691 17.168 7.17452 16.3563 6.59213 15.5446 6.2098 14.6067 6.0587 13.6192 5.90759 12.6317 5.992 11.6224 6.30503 10.6737 6.61806 9.725 7.15085 8.86369 7.85998 8.16V8.16zM17.78 7.25004C17.2594 6.71691 16.6588 6.26819 16 5.92004L15.59 6.73004C16.8509 7.38719 17.8553 8.44794 18.4427 9.74287 19.03 11.0378 19.1665 12.4922 18.8303 13.8738 18.4942 15.2554 17.7047 16.4845 16.588 17.3648 15.4714 18.245 14.0919 18.7257 12.67 18.73V17.2L10 19.05 12.62 21.05V19.6H12.67C14.0971 19.5916 15.4899 19.1622 16.674 18.3656 17.8581 17.5691 18.7808 16.4407 19.3264 15.1221 19.872 13.8034 20.0163 12.353 19.7412 10.9527 19.4662 9.55233 18.7839 8.26433 17.78 7.25004V7.25004z"
  }));
};

LightningBoltConnectCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
LightningBoltConnectCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var LightningCloud = function LightningCloud(_ref) {
  var cloudColor = _ref.cloudColor,
      lighningColor = _ref.lighningColor,
      props = _objectWithoutProperties(_ref, ["cloudColor", "lighningColor"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: "20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 23"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: cloudColor,
    d: "M5.55066 3.88546C5.18062 3.79295 4.81058 3.70044 4.44053 3.70044 2.03525 3.70044 0 5.64317 0 8.14097 0 10.6388 1.94273 12.5815 4.44053 12.5815H10.8238V0C8.32599.092511 6.29075 1.6652 5.55066 3.88546zM21 8.69604C21 6.56828 19.2423 4.90308 17.2071 4.90308 17.022 4.90308 16.7445 4.90308 16.5595 4.9956 16.1895 2.22026 13.7842 0 10.9163 0H10.8238V12.5815H17.2071C19.2423 12.5815 21 10.8238 21 8.69604z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: lighningColor,
    d: "M9.52864 13.9693H12.304L11.2863 16.7446H13.6916L9.52864 22.2952L10.3612 18.3173H7.86344L9.52864 13.9693Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: lighningColor,
    d: "M11.2863 16.7446L12.3039 13.9693H10.7312V20.7226L13.6916 16.7446H11.2863Z"
  }));
};

LightningCloud.propTypes = {
  cloudColor: PropTypes__default.string,
  lighningColor: PropTypes__default.string
};
LightningCloud.defaultProps = {
  cloudColor: SECONDARY_COLOR,
  lighningColor: IMPORTANT_COLOR
};

var Mail = function Mail(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "16",
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M1.91961 4.98656C2.1726 5.16508 2.93523 5.69531 4.20753 6.57697C5.47986 7.45863 6.45456 8.13749 7.13165 8.61358C7.20604 8.66577 7.36409 8.77921 7.60587 8.95406C7.84769 9.12903 8.04861 9.27043 8.2085 9.37828C8.36849 9.48609 8.56192 9.60704 8.78896 9.74093C9.01592 9.87469 9.22987 9.97532 9.43076 10.0419C9.63168 10.1091 9.81768 10.1424 9.98878 10.1424H10H10.0113C10.1824 10.1424 10.3684 10.109 10.5694 10.0419C10.7702 9.97532 10.9843 9.87458 11.2111 9.74093C11.438 9.60688 11.6314 9.48605 11.7914 9.37828C11.9514 9.27043 12.1522 9.12903 12.3941 8.95406C12.6358 8.77905 12.794 8.66577 12.8684 8.61358C13.5528 8.13749 15.2941 6.92836 18.0916 4.98632C18.6347 4.60702 19.0885 4.14934 19.453 3.6136C19.8178 3.07809 20 2.51631 20 1.92858C20 1.43744 19.8232 1.01702 19.4697 0.667346C19.1163 0.317598 18.6977 0.142822 18.2142 0.142822H1.78564C1.21276 0.142822 0.771892 0.336245 0.463112 0.72309C0.154371 1.11001 0 1.59365 0 2.17395C0 2.64269 0.204681 3.15064 0.613847 3.69749C1.02297 4.24437 1.45837 4.6741 1.91961 4.98656Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M18.8838 6.18066C16.4436 7.8323 14.5907 9.11589 13.3259 10.0312C12.9018 10.3435 12.5578 10.5874 12.2936 10.7621C12.0294 10.937 11.678 11.1156 11.2389 11.2978C10.8 11.4802 10.3909 11.5712 10.0114 11.5712H10H9.98882C9.60936 11.5712 9.20008 11.4802 8.76116 11.2978C8.32225 11.1156 7.97063 10.937 7.70649 10.7621C7.44243 10.5874 7.09827 10.3435 6.67421 10.0312C5.66969 9.29461 3.82076 8.01094 1.12735 6.18066C0.703131 5.89811 0.327388 5.57424 0 5.20972V14.0711C0 14.5624 0.174776 14.9826 0.524524 15.3323C0.874193 15.6822 1.29466 15.857 1.78576 15.857H18.2144C18.7054 15.857 19.1258 15.6822 19.4755 15.3323C19.8253 14.9825 20 14.5625 20 14.0711V5.20972C19.68 5.5667 19.3081 5.89057 18.8838 6.18066Z",
    fill: color
  }));
};

Mail.propTypes = {
  color: PropTypes__default.string
};
Mail.defaultProps = {
  color: TEXT_DARK_COLOR
};

var MoneySignCircle = function MoneySignCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: "20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: backgroundColor,
    d: "M11.5 0C5.15905 0 0 5.15905 0 11.5C0 17.8409 5.15905 23 11.5 23C17.8409 23 23 17.8409 23 11.5C23 5.15905 17.8409 0 11.5 0ZM14.6142 16.3683C14.0815 17.0017 13.376 17.444 12.438 17.6558V19.1122C12.4253 20.2677 10.483 20.2616 10.4633 19.1122V17.7664C9.52524 17.6874 8.50972 17.3887 7.85114 16.9676C6.79597 16.3101 7.5 14.5 8.78718 15.0373C10.0744 15.5746 10.3016 15.6728 11.1228 15.6791C12.2287 15.6791 12.9712 15.0965 12.9712 14.2291C12.9712 13.4392 12.4242 12.8962 11.0843 12.3531C9.96117 11.9122 9.19052 11.4704 8.66079 10.9614C8.01258 10.3344 7.69859 9.59189 7.69859 8.68597C7.69859 7.02372 8.83408 5.7105 10.562 5.29581V3.89718C10.5351 2.73545 12.5139 2.62088 12.5871 3.89718V5.1709C13.377 5.2415 14.0583 5.44243 14.6873 5.78308C15.8247 6.27227 15.4426 8.46184 13.77 7.73611C13.1498 7.40337 12.4556 7.23254 11.7518 7.23946C10.5709 7.23946 10.1498 7.87089 10.1498 8.46184C10.1498 9.17225 10.6207 9.57264 12.2494 10.247C13.3395 10.6913 14.0884 11.1712 14.6033 11.7562C15.1686 12.398 15.4426 13.1632 15.4426 14.0973C15.4419 14.9281 15.1486 15.7321 14.6142 16.3683Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M14.6142 16.3683C14.0815 17.0017 13.376 17.444 12.438 17.6558V19.1122C12.4253 20.2677 10.483 20.2616 10.4633 19.1122V17.7664C9.52527 17.6874 8.50975 17.3887 7.85117 16.9676C6.796 16.3101 7.50002 14.5 8.7872 15.0373C10.0744 15.5746 10.3016 15.6729 11.1228 15.6791C12.2287 15.6791 12.9712 15.0965 12.9712 14.2291C12.9712 13.4392 12.4242 12.8962 11.0843 12.3531C9.9612 11.9122 9.19055 11.4704 8.66082 10.9614C8.0126 10.3344 7.69862 9.5919 7.69862 8.68598C7.69862 7.02373 8.8341 5.71051 10.562 5.29581V3.89719C10.5351 2.73545 12.5139 2.62089 12.5871 3.89719V5.17091C13.377 5.24151 14.0583 5.44244 14.6873 5.78309C15.8247 6.27228 15.4426 8.46184 13.77 7.73612C13.1498 7.40338 12.4556 7.23255 11.7518 7.23947C10.5709 7.23947 10.1498 7.8709 10.1498 8.46184C10.1498 9.17226 10.6208 9.57264 12.2494 10.247C13.3395 10.6913 14.0884 11.1712 14.6034 11.7562C15.1686 12.398 15.4426 13.1632 15.4426 14.0973C15.4419 14.9281 15.1486 15.7321 14.6142 16.3683Z"
  }));
};

MoneySignCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
MoneySignCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var MoneySignGradient = function MoneySignGradient(_ref) {
  var startColor = _ref.startColor,
      stopColor = _ref.stopColor,
      props = _objectWithoutProperties(_ref, ["startColor", "stopColor"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    width: "20",
    height: "20"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M24 0C10.7667 0 0 10.7667 0 24C0 37.2333 10.7667 48 24 48C37.2333 48 48 37.2333 48 24C48 10.7667 37.2333 0 24 0ZM30.4992 34.1599C29.3875 35.4818 27.9152 36.4049 25.9576 36.8469V39.8863C25.9311 42.2978 21.8776 42.2851 21.8364 39.8863V37.0777C19.8788 36.9129 17.7594 36.2895 16.385 35.4107C14.1829 34.0384 15.6522 30.2609 18.3385 31.3822C21.0247 32.5035 21.4989 32.7085 23.2128 32.7216C25.5207 32.7216 27.0703 31.5058 27.0703 29.6955C27.0703 28.0471 25.9287 26.9137 23.1325 25.7804C20.7885 24.8603 19.1802 23.9382 18.0747 22.8759C16.7219 21.5674 16.0666 20.0179 16.0666 18.1272C16.0666 14.6582 18.4363 11.9176 22.0424 11.0521V8.13325C21.9863 5.70875 26.116 5.46967 26.2687 8.13325V10.7914C27.9172 10.9388 29.3391 11.3581 30.6517 12.069C33.0254 13.09 32.228 17.6595 28.7374 16.1449C27.443 15.4505 25.9943 15.094 24.5255 15.1084C22.061 15.1084 21.1821 16.4262 21.1821 17.6595C21.1821 19.1421 22.165 19.9777 25.564 21.3851C27.8389 22.3124 29.4019 23.3138 30.4765 24.5347C31.6562 25.8741 32.228 27.4711 32.228 29.4205C32.2266 31.1543 31.6145 32.8323 30.4992 34.1599Z"
  }), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("linearGradient", {
    id: "paint0_linear",
    x1: "24",
    x2: "24",
    y1: "0",
    y2: "48",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React__default.createElement("stop", {
    stopColor: startColor
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: "1",
    stopColor: stopColor
  }))));
};

MoneySignGradient.propTypes = {
  startColor: PropTypes__default.string,
  stopColor: PropTypes__default.string
};
MoneySignGradient.defaultProps = {
  startColor: SECONDARY_COLOR,
  stopColor: SECONDARY_GRADIENT_COLOR
};

var MultiplePeopleCircle = function MultiplePeopleCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: "20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: backgroundColor,
    d: "M11.4959 22.9918C17.8449 22.9918 22.9918 17.8449 22.9918 11.4959C22.9918 5.14689 17.8449 0 11.4959 0C5.14689 0 0 5.14689 0 11.4959C0 17.8449 5.14689 22.9918 11.4959 22.9918Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M18.8483 13.5027C18.2224 13.0623 17.272 13.2941 16.6694 12.5059 16.6694 12.5059 16.4376 12.251 16.9475 11.6483 17.4575 11.0456 17.4807 10.0721 17.3648 9.33032 17.2489 8.58857 16.5303 8.07861 15.8117 8.07861 15.07 8.07861 14.3746 8.56539 14.2587 9.33032 14.1428 10.0721 14.1659 11.0456 14.6759 11.6483 14.9309 11.9496 15.0004 12.1814 15.0004 12.3205 15.2322 12.39 15.464 12.5059 15.6726 12.645 16.623 13.3172 16.5535 14.5921 16.5303 14.963H19.335C19.3119 14.963 19.4741 13.9431 18.8483 13.5027zM7.39742 12.645C7.62922 12.4828 7.86102 12.39 8.09281 12.2973 8.09281 12.1583 8.16235 11.9496 8.41732 11.6483 8.9041 11.0456 8.95047 10.0721 8.83457 9.33032 8.71867 8.58857 8.0001 8.07861 7.28152 8.07861 6.53977 8.07861 5.84437 8.56539 5.72848 9.33032 5.61258 10.0721 5.63575 11.0456 6.14571 11.6483 6.65566 12.251 6.42387 12.5059 6.42387 12.5059 5.82119 13.2941 4.87082 13.0623 4.24497 13.5027 3.61911 13.9431 3.78137 14.963 3.78137 14.963H6.56294C6.4934 14.5921 6.44705 13.3172 7.39742 12.645z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M15.3018 13.1784C15.0931 13.0162 14.8382 12.9466 14.5832 12.8771C13.911 12.6917 13.146 12.6453 12.6129 11.9499C12.6129 11.9499 12.3348 11.6486 12.9606 10.8836C13.5865 10.1419 13.6328 8.93655 13.4706 8.00936C13.3083 7.08217 12.4506 6.47949 11.5466 6.47949C10.6426 6.47949 9.7618 7.10535 9.62272 8.00936C9.46046 8.93655 9.53 10.1419 10.1327 10.8836C10.7585 11.6254 10.4804 11.9499 10.4804 11.9499C9.94724 12.6453 9.20548 12.6917 8.53327 12.8771C8.27829 12.9466 8.02332 13.0394 7.79153 13.1784C7.02659 13.7348 7.21203 14.9865 7.21203 14.9865H7.30474H10.8281H11.5698H12.3348H15.8581H15.9276C15.8813 14.9633 16.0667 13.7116 15.3018 13.1784Z"
  }));
};

MultiplePeopleCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
MultiplePeopleCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var QuestionmarkCircle = function QuestionmarkCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: "20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: backgroundColor,
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M15.663 6.4007C15.4389 5.90947 15.1263 5.48514 14.7234 5.12963C14.3204 4.77411 13.8365 4.49696 13.2716 4.29818C12.7067 4.09939 12.0816 4 11.4 4C10.7541 4 10.161 4.10895 9.61682 4.32685C9.07453 4.54474 8.59815 4.85439 8.18767 5.25769C7.77719 5.66099 7.44579 6.14839 7.19159 6.72181C7.15205 6.81164 7.11439 6.90148 7.0805 6.99322C6.77923 7.79218 7.36105 8.64848 8.20273 8.64848H8.32512C8.84858 8.64848 9.31743 8.31017 9.4756 7.80365C9.8183 6.71034 10.466 6.16368 11.4188 6.16368C11.7163 6.16368 11.9874 6.21338 12.2341 6.31086C12.4789 6.40834 12.6898 6.54596 12.8668 6.72181C13.0438 6.89765 13.1812 7.10408 13.281 7.34109C13.3808 7.57811 13.4298 7.83805 13.4298 8.12094C13.4298 8.27194 13.4185 8.41147 13.3978 8.54144C13.3752 8.67142 13.3187 8.80904 13.2264 8.95812C13.1342 9.1053 12.9948 9.27541 12.8122 9.46846C12.6295 9.66151 12.3791 9.89279 12.0628 10.1623C11.3303 10.7797 10.8238 11.3779 10.5451 11.9571C10.402 12.2533 10.2984 12.6528 10.2325 13.1574C10.2118 13.3218 10.193 13.4977 10.1779 13.685C10.1215 14.3941 10.675 15 11.3755 15C12.0025 15 12.5222 14.5107 12.573 13.8761C12.6069 13.4384 12.6672 13.1288 12.75 12.9491C12.8178 12.7924 12.9553 12.605 13.1605 12.3871C13.3658 12.1692 13.635 11.9189 13.9702 11.636C14.746 10.988 15.2732 10.3859 15.5537 9.83162C15.8512 9.28306 16 8.67524 16 8.00817C15.9981 7.42711 15.887 6.89192 15.663 6.4007Z"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "11.5",
    cy: "17.5",
    r: "1.5",
    fill: color
  }));
};

QuestionmarkCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
QuestionmarkCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var QuestionmarkEmpty = function QuestionmarkEmpty(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: "20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 18"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    stroke: color,
    d: "M16.5 9.5C16.5 13.9183 12.9183 17.5 8.5 17.5C4.08172 17.5 0.5 13.9183 0.5 9.5C0.5 5.08172 4.08172 1.5 8.5 1.5C12.9183 1.5 16.5 5.08172 16.5 9.5Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M8.648 5.288C9.528 5.288 10.236 5.524 10.772 5.996C11.308 6.468 11.576 7.084 11.576 7.844C11.576 8.316 11.448 8.748 11.192 9.14C10.944 9.532 10.516 9.932 9.908 10.34C9.612 10.548 9.412 10.732 9.308 10.892C9.204 11.052 9.144 11.232 9.128 11.432H7.616C7.624 11.072 7.736 10.736 7.952 10.424C8.168 10.104 8.504 9.78 8.96 9.452C9.384 9.14 9.676 8.864 9.836 8.624C9.996 8.384 10.076 8.128 10.076 7.856C10.076 7.448 9.948 7.124 9.692 6.884C9.444 6.636 9.096 6.512 8.648 6.512C8.176 6.512 7.792 6.664 7.496 6.968C7.2 7.272 7.04 7.668 7.016 8.156H5.48C5.536 7.3 5.852 6.608 6.428 6.08C7.004 5.552 7.744 5.288 8.648 5.288ZM9.272 14H7.472V12.332H9.272V14Z"
  }));
};

QuestionmarkEmpty.propTypes = {
  color: PropTypes__default.string
};
QuestionmarkEmpty.defaultProps = {
  color: PRIMARY_COLOR
};

function _templateObject$f() {
  var data = _taggedTemplateLiteral(["\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}
var StyledSvg = newStyled.svg(_templateObject$f());

var InformationCircle = function InformationCircle(_ref) {
  var color = _ref.color,
      backgroundColor = _ref.backgroundColor,
      props = _objectWithoutProperties(_ref, ["color", "backgroundColor"]);

  return /*#__PURE__*/React__default.createElement(StyledSvg, _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    r: "11",
    cx: "11.5",
    cy: "11.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23ZM13 17.9759C13 18.5382 12.4851 19 11.8806 19H11.1194C10.4925 19 10 18.5382 10 17.9759V10.004C10 9.44177 10.5149 9 11.1194 9H11.8806C12.5075 9 13 9.46185 13 10.004V17.9759ZM11.5 7C12.3284 7 13 6.32843 13 5.5C13 4.67157 12.3284 4 11.5 4C10.6716 4 10 4.67157 10 5.5C10 6.32843 10.6716 7 11.5 7Z",
    fill: backgroundColor
  }));
};

InformationCircle.propTypes = {
  color: PropTypes__default.string,
  backgroundColor: PropTypes__default.string
};
InformationCircle.defaultProps = {
  backgroundColor: WARNING_COLOR,
  color: WHITE_COLOR
};

var RecurringCircle = function RecurringCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: "20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: backgroundColor,
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    stroke: color,
    strokeWidth: ".5",
    d: "M10.9424 6.43264C12.5047 6.43264 13.8647 7.21868 14.6714 8.41883 14.7962 8.60436 14.7599 8.84987 14.6018 9.00794L13.5205 10.0893C13.2055 10.4043 13.4286 10.9428 13.874 10.9428H15.4792 16.9118 17.4274C17.7006 10.9428 17.9233 10.7235 17.9274 10.4503L17.9811 6.86977C17.9878 6.42074 17.4451 6.19117 17.1276 6.50872L16.3648 7.27148C16.1406 7.49568 15.7675 7.45624 15.5675 7.21014 14.4783 5.86942 12.8191 5 10.969 5 7.87272 5 5.30193 7.38843 5.0469 10.443 5.02392 10.7182 5.24998 10.9428 5.52612 10.9428H5.95342C6.23165 10.9428 6.45341 10.7148 6.48187 10.4381 6.71382 8.18245 8.64394 6.43264 10.9424 6.43264zM12.0571 16.8854C10.4949 16.8854 9.13482 16.0994 8.32812 14.8993 8.20341 14.7137 8.23967 14.4682 8.39774 14.3101L9.47909 13.2288C9.79407 12.9138 9.57099 12.3752 9.12554 12.3752H7.5204 6.08775 5.57215C5.29893 12.3752 5.0763 12.5946 5.0722 12.8677L5.01849 16.4483C5.01176 16.8973 5.55445 17.1269 5.87199 16.8094L6.63475 16.0466C6.85896 15.8224 7.23212 15.8618 7.43205 16.1079 8.52127 17.4487 10.1805 18.3181 12.0306 18.3181 15.1268 18.3181 17.6976 15.9296 17.9527 12.8751 17.9757 12.5999 17.7496 12.3752 17.4735 12.3752H17.0461C16.7679 12.3752 16.5462 12.6033 16.5177 12.88 16.2857 15.1356 14.3556 16.8854 12.0571 16.8854z"
  }));
};

RecurringCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
RecurringCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var PanelsCircle = function PanelsCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: "20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: backgroundColor,
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M14.025 7.12087H17.3789L16.7442 5.21446C16.7235 5.15236 16.6838 5.09834 16.6307 5.06007 16.5776 5.02179 16.5138 5.0012 16.4483 5.00122H13.9957C14.016 5.05765 14.0265 5.1171 14.0269 5.17705L14.025 7.12087zM12.9647 7.12027V5.17583C12.9651 5.11588 12.9757 5.05643 12.9959 5H9.78979V7.11996L12.9647 7.12027zM8.72992 5.00122H6.30755C6.24209 5.0012 6.17829 5.02179 6.12519 5.06007 6.07209 5.09834 6.03238 5.15236 6.01169 5.21446L5.37695 7.12087H8.72992V5.00122zM14.0254 9.77743H18.2631L17.7316 8.18091H14.0254V9.77743zM12.966 8.18091H9.78979V9.77743H12.966V8.18091zM8.7298 8.18091H5.02361L4.49207 9.77743H8.7298V8.18091zM12.9647 10.837H9.78979V12.9498C9.78979 12.9498 12.9657 13.0031 12.9657 12.8875L12.9647 10.837zM4.13922 10.837L3.57213 12.5396C3.55652 12.5864 3.55227 12.6363 3.55973 12.6852 3.56719 12.734 3.58615 12.7803 3.61504 12.8204 3.64394 12.8605 3.68194 12.8931 3.72592 12.9156 3.76989 12.9381 3.81859 12.9498 3.86799 12.9498H8.73142V10.837H4.13922zM18.6167 10.837H14.0248C14.0248 10.837 14.0616 12.8734 14.0189 12.9498H18.8883C18.9377 12.9498 18.9864 12.9381 19.0304 12.9156 19.0743 12.8931 19.1123 12.8605 19.1412 12.8204 19.1701 12.7803 19.1891 12.734 19.1965 12.6852 19.204 12.6363 19.1998 12.5864 19.1841 12.5396L18.6167 10.837zM19.1491 13.7595H3.52999C3.38943 13.7595 3.25462 13.8154 3.15523 13.9148 3.05584 14.0141 3 14.1489 3 14.2895 3 14.4301 3.05584 14.5649 3.15523 14.6643 3.25462 14.7637 3.38943 14.8195 3.52999 14.8195H10.7432V16.9395H9.52449C9.38393 16.9395 9.24912 16.9953 9.14973 17.0947 9.05034 17.1941 8.9945 17.3289 8.9945 17.4695 8.9945 17.61 9.05034 17.7448 9.14973 17.8442 9.24912 17.9436 9.38393 17.9994 9.52449 17.9994H12.9663C13.1069 17.9994 13.2417 17.9436 13.3411 17.8442 13.4405 17.7448 13.4963 17.61 13.4963 17.4695 13.4963 17.3289 13.4405 17.1941 13.3411 17.0947 13.2417 16.9953 13.1069 16.9395 12.9663 16.9395H11.8031V14.8195H19.1491C19.2897 14.8195 19.4245 14.7637 19.5239 14.6643 19.6233 14.5649 19.6791 14.4301 19.6791 14.2895 19.6791 14.1489 19.6233 14.0141 19.5239 13.9148 19.4245 13.8154 19.2897 13.7595 19.1491 13.7595V13.7595z"
  }));
};

PanelsCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
PanelsCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var PersonCircle = function PersonCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: "20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: backgroundColor,
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M16.562 13.8416C15.5584 13.1307 13.9902 13.507 13.0284 12.2316C13.0284 12.2316 12.6729 11.8343 13.4884 10.8307C14.3038 9.84794 14.3665 8.25885 14.1575 7.04613C13.9484 5.8334 12.7984 5.01794 11.6065 5.01794C10.4147 5.01794 9.26473 5.8334 9.05564 7.04613C8.84655 8.25885 8.93018 9.82703 9.72473 10.8307C10.5193 11.8343 10.1847 12.2316 10.1847 12.2316C9.22291 13.507 7.67564 13.1307 6.65109 13.8416C5.64745 14.5525 5.87745 16.2043 5.87745 16.2043H11.6065H17.3147C17.3147 16.2043 17.5656 14.5734 16.562 13.8416Z",
    clipRule: "evenodd"
  }));
};

PersonCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
PersonCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var Phone = function Phone(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M19.5516 15.8057L16.4629 12.7167C15.8477 12.1039 14.8289 12.1226 14.1923 12.7594L12.6362 14.3152C12.5379 14.261 12.4361 14.2044 12.3291 14.1444C11.3465 13.5999 10.0015 12.8536 8.58628 11.4373C7.16683 10.018 6.41986 8.67103 5.87372 7.68774C5.81609 7.58357 5.76087 7.48313 5.70634 7.38775L6.75071 6.34494L7.26416 5.83085C7.90178 5.19306 7.91936 4.17455 7.30559 3.56003L4.2169 0.470661C3.60313 -0.142996 2.58387 -0.12438 1.94626 0.51341L1.07576 1.38891L1.09955 1.41252C0.807657 1.78497 0.563746 2.21453 0.382234 2.67776C0.214915 3.1187 0.110743 3.53946 0.0631095 3.9611C-0.344731 7.34219 1.20033 10.4323 5.39342 14.6254C11.1896 20.4211 15.8605 19.9833 16.062 19.9619C16.5009 19.9095 16.9214 19.8046 17.3489 19.6386C17.8081 19.4592 18.2374 19.2157 18.6096 18.9244L18.6286 18.9413L19.5105 18.0777C20.1468 17.4401 20.1651 16.4212 19.5516 15.8057Z",
    fill: color
  }));
};

Phone.propTypes = {
  color: PropTypes__default.string
};
Phone.defaultProps = {
  color: TEXT_DARK_COLOR
};

var PowerButtonCircle = function PowerButtonCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: "20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: backgroundColor,
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M12.3975 10.3482V4.85844C12.3975 4.38433 12.0132 4 11.5391 4C11.065 4 10.6807 4.38433 10.6807 4.85844V10.3482C10.6807 10.8223 11.065 11.2066 11.5391 11.2066C12.0132 11.2066 12.3975 10.8223 12.3975 10.3482Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    stroke: color,
    d: "M14.5543 6.17202C14.0514 5.91134 13.4996 6.31332 13.4996 6.87978V6.87978C13.4996 7.21575 13.7033 7.51379 13.9955 7.67966C15.5043 8.53622 16.5094 10.1508 16.5094 11.9907C16.5094 14.725 14.2838 16.9506 11.5496 16.9506C8.81527 16.9506 6.58971 14.725 6.58971 11.9907C6.58971 10.1521 7.61075 8.53845 9.10553 7.68144C9.39677 7.51446 9.59953 7.21637 9.59953 6.88066V6.88066C9.59953 6.31322 9.04736 5.90983 8.5429 6.16966C6.43481 7.25545 5 9.44965 5 11.9907C5 15.5941 7.94624 18.5403 11.5496 18.5403C15.1529 18.5403 18.0991 15.5941 18.0991 11.9907C18.0991 9.45149 16.6506 7.25863 14.5543 6.17202Z"
  }));
};

PowerButtonCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
PowerButtonCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var PowerLineConnect = function PowerLineConnect(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: "20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 37 34"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M2.95385 14.6425L6.43086 12.4331L4.10956 11.7917C6.30347 6.18144 11.6288 2.26773 17.7499 2.0042C26.2102 1.63996 33.3943 8.27485 33.761 16.7912C33.7733 17.0783 33.7748 17.3774 33.771 17.6882L34.4573 17.699C34.4606 17.3766 34.4586 17.066 34.4455 16.7617C34.2599 12.449 32.4198 8.47214 29.2592 5.55323C26.0987 2.63432 22.0046 1.13063 17.7202 1.31508C14.1376 1.46932 10.7991 2.78097 8.06991 5.10196C6.01455 6.84676 4.42448 9.10526 3.45603 11.6089L1.02465 10.9859L2.95385 14.6425Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: color,
    strokeWidth: ".5",
    d: "M4.10956 11.7917C6.30347 6.18144 11.6288 2.26773 17.7499 2.0042C26.2102 1.63996 33.3943 8.27485 33.761 16.7912C33.7733 17.0783 33.7748 17.3774 33.771 17.6882L34.4573 17.699C34.4606 17.3766 34.4586 17.066 34.4455 16.7617C34.2599 12.449 32.4198 8.47214 29.2592 5.55323C26.0987 2.63432 22.0046 1.13063 17.7202 1.31508C14.1376 1.46932 10.7991 2.78097 8.06991 5.10196C6.01455 6.84676 4.42448 9.10526 3.45603 11.6089M4.10956 11.7917L3.45603 11.6089M4.10956 11.7917L6.43086 12.4331L2.95385 14.6425L1.02465 10.9859L3.45603 11.6089"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M30.6748 22.2427L32.9299 22.9274C30.7647 28.4007 25.5566 32.2147 19.5777 32.4721C11.2792 32.8294 4.23235 26.3213 3.87271 17.9678C3.86059 17.6862 3.85917 17.3928 3.86286 17.0879L3.18967 17.0773C3.18646 17.3935 3.18837 17.6982 3.20122 17.9967C3.38334 22.227 5.18828 26.1278 8.28841 28.9909C11.3885 31.854 15.4044 33.329 19.6068 33.148C23.121 32.9968 26.3956 31.7102 29.0727 29.4336C31.0597 27.7467 32.6072 25.5703 33.5621 23.1567L35.9889 23.6618L34.0854 20.0756L30.6748 22.2427Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: color,
    strokeWidth: ".5",
    d: "M33.5621 23.1567C32.6072 25.5703 31.0597 27.7467 29.0727 29.4336C26.3956 31.7102 23.121 32.9968 19.6068 33.148C15.4044 33.329 11.3885 31.854 8.28841 28.9909C5.18828 26.1278 3.38334 22.227 3.20122 17.9967C3.18837 17.6982 3.18646 17.3935 3.18967 17.0773L3.86286 17.0879C3.85917 17.3928 3.86059 17.6862 3.87271 17.9678C4.23235 26.3213 11.2792 32.8294 19.5777 32.4721C25.5566 32.2147 30.7647 28.4007 32.9299 22.9274M33.5621 23.1567L32.9299 22.9274M33.5621 23.1567L35.9889 23.6618L34.0854 20.0756L30.6748 22.2427L32.9299 22.9274"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M17.4554 9.49915H11.953L11.9199 11.5058H13.677L17.4554 14.6812V13.7266C16.4515 12.8593 15.8887 12.3731 14.8848 11.5058L17.4554 11.5058V13.7266V14.6812V25.1354C17.4554 25.8306 17.4554 25.8306 17.1096 25.8306C16.7884 25.8306 16.7637 25.884 16.7637 26.2049V26.5792H18.2953H19.8269V26.2049C19.8269 25.8573 19.7774 25.8306 19.481 25.8306C19.1352 25.8306 19.1352 25.8306 19.1352 25.1354V14.7949V13.8296V11.5058L21.8635 11.5074L19.1352 13.8296V14.7949L23.0714 11.5082L25.0799 11.5094V9.49915H19.1352H17.4554Z"
  }));
};

PowerLineConnect.propTypes = {
  color: PropTypes__default.string
};
PowerLineConnect.defaultProps = {
  color: SECONDARY_COLOR
};

var PowerLineConnectCircle = function PowerLineConnectCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    height: "20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: backgroundColor,
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.676 7C19.6928 9.97032 19.4078 14.0577 16.8055 16.7147 15.5396 18.0081 13.8595 18.8069 12.064 18.9693 10.5841 19.1031 9.1049 18.7973 7.80518 18.1002M5.29824 16C3.32085 13.0297 3.59995 8.94237 6.15183 6.28445 7.28489 5.10494 8.75891 4.33378 10.3537 4.08618 11.9485 3.83858 13.5784 4.12784 15 4.91074"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M15.8614 3.8733L16.5328 5.99343C16.5458 6.03448 16.5486 6.07899 16.5408 6.12249C16.533 6.166 16.515 6.20696 16.4885 6.24127C16.462 6.27557 16.428 6.30201 16.39 6.31793C16.3519 6.33384 16.311 6.33867 16.2715 6.33193L14.2313 5.98181C14.1917 5.97497 14.155 5.95677 14.1247 5.92903C14.0944 5.9013 14.0716 5.86501 14.0588 5.82384C14.0459 5.78266 14.0433 5.73805 14.0513 5.6945C14.0592 5.65095 14.0775 5.61 14.1042 5.57579L15.4725 3.80399C15.4992 3.76993 15.5333 3.74378 15.5715 3.72817C15.6096 3.71257 15.6504 3.70805 15.6898 3.71507C15.7292 3.72209 15.7658 3.74041 15.7959 3.76818C15.8261 3.79595 15.8486 3.83221 15.8614 3.8733V3.8733Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M15.8614 3.8733L16.5328 5.99343C16.5458 6.03448 16.5486 6.07899 16.5408 6.12249 16.533 6.166 16.515 6.20696 16.4885 6.24127 16.462 6.27557 16.428 6.30201 16.39 6.31793 16.3519 6.33384 16.311 6.33867 16.2715 6.33193L14.2313 5.98181C14.1917 5.97497 14.155 5.95677 14.1247 5.92903 14.0944 5.9013 14.0716 5.86501 14.0588 5.82384 14.0459 5.78266 14.0433 5.73805 14.0513 5.6945 14.0592 5.65095 14.0775 5.61 14.1042 5.57579L15.4725 3.80399C15.4992 3.76993 15.5333 3.74378 15.5715 3.72817 15.6096 3.71257 15.6504 3.70805 15.6898 3.71507 15.7292 3.72209 15.7658 3.74041 15.7959 3.76818 15.8261 3.79595 15.8486 3.83221 15.8614 3.8733V3.8733zM6.91645 17.0151L9.12969 17.2326C9.17255 17.2368 9.21455 17.2518 9.25148 17.276 9.28841 17.3003 9.31896 17.333 9.34007 17.3709 9.36118 17.4087 9.3721 17.4504 9.37173 17.4916 9.37137 17.5329 9.35973 17.5724 9.33798 17.606L8.21289 19.3437C8.19104 19.3773 8.15983 19.404 8.12241 19.4209 8.08499 19.4378 8.04268 19.4444 7.99976 19.4401 7.95683 19.4357 7.9148 19.4205 7.87791 19.396 7.84102 19.3716 7.81057 19.3387 7.78963 19.3006L6.69963 17.3453C6.67882 17.3073 6.66822 17.2657 6.66889 17.2245 6.66956 17.1832 6.68148 17.1439 6.70344 17.1105 6.72541 17.077 6.75665 17.0506 6.79404 17.0339 6.83143 17.0171 6.87365 17.0106 6.91645 17.0151V17.0151z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M6.91645 17.0151L9.12969 17.2326C9.17255 17.2368 9.21455 17.2518 9.25148 17.276 9.28841 17.3003 9.31896 17.333 9.34007 17.3709 9.36118 17.4087 9.3721 17.4504 9.37173 17.4916 9.37137 17.5329 9.35973 17.5724 9.33798 17.606L8.21289 19.3437C8.19104 19.3773 8.15983 19.404 8.12241 19.4209 8.08499 19.4378 8.04268 19.4444 7.99976 19.4401 7.95683 19.4357 7.9148 19.4205 7.87791 19.396 7.84102 19.3716 7.81057 19.3387 7.78963 19.3006L6.69963 17.3453C6.67882 17.3073 6.66822 17.2657 6.66889 17.2245 6.66956 17.1832 6.68148 17.1439 6.70344 17.1105 6.72541 17.077 6.75665 17.0506 6.79404 17.0339 6.83143 17.0171 6.87365 17.0106 6.91645 17.0151V17.0151zM13.9837 8.30098C14.2457 8.57016 14.3209 8.92859 14.1532 9.09182L12.1271 11.0638C11.9549 11.2314 11.6031 11.1421 11.3411 10.8729 11.0792 10.6038 11.0039 10.2453 11.1716 10.0821L13.1977 8.11012C13.3655 7.94689 13.7217 8.0318 13.9837 8.30098z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M9.08502 8.29371C8.8128 8.57341 8.72651 8.93796 8.89109 9.09814L10.8794 11.0333C11.0484 11.1978 11.406 11.0974 11.6783 10.8177C11.9505 10.538 12.0368 10.1734 11.8722 10.0132L9.88391 8.07806C9.71933 7.91788 9.35725 8.01401 9.08502 8.29371Z"
  }), /*#__PURE__*/React__default.createElement("rect", {
    width: "1.6",
    height: "8.6",
    x: "11",
    y: "8",
    fill: color,
    rx: ".8"
  }), /*#__PURE__*/React__default.createElement("rect", {
    width: "1.1",
    height: "7",
    x: "8",
    y: "9",
    fill: color,
    rx: ".5",
    transform: "rotate(-90 8 9)"
  }));
};

PowerLineConnectCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
PowerLineConnectCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var Cloudy = function Cloudy(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "21",
    height: "23",
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M5.55066 8.88546C5.18062 8.79295 4.81058 8.70044 4.44053 8.70044C2.03525 8.70044 0 10.6432 0 13.141C0 15.6388 1.94273 17.5815 4.44053 17.5815H10.8238V5C8.32599 5.09251 6.29075 6.6652 5.55066 8.88546Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M21.0001 13.696C21.0001 11.5683 19.2424 9.90308 17.2071 9.90308C17.0221 9.90308 16.7446 9.90308 16.5595 9.9956C16.1895 7.22026 13.7842 5 10.9164 5H10.8239V17.5815H17.2071C19.2424 17.5815 21.0001 15.8238 21.0001 13.696Z",
    fill: color
  }));
};

Cloudy.propTypes = {
  color: PropTypes__default.string
};
Cloudy.defaultProps = {
  color: SECONDARY_COLOR
};

var CloudyCircle = function CloudyCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    r: "11",
    cx: "11.5",
    cy: "11.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 11.5C23 17.8513 17.8513 23 11.5 23C5.14873 23 0 17.8513 0 11.5C0 5.14873 5.14873 0 11.5 0C17.8513 0 23 5.14873 23 11.5ZM16.1936 8.76345C16.3441 8.74004 16.4946 8.71662 16.6452 8.71662C18.4731 8.71662 19.9785 10.356 20 12.37C20 14.3841 18.5161 16 16.6667 16H6.55914C5.13979 16 4 14.7354 4 13.2131C4 11.8314 4.94624 10.6838 6.15054 10.4731C6.25806 9.04449 7.35484 7.94379 8.68817 7.94379H8.68827C8.81726 7.94379 8.92476 7.94379 9.05376 7.9672C9.78495 6.77282 11.0108 6 12.4301 6C14.129 6 15.5914 7.14754 16.1936 8.76346L16.1936 8.76345Z",
    fill: backgroundColor
  }));
};

CloudyCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
CloudyCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var Night = function Night(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "18",
    height: "19",
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M6.66232 10.7403C5.52343 7.96824 5.80882 4.97904 7.17971 2.55578C7.71896 1.60258 7.06369 0.28197 6.04631 0.687308C1.09772 2.65302 -1.29313 8.19063 0.70626 13.0559C2.70565 17.9211 8.33777 20.2713 13.2864 18.3056C14.2592 17.9205 13.8618 16.5785 12.8579 16.2833C10.142 15.4846 7.80687 13.5242 6.66232 10.7403Z",
    fill: color
  }));
};

Night.propTypes = {
  color: PropTypes__default.string
};
Night.defaultProps = {
  color: YELLOW_COLOR
};

var NightCircle = function NightCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    r: "11",
    cx: "11.5",
    cy: "11.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 11.5C23 17.8513 17.8513 23 11.5 23C5.14873 23 0 17.8513 0 11.5C0 5.14873 5.14873 0 11.5 0C17.8513 0 23 5.14873 23 11.5ZM10.4735 5.95705C9.42069 7.83579 9.19881 10.1579 10.0684 12.3108C10.9377 14.4614 12.71 15.9771 14.7719 16.5969C15.5442 16.8291 15.8557 17.8635 15.1077 18.1647C11.343 19.6857 7.05834 17.8672 5.53729 14.1025C4.01625 10.3378 5.83509 6.05288 9.59976 4.53183C10.3791 4.21602 10.8846 5.2235 10.4735 5.95705Z",
    fill: backgroundColor
  }));
};

NightCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
NightCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var PartlyCloudy = function PartlyCloudy(_ref) {
  var sun = _ref.sun,
      cloud = _ref.cloud;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "21",
    height: "19",
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.031 10.5531L12.9204 10.6195V10.7522C12.9204 10.7522 12.9646 12.3451 12.9867 12.9867C12.3451 12.9646 10.8186 12.9204 10.7522 12.9204H10.6195L10.5531 13.031C10.5531 13.031 9.82301 14.4248 9.51328 15L7.61062 13.8274L7.5 13.7611L7.38938 13.8717C7.38938 13.8717 6.08407 14.6903 5.50885 15.0443C5.41961 14.8785 5.29732 14.6504 5.16737 14.4079L5.16703 14.4073L5.16693 14.4071C4.84593 13.8082 4.47838 13.1225 4.4469 13.0752L4.38053 12.9646H4.24778C4.22566 12.9646 2.67699 13.0089 2.01327 13.031C2.03539 12.3673 2.07964 10.8186 2.07964 10.7965V10.6637L1.96903 10.5974L0 9.53541L1.23893 7.52213L1.17256 7.41151C1.17256 7.41151 0.353982 6.06195 0 5.50886L1.96903 4.44691L2.07964 4.38053V4.24779C2.07964 4.24779 2.0354 2.72125 1.99115 2.01328L4.3584 2.07965L4.42478 1.96903C4.45626 1.92182 4.82363 1.23639 5.14457 0.637599L5.14458 0.637583C5.27478 0.394666 5.39734 0.166008 5.48672 0L7.5 1.23895L7.61062 1.17256L9.51328 0C9.82301 0.619469 10.5973 2.0354 10.5973 2.0354L10.6637 2.14602H10.7965C10.7965 2.14602 12.323 2.05753 12.9867 2.01328C12.9646 2.65488 12.9204 4.22567 12.9204 4.22567V4.35841L13.031 4.42478L15 5.48672C14.6681 6.03982 13.8274 7.38939 13.8274 7.38939L13.7611 7.50001L13.8274 7.61063C13.8466 7.6394 14.0072 7.90098 14.2099 8.23138L14.21 8.23147C14.4749 8.66324 14.812 9.21249 15 9.51328C14.4248 9.80752 13.031 10.5531 13.031 10.5531ZM7.51113 13.1959C10.6629 13.1959 13.218 10.6408 13.218 7.48901C13.218 4.3372 10.6629 1.78215 7.51113 1.78215C4.35932 1.78215 1.80427 4.3372 1.80427 7.48901C1.80427 10.6408 4.35932 13.1959 7.51113 13.1959Z",
    fill: sun
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "7.51098",
    cy: "7.48901",
    r: "4.89159",
    fill: sun
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M6.30008 9.70591C6.00007 9.70591 5.60007 9.60591 5.20006 9.60591C2.90003 9.60591 1 11.5059 1 13.806C1 16.106 2.90003 18.006 5.20006 18.006H11.3001V6.00586C9.00011 6.10586 7.00009 7.60588 6.30008 9.70591Z",
    fill: cloud
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M20.9999 14.206C20.9999 12.2059 19.3999 10.6059 17.3999 10.6059C17.1999 10.6059 16.9999 10.6059 16.7999 10.7059C16.4999 8.00589 14.1998 6.00586 11.3998 6.00586H11.2998V18.006H17.3999C19.2999 17.806 20.9999 16.206 20.9999 14.206Z",
    fill: cloud
  }));
};

PartlyCloudy.propTypes = {
  sun: PropTypes__default.string,
  cloud: PropTypes__default.string
};
PartlyCloudy.defaultProps = {
  sun: YELLOW_COLOR,
  cloud: SECONDARY_COLOR
};

var Rain = function Rain(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M13.4995 10.7771C13.4908 11.8985 13.0393 12.971 12.2432 13.761C11.4472 14.5509 10.3712 14.9941 9.24975 14.9941C8.1283 14.9941 7.0523 14.5509 6.25626 13.761C5.46022 12.971 5.00866 11.8985 5 10.7771C5 7.4863 8.92283 1.99414 9.24988 1.99414C9.57693 1.99414 13.4995 7.31188 13.4995 10.7771Z",
    fill: color
  }));
};

Rain.propTypes = {
  color: PropTypes__default.string
};
Rain.defaultProps = {
  color: SECONDARY_COLOR
};

var RainCircle = function RainCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "23",
    height: "23",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z",
    fill: backgroundColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15.4995 13.7829C15.4908 14.9044 15.0393 15.9769 14.2432 16.7668C13.4472 17.5567 12.3712 18 11.2498 18C10.1283 18 9.0523 17.5567 8.25626 16.7668C7.46022 15.9769 7.00866 14.9044 7 13.7829C7 10.4922 10.9228 5 11.2499 5C11.5769 5 15.4995 10.3177 15.4995 13.7829Z",
    fill: color
  }));
};

RainCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
RainCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var RainCloud = function RainCloud(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M12.6452 2.44496C12.4946 2.44496 12.3441 2.46604 12.1935 2.48712C11.5914 1.03278 10.129 0 8.43011 0C7.01075 0 5.78495 0.695542 5.05376 1.77048C4.92473 1.74941 4.8172 1.74941 4.68817 1.74941C3.35484 1.74941 2.25806 2.74004 2.15054 4.02575C0.946236 4.21545 0 5.24824 0 6.4918C0 7.86182 1.13979 9 2.55914 9H12.6667C14.5161 9 16 7.54567 16 5.73302C15.9785 3.92038 14.4731 2.44496 12.6452 2.44496Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.55556 13.6741C7.55193 14.1432 7.36303 14.5919 7.03003 14.9224C6.69703 15.2528 6.24691 15.4382 5.77778 15.4382C5.30865 15.4382 4.85853 15.2528 4.52553 14.9224C4.19252 14.5919 4.00362 14.1432 4 13.6741C4 12.2975 5.64102 10 5.77783 10C5.91464 10 7.55556 12.2245 7.55556 13.6741Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.9999 13.6741C11.9963 14.1432 11.8074 14.5919 11.4744 14.9224C11.1414 15.2528 10.6912 15.4382 10.2221 15.4382C9.75298 15.4382 9.30287 15.2528 8.96986 14.9224C8.63686 14.5919 8.44796 14.1432 8.44434 13.6741C8.44434 12.2975 10.0854 10 10.2222 10C10.359 10 11.9999 12.2245 11.9999 13.6741Z",
    fill: color
  }));
};

RainCloud.propTypes = {
  color: PropTypes__default.string
};
RainCloud.defaultProps = {
  color: SECONDARY_COLOR
};

var RainCloudCircle = function RainCloudCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    r: "11",
    cx: "11.5",
    cy: "11.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 11.5C23 17.8513 17.8513 23 11.5 23C5.14873 23 0 17.8513 0 11.5C0 5.14873 5.14873 0 11.5 0C17.8513 0 23 5.14873 23 11.5ZM15.1936 6.48711C15.3441 6.46603 15.4946 6.44496 15.6452 6.44496C17.4731 6.44496 18.9785 7.92038 19 9.73302C19 11.5457 17.5161 13 15.6667 13H5.55914C4.13979 13 3 11.8618 3 10.4918C3 9.24824 3.94624 8.21545 5.15054 8.02575C5.25806 6.74004 6.35484 5.74941 7.68817 5.74941H7.68827C7.81726 5.74941 7.92476 5.74941 8.05376 5.77048C8.78495 4.69554 10.0108 4 11.4301 4C13.129 4 14.5914 5.03278 15.1935 6.48712L15.1936 6.48711ZM10.5556 17.6741C10.5519 18.1432 10.363 18.5919 10.03 18.9224C9.69703 19.2528 9.24691 19.4382 8.77778 19.4382C8.30865 19.4382 7.85853 19.2528 7.52553 18.9224C7.19252 18.5919 7.00362 18.1432 7 17.6741C7 16.2975 8.64102 14 8.77783 14C8.91464 14 10.5556 16.2245 10.5556 17.6741ZM14.4744 18.9224C14.8074 18.5919 14.9963 18.1432 14.9999 17.6741C14.9999 16.2245 13.359 14 13.2222 14C13.0854 14 11.4443 16.2975 11.4443 17.6741C11.448 18.1432 11.6369 18.5919 11.9699 18.9224C12.3029 19.2528 12.753 19.4382 13.2221 19.4382C13.6912 19.4382 14.1414 19.2528 14.4744 18.9224Z",
    fill: backgroundColor
  }));
};

RainCloudCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
RainCloudCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var Snow = function Snow(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "23",
    height: "22",
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    stroke: color,
    d: "M20.0798 11.2469L21.7961 12.8917C21.8589 12.9519 21.9092 13.0238 21.9441 13.1035C21.9791 13.1831 21.998 13.2688 21.9999 13.3558C22.0017 13.4427 21.9864 13.5292 21.9548 13.6102C21.9232 13.6913 21.8759 13.7653 21.8158 13.8281C21.7556 13.8908 21.6836 13.9411 21.604 13.9761C21.5243 14.0111 21.4386 14.03 21.3516 14.0318C21.2647 14.0336 21.1782 14.0183 21.0972 13.9867C21.0162 13.9551 20.9421 13.9079 20.8794 13.8477L18.1656 11.2469H13.1077L16.7125 14.9801L20.6596 14.995C20.8352 14.9953 21.0035 15.0654 21.1275 15.1898C21.2514 15.3142 21.3209 15.4828 21.3206 15.6584C21.3202 15.834 21.2501 16.0023 21.1257 16.1263C21.0013 16.2502 20.8327 16.3197 20.6571 16.3194H20.6546L17.9963 16.309C17.3252 16.337 17.1608 16.5848 17.2261 17.4186L17.2332 19.6014C17.2332 19.7766 17.1637 19.9448 17.0399 20.0689C16.9162 20.193 16.7483 20.263 16.573 20.2636H16.571C16.3957 20.2636 16.2276 20.1941 16.1034 20.0703C15.9793 19.9466 15.9093 19.7787 15.9088 19.6034L15.8976 16.04L12.2199 12.2324V17.3458L14.8641 20.1017C14.9244 20.1645 14.9717 20.2385 15.0033 20.3196C15.035 20.4007 15.0503 20.4871 15.0485 20.5741C15.0468 20.6611 15.0278 20.7469 14.9929 20.8266C14.958 20.9063 14.9077 20.9783 14.8449 21.0385C14.7821 21.0988 14.7081 21.1461 14.627 21.1777C14.546 21.2094 14.4595 21.2247 14.3725 21.2229C14.2855 21.2212 14.1997 21.2022 14.1201 21.1673C14.0404 21.1324 13.9683 21.0821 13.9081 21.0193L12.2195 19.2591C11.6154 18.8993 11.3504 18.9731 10.8951 19.3535L9.16719 21.0346C9.10499 21.0958 9.03131 21.1442 8.95037 21.1768C8.86944 21.2095 8.78284 21.2258 8.69557 21.2249C8.6083 21.2239 8.52207 21.2058 8.44185 21.1714C8.36163 21.137 8.28899 21.0871 8.22811 21.0246C8.16724 20.9621 8.11933 20.8881 8.08713 20.807C8.05494 20.7259 8.0391 20.6392 8.04052 20.5519C8.04194 20.4647 8.0606 20.3785 8.09542 20.2985C8.13025 20.2185 8.18054 20.1461 8.24343 20.0856L10.8951 17.5055V12.1144L7.73436 15.3873L7.72277 19.1283C7.72223 19.3039 7.65193 19.4722 7.52736 19.596C7.40278 19.7198 7.23413 19.789 7.05851 19.7884C6.88288 19.7879 6.71467 19.7176 6.59087 19.593C6.46707 19.4685 6.39783 19.2998 6.39838 19.1242L6.40583 16.763C6.44404 16.0306 6.26138 15.7883 5.46345 15.8331L2.97731 15.8426H2.97483C2.79921 15.8429 2.63064 15.7735 2.50622 15.6495C2.3818 15.5256 2.31172 15.3573 2.31139 15.1816C2.31106 15.006 2.38051 14.8374 2.50447 14.713C2.62842 14.5886 2.79672 14.5185 2.97235 14.5182L6.74728 14.5037L9.89271 11.2469H4.90265L2.1326 13.9007C2.07039 13.9635 1.99624 14.0132 1.91452 14.0469C1.8328 14.0805 1.74516 14.0975 1.65677 14.0968C1.56839 14.0961 1.48104 14.0777 1.39988 14.0426C1.31872 14.0076 1.2454 13.9567 1.18422 13.8929C1.12305 13.8291 1.07527 13.7537 1.04369 13.6712C1.01212 13.5886 0.99739 13.5006 1.00038 13.4122C1.00337 13.3239 1.02401 13.237 1.06109 13.1568C1.09817 13.0766 1.15094 13.0046 1.21629 12.9451L2.98849 11.2482C3.46425 10.7254 3.5375 10.4436 3.06464 9.92379L1.39798 8.20747C1.33738 8.14496 1.28968 8.07113 1.25761 7.9902C1.22554 7.90926 1.20973 7.8228 1.21107 7.73575C1.21242 7.64871 1.2309 7.56278 1.26545 7.48287C1.3 7.40296 1.34996 7.33065 1.41246 7.27005C1.53869 7.14766 1.70837 7.08042 1.88417 7.08314C1.97122 7.08449 2.05715 7.10296 2.13706 7.13752C2.21696 7.17207 2.28928 7.22203 2.34988 7.28453L4.91341 9.92255H9.98748L6.51965 6.33138L2.79686 6.31731C2.7099 6.31698 2.62386 6.29953 2.54364 6.26595C2.46343 6.23237 2.39061 6.18332 2.32935 6.1216C2.26809 6.05988 2.21959 5.9867 2.18661 5.90623C2.15363 5.82576 2.13683 5.73959 2.13715 5.65263C2.13748 5.56567 2.15493 5.47963 2.18851 5.39941C2.22209 5.31919 2.27114 5.24637 2.33286 5.18511C2.39458 5.12385 2.46777 5.07535 2.54823 5.04237C2.6287 5.0094 2.71487 4.99259 2.80183 4.99292L5.23582 5.00202C6.12809 5.04865 6.30869 4.82836 6.23035 4.12627L6.22414 1.71091C6.22387 1.62395 6.24073 1.53778 6.27376 1.45734C6.30678 1.37689 6.35533 1.30374 6.41663 1.24206C6.47793 1.18038 6.55078 1.13137 6.63101 1.09784C6.71125 1.06431 6.79731 1.04692 6.88427 1.04664H6.88634C7.06161 1.04664 7.22972 1.11613 7.35385 1.23986C7.47798 1.3636 7.54799 1.5315 7.54853 1.70677L7.56012 5.50198L10.8955 8.95575V3.81752L8.15113 1.1468C8.08663 1.0867 8.03477 1.01432 7.99861 0.933912C7.96245 0.853504 7.94271 0.766682 7.94055 0.678543C7.93838 0.590403 7.95385 0.50272 7.98602 0.420635C8.0182 0.338551 8.06644 0.263718 8.12793 0.200525C8.18941 0.137335 8.26289 0.0870571 8.34406 0.0526428C8.42524 0.0182285 8.51246 0.000370026 8.60063 0.000114441C8.68879 -0.000139236 8.77612 0.0172138 8.85749 0.0511589C8.93886 0.085104 9.01264 0.134954 9.07448 0.19779L10.8955 1.96958C11.355 2.42562 11.6581 2.36707 12.2199 1.87687L13.8158 0.213932C13.876 0.151184 13.948 0.100914 14.0277 0.0659885C14.1073 0.0310612 14.1931 0.0121651 14.28 0.0103779C14.367 0.0085907 14.4534 0.0239487 14.5344 0.0555725C14.6155 0.0871964 14.6894 0.134468 14.7522 0.194689C14.8149 0.254908 14.8652 0.326895 14.9001 0.406544C14.9351 0.486193 14.954 0.571943 14.9557 0.658895C14.9575 0.745846 14.9422 0.8323 14.9106 0.913317C14.8789 0.994333 14.8317 1.06833 14.7714 1.13107L12.2195 3.78979V8.83614L15.6455 5.28801L15.6575 1.55281C15.6581 1.37754 15.7281 1.20964 15.8522 1.0859C15.9763 0.962166 16.1445 0.892683 16.3197 0.892683H16.3226C16.4096 0.892956 16.4956 0.910353 16.5759 0.943882C16.6561 0.977411 16.729 1.02642 16.7903 1.0881C16.8516 1.14978 16.9001 1.22293 16.9331 1.30338C16.9662 1.38383 16.983 1.46999 16.9828 1.55695L16.9753 3.9123C16.894 4.6748 17.1044 4.82706 17.9119 4.84806L20.4038 4.83896H20.4063C20.5819 4.83863 20.7505 4.90808 20.8749 5.03203C20.9993 5.15598 21.0694 5.32429 21.0697 5.49991C21.0701 5.67554 21.0006 5.8441 20.8767 5.96852C20.7527 6.09294 20.5844 6.16302 20.4088 6.16335L16.6281 6.17742L13.0117 9.92255H18.0489L20.6646 7.23238C20.7871 7.10698 20.9543 7.03528 21.1296 7.03299C21.3049 7.03071 21.474 7.09804 21.5997 7.22021C21.7254 7.34239 21.7976 7.50943 21.8004 7.68473C21.8031 7.86002 21.7362 8.02925 21.6144 8.15532L19.8956 9.92421C19.3632 10.511 19.3675 10.7869 20.0798 11.2469Z",
    strokeWidth: "0.5"
  }));
};

Snow.propTypes = {
  color: PropTypes__default.string
};
Snow.defaultProps = {
  color: SECONDARY_COLOR
};

var SnowCircle = function SnowCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    r: "11",
    cx: "11.5",
    cy: "11.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z",
    fill: backgroundColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M17.1692 11.7628L18.3539 12.898C18.3972 12.9396 18.4319 12.9892 18.4561 13.0442C18.4802 13.0992 18.4933 13.1583 18.4945 13.2184C18.4958 13.2784 18.4852 13.338 18.4634 13.394C18.4416 13.4499 18.409 13.501 18.3675 13.5443C18.3259 13.5876 18.2762 13.6224 18.2213 13.6465C18.1663 13.6706 18.1071 13.6837 18.0471 13.685C17.9871 13.6862 17.9274 13.6756 17.8715 13.6538C17.8156 13.632 17.7645 13.5994 17.7211 13.5579L15.8481 11.7628H12.357L14.8451 14.3395L17.5695 14.3497C17.6907 14.35 17.8068 14.3983 17.8924 14.4842C17.978 14.5701 18.0259 14.6864 18.0257 14.8077C18.0254 14.9289 17.9771 15.0451 17.8912 15.1306C17.8053 15.2162 17.689 15.2641 17.5677 15.2639H17.566L15.7312 15.2567C15.268 15.276 15.1545 15.447 15.1996 16.0226L15.2045 17.5292C15.2045 17.6502 15.1565 17.7662 15.0711 17.8519C14.9857 17.9375 14.8698 17.9859 14.7488 17.9862H14.7474C14.6264 17.9862 14.5104 17.9383 14.4247 17.8529C14.339 17.7675 14.2907 17.6516 14.2903 17.5306L14.2826 15.071L11.7442 12.4429V15.9723L13.5693 17.8745C13.6109 17.9179 13.6435 17.969 13.6654 18.0249C13.6872 18.0809 13.6978 18.1406 13.6966 18.2006C13.6954 18.2606 13.6823 18.3198 13.6582 18.3748C13.6341 18.4298 13.5994 18.4796 13.556 18.5211C13.5127 18.5627 13.4616 18.5954 13.4057 18.6172C13.3497 18.639 13.29 18.6497 13.23 18.6484C13.1699 18.6472 13.1107 18.6341 13.0557 18.61C13.0007 18.5859 12.951 18.5512 12.9094 18.5079L11.7439 17.2929C11.327 17.0446 11.144 17.0955 10.8298 17.3581L9.63716 18.5184C9.59423 18.5607 9.54337 18.594 9.48751 18.6166C9.43164 18.6391 9.37188 18.6504 9.31164 18.6498C9.2514 18.6491 9.19189 18.6366 9.13652 18.6128C9.08115 18.5891 9.03101 18.5547 8.98899 18.5115C8.94697 18.4684 8.9139 18.4173 8.89168 18.3613C8.86946 18.3053 8.85853 18.2455 8.85951 18.1853C8.86049 18.125 8.87337 18.0656 8.89741 18.0104C8.92144 17.9551 8.95616 17.9052 8.99956 17.8634L10.8298 16.0826V12.3615L8.64819 14.6206L8.6402 17.2027C8.63982 17.3239 8.5913 17.44 8.50532 17.5254C8.41933 17.6109 8.30293 17.6587 8.18171 17.6583C8.06049 17.6579 7.94438 17.6094 7.85893 17.5234C7.77349 17.4374 7.7257 17.321 7.72607 17.1998L7.73122 15.5701C7.75759 15.0646 7.63151 14.8973 7.08076 14.9282L5.36478 14.9348H5.36307C5.24185 14.935 5.1255 14.8871 5.03963 14.8015C4.95375 14.716 4.90538 14.5998 4.90515 14.4786C4.90492 14.3574 4.95286 14.241 5.03841 14.1551C5.12397 14.0693 5.24013 14.0209 5.36135 14.0207L7.96689 14.0107L10.1379 11.7628H6.69369L4.78174 13.5945C4.7388 13.6378 4.68762 13.6721 4.63122 13.6953C4.57481 13.7186 4.51432 13.7303 4.45332 13.7298C4.39231 13.7293 4.33202 13.7166 4.27601 13.6924C4.21999 13.6683 4.16938 13.6331 4.12715 13.5891C4.08493 13.5451 4.05195 13.493 4.03016 13.436C4.00836 13.3791 3.9982 13.3183 4.00026 13.2573C4.00232 13.1963 4.01657 13.1364 4.04217 13.081C4.06776 13.0256 4.10418 12.9759 4.14929 12.9349L5.3725 11.7636C5.70087 11.4028 5.75143 11.2083 5.42506 10.8495L4.27469 9.66487C4.23286 9.62173 4.19994 9.57077 4.17781 9.51491C4.15567 9.45905 4.14476 9.39937 4.14569 9.33929C4.14662 9.27921 4.15937 9.2199 4.18322 9.16474C4.20707 9.10959 4.24155 9.05967 4.28469 9.01785C4.37182 8.93337 4.48893 8.88697 4.61027 8.88884C4.67036 8.88977 4.72967 8.90252 4.78482 8.92637C4.83997 8.95022 4.88989 8.9847 4.93172 9.02784L6.70111 10.8487H10.2033L7.80977 8.36996L5.24023 8.36025C5.18021 8.36002 5.12082 8.34798 5.06545 8.3248C5.01009 8.30162 4.95983 8.26777 4.91754 8.22517C4.87526 8.18257 4.84178 8.13205 4.81902 8.07651C4.79626 8.02097 4.78466 7.9615 4.78489 7.90147C4.78511 7.84145 4.79716 7.78206 4.82033 7.7267C4.84351 7.67133 4.87737 7.62107 4.91997 7.57878C4.96257 7.5365 5.01308 7.50302 5.06862 7.48026C5.12416 7.4575 5.18364 7.4459 5.24366 7.44613L6.92365 7.45241C7.53951 7.4846 7.66416 7.33255 7.61009 6.84795L7.60581 5.18082C7.60562 5.1208 7.61726 5.06132 7.64005 5.0058C7.66285 4.95027 7.69636 4.89978 7.73867 4.85721C7.78098 4.81463 7.83126 4.78081 7.88664 4.75767C7.94202 4.73452 8.00142 4.72252 8.06144 4.72233H8.06287C8.18384 4.72233 8.29988 4.77029 8.38556 4.85569C8.47123 4.9411 8.51955 5.05699 8.51993 5.17796L8.52793 7.79749L10.8301 10.1814V6.63484L8.93586 4.79146C8.89133 4.74998 8.85554 4.70002 8.83058 4.64452C8.80562 4.58902 8.792 4.52909 8.79051 4.46826C8.78901 4.40742 8.79969 4.3469 8.82189 4.29024C8.8441 4.23359 8.8774 4.18194 8.91984 4.13832C8.96228 4.0947 9.013 4.06 9.06902 4.03625C9.12505 4.01249 9.18526 4.00017 9.24611 3.99999C9.30696 3.99982 9.36724 4.01179 9.4234 4.03522C9.47957 4.05865 9.53048 4.09306 9.57317 4.13643L10.8301 5.35936C11.1472 5.67413 11.3564 5.63371 11.7442 5.29537L12.8457 4.14757C12.8873 4.10426 12.937 4.06957 12.992 4.04546C13.0469 4.02135 13.1061 4.00831 13.1661 4.00708C13.2262 4.00584 13.2858 4.01644 13.3417 4.03827C13.3977 4.0601 13.4487 4.09273 13.492 4.13429C13.5354 4.17586 13.5701 4.22554 13.5942 4.28052C13.6183 4.33549 13.6313 4.39468 13.6325 4.4547C13.6338 4.51471 13.6232 4.57438 13.6013 4.6303C13.5795 4.68622 13.5469 4.73729 13.5053 4.7806L11.7439 6.6157V10.0988L14.1086 7.6498L14.1169 5.07169C14.1173 4.95072 14.1656 4.83483 14.2513 4.74943C14.337 4.66402 14.453 4.61606 14.574 4.61606H14.576C14.636 4.61625 14.6954 4.62826 14.7508 4.6514C14.8062 4.67454 14.8565 4.70837 14.8988 4.75094C14.9411 4.79352 14.9746 4.84401 14.9974 4.89953C15.0202 4.95506 15.0318 5.01453 15.0316 5.07455L15.0265 6.70026C14.9703 7.22656 15.1156 7.33165 15.6729 7.34614L17.3929 7.33986H17.3946C17.5159 7.33963 17.6322 7.38757 17.7181 7.47312C17.8039 7.55868 17.8523 7.67484 17.8525 7.79606C17.8528 7.91728 17.8048 8.03363 17.7193 8.11951C17.6337 8.20538 17.5176 8.25375 17.3963 8.25398L14.7868 8.26369L12.2907 10.8487H15.7675L17.5729 8.99185C17.6574 8.90529 17.7729 8.8558 17.8939 8.85423C18.0149 8.85265 18.1316 8.89913 18.2183 8.98345C18.3051 9.06778 18.3549 9.18308 18.3568 9.30407C18.3587 9.42506 18.3126 9.54187 18.2285 9.62888L17.0421 10.8498C16.6747 11.2548 16.6776 11.4453 17.1692 11.7628Z",
    fill: "white",
    stroke: "white",
    strokeWidth: "0.5"
  }));
};

SnowCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
SnowCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var Sunny = function Sunny(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M11.5 16.053C14.57 16.053 17.0588 13.5642 17.0588 10.4941C17.0588 7.42407 14.57 4.9353 11.5 4.9353C8.42993 4.9353 5.94116 7.42407 5.94116 10.4941C5.94116 13.5642 8.42993 16.053 11.5 16.053Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M5.17158 14.376L3.97506 17.4281C3.82972 17.7999 4.19476 18.165 4.56656 18.0196L7.61871 16.8197C7.96009 16.6845 8.01079 16.2249 7.70997 16.0187C7.03059 15.5522 6.44247 14.9641 5.97602 14.2847C5.76646 13.9839 5.30678 14.0346 5.17158 14.376Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M17.8291 6.61151L19.029 3.55936C19.1743 3.18756 18.8093 2.82251 18.4375 2.96785L15.3853 4.16776C15.044 4.30296 14.9933 4.76264 15.2941 4.96882C15.9735 5.43526 16.5616 6.02339 17.028 6.70277C17.2342 7.00359 17.6939 6.95289 17.8291 6.61151Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M4.27861 8.76541L1.27378 10.0769C0.90874 10.2357 0.90874 10.7562 1.27378 10.9151L4.27861 12.2232C4.61661 12.3685 4.97827 12.0812 4.91067 11.7195C4.83631 11.3207 4.79913 10.9117 4.79913 10.4926C4.79913 10.0735 4.83631 9.66449 4.91067 9.26565C4.97827 8.90737 4.61661 8.62007 4.27861 8.76541Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M18.7213 12.2229L21.7262 10.9114C22.0912 10.7526 22.0912 10.232 21.7262 10.0732L18.7213 8.76173C18.3833 8.61639 18.0217 8.90369 18.0893 9.26535C18.1636 9.66419 18.2008 10.0732 18.2008 10.4923C18.2008 10.9114 18.1636 11.3204 18.0893 11.7192C18.0217 12.0809 18.3833 12.3716 18.7213 12.2229Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M7.61871 4.16438L4.56656 2.96785C4.19476 2.82251 3.82972 3.18756 3.97506 3.55936L5.17496 6.61151C5.31016 6.95289 5.76984 7.00359 5.97602 6.70277C6.44247 6.02339 7.03059 5.43526 7.70997 4.96882C8.01079 4.75926 7.96009 4.29958 7.61871 4.16438Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M15.3819 16.8234L18.4341 18.0233C18.8059 18.1686 19.1709 17.8036 19.0256 17.4318L17.8257 14.3797C17.6905 14.0383 17.2308 13.9876 17.0246 14.2884C16.5582 14.9678 15.97 15.5559 15.2907 16.0223C14.9898 16.2285 15.0405 16.6882 15.3819 16.8234Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M13.2289 3.27275L11.9209 0.267922C11.762 -0.0971197 11.2415 -0.0971197 11.0826 0.267922L9.77119 3.27275C9.62585 3.61075 9.91315 3.97241 10.2748 3.90481C10.6737 3.83045 11.0826 3.79327 11.5018 3.79327C11.9209 3.79327 12.3299 3.83045 12.7287 3.90481C13.087 3.97241 13.3777 3.61075 13.2289 3.27275Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M9.77119 17.715L11.0826 20.7199C11.2415 21.0849 11.762 21.0849 11.9209 20.7199L13.2323 17.715C13.3777 17.377 13.0904 17.0154 12.7287 17.083C12.3299 17.1573 11.9209 17.1945 11.5018 17.1945C11.0826 17.1945 10.6737 17.1573 10.2748 17.083C9.91315 17.0154 9.62585 17.377 9.77119 17.715Z"
  }));
};

Sunny.propTypes = {
  color: PropTypes__default.string
};
Sunny.defaultProps = {
  color: YELLOW_COLOR
};

var SunnyCircle = function SunnyCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    r: "11",
    cx: "11.5",
    cy: "11.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 11.5C23 17.8513 17.8513 23 11.5 23C5.14873 23 0 17.8513 0 11.5C0 5.14873 5.14873 0 11.5 0C17.8513 0 23 5.14873 23 11.5ZM16 11.5C16 13.9853 13.9853 16 11.5 16C9.01472 16 7 13.9853 7 11.5C7 9.01472 9.01472 7 11.5 7C13.9853 7 16 9.01472 16 11.5ZM6.3769 14.6425L5.40829 17.1133C5.29063 17.4142 5.58614 17.7097 5.88712 17.5921L8.35791 16.6207C8.63426 16.5113 8.67531 16.1392 8.43179 15.9723C7.88181 15.5947 7.40571 15.1186 7.02812 14.5686C6.85847 14.3251 6.48635 14.3661 6.3769 14.6425ZM17.595 5.88614L16.6237 8.35693C16.5142 8.63329 16.1421 8.67433 15.9752 8.43081C15.5976 7.88083 15.1215 7.40474 14.5715 7.02714C14.328 6.86023 14.369 6.48811 14.6454 6.37866L17.1162 5.40731C17.4172 5.28965 17.7127 5.58516 17.595 5.88614ZM5.65411 10.1005L3.22163 11.1622C2.92612 11.2908 2.92612 11.7122 3.22163 11.8408L5.65411 12.8997C5.92773 13.0173 6.22051 12.7847 6.16578 12.492C6.10559 12.1691 6.07549 11.838 6.07549 11.4987C6.07549 11.1594 6.10559 10.8284 6.16578 10.5055C6.22051 10.2155 5.92773 9.98288 5.65411 10.1005ZM19.7784 11.8378L17.346 12.8995C17.0723 13.0199 16.7796 12.7845 16.8343 12.4918C16.8945 12.1689 16.9246 11.8378 16.9246 11.4985C16.9246 11.1592 16.8945 10.8282 16.8343 10.5053C16.7796 10.2125 17.0723 9.97994 17.346 10.0976L19.7784 11.1592C20.074 11.2878 20.074 11.7092 19.7784 11.8378ZM8.35791 6.37592L5.88712 5.40731C5.58614 5.28965 5.29063 5.58516 5.40829 5.88614L6.37964 8.35693C6.48909 8.63329 6.86121 8.67433 7.02812 8.43081C7.40571 7.88083 7.88181 7.40474 8.43179 7.02714C8.67531 6.8575 8.63426 6.48537 8.35791 6.37592ZM17.1133 17.595L14.6425 16.6237C14.3661 16.5142 14.3251 16.1421 14.5686 15.9752C15.1186 15.5976 15.5947 15.1215 15.9723 14.5715C16.1392 14.328 16.5113 14.369 16.6207 14.6454L17.5921 17.1162C17.7097 17.4172 17.4142 17.7127 17.1133 17.595ZM12.8996 5.65411L11.8407 3.22163C11.7121 2.92612 11.2908 2.92612 11.1622 3.22163L10.1005 5.65411C9.98287 5.92773 10.2154 6.22051 10.5082 6.16578C10.8311 6.10559 11.1622 6.07549 11.5015 6.07549C11.8407 6.07549 12.1718 6.10559 12.4947 6.16578C12.7847 6.22051 13.02 5.92773 12.8996 5.65411ZM11.1622 19.7779L10.1005 17.3455C9.98287 17.0719 10.2154 16.7791 10.5082 16.8338C10.8311 16.894 11.1622 16.9241 11.5015 16.9241C11.8407 16.9241 12.1718 16.894 12.4947 16.8338C12.7875 16.7791 13.0201 17.0719 12.9024 17.3455L11.8407 19.7779C11.7121 20.0735 11.2908 20.0735 11.1622 19.7779Z",
    fill: backgroundColor
  }));
};

SunnyCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
SunnyCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var Tornado = function Tornado(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "19",
    height: "20",
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M14.0909 1.31518C17.0043 1.79364 19 2.76656 19 3.88925C19 5.4847 14.9703 6.77814 10 6.77814C5.02972 6.77814 1 5.4847 1 3.88925C1 2.29379 5.02937 1 10 1",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M17.9662 7.923C16.4124 8.78956 13.4986 9.37296 10.1604 9.37296C6.81652 9.37296 3.89668 8.78707 2.34534 7.91766",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M16.706 11.0358C15.0667 11.5879 12.7541 11.9315 10.1911 11.9315C7.94999 11.9315 5.89707 11.6683 4.32153 11.2325",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15.3968 14.0045C11.4482 14.8294 6.94465 14.3798 5.54663 13.8266",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M14.7208 16.5169C12.4508 17.0882 9.35598 17.0715 7.54175 16.4457",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M14.084 18.689C13.2601 19.1081 11.2506 19.3375 9.99731 18.9519",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

Tornado.propTypes = {
  color: PropTypes__default.string
};
Tornado.defaultProps = {
  color: SECONDARY_COLOR
};

var TornadoCircle = function TornadoCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z",
    fill: backgroundColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M14.0985 5.24313C16.3459 5.61222 17.8854 6.36275 17.8854 7.2288C17.8854 8.45955 14.7768 9.45733 10.9427 9.45733C7.10858 9.45733 4 8.45955 4 7.2288C4 5.99805 7.1083 5 10.9427 5",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M17.088 10.3405C15.8893 11.009 13.6416 11.4591 11.0665 11.4591C8.48697 11.4591 6.23457 11.0071 5.03784 10.3364",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M16.1157 12.7417C14.8512 13.1676 13.0673 13.4327 11.0901 13.4327C9.36129 13.4327 7.77764 13.2296 6.56226 12.8935",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15.1059 15.0319C12.0599 15.6682 8.58578 15.3214 7.50732 14.8947",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M14.5844 16.9699C12.8333 17.4106 10.4459 17.3977 9.04639 16.915",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M14.0932 18.6455C13.4576 18.9688 11.9074 19.1458 10.9407 18.8483",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

TornadoCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
TornadoCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var Windy = function Windy(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "24",
    height: "15",
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M19.9408 6.85701H19.9345L18.2993 6.87802H17.2416C17.6443 6.4806 17.9424 5.98987 18.1097 5.44944C18.277 4.90901 18.3082 4.33562 18.2004 3.78025C18.0927 3.22487 17.8495 2.70471 17.4923 2.26599C17.1352 1.82727 16.6751 1.48358 16.1531 1.26547C15.6312 1.04737 15.0634 0.961601 14.5002 1.01579C13.9371 1.06999 13.3961 1.26246 12.9253 1.57611C12.4545 1.88976 12.0684 2.31486 11.8015 2.81365C11.5345 3.31243 11.395 3.86943 11.3951 4.43516C11.3951 4.56826 11.448 4.69592 11.5421 4.79004C11.6362 4.88416 11.7639 4.93703 11.897 4.93703C12.0301 4.93703 12.1578 4.88416 12.2519 4.79004C12.346 4.69592 12.3989 4.56826 12.3989 4.43516C12.3989 3.95436 12.5415 3.48436 12.8086 3.0846C13.0757 2.68483 13.4553 2.37325 13.8995 2.18926C14.3437 2.00526 14.8325 1.95712 15.3041 2.05092C15.7756 2.14472 16.2088 2.37625 16.5488 2.71622C16.8887 3.05619 17.1203 3.48935 17.2141 3.9609C17.3079 4.43246 17.2597 4.92124 17.0757 5.36544C16.8917 5.80964 16.5802 6.1893 16.1804 6.45642C15.7806 6.72353 15.3106 6.8661 14.8298 6.8661H6.50187C6.36877 6.8661 6.24111 6.91898 6.147 7.0131C6.05288 7.10722 6 7.23487 6 7.36798C6 7.50108 6.05288 7.62873 6.147 7.72285C6.24111 7.81697 6.36877 7.86985 6.50187 7.86985H14.8298C14.8505 7.86985 14.8709 7.86985 14.8926 7.86985C14.9289 7.87827 14.966 7.88259 15.0033 7.88271H18.3087L19.9439 7.86169C20.3505 7.8625 20.7477 7.98382 21.0854 8.21031C21.423 8.4368 21.686 8.75831 21.841 9.1342C21.996 9.51009 22.0361 9.92348 21.9562 10.3221C21.8763 10.7208 21.68 11.0868 21.3922 11.374C21.1043 11.6611 20.7378 11.8565 20.3389 11.9354C19.9401 12.0143 19.5268 11.9733 19.1513 11.8173C18.7758 11.6614 18.4549 11.3977 18.2292 11.0595C18.0036 10.7213 17.8832 10.3238 17.8834 9.91718C17.8834 9.78407 17.8305 9.65642 17.7364 9.5623C17.6423 9.46818 17.5146 9.4153 17.3815 9.4153C17.2484 9.4153 17.1208 9.46818 17.0267 9.5623C16.9325 9.65642 16.8797 9.78407 16.8797 9.91718C16.8797 10.5224 17.0591 11.1141 17.3954 11.6173C17.7316 12.1206 18.2096 12.5128 18.7688 12.7444C19.3279 12.976 19.9432 13.0366 20.5368 12.9185C21.1305 12.8005 21.6757 12.509 22.1037 12.081C22.5317 11.6531 22.8231 11.1078 22.9412 10.5142C23.0593 9.92057 22.9987 9.30527 22.7671 8.7461C22.5354 8.18693 22.1432 7.70899 21.64 7.37274C21.1367 7.03648 20.5451 6.85701 19.9398 6.85701H19.9408Z",
    fill: color,
    stroke: color,
    strokeWidth: "0.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12.7282 9.49707H6.50187C6.36877 9.49707 6.24111 9.54995 6.147 9.64407C6.05288 9.73818 6 9.86584 6 9.99894C6 10.132 6.05288 10.2597 6.147 10.3538C6.24111 10.4479 6.36877 10.5008 6.50187 10.5008H12.7282C13.0291 10.5008 13.3232 10.59 13.5734 10.7572C13.8236 10.9244 14.0186 11.162 14.1337 11.4399C14.2489 11.7179 14.279 12.0238 14.2203 12.3189C14.1616 12.614 14.0167 12.8851 13.804 13.0978C13.5912 13.3106 13.3201 13.4555 13.025 13.5142C12.7299 13.5729 12.424 13.5428 12.1461 13.4276C11.8681 13.3125 11.6305 13.1175 11.4633 12.8673C11.2962 12.6171 11.2069 12.323 11.2069 12.0221C11.2069 11.889 11.1541 11.7614 11.0599 11.6672C10.9658 11.5731 10.8382 11.5202 10.7051 11.5202C10.572 11.5202 10.4443 11.5731 10.3502 11.6672C10.2561 11.7614 10.2032 11.889 10.2032 12.0221C10.2032 12.5215 10.3513 13.0097 10.6287 13.425C10.9062 13.8402 11.3005 14.1638 11.7619 14.355C12.2233 14.5461 12.731 14.5961 13.2208 14.4986C13.7107 14.4012 14.1606 14.1607 14.5137 13.8076C14.8668 13.4545 15.1073 13.0045 15.2048 12.5147C15.3022 12.0249 15.2522 11.5172 15.0611 11.0558C14.87 10.5944 14.5463 10.2001 14.1311 9.92262C13.7158 9.64516 13.2276 9.49707 12.7282 9.49707Z",
    fill: color,
    stroke: color,
    strokeWidth: "0.5"
  }));
};

Windy.propTypes = {
  color: PropTypes__default.string
};
Windy.defaultProps = {
  color: SECONDARY_COLOR
};

var WindyCircle = function WindyCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z",
    fill: backgroundColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M16.9408 9.85701H16.9345L15.2993 9.87802H14.2416C14.6443 9.4806 14.9424 8.98987 15.1097 8.44944C15.277 7.90901 15.3082 7.33562 15.2004 6.78025C15.0927 6.22487 14.8495 5.70471 14.4923 5.26599C14.1352 4.82727 13.6751 4.48358 13.1531 4.26547C12.6312 4.04737 12.0634 3.9616 11.5002 4.01579C10.9371 4.06999 10.3961 4.26246 9.92529 4.57611C9.45447 4.88976 9.06843 5.31486 8.80149 5.81365C8.53454 6.31243 8.39495 6.86943 8.39513 7.43516C8.39513 7.56826 8.44801 7.69592 8.54213 7.79004C8.63625 7.88416 8.7639 7.93703 8.89701 7.93703C9.03011 7.93703 9.15776 7.88416 9.25188 7.79004C9.346 7.69592 9.39888 7.56826 9.39888 7.43516C9.39888 6.95436 9.54145 6.48436 9.80857 6.0846C10.0757 5.68483 10.4553 5.37325 10.8995 5.18926C11.3437 5.00526 11.8325 4.95712 12.3041 5.05092C12.7756 5.14472 13.2088 5.37625 13.5488 5.71622C13.8887 6.05619 14.1203 6.48935 14.2141 6.9609C14.3079 7.43246 14.2597 7.92124 14.0757 8.36544C13.8917 8.80964 13.5802 9.1893 13.1804 9.45642C12.7806 9.72353 12.3106 9.8661 11.8298 9.8661H3.50187C3.36877 9.8661 3.24111 9.91898 3.147 10.0131C3.05288 10.1072 3 10.2349 3 10.368C3 10.5011 3.05288 10.6287 3.147 10.7229C3.24111 10.817 3.36877 10.8698 3.50187 10.8698H11.8298C11.8505 10.8698 11.8709 10.8698 11.8926 10.8698C11.9289 10.8783 11.966 10.8826 12.0033 10.8827H15.3087L16.9439 10.8617C17.3505 10.8625 17.7477 10.9838 18.0854 11.2103C18.423 11.4368 18.686 11.7583 18.841 12.1342C18.996 12.5101 19.0361 12.9235 18.9562 13.3221C18.8763 13.7208 18.68 14.0868 18.3922 14.374C18.1043 14.6611 17.7378 14.8565 17.3389 14.9354C16.9401 15.0143 16.5268 14.9733 16.1513 14.8173C15.7758 14.6614 15.4549 14.3977 15.2292 14.0595C15.0036 13.7213 14.8832 13.3238 14.8834 12.9172C14.8834 12.7841 14.8305 12.6564 14.7364 12.5623C14.6423 12.4682 14.5146 12.4153 14.3815 12.4153C14.2484 12.4153 14.1208 12.4682 14.0267 12.5623C13.9325 12.6564 13.8797 12.7841 13.8797 12.9172C13.8797 13.5224 14.0591 14.1141 14.3954 14.6173C14.7316 15.1206 15.2096 15.5128 15.7688 15.7444C16.3279 15.976 16.9432 16.0366 17.5368 15.9185C18.1305 15.8005 18.6757 15.509 19.1037 15.081C19.5317 14.6531 19.8231 14.1078 19.9412 13.5142C20.0593 12.9206 19.9987 12.3053 19.7671 11.7461C19.5354 11.1869 19.1432 10.709 18.64 10.3727C18.1367 10.0365 17.5451 9.85701 16.9398 9.85701H16.9408Z",
    fill: color,
    stroke: color,
    strokeWidth: "0.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M9.72823 12.4971H3.50187C3.36877 12.4971 3.24111 12.5499 3.147 12.6441C3.05288 12.7382 3 12.8658 3 12.9989C3 13.132 3.05288 13.2597 3.147 13.3538C3.24111 13.4479 3.36877 13.5008 3.50187 13.5008H9.72823C10.0291 13.5008 10.3232 13.59 10.5734 13.7572C10.8236 13.9244 11.0186 14.162 11.1337 14.4399C11.2489 14.7179 11.279 15.0238 11.2203 15.3189C11.1616 15.614 11.0167 15.8851 10.804 16.0978C10.5912 16.3106 10.3201 16.4555 10.025 16.5142C9.72992 16.5729 9.42404 16.5428 9.14605 16.4276C8.86807 16.3125 8.63048 16.1175 8.46332 15.8673C8.29615 15.6171 8.20693 15.323 8.20693 15.0221C8.20693 14.889 8.15405 14.7614 8.05993 14.6672C7.96582 14.5731 7.83816 14.5202 7.70506 14.5202C7.57195 14.5202 7.4443 14.5731 7.35018 14.6672C7.25606 14.7614 7.20318 14.889 7.20318 15.0221C7.20318 15.5215 7.35128 16.0097 7.62873 16.425C7.90619 16.8402 8.30055 17.1638 8.76194 17.355C9.22333 17.5461 9.73103 17.5961 10.2208 17.4986C10.7107 17.4012 11.1606 17.1607 11.5137 16.8076C11.8668 16.4545 12.1073 16.0045 12.2048 15.5147C12.3022 15.0249 12.2522 14.5172 12.0611 14.0558C11.87 13.5944 11.5463 13.2001 11.1311 12.9226C10.7158 12.6452 10.2276 12.4971 9.72823 12.4971Z",
    fill: color,
    stroke: color,
    strokeWidth: "0.5"
  }));
};

WindyCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
WindyCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var MainLogo = function MainLogo(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 670.25 670.75",
    width: "50",
    height: "50"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    cx: "335",
    cy: "335",
    r: "335",
    fill: SECONDARY_COLOR
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M335.25.75c-185,0-335,150-335,335s150,335,335,335Z",
    fill: DARK_BLUE_COLOR
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M670.25,335.25c0-185-150-335-335-335,0,119,1.21,208.91,0,335Z",
    fill: PRIMARY_COLOR
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M183.78,403.25c-20.7,0-41.23-5.61-54.41-20.16a2.3,2.3,0,0,1-.59-2.49l14.36-16.09c.78-1,2.32-1.33,2.87-.59,11.26,11.63,24.64,14.92,39.54,14.92,14.13,0,25.35-4.85,25.35-15.11,0-9.86-9.85-13.92-27.85-19.17-31.39-9.3-48.07-20.14-48.07-45.12,0-24.38,21.51-37.17,49.39-37.17,18.4,0,37.78,4.46,48.21,18.2.79,1.16,1.18,2.13.4,2.9l-13.73,14.16c-.58.56-2.13,1.34-3.11.35-10.63-10.06-23.44-11.62-32.16-11.62-15.29,0-21.1,6-21.1,13,0,9.68,7.14,13.75,31.19,20.73,27.29,7.91,43.78,16.83,43.78,43.19,0,27.29-25,40.07-54.07,40.07",
    fill: WHITE_COLOR
  }));
};

var ArrowDown = function ArrowDown(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "15",
    height: "13",
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M14.3465 4.82364C13.8239 4.3011 12.9461 4.3011 12.4235 4.82364L8.89116 8.356V2.00192C8.89116 1.24946 8.28501 0.643311 7.53255 0.643311C6.7801 0.643311 6.17395 1.24946 6.17395 2.00192V8.29331L2.70426 4.82364C2.18172 4.3011 1.30385 4.3011 0.78131 4.82364C0.258769 5.34618 0.258769 6.22404 0.78131 6.74658L5.33788 11.3032C5.94403 11.9093 6.73829 12.2437 7.59526 12.2437C8.45222 12.2437 9.24648 11.9093 9.85263 11.3032L14.4092 6.74658C14.8899 6.22404 14.8899 5.34618 14.3465 4.82364Z",
    fill: color
  }));
};

ArrowDown.propTypes = {
  color: PropTypes__default.string
};
ArrowDown.defaultProps = {
  color: TEXT_DARK_COLOR
};

var ArrowLeft = function ArrowLeft(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "13",
    height: "15",
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M8.06364 14.3465C8.58618 13.8239 8.58618 12.9461 8.06364 12.4235L4.53128 8.89116H10.8854C11.6378 8.89116 12.244 8.28501 12.244 7.53255C12.244 6.7801 11.6378 6.17395 10.8854 6.17395H4.59397L8.06364 2.70428C8.58618 2.18174 8.58618 1.30385 8.06364 0.78131C7.5411 0.258769 6.66324 0.258769 6.1407 0.78131L1.58413 5.33788C0.977981 5.94403 0.643555 6.73828 0.643555 7.59524C0.643555 8.45221 0.977981 9.24648 1.58413 9.85263L6.1407 14.4092C6.66324 14.8899 7.5411 14.8899 8.06364 14.3465Z",
    fill: color
  }));
};

ArrowLeft.propTypes = {
  color: PropTypes__default.string
};
ArrowLeft.defaultProps = {
  color: TEXT_DARK_COLOR
};

var ArrowRight = function ArrowRight(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "13",
    height: "15",
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M4.82389 0.80519C4.30134 1.32773 4.30134 2.20559 4.82389 2.72813L8.35627 6.26052H2.00216C1.2497 6.26052 0.643555 6.86666 0.643555 7.61912C0.643555 8.37158 1.2497 8.97773 2.00216 8.97773H8.29357L4.82389 12.4474C4.30134 12.9699 4.30134 13.8478 4.82389 14.3704C5.34643 14.8929 6.2243 14.8929 6.74684 14.3704L11.3034 9.8138C11.9095 9.20765 12.244 8.4134 12.244 7.55643C12.244 6.69947 11.9095 5.90519 11.3034 5.29905L6.74684 0.742475C6.2243 0.261737 5.34643 0.261747 4.82389 0.80519Z",
    fill: color
  }));
};

ArrowRight.propTypes = {
  color: PropTypes__default.string
};
ArrowRight.defaultProps = {
  color: TEXT_DARK_COLOR
};

var ArrowUp = function ArrowUp(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "15",
    height: "13",
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M0.805183 8.0634C1.32772 8.58594 2.20558 8.58594 2.72813 8.0634L6.26051 4.53104V10.8851C6.26051 11.6376 6.86666 12.2437 7.61912 12.2437C8.37158 12.2437 8.97773 11.6376 8.97773 10.8851V4.59373L12.4474 8.0634C12.9699 8.58594 13.8478 8.58594 14.3704 8.0634C14.8929 7.54086 14.8929 6.663 14.3704 6.14046L9.81379 1.58389C9.20764 0.977737 8.41339 0.643311 7.55643 0.643311C6.69946 0.643311 5.90519 0.977737 5.29904 1.58389L0.742481 6.14046C0.261743 6.663 0.26174 7.54086 0.805183 8.0634Z",
    fill: color
  }));
};

ArrowUp.propTypes = {
  color: PropTypes__default.string
};
ArrowUp.defaultProps = {
  color: TEXT_DARK_COLOR
};

var ArrowDownCircle = function ArrowDownCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    r: "11",
    cx: "11.5",
    cy: "11.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9918 11.4959C22.9918 17.8449 17.8449 22.9918 11.4959 22.9918C5.14689 22.9918 0 17.8449 0 11.4959C0 5.14689 5.14689 0 11.4959 0C17.8449 0 22.9918 5.14689 22.9918 11.4959ZM16.4235 9.8236C16.946 9.30105 17.8239 9.30105 18.3465 9.8236C18.8899 10.3461 18.8899 11.224 18.4092 11.7465L13.8526 16.3031C13.2465 16.9093 12.4522 17.2437 11.5952 17.2437C10.7383 17.2437 9.944 16.9093 9.33785 16.3031L4.78128 11.7465C4.25874 11.224 4.25874 10.3461 4.78128 9.8236C5.30382 9.30105 6.18169 9.30105 6.70423 9.8236L10.1739 13.2933V7.00187C10.1739 6.24941 10.7801 5.64326 11.5325 5.64326C12.285 5.64326 12.8911 6.24941 12.8911 7.00187V13.356L16.4235 9.8236Z",
    fill: backgroundColor
  }));
};

ArrowDownCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
ArrowDownCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var ArrowRightCircle = function ArrowRightCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    r: "11",
    cx: "11.5",
    cy: "11.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9918 11.4959C22.9918 17.8449 17.8449 22.9918 11.4959 22.9918C5.14689 22.9918 0 17.8449 0 11.4959C0 5.14689 5.14689 0 11.4959 0C17.8449 0 22.9918 5.14689 22.9918 11.4959ZM9.82385 6.7281C9.30131 6.20556 9.30131 5.3277 9.82385 4.80516C10.3464 4.26172 11.2243 4.26171 11.7468 4.74244L16.3034 9.29902C16.9095 9.90516 17.2439 10.6994 17.2439 11.5564C17.2439 12.4134 16.9095 13.2076 16.3034 13.8138L11.7468 18.3703C11.2243 18.8929 10.3464 18.8929 9.82385 18.3703C9.30131 17.8478 9.30131 16.9699 9.82385 16.4474L13.2935 12.9777H7.00212C6.24967 12.9777 5.64352 12.3716 5.64352 11.6191C5.64352 10.8666 6.24967 10.2605 7.00212 10.2605H13.3562L9.82385 6.7281Z",
    fill: backgroundColor
  }));
};

ArrowRightCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
ArrowRightCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var ArrowLeftCircle = function ArrowLeftCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    r: "11",
    cx: "11.5",
    cy: "11.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9918 11.4959C22.9918 17.8449 17.8449 22.9918 11.4959 22.9918C5.14689 22.9918 0 17.8449 0 11.4959C0 5.14689 5.14689 0 11.4959 0C17.8449 0 22.9918 5.14689 22.9918 11.4959ZM13.0636 16.4235C13.5861 16.9461 13.5861 17.8239 13.0636 18.3465C12.5411 18.8899 11.6632 18.8899 11.1407 18.4092L6.58409 13.8526C5.97794 13.2465 5.64352 12.4522 5.64352 11.5952C5.64352 10.7382 5.97794 9.944 6.58409 9.33785L11.1407 4.78128C11.6632 4.25874 12.5411 4.25874 13.0636 4.78128C13.5861 5.30382 13.5861 6.18171 13.0636 6.70425L9.59393 10.1739H15.8853C16.6378 10.1739 17.2439 10.7801 17.2439 11.5325C17.2439 12.285 16.6378 12.8911 15.8853 12.8911H9.53124L13.0636 16.4235Z",
    fill: backgroundColor
  }));
};

ArrowLeftCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
ArrowLeftCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var ArrowUpCircle = function ArrowUpCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    r: "11",
    cx: "11.5",
    cy: "11.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9918 11.4959C22.9918 17.8449 17.8449 22.9918 11.4959 22.9918C5.14689 22.9918 0 17.8449 0 11.4959C0 5.14689 5.14689 0 11.4959 0C17.8449 0 22.9918 5.14689 22.9918 11.4959ZM6.7281 13.0634C6.20555 13.5859 5.32769 13.5859 4.80515 13.0634C4.26171 12.5408 4.26171 11.663 4.74245 11.1404L9.29901 6.58384C9.90516 5.97769 10.6994 5.64326 11.5564 5.64326C12.4134 5.64326 13.2076 5.97769 13.8138 6.58384L18.3703 11.1404C18.8929 11.663 18.8929 12.5408 18.3703 13.0634C17.8478 13.5859 16.9699 13.5859 16.4474 13.0634L12.9777 9.59368V15.8851C12.9777 16.6375 12.3715 17.2437 11.6191 17.2437C10.8666 17.2437 10.2605 16.6375 10.2605 15.8851V9.53099L6.7281 13.0634Z",
    fill: backgroundColor
  }));
};

ArrowUpCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
ArrowUpCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var LargeHouse = function LargeHouse(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "100",
    height: "100",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    cx: "50",
    cy: "50",
    r: "50",
    fill: backgroundColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M33.0083 42.9972C33.0114 42.507 33.2539 42.0492 33.6577 41.7712L49.0584 31.1673C49.5753 30.8114 50.2591 30.8149 50.7723 31.1761L66.3631 42.1473C66.7634 42.429 67.0011 42.8882 66.9999 43.3776L66.9518 63.2182C66.9498 64.0443 66.2801 64.7133 65.4539 64.7145L54.7686 64.7298H45.1393L34.3843 64.7598C33.5506 64.7621 32.8749 64.084 32.8802 63.2503L33.0083 42.9972Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M45.7642 53.2729C45.7642 52.7207 46.2119 52.2729 46.7642 52.2729H52.4796C53.0319 52.2729 53.4796 52.7207 53.4796 53.2729V67.7039H45.7642V53.2729Z",
    fill: backgroundColor
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "58.6143",
    y: "31.4177",
    width: "5.14366",
    height: "28.2901",
    rx: "0.5",
    fill: color
  }));
};

LargeHouse.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
LargeHouse.defaultProps = {
  backgroundColor: NEUTRAL_COLOR_LEVEL_2,
  color: TEXT_DARK_COLOR
};

var LargePanels = function LargePanels(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "100",
    height: "100",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    cx: "50",
    cy: "50",
    r: "50",
    fill: backgroundColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M58.9246 35.5259H69.2448L67.2917 29.6598C67.228 29.4687 67.1058 29.3025 66.9424 29.1847C66.779 29.067 66.5827 29.0036 66.3813 29.0037H58.8345C58.8968 29.1773 58.9293 29.3602 58.9304 29.5447L58.9246 35.5259Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M55.6621 35.5242V29.541C55.6632 29.3566 55.6957 29.1736 55.758 29H45.8926V35.5232L55.6621 35.5242Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M42.6312 29.0037H35.1775C34.9761 29.0036 34.7797 29.067 34.6163 29.1847C34.4529 29.3025 34.3307 29.4687 34.2671 29.6598L32.314 35.5259H42.6312V29.0037Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M58.9258 43.7002H71.9655L70.3299 38.7876H58.9258V43.7002Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M55.6659 38.7876H45.8926V43.7002H55.6659V38.7876Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M42.6311 38.7876H31.2269L29.5913 43.7002H42.6311V38.7876Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M55.6621 46.9607H45.8926V53.4619C45.8926 53.4619 55.665 53.6259 55.665 53.27L55.6621 46.9607Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M28.5055 46.9607L26.7606 52.1994C26.7125 52.3436 26.6995 52.4972 26.7224 52.6475C26.7454 52.7977 26.8037 52.9404 26.8926 53.0637C26.9815 53.187 27.0985 53.2874 27.2338 53.3566C27.3691 53.4258 27.519 53.4619 27.671 53.4619H42.636V46.9607H28.5055Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M73.0535 46.9607H58.924C58.924 46.9607 59.0372 53.2268 58.9058 53.4619H73.8891C74.0411 53.4619 74.1909 53.4258 74.3262 53.3566C74.4615 53.2874 74.5785 53.187 74.6674 53.0637C74.7563 52.9404 74.8146 52.7977 74.8376 52.6475C74.8605 52.4972 74.8475 52.3436 74.7994 52.1994L73.0535 46.9607Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M74.6917 55.9536H26.6308C26.1983 55.9536 25.7835 56.1254 25.4777 56.4313C25.1718 56.7371 25 57.1519 25 57.5844C25 58.0169 25.1718 58.4317 25.4777 58.7376C25.7835 59.0434 26.1983 59.2152 26.6308 59.2152H48.8261V65.7385H45.0762C44.6437 65.7385 44.2289 65.9103 43.9231 66.2161C43.6172 66.522 43.4454 66.9368 43.4454 67.3693C43.4454 67.8018 43.6172 68.2166 43.9231 68.5224C44.2289 68.8283 44.6437 69.0001 45.0762 69.0001H55.6669C56.0994 69.0001 56.5142 68.8283 56.82 68.5224C57.1259 68.2166 57.2977 67.8018 57.2977 67.3693C57.2977 66.9368 57.1259 66.522 56.82 66.2161C56.5142 65.9103 56.0994 65.7385 55.6669 65.7385H52.0877V59.2152H74.6917C75.1242 59.2152 75.539 59.0434 75.8449 58.7376C76.1507 58.4317 76.3225 58.0169 76.3225 57.5844C76.3225 57.1519 76.1507 56.7371 75.8449 56.4313C75.539 56.1254 75.1242 55.9536 74.6917 55.9536Z",
    fill: color
  }));
};

LargePanels.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
LargePanels.defaultProps = {
  backgroundColor: NEUTRAL_COLOR_LEVEL_2,
  color: TEXT_DARK_COLOR
};

var LargeBattery = function LargeBattery(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "100",
    height: "100",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    cx: "50",
    cy: "50",
    r: "50",
    fill: backgroundColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M61.71 29.7512H37.2891C36.9471 29.7515 36.6193 29.8875 36.3775 30.1294C36.1358 30.3713 36 30.6992 36 31.0412V69.2354C36 69.5773 36.1358 69.9051 36.3776 70.1469C36.6193 70.3887 36.9472 70.5245 37.2891 70.5245H61.71C62.052 70.5245 62.38 70.3887 62.6219 70.147C62.8638 69.9052 62.9998 69.5773 63 69.2354V31.0412C63 30.6991 62.8641 30.371 62.6222 30.129C62.3802 29.8871 62.0521 29.7512 61.71 29.7512ZM58.2052 65.5441C58.2052 65.8248 58.0938 66.094 57.8954 66.2926C57.697 66.4912 57.4278 66.6028 57.1471 66.6031H41.4999C41.3608 66.6031 41.2231 66.5757 41.0946 66.5225C40.9661 66.4692 40.8494 66.3912 40.7511 66.2929C40.6527 66.1946 40.5747 66.0778 40.5215 65.9493C40.4683 65.8209 40.4409 65.6831 40.4409 65.5441V45.4377C40.4411 45.1569 40.5528 44.8878 40.7514 44.6894C40.9499 44.491 41.2192 44.3795 41.4999 44.3795H57.1471C57.4277 44.3798 57.6967 44.4913 57.8951 44.6897C58.0935 44.8881 58.205 45.1571 58.2052 45.4377V65.5441Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M57.4659 23.8446C57.466 23.7337 57.4443 23.6239 57.402 23.5214C57.3596 23.419 57.2975 23.3259 57.2191 23.2474C57.1408 23.169 57.0477 23.1068 56.9453 23.0643C56.8429 23.0219 56.7331 23 56.6222 23H42.7635C42.5395 23 42.3247 23.089 42.1663 23.2474C42.0079 23.4058 41.9189 23.6206 41.9189 23.8446V26.8996H57.4659V23.8446Z",
    fill: color
  }));
};

LargeBattery.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
LargeBattery.defaultProps = {
  backgroundColor: NEUTRAL_COLOR_LEVEL_2,
  color: TEXT_DARK_COLOR
};

var LargeElectricPole = function LargeElectricPole(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "100",
    height: "100",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    cx: "50",
    cy: "50",
    r: "50",
    fill: backgroundColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M65.1158 30.335C65.4768 30.706 65.02 31.7454 64.12 32.6213L53.2471 43.2037C52.3228 44.1033 51.2957 44.508 50.9347 44.1371C50.5737 43.7662 51.0304 42.7268 51.9304 41.8508L62.8034 31.2685C63.7033 30.3925 64.7547 29.9641 65.1158 30.335Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M34.5555 30.2357C34.246 30.5536 34.7453 31.5494 35.6452 32.4253L46.5182 43.0077C47.4425 43.9073 48.4271 44.3557 48.7365 44.0378C49.0459 43.7198 48.5467 42.7241 47.6467 41.8481L36.7738 31.2658C35.8738 30.3898 34.8649 29.9178 34.5555 30.2357Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "45.5483",
    y: "26.7666",
    width: "8.66878",
    height: "46.2335",
    rx: "0.510929",
    fill: color
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "31.1001",
    y: "32.5459",
    width: "5.77918",
    height: "37.5647",
    rx: "0.510929",
    transform: "rotate(-90 31.1001 32.5459)",
    fill: color
  }));
};

LargeElectricPole.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
LargeElectricPole.defaultProps = {
  backgroundColor: NEUTRAL_COLOR_LEVEL_2,
  color: TEXT_DARK_COLOR
};

var LargeInverter = function LargeInverter(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "100",
    height: "100",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    cx: "50",
    cy: "50",
    r: "50",
    fill: backgroundColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M43.2146 53.1008V55.9455H55.7857V53.1008H61.791V72.7991H37.2092V53.1008H43.2146ZM49.4987 63.0999C50.6446 63.1026 51.573 62.2107 51.5758 61.1098C51.5786 60.0089 50.6502 59.1169 49.5043 59.1142C48.3584 59.1115 47.43 60.0035 47.4272 61.1044V61.1071C47.4272 62.208 48.3529 63.0973 49.4987 63.0999Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M37.2092 22.2009H61.791V50.8857H37.2092V22.2009Z",
    fill: color
  }));
};

LargeInverter.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
LargeInverter.defaultProps = {
  backgroundColor: NEUTRAL_COLOR_LEVEL_2,
  color: TEXT_DARK_COLOR
};

var Exclamationmark = function Exclamationmark(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "3",
    height: "15",
    viewBox: "0 0 3 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M3 8.97591C3 9.53815 2.48507 10 1.8806 10H1.1194C0.492538 10 0 9.53815 0 8.97591V1.00402C0 0.441767 0.514926 0 1.1194 0H1.8806C2.50746 0 3 0.461848 3 1.00402V8.97591Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "1.5",
    cy: "13.5",
    r: "1.5",
    fill: color
  }));
};

Exclamationmark.propTypes = {
  color: PropTypes__default.string
};
Exclamationmark.defaultProps = {
  color: TEXT_DARK_COLOR
};

var Information = function Information(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "3",
    height: "15",
    viewBox: "0 0 3 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M3 13.9759C3 14.5382 2.48507 15 1.8806 15H1.1194C0.492538 15 0 14.5382 0 13.9759V6.00402C0 5.44177 0.514926 5 1.1194 5H1.8806C2.50746 5 3 5.46185 3 6.00402V13.9759Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "1.5",
    cy: "1.5",
    r: "1.5",
    fill: color
  }));
};

Information.propTypes = {
  color: PropTypes__default.string
};
Information.defaultProps = {
  color: TEXT_DARK_COLOR
};

var CreditCardCircle = function CreditCardCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    r: "11",
    cx: "11.5",
    cy: "11.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 11.5C23 17.8513 17.8513 23 11.5 23C5.14873 23 0 17.8513 0 11.5C0 5.14873 5.14873 0 11.5 0C17.8513 0 23 5.14873 23 11.5ZM6.83636 16H16.2909C17.3091 16 18.1273 15.1818 18.1273 14.1636V7.83636C18.1273 6.81818 17.3091 6 16.2909 6H6.83636C5.81818 6 5 6.81818 5 7.83636V14.1636C5 15.1818 5.81818 16 6.83636 16ZM6.14546 7.83636C6.14546 7.45454 6.45455 7.14545 6.83636 7.14545H16.2909C16.6727 7.14545 16.9818 7.45454 16.9818 7.83636V10.9996H6.14546V7.83636ZM6.14546 13.5996H16.9818V14.1636C16.9818 14.5455 16.6727 14.8545 16.2909 14.8545H6.83636C6.45455 14.8545 6.14546 14.5455 6.14546 14.1636V13.5996ZM14.8726 9.67303H10.8362C10.5271 9.67303 10.2726 9.41848 10.2726 9.10939C10.2726 8.8003 10.5271 8.54576 10.8362 8.54576H14.8726C15.1817 8.54576 15.4362 8.8003 15.4362 9.10939C15.4544 9.4003 15.1999 9.67303 14.8726 9.67303Z",
    fill: backgroundColor
  }));
};

CreditCardCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
CreditCardCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var Questionmark = function Questionmark(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "9",
    height: "15",
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M8.66295 2.4007C8.43888 1.90947 8.12631 1.48514 7.72336 1.12963C7.32041 0.774109 6.8365 0.496959 6.27162 0.298176C5.70673 0.0993918 5.08159 0 4.39997 0C3.75412 0 3.16099 0.108949 2.61682 0.326846C2.07453 0.544744 1.59815 0.854388 1.18767 1.25769C0.777185 1.66099 0.445787 2.14839 0.19159 2.72181C0.152048 2.81164 0.114389 2.90148 0.080496 2.99322C-0.220775 3.79218 0.361055 4.64848 1.20273 4.64848H1.32512C1.84858 4.64848 2.31743 4.31016 2.4756 3.80365C2.8183 2.71034 3.46603 2.16368 4.4188 2.16368C4.7163 2.16368 4.98745 2.21338 5.23411 2.31086C5.4789 2.40834 5.68979 2.54596 5.86678 2.72181C6.04378 2.89765 6.18123 3.10408 6.28103 3.34109C6.38083 3.57811 6.42978 3.83805 6.42978 4.12094C6.42978 4.27194 6.41848 4.41147 6.39777 4.54144C6.37518 4.67142 6.31869 4.80904 6.22642 4.95812C6.13416 5.1053 5.99482 5.27541 5.81218 5.46846C5.62953 5.66151 5.3791 5.89279 5.06276 6.16229C4.3303 6.77967 3.82379 7.37793 3.54511 7.95708C3.40201 8.25334 3.29845 8.65282 3.23254 9.15743C3.21183 9.32181 3.193 9.49765 3.17794 9.68497C3.12145 10.3941 3.67504 11 4.37549 11C5.00251 11 5.5222 10.5107 5.57304 9.87611C5.60694 9.4384 5.66719 9.12876 5.75004 8.94909C5.81783 8.79235 5.95528 8.60504 6.16052 8.38714C6.36576 8.16924 6.63502 7.91885 6.97019 7.63597C7.74596 6.98801 8.27318 6.38593 8.55374 5.83162C8.85125 5.28306 9 4.67524 9 4.00817C8.99812 3.42711 8.88702 2.89192 8.66295 2.4007Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "4.5",
    cy: "13.5",
    r: "1.5",
    fill: color
  }));
};

Questionmark.propTypes = {
  color: PropTypes__default.string
};
Questionmark.defaultProps = {
  color: TEXT_DARK_COLOR
};

var CalculatorCircle = function CalculatorCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    r: "11",
    cx: "11.5",
    cy: "11.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 11.5C23 17.8513 17.8513 23 11.5 23C5.14873 23 0 17.8513 0 11.5C0 5.14873 5.14873 0 11.5 0C17.8513 0 23 5.14873 23 11.5ZM8 5C6.89543 5 6 5.89543 6 7V16C6 17.1046 6.89543 18 8 18H15.1429C16.2474 18 17.1429 17.1046 17.1429 16V7C17.1429 5.89543 16.2474 5 15.1429 5H8ZM9.02581 7.00042C8.47352 7.00042 8.02581 7.44813 8.02581 8.00042V9.00042C8.02581 9.5527 8.47352 10.0004 9.02581 10.0004H14.1167C14.669 10.0004 15.1167 9.5527 15.1167 9.00042V8.00042C15.1167 7.44813 14.669 7.00042 14.1167 7.00042H9.02581ZM7.85714 11.75C7.85714 11.6119 7.96907 11.5 8.10714 11.5H9.46429C9.60236 11.5 9.71429 11.6119 9.71429 11.75V13.1071C9.71429 13.2452 9.60236 13.3571 9.46429 13.3571H8.10714C7.96907 13.3571 7.85714 13.2452 7.85714 13.1071V11.75ZM10.8931 11.5C10.755 11.5 10.6431 11.6119 10.6431 11.75V13.1071C10.6431 13.2452 10.755 13.3571 10.8931 13.3571H12.2502C12.3883 13.3571 12.5002 13.2452 12.5002 13.1071V11.75C12.5002 11.6119 12.3883 11.5 12.2502 11.5H10.8931ZM7.85735 14.5357C7.85735 14.3976 7.96928 14.2857 8.10735 14.2857H9.46449C9.60257 14.2857 9.71449 14.3976 9.71449 14.5357V15.8929C9.71449 16.0309 9.60257 16.1429 9.46449 16.1429H8.10735C7.96928 16.1429 7.85735 16.0309 7.85735 15.8929V14.5357ZM10.8931 14.2857C10.755 14.2857 10.6431 14.3976 10.6431 14.5357V15.8929C10.6431 16.0309 10.755 16.1429 10.8931 16.1429H12.2502C12.3883 16.1429 12.5002 16.0309 12.5002 15.8929V14.5357C12.5002 14.3976 12.3883 14.2857 12.2502 14.2857H10.8931ZM13.4288 11.75C13.4288 11.6119 13.5407 11.5 13.6788 11.5H15.0359C15.174 11.5 15.2859 11.6119 15.2859 11.75V15.8929C15.2859 16.0309 15.174 16.1429 15.0359 16.1429H13.6788C13.5407 16.1429 13.4288 16.0309 13.4288 15.8929V11.75Z",
    fill: backgroundColor
  }));
};

CalculatorCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
CalculatorCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var CalendarCircle = function CalendarCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    r: "11",
    cx: "11.5",
    cy: "11.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23ZM13.962 5.65884V4.80727C13.962 4.36115 14.3232 4 14.7693 4C15.2154 4 15.5766 4.36115 15.5766 4.80727V5.68418C15.6826 5.70808 15.8062 5.74061 15.9591 5.7843C17.1488 6.1242 18.041 7.22889 17.9985 8.54603V15.1317C17.9985 16.7037 16.7239 17.9996 15.1306 17.9996H8.54494C6.97287 17.9996 5.67699 16.725 5.67699 15.1317V8.54603C5.67699 7.22889 6.56924 6.1242 7.7589 5.7843C7.89025 5.74679 8.00184 5.71605 8.09837 5.69104V4.80727C8.09837 4.36115 8.45952 4 8.90564 4C9.35177 4 9.71292 4.36115 9.71292 4.80727V5.65661C9.83654 5.65871 9.97711 5.65906 10.1382 5.65683H13.5798C13.7203 5.65884 13.8471 5.65937 13.962 5.65884ZM16.9363 15.1317C16.9363 16.1089 16.1291 16.9162 15.1518 16.9162H8.56618C7.58895 16.9162 6.78168 16.1089 6.78168 15.1317V9.8844H16.9576V15.1317H16.9363ZM8.25 11C8.11193 11 8 11.1119 8 11.25V12.6071C8 12.7452 8.11193 12.8571 8.25 12.8571H9.60714C9.74521 12.8571 9.85714 12.7452 9.85714 12.6071V11.25C9.85714 11.1119 9.74521 11 9.60714 11H8.25ZM11 11.25C11 11.1119 11.1119 11 11.25 11H12.6071C12.7452 11 12.8571 11.1119 12.8571 11.25V12.6071C12.8571 12.7452 12.7452 12.8571 12.6071 12.8571H11.25C11.1119 12.8571 11 12.7452 11 12.6071V11.25ZM8.25 14C8.11193 14 8 14.1119 8 14.25V15.6071C8 15.7452 8.11193 15.8571 8.25 15.8571H9.60714C9.74521 15.8571 9.85714 15.7452 9.85714 15.6071V14.25C9.85714 14.1119 9.74521 14 9.60714 14H8.25ZM11 14.25C11 14.1119 11.1119 14 11.25 14H12.6071C12.7452 14 12.8571 14.1119 12.8571 14.25V15.6071C12.8571 15.7452 12.7452 15.8571 12.6071 15.8571H11.25C11.1119 15.8571 11 15.7452 11 15.6071V14.25ZM14.25 14C14.1119 14 14 14.1119 14 14.25V15.6071C14 15.7452 14.1119 15.8571 14.25 15.8571H15.6071C15.7452 15.8571 15.8571 15.7452 15.8571 15.6071V14.25C15.8571 14.1119 15.7452 14 15.6071 14H14.25Z",
    fill: backgroundColor
  }));
};

CalendarCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
CalendarCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var Download = function Download(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "12",
    height: "15",
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.6529 3.6036C11.2166 3.15315 10.4836 3.15315 10.0474 3.6036L7.09817 6.64863V1.17117C7.09817 0.522523 6.5921 0 5.96386 0C5.33563 0 4.82955 0.522523 4.82955 1.17117V6.59459L1.93269 3.6036C1.49642 3.15315 0.763478 3.15315 0.327205 3.6036C-0.109068 4.05405 -0.109068 4.8108 0.327205 5.26125L4.13152 9.18919C4.63759 9.71171 5.30073 10 6.01621 10C6.7317 10 7.39484 9.71171 7.90091 9.18919L11.7052 5.26125C12.1066 4.8108 12.1066 4.05405 11.6529 3.6036Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.9487 13.1242C11.9487 13.8211 11.3134 14.3949 10.555 14.3949H1.39369C0.614867 14.3949 0 13.8211 0 13.1242C0 12.4274 0.635362 11.8535 1.39369 11.8535H10.555C11.3134 11.8535 11.9487 12.4274 11.9487 13.1242Z",
    fill: color
  }));
};

Download.propTypes = {
  color: PropTypes__default.string
};
Download.defaultProps = {
  color: TEXT_DARK_COLOR
};

var HouseAlt = function HouseAlt(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "15",
    height: "13",
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M12.8258 8.17394C12.5322 8.17394 12.214 8.07607 11.9693 7.85581L7.71737 4.04812C7.33763 3.70805 6.76287 3.70805 6.38313 4.04812L2.13121 7.85581C1.59281 8.3208 0.785198 8.27185 0.320214 7.75792C-0.144771 7.24399 -0.0958341 6.43638 0.418096 5.94692L6.35682 0.602068C6.73712 0.259794 7.31444 0.259794 7.69475 0.602069L13.6335 5.94692C14.1474 6.4119 14.1963 7.21951 13.7313 7.75792C13.5355 8.02712 13.1929 8.17394 12.8258 8.17394Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.67306 5.58281C7.2956 5.24966 6.72934 5.24907 6.35119 5.58141L1.33985 9.9857C1.12383 10.1756 1 10.4492 1 10.7368V12.1437C1 12.6086 1.40764 13 1.89172 13H4.10191C4.65419 13 5.10191 12.5523 5.10191 12V11.1621C5.10191 10.6098 5.54962 10.1621 6.10191 10.1621H7.89809C8.45038 10.1621 8.89809 10.6098 8.89809 11.1621V12C8.89809 12.5523 9.34581 13 9.89809 13H12.1083C12.5924 13 13 12.6086 13 12.1437V10.7356C13 10.4487 12.8768 10.1757 12.6617 9.98583L7.67306 5.58281Z",
    fill: color
  }));
};

HouseAlt.propTypes = {
  color: PropTypes__default.string
};
HouseAlt.defaultProps = {
  color: TEXT_DARK_COLOR
};

var House$1 = function House(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "14",
    height: "13",
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.690298 3.75457C0.286531 4.03257 0.0440857 4.49034 0.0409837 4.98055L3.06899e-05 11.4523C-0.00524529 12.286 0.670411 12.9641 1.50418 12.9618L4.76087 12.9527H5.00318V9.1092C5.00318 8.55692 5.4509 8.1092 6.00318 8.1092H7.00318C7.55547 8.1092 8.00318 8.55692 8.00318 9.1092V12.9527H8.505L11.7465 12.948C12.5727 12.9469 13.2424 12.2779 13.2444 11.4517L13.2597 5.12763C13.2609 4.63819 13.0232 4.17896 12.623 3.89729L7.47303 0.273287C6.95981 -0.0878632 6.27602 -0.091357 5.75914 0.26453L0.690298 3.75457Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "10",
    width: "2",
    height: "11",
    rx: "0.5",
    fill: color
  }));
};

House$1.propTypes = {
  color: PropTypes__default.string
};
House$1.defaultProps = {
  color: TEXT_DARK_COLOR
};

var PowerButton = function PowerButton(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "15",
    height: "16",
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M8.39753 6.3482V0.858435C8.39753 0.384335 8.0132 0 7.5391 0C7.065 0 6.68066 0.384335 6.68066 0.858435V6.3482C6.68066 6.8223 7.065 7.20664 7.5391 7.20664C8.0132 7.20664 8.39753 6.8223 8.39753 6.3482Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M10.5543 2.17202C10.0514 1.91134 9.4996 2.31332 9.4996 2.87978C9.4996 3.21575 9.7033 3.51379 9.99548 3.67966C11.5043 4.53622 12.5094 6.15083 12.5094 7.99073C12.5094 10.725 10.2838 12.9506 7.54955 12.9506C4.81527 12.9506 2.58971 10.725 2.58971 7.99073C2.58971 6.1521 3.61075 4.53845 5.10553 3.68144C5.39677 3.51446 5.59953 3.21637 5.59953 2.88066C5.59953 2.31322 5.04736 1.90983 4.5429 2.16966C2.43481 3.25545 1 5.44965 1 7.99073C1 11.5941 3.94624 14.5403 7.54955 14.5403C11.1529 14.5403 14.0991 11.5941 14.0991 7.99073C14.0991 5.45149 12.6507 3.25863 10.5543 2.17202Z",
    fill: color,
    stroke: color
  }));
};

PowerButton.propTypes = {
  color: PropTypes__default.string
};
PowerButton.defaultProps = {
  color: TEXT_DARK_COLOR
};

var Redo = function Redo(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "14",
    height: "16",
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M3.22209 12.3222C3.03314 12.1259 3.03609 11.8145 3.22874 11.6219L5.90928 8.94132C6.22426 8.62634 6.76283 8.84942 6.76283 9.29488V14.7597C6.76283 15.2098 6.21476 15.4307 5.90263 15.1065L3.22209 12.3222Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M2.58121 7.48889C2.58121 7.48734 2.58105 7.4858 2.58073 7.48428C2.30621 6.15788 2.68195 4.73172 3.70795 3.70572C5.33546 2.07821 7.98955 2.07821 9.61707 3.70572C11.2446 5.33324 11.2446 7.98734 9.61707 9.61485C8.91907 10.3129 8.06026 10.7071 7.16139 10.8127C6.88713 10.8449 6.66251 11.0656 6.66251 11.3417V12.8456C6.66251 13.1218 6.88667 13.3475 7.16205 13.327C8.69879 13.2121 10.2201 12.5673 11.3948 11.3926C13.9988 8.78857 13.9988 4.55704 11.3948 1.95302C8.79079 -0.651006 4.55926 -0.651006 1.95524 1.95302C0.56365 3.34461 -0.0974957 5.23032 0.0116041 7.07285C0.0264914 7.32428 0.241133 7.5116 0.492997 7.5116H2.5585C2.57104 7.5116 2.58121 7.50144 2.58121 7.48889Z",
    fill: color
  }));
};

Redo.propTypes = {
  color: PropTypes__default.string
};
Redo.defaultProps = {
  color: TEXT_DARK_COLOR
};

var RedoCircle = function RedoCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z",
    fill: backgroundColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M8.22209 16.3222C8.03314 16.1259 8.03609 15.8145 8.22874 15.6219L10.9093 12.9413C11.2243 12.6263 11.7628 12.8494 11.7628 13.2949V18.7597C11.7628 19.2098 11.2148 19.4307 10.9026 19.1065L8.22209 16.3222Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.58121 11.4889C7.58121 11.4873 7.58105 11.4858 7.58073 11.4843C7.30621 10.1579 7.68195 8.73172 8.70795 7.70572C10.3355 6.07821 12.9896 6.07821 14.6171 7.70572C16.2446 9.33324 16.2446 11.9873 14.6171 13.6149C13.9191 14.3129 13.0603 14.7071 12.1614 14.8127C11.8871 14.8449 11.6625 15.0656 11.6625 15.3417V16.8456C11.6625 17.1218 11.8867 17.3475 12.162 17.327C13.6988 17.2121 15.2201 16.5673 16.3948 15.3926C18.9988 12.7886 18.9988 8.55704 16.3948 5.95302C13.7908 3.34899 9.55926 3.34899 6.95524 5.95302C5.56365 7.34461 4.9025 9.23032 5.0116 11.0729C5.02649 11.3243 5.24113 11.5116 5.493 11.5116H7.5585C7.57104 11.5116 7.58121 11.5014 7.58121 11.4889Z",
    fill: color
  }));
};

RedoCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
RedoCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var TransmissionTower = function TransmissionTower(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "14",
    height: "15",
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M6.4426 12.0758L9.48344 10.3611L6.55977 8.09875L3.65295 10.3998L6.4426 12.0758Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M10.5714 14.5553C10.5715 14.5409 10.5707 14.5265 10.5692 14.5122L10.2039 10.9695L7.31445 12.5999L10.5714 14.5553Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M3.05664 15.0002H9.59317L6.42826 13.0988L3.05664 15.0002Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M13.0085 3.9411L9.90021 0.465576C9.87397 0.548836 9.82345 0.622355 9.75513 0.676699L7.21143 2.71194L9.63078 4.67865H12.6788C12.7642 4.67869 12.8477 4.654 12.9194 4.60758C12.9911 4.56116 13.0477 4.49498 13.0826 4.41704C13.1175 4.33911 13.129 4.25274 13.1159 4.16838C13.1027 4.08402 13.0654 4.00527 13.0085 3.94165V3.9411Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M3.35265 5.61658H3.31673L2.73254 10.0001L5.83943 7.54073L3.35265 5.61658Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M2.64997 10.8281C2.64112 10.8229 2.63283 10.8173 2.62454 10.8115L2.13293 14.4993C2.13293 14.5015 2.13293 14.5037 2.13293 14.5059L5.55761 12.5746L2.64997 10.8281Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M3.41614 0.767432C3.35279 0.715869 3.30497 0.647767 3.27797 0.570679L0.121067 3.93262C0.0615883 3.99545 0.0218474 4.07434 0.00676812 4.15953C-0.00831119 4.24472 0.00193369 4.33247 0.0362334 4.41189C0.0705332 4.49132 0.127381 4.55893 0.199733 4.60637C0.272086 4.6538 0.356765 4.67896 0.443279 4.67874H3.33793L5.80261 2.70706L3.41614 0.767432Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M6.50947 2.14135L9.18582 0H4.00556C3.96095 0.000133449 3.91662 0.00693281 3.87402 0.0201728C3.90998 0.0357889 3.94364 0.0562428 3.97406 0.0809675L6.50947 2.14135Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M8.29537 4.73258L6.50469 3.2771L4.68555 4.73258H8.29537Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M6.55347 6.97506L8.26981 5.61658H4.79761L6.55347 6.97506Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M10.0723 9.6985L9.65474 5.64819L7.2738 7.5331L10.0723 9.6985Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M9.65517 5.6478L9.69469 5.61658H9.65186L9.65517 5.6478Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M3.31997 5.59155L3.31665 5.61698H3.35257L3.31997 5.59155Z",
    fill: color
  }));
};

TransmissionTower.propTypes = {
  color: PropTypes__default.string
};
TransmissionTower.defaultProps = {
  color: TEXT_DARK_COLOR
};

var TransmissionTowerCircle = function TransmissionTowerCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    r: "11",
    cx: "11.5",
    cy: "11.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23ZM11.4426 16.0758L14.4834 14.3611L11.5598 12.0987L8.65295 14.3998L11.4426 16.0758ZM15.5692 18.5122C15.5707 18.5265 15.5715 18.5409 15.5714 18.5553L12.3144 16.5999L15.2038 14.9695L15.5692 18.5122ZM8.05658 19.0002H14.5931L11.4282 17.0987L8.05658 19.0002ZM14.9002 4.46556L18.0084 7.94108V7.94164C18.0654 8.00526 18.1027 8.08401 18.1158 8.16837C18.129 8.25273 18.1174 8.33909 18.0826 8.41703C18.0477 8.49497 17.991 8.56114 17.9194 8.60757C17.8477 8.65399 17.7641 8.67867 17.6788 8.67863H14.6307L12.2114 6.71192L14.7551 4.67668C14.8234 4.62234 14.8739 4.54882 14.9002 4.46556ZM8.31664 9.61696H8.31659L8.31991 9.59154L8.35209 9.61663H8.35261L10.8394 11.5408L7.7325 14.0002L8.31664 9.61696ZM7.62454 14.8115C7.63283 14.8173 7.64112 14.8228 7.64996 14.8281L10.5576 16.5745L7.13293 18.5059V18.4992L7.62454 14.8115ZM8.41614 4.76749C8.35279 4.71593 8.30497 4.64783 8.27797 4.57074L5.12107 7.93269C5.06159 7.99551 5.02185 8.07441 5.00677 8.1596C4.99169 8.24479 5.00193 8.33253 5.03623 8.41195C5.07053 8.49138 5.12738 8.559 5.19973 8.60643C5.27209 8.65386 5.35676 8.67902 5.44328 8.6788H8.33793L10.8026 6.70712L8.41614 4.76749ZM14.1858 4L11.5094 6.14135L8.97402 4.08097C8.94359 4.05624 8.90994 4.03579 8.87398 4.02017C8.91658 4.00693 8.96091 4.00013 9.00552 4H14.1858ZM13.2953 8.73256L11.5047 7.27708L9.68551 8.73256H13.2953ZM13.2698 9.61663L11.5535 10.9751L9.79763 9.61663H13.2698ZM15.0724 13.6984L14.6548 9.64813L12.2739 11.533L15.0724 13.6984ZM14.6947 9.61663L14.6552 9.64786L14.6519 9.61663H14.6947Z",
    fill: backgroundColor
  }));
};

TransmissionTowerCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
TransmissionTowerCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var PowerLine = function PowerLine(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "13",
    height: "16",
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.7716 1.23507C11.8965 1.36344 11.7384 1.72314 11.427 2.02628L7.66419 5.68852C7.34431 5.99985 6.98888 6.13992 6.86394 6.01155C6.739 5.88318 6.89707 5.52348 7.20853 5.22034L10.9713 1.55811C11.2828 1.25497 11.6466 1.1067 11.7716 1.23507Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1.1958 1.20065C1.08871 1.31068 1.26148 1.65527 1.57294 1.95841L5.33573 5.62065C5.65561 5.93198 5.99634 6.08716 6.10343 5.97713C6.21052 5.8671 6.03775 5.5225 5.72629 5.21937L1.9635 1.55713C1.65204 1.25399 1.30289 1.09062 1.1958 1.20065Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "5",
    width: "3",
    height: "16",
    rx: "1",
    fill: color
  }), /*#__PURE__*/React__default.createElement("rect", {
    y: "2",
    width: "2",
    height: "13",
    rx: "1",
    transform: "rotate(-90 0 2)",
    fill: color
  }));
};

PowerLine.propTypes = {
  color: PropTypes__default.string
};
PowerLine.defaultProps = {
  color: TEXT_DARK_COLOR
};

var PowerLineCircle = function PowerLineCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    r: "11",
    cx: "11.5",
    cy: "11.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23ZM16.4532 6C16.4445 6.00878 16.4357 6.01753 16.4267 6.02623L13 9.36138V19C13 19.5523 12.5523 20 12 20H11C10.4477 20 10 19.5523 10 19V9.29408L6.61547 6H6C5.44772 6 5 5.55228 5 5C5 4.44772 5.44772 4 6 4H11H12H17C17.5523 4 18 4.44772 18 5C18 5.55228 17.5523 6 17 6H16.4532ZM10 6H7.41832L10 8.51268V6ZM13 6H15.517L13 8.44972V6Z",
    fill: backgroundColor
  }));
};

PowerLineCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
PowerLineCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var LightningBoltConnect = function LightningBoltConnect(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "17",
    height: "17",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.7572 8.79502C11.8717 8.65585 11.8058 8.44488 11.6324 8.39565L8.75219 7.57797C8.61489 7.53899 8.53803 7.39316 8.58348 7.25786L9.91783 3.28573C10.0062 3.02267 9.66417 2.83298 9.48782 3.04725L5.24281 8.20498C5.12827 8.34415 5.19417 8.55512 5.36756 8.60435L8.24781 9.42203C8.38511 9.46101 8.46197 9.60684 8.41652 9.74214L7.08217 13.7143C6.9938 13.9773 7.33583 14.167 7.51218 13.9527L11.7572 8.79502Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M14.676 4C16.6928 6.97032 16.4078 11.0577 13.8055 13.7147C12.5396 15.0081 10.8595 15.8069 9.06402 15.9693C7.5841 16.1031 6.1049 15.7973 4.80518 15.1002",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M2.29824 13C0.320853 10.0297 0.599951 5.94237 3.15183 3.28445C4.28489 2.10494 5.75891 1.33378 7.35369 1.08618C8.94847 0.838585 10.5784 1.12784 12 1.91074",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12.8614 0.873301L13.5328 2.99343C13.5458 3.03448 13.5486 3.07899 13.5408 3.12249C13.533 3.166 13.515 3.20696 13.4885 3.24127C13.462 3.27557 13.428 3.30201 13.39 3.31793C13.3519 3.33384 13.311 3.33867 13.2715 3.33193L11.2313 2.98181C11.1917 2.97497 11.155 2.95677 11.1247 2.92903C11.0944 2.9013 11.0716 2.86501 11.0588 2.82383C11.0459 2.78266 11.0433 2.73805 11.0513 2.6945C11.0592 2.65095 11.0775 2.61 11.1042 2.57579L12.4725 0.803991C12.4992 0.769928 12.5333 0.743782 12.5715 0.728174C12.6096 0.712567 12.6504 0.708047 12.6898 0.715069C12.7292 0.722091 12.7658 0.740407 12.7959 0.76818C12.8261 0.795953 12.8486 0.832206 12.8614 0.873301Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M3.91645 14.0151L6.12969 14.2326C6.17255 14.2368 6.21455 14.2518 6.25148 14.276C6.28841 14.3003 6.31896 14.333 6.34007 14.3709C6.36118 14.4087 6.3721 14.4504 6.37173 14.4916C6.37137 14.5329 6.35973 14.5724 6.33798 14.606L5.21289 16.3437C5.19104 16.3773 5.15983 16.404 5.12241 16.4209C5.08499 16.4378 5.04268 16.4444 4.99976 16.4401C4.95683 16.4357 4.9148 16.4205 4.87791 16.396C4.84102 16.3716 4.81057 16.3387 4.78963 16.3006L3.69963 14.3453C3.67882 14.3073 3.66822 14.2657 3.66889 14.2245C3.66956 14.1832 3.68148 14.1439 3.70344 14.1105C3.72541 14.077 3.75665 14.0506 3.79404 14.0339C3.83143 14.0171 3.87365 14.0106 3.91645 14.0151Z",
    fill: color
  }));
};

LightningBoltConnect.propTypes = {
  color: PropTypes__default.string
};
LightningBoltConnect.defaultProps = {
  color: TEXT_DARK_COLOR
};

var Person = function Person(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "13",
    height: "12",
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.556 8.83661C10.5527 8.12595 8.98509 8.50218 8.02362 7.22718C8.02362 7.22718 7.66829 6.83005 8.48345 5.82677C9.29862 4.84439 9.36132 3.25587 9.1523 2.04357C8.94329 0.831278 7.7937 0.0161133 6.6023 0.0161133C5.41091 0.0161133 4.26132 0.831278 4.0523 2.04357C3.84328 3.25587 3.92689 4.82349 4.72115 5.82677C5.51542 6.83005 5.18099 7.22718 5.18099 7.22718C4.21951 8.50218 2.67279 8.12595 1.64861 8.83661C0.645331 9.54727 0.875249 11.1985 0.875249 11.1985H6.6023H12.3085C12.3085 11.1985 12.5593 9.56817 11.556 8.83661Z",
    fill: color
  }));
};

Person.propTypes = {
  color: PropTypes__default.string
};
Person.defaultProps = {
  color: TEXT_DARK_COLOR
};

var MultiplePeople = function MultiplePeople(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "17",
    height: "9",
    viewBox: "0 0 17 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M15.8481 7.50268C15.2223 7.06226 14.2719 7.29406 13.6692 6.50595C13.6692 6.50595 13.4375 6.25097 13.9474 5.6483C14.4574 5.04562 14.4805 4.07207 14.3646 3.33032C14.2487 2.58857 13.5302 2.07861 12.8116 2.07861C12.0698 2.07861 11.3744 2.56539 11.2585 3.33032C11.1426 4.07207 11.1658 5.04562 11.6758 5.6483C11.9308 5.94963 12.0003 6.18143 12.0003 6.32051C12.2321 6.39005 12.4639 6.50595 12.6725 6.64503C13.6229 7.31724 13.5533 8.59213 13.5302 8.963H16.3349C16.3117 8.963 16.474 7.94309 15.8481 7.50268Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M4.39718 6.64503C4.62898 6.48277 4.86077 6.39005 5.09257 6.29733C5.09257 6.15825 5.1621 5.94963 5.41708 5.6483C5.90385 5.04562 5.95022 4.07207 5.83433 3.33032C5.71843 2.58857 4.99985 2.07861 4.28128 2.07861C3.53953 2.07861 2.84413 2.56539 2.72823 3.33032C2.61233 4.07207 2.63551 5.04562 3.14546 5.6483C3.65542 6.25097 3.42362 6.50595 3.42362 6.50595C2.82095 7.29406 1.87057 7.06226 1.24472 7.50268C0.618868 7.94309 0.781126 8.963 0.781126 8.963H3.5627C3.49316 8.59213 3.44681 7.31724 4.39718 6.64503Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12.3016 7.17844C12.093 7.01618 11.838 6.94665 11.5831 6.87711C10.9109 6.69167 10.1459 6.64531 9.61279 5.94992C9.61279 5.94992 9.33464 5.64858 9.96049 4.88365C10.5863 4.1419 10.6327 2.93655 10.4704 2.00936C10.3082 1.08217 9.45053 0.479492 8.54651 0.479492C7.6425 0.479492 6.76168 1.10535 6.6226 2.00936C6.46034 2.93655 6.52988 4.1419 7.13255 4.88365C7.75841 5.6254 7.48025 5.94992 7.48025 5.94992C6.94712 6.64531 6.20536 6.69167 5.53315 6.87711C5.27817 6.94665 5.0232 7.03936 4.7914 7.17844C4.02647 7.73476 4.21191 8.98646 4.21191 8.98646H4.30462H7.82795H8.5697H9.33463H12.858H12.9275C12.8811 8.96328 13.0666 7.71158 12.3016 7.17844Z",
    fill: color
  }));
};

MultiplePeople.propTypes = {
  color: PropTypes__default.string
};
MultiplePeople.defaultProps = {
  color: TEXT_DARK_COLOR
};

var Document = function Document(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "11",
    height: "13",
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M1.47949 0.852783C0.927206 0.852783 0.479492 1.3005 0.479492 1.85278V11.0561C0.479492 11.6084 0.927207 12.0561 1.47949 12.0561H9.4287C9.98099 12.0561 10.4287 11.6084 10.4287 11.0561V1.85278C10.4287 1.3005 9.98098 0.852783 9.4287 0.852783H1.47949ZM2.17255 3.09971C2.17255 2.79381 2.42053 2.54582 2.72643 2.54582H5.27645C5.58235 2.54582 5.83034 2.79381 5.83034 3.09971C5.83034 3.40561 5.58235 3.6536 5.27645 3.6536H2.72643C2.42053 3.6536 2.17255 3.40561 2.17255 3.09971ZM8.79836 9.3911C8.79836 9.69701 8.55038 9.94499 8.24447 9.94499H2.72643C2.42053 9.94499 2.17255 9.69701 2.17255 9.3911C2.17255 9.0852 2.42053 8.83722 2.72643 8.83722H8.24447C8.55038 8.83722 8.79836 9.0852 8.79836 9.3911ZM8.79836 6.23496C8.79836 6.54086 8.55038 6.78884 8.24447 6.78884H2.72643C2.42053 6.78884 2.17255 6.54086 2.17255 6.23496C2.17255 5.92906 2.42053 5.68107 2.72643 5.68107H8.24447C8.55038 5.68107 8.79836 5.92906 8.79836 6.23496Z",
    fill: color
  }));
};

Document.propTypes = {
  color: PropTypes__default.string
};
Document.defaultProps = {
  color: TEXT_DARK_COLOR
};

var CogWheel = function CogWheel(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "13",
    height: "14",
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.7422 6.55882C11.7422 6.308 11.7213 6.07808 11.7004 5.82726L12.7664 4.42685C12.5156 3.69529 12.1394 3.02644 11.6586 2.42029L9.90289 2.5875C9.48486 2.25308 9.02502 1.96045 8.52339 1.75144L7.83363 0.142006C7.4365 0.0583998 7.01847 0.0166016 6.60044 0.0166016C6.24511 0.0166016 5.88978 0.0375019 5.55535 0.100207L4.8238 1.68873C4.32216 1.87685 3.84142 2.14857 3.42338 2.48299L1.68855 2.27398C1.18691 2.85922 0.789775 3.50717 0.518054 4.23873L1.54223 5.66005C1.50043 5.95267 1.45863 6.24529 1.45863 6.53791C1.45863 6.78873 1.47953 7.01865 1.50043 7.26947L0.434448 8.66988C0.685268 9.40144 1.0615 10.0703 1.54223 10.6764L3.29797 10.5092C3.716 10.8437 4.17584 11.1363 4.67748 11.3453L5.36724 12.9547C5.76437 13.0383 6.1824 13.0801 6.60044 13.0801C6.95576 13.0801 7.31109 13.0592 7.64552 12.9965L8.37708 11.408C8.87872 11.2199 9.35945 10.9482 9.77748 10.6137L11.5123 10.8228C12.014 10.2375 12.4111 9.58956 12.6828 8.858L11.6586 7.43669C11.7213 7.14407 11.7422 6.85144 11.7422 6.55882ZM9.79839 6.55882C9.79839 8.33546 8.35617 9.77767 6.57953 9.77767C4.80289 9.77767 3.36068 8.33546 3.36068 6.55882C3.36068 4.78218 4.80289 3.33996 6.57953 3.33996C8.35617 3.33996 9.79839 4.78218 9.79839 6.55882Z",
    fill: color
  }));
};

CogWheel.propTypes = {
  color: PropTypes__default.string
};
CogWheel.defaultProps = {
  color: TEXT_DARK_COLOR
};

var BarChart = function BarChart(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "13",
    height: "11",
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M3.44438 9.61387C3.44438 10.1991 2.96364 10.6799 2.39929 10.6799H1.68864C1.10339 10.6799 0.643555 10.1991 0.643555 9.61387V5.87248C0.643555 5.28723 1.12429 4.82739 1.68864 4.82739H2.39929C2.98454 4.82739 3.44438 5.30813 3.44438 5.87248V9.61387Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.85454 9.6142C7.85454 10.1994 7.3738 10.6802 6.80946 10.6802H6.09879C5.51355 10.6802 5.05371 10.1994 5.05371 9.6142V3.59452C5.05371 3.00927 5.53445 2.54944 6.09879 2.54944H6.80946C7.3947 2.54944 7.85454 3.03018 7.85454 3.59452V9.6142Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12.2859 9.61403C12.2859 10.1993 11.8052 10.68 11.2408 10.68H10.5302C9.94494 10.68 9.48511 10.1993 9.48511 9.61403V1.31608C9.48511 0.730832 9.96585 0.270996 10.5302 0.270996H11.2408C11.8261 0.270996 12.2859 0.751734 12.2859 1.31608V9.61403Z",
    fill: color
  }));
};

BarChart.propTypes = {
  color: PropTypes__default.string
};
BarChart.defaultProps = {
  color: TEXT_DARK_COLOR
};

var BubbleQuestion = function BubbleQuestion(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "15",
    height: "13",
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.5127 9.08941C11.7838 9.09627 12 9.31803 12 9.58925V11.7934C12 12.2388 11.4614 12.4619 11.1464 12.1469L8.88507 9.88556C8.56575 9.56624 8.79984 9.02074 9.25127 9.03216L11.5127 9.08941Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15 5.90685C15 8.16437 13.2021 10.0005 10.9916 10.0005H5.00841C2.79789 10.0005 1 8.16437 1 5.90685V5.09413C1 2.8366 2.79789 1.00049 5.00841 1.00049H10.9916C13.2021 1.00049 15 2.8366 15 5.09413V5.90685Z",
    fill: color
  }));
};

BubbleQuestion.propTypes = {
  color: PropTypes__default.string
};
BubbleQuestion.defaultProps = {
  color: TEXT_DARK_COLOR
};

var Plus = function Plus(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M14.3115 7.52197C14.3115 8.3566 13.5505 9.04395 12.6422 9.04395H1.66927C0.73645 9.04395 0 8.3566 0 7.52197C0 6.68735 0.760998 6 1.66927 6H12.6422C13.5505 6 14.3115 6.68735 14.3115 7.52197Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.15576 0.366278C7.99039 0.366278 8.67774 1.12728 8.67774 2.03555V13.0085C8.67774 13.9413 7.99039 14.6777 7.15576 14.6777C6.32113 14.6777 5.63379 13.9167 5.63379 13.0085L5.63379 2.03555C5.63379 1.12728 6.32113 0.366278 7.15576 0.366278Z",
    fill: color
  }));
};

Plus.propTypes = {
  color: PropTypes__default.string
};
Plus.defaultProps = {
  color: TEXT_DARK_COLOR
};

var PlusCircle = function PlusCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    r: "11",
    cx: "11.5",
    cy: "11.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23ZM18.3115 11.5219C18.3115 12.3565 17.5505 13.0439 16.6422 13.0439H12.6777V17.0084C12.6777 17.9412 11.9904 18.6777 11.1558 18.6777C10.3211 18.6777 9.63379 17.9167 9.63379 17.0084V13.0439H5.66927C4.73645 13.0439 4 12.3565 4 11.5219C4 10.6873 4.761 9.99993 5.66927 9.99993H9.63379V6.03548C9.63379 5.12721 10.3211 4.36621 11.1558 4.36621C11.9904 4.36621 12.6777 5.12721 12.6777 6.03548V9.99993H16.6422C17.5505 9.99993 18.3115 10.6873 18.3115 11.5219Z",
    fill: backgroundColor
  }));
};

PlusCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
PlusCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var Minus = function Minus(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "15",
    height: "4",
    viewBox: "0 0 15 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M14.3115 1.52197C14.3115 2.3566 13.5505 3.04395 12.6422 3.04395H1.66927C0.73645 3.04395 0 2.3566 0 1.52197C0 0.687345 0.760998 0 1.66927 0H12.6422C13.5505 0 14.3115 0.687345 14.3115 1.52197Z",
    fill: color
  }));
};

Minus.propTypes = {
  color: PropTypes__default.string
};
Minus.defaultProps = {
  color: TEXT_DARK_COLOR
};

var MinusCircle = function MinusCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    r: "11",
    cx: "11.5",
    cy: "11.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 11.5C23 17.8513 17.8513 23 11.5 23C5.14873 23 0 17.8513 0 11.5C0 5.14873 5.14873 0 11.5 0C17.8513 0 23 5.14873 23 11.5ZM16.6422 13.044C17.5505 13.044 18.3115 12.3566 18.3115 11.522C18.3115 10.6873 17.5505 10 16.6422 10H5.66927C4.761 10 4 10.6873 4 11.522C4 12.3566 4.73645 13.044 5.66927 13.044H16.6422Z",
    fill: backgroundColor
  }));
};

MinusCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
MinusCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var LightningBolt = function LightningBolt(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "12",
    height: "18",
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.2581 9.88983C11.6063 9.47209 11.4081 8.83415 10.8844 8.68738L6.76277 7.53228C6.34839 7.41615 6.11651 6.97589 6.25514 6.56849L7.86894 1.82609C8.1368 1.03892 7.11533 0.465555 6.58287 1.10421L0.74179 8.11019C0.393512 8.52793 0.591753 9.16587 1.11545 9.31264L5.23708 10.4677C5.65146 10.5839 5.88334 11.0241 5.74471 11.4315L4.13092 16.1739C3.86305 16.9611 4.88453 17.5345 5.41699 16.8958L11.2581 9.88983Z",
    fill: color
  }));
};

LightningBolt.propTypes = {
  color: PropTypes__default.string
};
LightningBolt.defaultProps = {
  color: TEXT_DARK_COLOR
};

var Recurring = function Recurring(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M6.94244 2.43264C8.50465 2.43264 9.86475 3.21868 10.6714 4.41883C10.7962 4.60436 10.7599 4.84987 10.6018 5.00794L9.52048 6.08928C9.2055 6.40426 9.42858 6.94284 9.87403 6.94284H11.4792H12.9118H13.4274C13.7006 6.94284 13.9233 6.72352 13.9274 6.45034L13.9811 2.86977C13.9878 2.42074 13.4451 2.19117 13.1276 2.50872L12.3648 3.27148C12.1406 3.49568 11.7675 3.45624 11.5675 3.21014C10.4783 1.86942 8.81906 1 6.96897 1C3.87272 1 1.30193 3.38843 1.0469 6.443C1.02392 6.71819 1.24998 6.94284 1.52612 6.94284H1.95342C2.23165 6.94284 2.45341 6.71483 2.48187 6.43806C2.71382 4.18245 4.64394 2.43264 6.94244 2.43264Z",
    fill: color,
    stroke: color,
    strokeWidth: "0.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M8.05713 12.8854C6.49492 12.8854 5.13482 12.0994 4.32812 10.8993C4.20341 10.7137 4.23967 10.4682 4.39774 10.3101L5.47909 9.2288C5.79407 8.91382 5.57099 8.37524 5.12554 8.37524H3.5204H2.08775H1.57215C1.29893 8.37524 1.0763 8.59456 1.0722 8.86775L1.01849 12.4483C1.01176 12.8973 1.55445 13.1269 1.87199 12.8094L2.63475 12.0466C2.85896 11.8224 3.23212 11.8618 3.43205 12.1079C4.52127 13.4487 6.18051 14.3181 8.0306 14.3181C11.1268 14.3181 13.6976 11.9296 13.9527 8.87508C13.9757 8.59989 13.7496 8.37524 13.4735 8.37524H13.0461C12.7679 8.37524 12.5462 8.60325 12.5177 8.88002C12.2857 11.1356 10.3556 12.8854 8.05713 12.8854Z",
    fill: color,
    stroke: color,
    strokeWidth: "0.5"
  }));
};

Recurring.propTypes = {
  color: PropTypes__default.string
};
Recurring.defaultProps = {
  color: TEXT_DARK_COLOR
};

var MagnifyingGlass = function MagnifyingGlass(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M0 5.63116C0 8.72496 2.51511 11.2401 5.60891 11.2401C6.85533 11.2401 7.99046 10.8394 8.92528 10.1494L11.6852 12.6645C12.2417 13.1765 13.132 13.1542 13.6439 12.5755C13.8887 12.3084 14 11.9746 14 11.6407C14 11.2623 13.8442 10.8839 13.5548 10.6169L10.6836 7.99046C11.0175 7.25596 11.2178 6.45469 11.2178 5.6089C11.2178 2.5151 8.70271 0 5.60891 0C2.51511 0 0 2.5151 0 5.63116ZM9.7043 5.63116C9.7043 7.87917 7.87917 9.70429 5.63116 9.70429C3.38315 9.70429 1.55803 7.87917 1.55803 5.63116C1.55803 3.38315 3.38315 1.55803 5.63116 1.55803C7.87917 1.53577 9.7043 3.36089 9.7043 5.63116Z",
    fill: color
  }));
};

MagnifyingGlass.propTypes = {
  color: PropTypes__default.string
};
MagnifyingGlass.defaultProps = {
  color: TEXT_DARK_COLOR
};

var MagnifyingGlassCircle = function MagnifyingGlassCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    r: "11",
    cx: "11.5",
    cy: "11.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 11.5C23 17.8513 17.8513 23 11.5 23C5.14873 23 0 17.8513 0 11.5C0 5.14873 5.14873 0 11.5 0C17.8513 0 23 5.14873 23 11.5ZM9.60891 16.2401C6.51511 16.2401 4 13.725 4 10.6312C4 7.5151 6.51511 5 9.60891 5C12.7027 5 15.2178 7.5151 15.2178 10.6089C15.2178 11.4547 15.0175 12.256 14.6836 12.9905L17.5548 15.6169C17.8442 15.8839 18 16.2623 18 16.6407C18 16.9746 17.8887 17.3084 17.6439 17.5755C17.132 18.1542 16.2417 18.1765 15.6852 17.6645L12.9253 15.1494C11.9905 15.8394 10.8553 16.2401 9.60891 16.2401ZM9.63116 14.7043C11.8792 14.7043 13.7043 12.8792 13.7043 10.6312C13.7043 8.36089 11.8792 6.53577 9.63116 6.55803C7.38315 6.55803 5.55803 8.38315 5.55803 10.6312C5.55803 12.8792 7.38315 14.7043 9.63116 14.7043Z",
    fill: backgroundColor
  }));
};

MagnifyingGlassCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
MagnifyingGlassCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var ExclamationTriangle = function ExclamationTriangle(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "16",
    height: "14",
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26538 0.75C6.84273 -0.25 8.2861 -0.25 8.86345 0.749999L14.9256 11.25C15.503 12.25 14.7813 13.5 13.6266 13.5H1.50224C0.347538 13.5 -0.374151 12.25 0.2032 11.25L6.26538 0.75ZM8.56442 7.88554C8.56442 8.22289 8.22113 8.5 7.81815 8.5H7.31069C6.89277 8.5 6.56442 8.22289 6.56442 7.88554V3.10241C6.56442 2.76506 6.9077 2.5 7.31069 2.5H7.81815C8.23606 2.5 8.56442 2.77711 8.56442 3.10241V7.88554ZM7.56442 11.5C8.1167 11.5 8.56442 11.0523 8.56442 10.5C8.56442 9.94771 8.1167 9.5 7.56442 9.5C7.01213 9.5 6.56442 9.94771 6.56442 10.5C6.56442 11.0523 7.01213 11.5 7.56442 11.5Z",
    fill: color
  }));
};

ExclamationTriangle.propTypes = {
  color: PropTypes__default.string
};
ExclamationTriangle.defaultProps = {
  color: TEXT_DARK_COLOR
};

var ExclamationTriangleCircle = function ExclamationTriangleCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    r: "11",
    cx: "11.5",
    cy: "11.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 11.5C23 17.8513 17.8513 23 11.5 23C5.14873 23 0 17.8513 0 11.5C0 5.14873 5.14873 0 11.5 0C17.8513 0 23 5.14873 23 11.5ZM12.8635 3.75C12.2861 2.75 10.8427 2.75 10.2654 3.75L4.2032 14.25C3.62585 15.25 4.34754 16.5 5.50224 16.5H17.6266C18.7813 16.5 19.503 15.25 18.9256 14.25L12.8635 3.75ZM11.8181 11.5C12.2211 11.5 12.5644 11.2229 12.5644 10.8855V6.10241C12.5644 5.77711 12.2361 5.5 11.8181 5.5H11.3107C10.9077 5.5 10.5644 5.76506 10.5644 6.10241V10.8855C10.5644 11.2229 10.8928 11.5 11.3107 11.5H11.8181ZM12.5644 13.5C12.5644 14.0523 12.1167 14.5 11.5644 14.5C11.0121 14.5 10.5644 14.0523 10.5644 13.5C10.5644 12.9477 11.0121 12.5 11.5644 12.5C12.1167 12.5 12.5644 12.9477 12.5644 13.5Z",
    fill: backgroundColor
  }));
};

ExclamationTriangleCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
ExclamationTriangleCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var ClearCircle = function ClearCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    r: "11",
    cx: "11.5",
    cy: "11.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23ZM16.3517 16.1754C15.7719 16.7757 14.747 16.7415 14.0937 16.1105L11.2418 13.3562L8.48792 16.2077C7.8399 16.8787 6.83388 16.9309 6.23353 16.3511C5.63317 15.7713 5.66742 14.7464 6.29839 14.0931L9.05229 11.2416L6.20081 8.48769C5.52982 7.83966 5.47758 6.83364 6.05739 6.23329C6.6372 5.63293 7.66209 5.66718 8.31542 6.29815L11.1669 9.05207L13.9212 6.20019C14.5522 5.54686 15.5752 5.47696 16.1756 6.05677C16.7759 6.63659 16.7417 7.66147 16.1107 8.3148L13.3564 11.1667L16.2083 13.921C16.8616 14.5519 16.9315 15.575 16.3517 16.1754Z",
    fill: backgroundColor
  }));
};

ClearCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
ClearCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var MoneySign = function MoneySign(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "9",
    height: "18",
    viewBox: "0 0 9 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.61422 14.3683C7.08153 15.0017 6.37604 15.444 5.43804 15.6558V17.1122C5.42533 18.2677 3.48302 18.2616 3.46328 17.1122V15.7664C2.52527 15.6874 1.50975 15.3887 0.851167 14.9676C-0.204004 14.3101 0.500025 12.5 1.7872 13.0373C3.07438 13.5746 3.3016 13.6729 4.12285 13.6791C5.22871 13.6791 5.97122 13.0965 5.97122 12.2291C5.97122 11.4392 5.42421 10.8962 4.08434 10.3531C2.96119 9.91224 2.19055 9.47039 1.66082 8.96139C1.0126 8.33441 0.698617 7.5919 0.698617 6.68598C0.698617 5.02373 1.8341 3.71051 3.56202 3.29581V1.89719C3.53514 0.735453 5.51392 0.620889 5.58713 1.89719V3.17091C6.37703 3.24151 7.05832 3.44244 7.68728 3.78309C8.82471 4.27228 8.44263 6.46184 6.77001 5.73612C6.14979 5.40338 5.45562 5.23255 4.75181 5.23947C3.5709 5.23947 3.14978 5.8709 3.14978 6.46184C3.14978 7.17226 3.62076 7.57264 5.24944 8.24702C6.33951 8.69134 7.08844 9.17121 7.60336 9.75623C8.16863 10.398 8.44263 11.1632 8.44263 12.0973C8.44191 12.9281 8.14862 13.7321 7.61422 14.3683Z",
    fill: color
  }));
};

MoneySign.propTypes = {
  color: PropTypes__default.string
};
MoneySign.defaultProps = {
  color: TEXT_DARK_COLOR
};

var GraduationCap = function GraduationCap(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "17",
    height: "16",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M3.84961 9.91504V10.3893V12.0127C3.84961 13.8044 6.13966 15.1084 8.96525 15.1084C11.7908 15.1084 14.0809 13.8851 14.0809 12.0127V9.91504C12.2991 11.1898 11.2705 11.9436 9.13152 12.8C8.90005 12.8927 8.6408 12.8923 8.41026 12.7974C6.64482 12.0704 5.60242 11.3488 3.84961 9.91504Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M8.27187 11.7326C8.59119 11.9396 8.99897 11.9438 9.32239 11.7433C11.1355 10.6191 16.9901 6.91753 16.9506 6.01822C16.9112 5.11919 11.1802 1.45297 9.39008 0.329097C9.06749 0.12657 8.65864 0.127987 8.33796 0.33353C6.58095 1.4597 1.00822 5.10152 0.978997 6.00708C0.94976 6.91297 6.5182 10.5957 8.27187 11.7326Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M2.78732 10.7612L1.71274 8.68912C1.68275 8.63122 1.63959 8.58313 1.5876 8.5497C1.53562 8.51626 1.47663 8.49866 1.41659 8.49866C1.35655 8.49866 1.29757 8.51626 1.24558 8.5497C1.1936 8.58313 1.15044 8.63122 1.12045 8.68912L0.0458632 10.7612C0.015825 10.8191 6.12719e-06 10.8847 1.77959e-09 10.9515C-6.12363e-06 11.0182 0.0158008 11.0839 0.0458284 11.1417C0.0758559 11.1995 0.119044 11.2475 0.17104 11.2808C0.223037 11.3142 0.282007 11.3317 0.342009 11.3315H2.49118C2.55113 11.3315 2.61002 11.3139 2.66194 11.2806C2.71387 11.2472 2.75699 11.1992 2.78699 11.1414C2.817 11.0837 2.83282 11.0181 2.83288 10.9514C2.83294 10.8847 2.81723 10.8191 2.78732 10.7612Z",
    fill: color
  }));
};

GraduationCap.propTypes = {
  color: PropTypes__default.string
};
GraduationCap.defaultProps = {
  color: TEXT_DARK_COLOR
};

var Panels = function Panels(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "17",
    height: "13",
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.025 2.12087H14.3789L13.7442 0.214464C13.7235 0.15236 13.6838 0.0983419 13.6307 0.0600677C13.5776 0.0217936 13.5138 0.00120495 13.4483 0.00122071H10.9957C11.016 0.0576462 11.0265 0.117101 11.0269 0.177053L11.025 2.12087Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M9.96475 2.12027V0.175832C9.96512 0.11588 9.97566 0.0564254 9.99592 0H6.78979V2.11996L9.96475 2.12027Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M5.72992 0.00122071H3.30755C3.24209 0.00120495 3.17829 0.0217936 3.12519 0.0600677C3.07209 0.0983419 3.03238 0.15236 3.01169 0.214464L2.37695 2.12087H5.72992V0.00122071Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.0254 4.77743H15.2631L14.7316 3.18091H11.0254V4.77743Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M9.96599 3.18091H6.78979V4.77743H9.96599V3.18091Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M5.7298 3.18091H2.02361L1.49207 4.77743H5.7298V3.18091Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M9.96475 5.83704H6.78979V7.94983C6.78979 7.94983 9.96568 8.00314 9.96568 7.88747L9.96475 5.83704Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1.13922 5.83704L0.572127 7.53955C0.556517 7.58642 0.552268 7.63633 0.559729 7.68516C0.567191 7.73399 0.58615 7.78035 0.615043 7.82042C0.643937 7.86048 0.681938 7.89311 0.725916 7.91561C0.769893 7.93811 0.818588 7.94984 0.867986 7.94983H5.73142V5.83704H1.13922Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15.6167 5.83704H11.0248C11.0248 5.83704 11.0616 7.87345 11.0189 7.94983H15.8883C15.9377 7.94984 15.9864 7.93811 16.0304 7.91561C16.0743 7.89311 16.1123 7.86048 16.1412 7.82042C16.1701 7.78035 16.1891 7.73399 16.1965 7.68516C16.204 7.63633 16.1998 7.58642 16.1841 7.53955L15.6167 5.83704Z",
    fill: color
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M16.1491 8.75952H0.52999C0.389428 8.75952 0.254623 8.81536 0.15523 8.91475C0.0558381 9.01414 0 9.14895 0 9.28951C0 9.43007 0.0558381 9.56488 0.15523 9.66427C0.254623 9.76366 0.389428 9.8195 0.52999 9.8195H7.74315V11.9395H6.52449C6.38393 11.9395 6.24912 11.9953 6.14973 12.0947C6.05034 12.1941 5.9945 12.3289 5.9945 12.4695C5.9945 12.61 6.05034 12.7448 6.14973 12.8442C6.24912 12.9436 6.38393 12.9994 6.52449 12.9994H9.96631C10.1069 12.9994 10.2417 12.9436 10.3411 12.8442C10.4405 12.7448 10.4963 12.61 10.4963 12.4695C10.4963 12.3289 10.4405 12.1941 10.3411 12.0947C10.2417 11.9953 10.1069 11.9395 9.96631 11.9395H8.80313V9.8195H16.1491C16.2897 9.8195 16.4245 9.76366 16.5239 9.66427C16.6233 9.56488 16.6791 9.43007 16.6791 9.28951C16.6791 9.14895 16.6233 9.01414 16.5239 8.91475C16.4245 8.81536 16.2897 8.75952 16.1491 8.75952Z",
    fill: color
  }));
};

Panels.propTypes = {
  color: PropTypes__default.string
};
Panels.defaultProps = {
  color: TEXT_DARK_COLOR
};

var Leaf = function Leaf(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "11",
    height: "16",
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M5.5042 0C9.93063 4.29265 14.7711 12.6274 6.49888 15.7848C6.12459 13.9189 5.88342 10.4278 5.70665 10.1318C5.54476 9.96668 5.45345 9.95112 5.2921 10.1318C5.14509 10.4693 4.8787 13.9261 4.49988 15.7848C-3.77233 12.6274 1.06835 4.29265 5.5042 0Z",
    fill: color
  }));
};

Leaf.propTypes = {
  color: PropTypes__default.string
};
Leaf.defaultProps = {
  color: TEXT_DARK_COLOR
};

var LeafCircle = function LeafCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    fill: color,
    r: "11",
    cx: "11.5",
    cy: "11.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 11.5C23 17.8513 17.8513 23 11.5 23C5.14873 23 0 17.8513 0 11.5C0 5.14873 5.14873 0 11.5 0C17.8513 0 23 5.14873 23 11.5ZM12.4989 19.7848C20.7711 16.6274 15.9306 8.29265 11.5042 4C7.06834 8.29265 2.22767 16.6274 10.4999 19.7848C10.709 18.7588 10.8839 17.2457 11.0233 16.0391C11.1364 15.0601 11.2262 14.283 11.2921 14.1318C11.4535 13.9511 11.5448 13.9667 11.7067 14.1318C11.7921 14.2749 11.8927 15.165 12.016 16.2572C12.1478 17.4239 12.3056 18.8211 12.4989 19.7848Z",
    fill: backgroundColor
  }));
};

LeafCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
LeafCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var Recycle = function Recycle(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M5.73213 4.57197C5.64658 4.71308 5.47548 4.75541 5.33289 4.67074L3.6076 3.68297C3.46502 3.59831 3.42224 3.42897 3.50779 3.28786L4.42034 1.73565C5.04772 0.663217 6.21692 0 7.47167 0C8.72643 0 9.89563 0.663217 10.523 1.73565L11.35 3.14675L12.1485 2.72342C12.3624 2.61054 12.6333 2.79398 12.5762 3.03387L11.8348 6.2794C11.792 6.44873 11.6209 6.54751 11.4498 6.49106L8.29867 5.33396C8.07053 5.24929 8.04202 4.92474 8.25589 4.81185L9.08289 4.3603L8.28441 3.00564C8.04202 2.58231 7.62852 2.53998 7.45741 2.53998C7.28631 2.53998 6.88707 2.58231 6.63042 3.00564L5.73213 4.57197ZM2.69506 10.809C2.60951 10.6679 2.45266 10.2869 2.69506 9.86359L3.50779 8.4666L4.27776 8.93227C4.49163 9.05927 4.76255 8.87582 4.71977 8.63594L4.16369 5.36218C4.13517 5.19285 3.96407 5.07996 3.79297 5.13641L0.584791 6.12418C0.342396 6.19473 0.29962 6.51928 0.513498 6.64628L1.34049 7.14017L1.32624 7.12606L0.470723 8.5936C-0.142395 9.66604 -0.156654 10.936 0.442205 12.0226C1.06958 13.1515 2.31008 13.8147 3.6076 13.8147H5.34715C5.50399 13.8147 5.63232 13.6877 5.63232 13.5325V11.571C5.63232 11.4158 5.50399 11.2888 5.34715 11.2888H3.52205C3.023 11.2747 2.78061 10.9501 2.69506 10.809ZM14.5011 8.49483L13.6171 6.98495C13.5316 6.84384 13.3605 6.80151 13.2179 6.88617L11.4926 7.87394C11.35 7.95861 11.3072 8.12794 11.3928 8.26905L12.3053 9.83537C12.5477 10.2587 12.3909 10.6397 12.3053 10.7808C12.2198 10.9219 11.9774 11.2465 11.4783 11.2465H9.90989L9.9384 10.3575C9.9384 10.1035 9.65323 9.97648 9.46787 10.1317L6.88707 12.2484C6.74449 12.3612 6.74449 12.5588 6.87281 12.6858L9.33954 14.9436C9.52491 15.1129 9.82434 14.9859 9.82434 14.746L9.85285 13.8006H11.5068C12.7901 13.8006 13.9451 13.1373 14.5724 12.0226C15.1856 10.9078 15.1428 9.56726 14.5011 8.49483Z",
    fill: color
  }));
};

Recycle.propTypes = {
  color: PropTypes__default.string
};
Recycle.defaultProps = {
  color: TEXT_DARK_COLOR
};

var RecycleCircle = function RecycleCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z",
    fill: backgroundColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M9.73213 8.57197C9.64658 8.71308 9.47548 8.75541 9.33289 8.67074L7.6076 7.68297C7.46502 7.59831 7.42224 7.42897 7.50779 7.28786L8.42034 5.73565C9.04772 4.66322 10.2169 4 11.4717 4C12.7264 4 13.8956 4.66322 14.523 5.73565L15.35 7.14675L16.1485 6.72342C16.3624 6.61054 16.6333 6.79398 16.5762 7.03387L15.8348 10.2794C15.792 10.4487 15.6209 10.5475 15.4498 10.4911L12.2987 9.33396C12.0705 9.24929 12.042 8.92474 12.2559 8.81185L13.0829 8.3603L12.2844 7.00564C12.042 6.58231 11.6285 6.53998 11.4574 6.53998C11.2863 6.53998 10.8871 6.58231 10.6304 7.00564L9.73213 8.57197ZM6.69506 14.809C6.60951 14.6679 6.45266 14.2869 6.69506 13.8636L7.50779 12.4666L8.27776 12.9323C8.49163 13.0593 8.76255 12.8758 8.71977 12.6359L8.16369 9.36218C8.13517 9.19285 7.96407 9.07996 7.79297 9.13641L4.58479 10.1242C4.3424 10.1947 4.29962 10.5193 4.5135 10.6463L5.34049 11.1402L5.32624 11.1261L4.47072 12.5936C3.8576 13.666 3.84335 14.936 4.44221 16.0226C5.06958 17.1515 6.31008 17.8147 7.6076 17.8147H9.34715C9.50399 17.8147 9.63232 17.6877 9.63232 17.5325V15.571C9.63232 15.4158 9.50399 15.2888 9.34715 15.2888H7.52205C7.023 15.2747 6.78061 14.9501 6.69506 14.809ZM18.5011 12.4948L17.6171 10.9849C17.5316 10.8438 17.3605 10.8015 17.2179 10.8862L15.4926 11.8739C15.35 11.9586 15.3072 12.1279 15.3928 12.269L16.3053 13.8354C16.5477 14.2587 16.3909 14.6397 16.3053 14.7808C16.2198 14.9219 15.9774 15.2465 15.4783 15.2465H13.9099L13.9384 14.3575C13.9384 14.1035 13.6532 13.9765 13.4679 14.1317L10.8871 16.2484C10.7445 16.3612 10.7445 16.5588 10.8728 16.6858L13.3395 18.9436C13.5249 19.1129 13.8243 18.9859 13.8243 18.746L13.8529 17.8006H15.5068C16.7901 17.8006 17.9451 17.1373 18.5724 16.0226C19.1856 14.9078 19.1428 13.5673 18.5011 12.4948Z",
    fill: color
  }));
};

RecycleCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
RecycleCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var CaretDown = function CaretDown(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "10",
    height: "6",
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.41421 0C0.523309 0 0.077142 1.07714 0.707107 1.70711L4.29289 5.29289C4.68342 5.68342 5.31658 5.68342 5.70711 5.29289L9.29289 1.70711C9.92286 1.07714 9.47669 0 8.58579 0H1.41421Z",
    fill: color
  }));
};

CaretDown.propTypes = {
  color: PropTypes__default.string
};
CaretDown.defaultProps = {
  color: TEXT_DARK_COLOR
};

var Sun$1 = function Sun(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M3.10544 10.0589C3.10544 9.75512 2.76971 9.45133 2.43399 9.45133H.671446C.335723 9.45133 0 9.67918 0 10.0589 0 10.3627.335723 10.6665.671446 10.6665H2.43399C2.76971 10.6665 3.10544 10.3627 3.10544 10.0589zM20 10.0589C20 9.75512 19.6643 9.45133 19.3286 9.45133H17.566C17.2303 9.45133 16.8946 9.67918 16.8946 10.0589 16.8946 10.3627 17.2303 10.6665 17.566 10.6665H19.3286C19.6643 10.6665 20 10.3627 20 10.0589zM9.90917 3.10544C10.213 3.10544 10.5168 2.76971 10.5168 2.43399L10.5168.671446C10.5168.335723 10.2889-9.95941e-9 9.90917-2.65584e-8 9.60538-3.98376e-8 9.30158.335723 9.30158.671446L9.30158 2.43399C9.30158 2.76971 9.60538 3.10544 9.90917 3.10544zM9.90917 20C10.213 20 10.5168 19.6643 10.5168 19.3286L10.5168 17.566C10.5168 17.2303 10.2889 16.8946 9.90917 16.8946 9.60538 16.8946 9.30158 17.2303 9.30158 17.566L9.30158 19.3286C9.30158 19.6643 9.60538 20 9.90917 20zM5.18721 5.15004C5.39975 4.93298 5.37241 4.48104 5.13254 4.24616L3.87319 3.01303C3.63331 2.77815 3.23403 2.70606 2.96835 2.97739 2.75581 3.19445 2.78314 3.64639 3.02302 3.88128L4.28237 5.11441C4.52224 5.34929 4.97466 5.36711 5.18721 5.15004zM5.17572 14.7738C4.9609 14.559 4.5087 14.5816 4.2713 14.819L3.025 16.0653C2.7876 16.3027 2.71132 16.7012 2.97984 16.9697 3.19465 17.1845 3.64686 17.1619 3.88425 16.9245L5.13056 15.6782C5.36795 15.4408 5.39053 14.9886 5.17572 14.7738zM17.1585 2.9729C16.9436 2.75808 16.4914 2.78066 16.2541 3.01805L15.0077 4.26436C14.7704 4.50175 14.6941 4.90025 14.9626 5.16877 15.1774 5.38359 15.6296 5.36101 15.867 5.12362L17.1133 3.87731C17.3507 3.63992 17.3733 3.18771 17.1585 2.9729zM17.1585 16.9768C17.3733 16.762 17.3507 16.3098 17.1133 16.0724L15.867 14.8261C15.6296 14.5887 15.2311 14.5124 14.9626 14.7809 14.7478 14.9957 14.7703 15.4479 15.0077 15.6853L16.254 16.9316C16.4914 17.169 16.9436 17.1916 17.1585 16.9768zM15.3922 9.99133C15.3922 12.9741 12.9742 15.3921 9.9914 15.3921 7.00864 15.3921 4.59064 12.9741 4.59064 9.99133 4.59064 7.00857 7.00864 4.59057 9.9914 4.59057 12.9742 4.59057 15.3922 7.00857 15.3922 9.99133z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M9.9914 13.7571C12.0712 13.7571 13.7572 12.0711 13.7572 9.99133C13.7572 7.91153 12.0712 6.22553 9.9914 6.22553C7.9116 6.22553 6.22559 7.91153 6.22559 9.99133C6.22559 12.0711 7.9116 13.7571 9.9914 13.7571ZM9.9914 15.3921C12.9742 15.3921 15.3922 12.9741 15.3922 9.99133C15.3922 7.00857 12.9742 4.59057 9.9914 4.59057C7.00864 4.59057 4.59064 7.00857 4.59064 9.99133C4.59064 12.9741 7.00864 15.3921 9.9914 15.3921Z",
    clipRule: "evenodd"
  }));
};

Sun$1.propTypes = {
  color: PropTypes__default.string
};
Sun$1.defaultProps = {
  color: TEXT_DARK_COLOR
};

var GradientLeaf = function GradientLeaf(_ref) {
  var stopColor = _ref.stopColor,
      props = _objectWithoutProperties(_ref, ["stopColor"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "56",
    height: "56",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: "url(#paintleaf".concat(stopColor, "_linear)"),
    fillRule: "evenodd",
    d: "M56 28c0 15.464-12.536 28-28 28S0 43.464 0 28 12.536 0 28 0s28 12.536 28 28zM30.433 48.172c20.14-7.688 8.355-27.981-2.422-38.433-10.8 10.452-22.587 30.745-2.446 38.433.51-2.499.935-6.183 1.275-9.12.275-2.384.494-4.276.654-4.644.393-.44.616-.402 1.01 0 .208.348.452 2.515.753 5.175.32 2.84.705 6.242 1.175 8.589z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("linearGradient", {
    id: "paintleaf".concat(stopColor, "_linear"),
    x1: "28",
    x2: "28",
    y1: "10.5",
    y2: "56",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React__default.createElement("stop", {
    stopColor: stopColor
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: "1",
    stopColor: stopColor,
    stopOpacity: "0.4"
  }))));
};

GradientLeaf.propTypes = {
  stopColor: PropTypes__default.string
};
GradientLeaf.defaultProps = {
  stopColor: "#00B085"
};

var GradientHouse = function GradientHouse(_ref) {
  var stopColor = _ref.stopColor,
      props = _objectWithoutProperties(_ref, ["stopColor"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "56",
    height: "56",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: "url(#paint".concat(stopColor, "house_linear)"),
    fillRule: "evenodd",
    d: "M28 56c15.464 0 28-12.536 28-28S43.464 0 28 0 0 12.536 0 28s12.536 28 28 28zm13.843-26.36c-.715 0-1.49-.238-2.086-.774l-11.31-10.128a1 1 0 00-1.334 0l-11.31 10.128c-1.31 1.132-3.277 1.013-4.409-.238-1.132-1.251-1.013-3.218.239-4.41l15.419-13.877a1 1 0 011.338 0l15.419 13.877c1.251 1.133 1.37 3.099.238 4.41-.476.655-1.31 1.013-2.204 1.013zm-14.818-7.146a1 1 0 011.322.002l13.58 11.985a1 1 0 01.338.75v4.075c0 1.132-.993 2.085-2.171 2.085h-6.816a1 1 0 01-1-1v-4.91a1 1 0 00-1-1h-7.243a1 1 0 00-1 1v4.91a1 1 0 01-1 1h-6.816c-1.18 0-2.172-.953-2.172-2.085v-4.074a1 1 0 01.34-.752l13.639-11.986z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("linearGradient", {
    id: "paint".concat(stopColor, "house_linear"),
    x1: "28",
    x2: "28",
    y1: "10.938",
    y2: "56",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React__default.createElement("stop", {
    stopColor: stopColor
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: "1",
    stopColor: stopColor,
    stopOpacity: "0.43"
  }))));
};

GradientHouse.propTypes = {
  stopColor: PropTypes__default.string
};
GradientHouse.defaultProps = {
  stopColor: "#F48503"
};

var HollowTreesCircle = function HollowTreesCircle(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64",
    height: "64",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    cx: "32",
    cy: "32",
    r: "32",
    fill: color,
    fillOpacity: "0.1"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    stroke: color,
    strokeWidth: "0.75",
    d: "M41.654 30.334c0-.162-.133-.324-.356-.324-.178 0-.356.122-.356.324 0 1.78-1.113 3.358-2.76 4.126-.178.081-.4.162-.579.243v.647c2.36-.687 4.051-2.67 4.051-5.016zM47.642 44.651H16.63a.353.353 0 01-.36-.356c0-.178.135-.355.36-.355h31.012c.18 0 .36.133.36.355 0 .223-.18.356-.36.356zM23.877 40.913c-1.98 0-3.826-1.202-4.591-3.026A3.22 3.22 0 0116 34.683c0-.801.27-1.558.81-2.136-.225-.579-.36-1.157-.36-1.78 0-2.492 2.026-4.495 4.546-4.495.135 0 .315 0 .495.045.36-1.024 1.35-1.692 2.43-1.692 1.036 0 1.981.623 2.386 1.558.9-.178 1.756.044 2.476.579.135.133.18.311.045.489-.135.133-.315.178-.495.044-.63-.445-1.395-.623-2.16-.4l-.27.044-.09-.311c-.226-.801-.99-1.38-1.846-1.38-.9 0-1.665.623-1.89 1.469l-.09.312-.316-.045c-.27-.045-.45-.045-.675-.045-2.115 0-3.87 1.736-3.87 3.828 0 .623.134 1.201.404 1.735l.135.178-.18.178c-.495.49-.81 1.113-.81 1.825a2.55 2.55 0 002.566 2.536h.27l.27-.044.09.267a4.32 4.32 0 004.05 2.803c1.936 0 3.602-1.29 4.142-3.115l.045-.222h.225a3.88 3.88 0 002.88-1.602c.09-.134.316-.178.496-.09.135.09.18.312.09.49-.72 1.024-1.89 1.691-3.151 1.87-.72 1.957-2.656 3.337-4.771 3.337z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    stroke: color,
    strokeWidth: "0.75",
    d: "M23.886 30.322c.18 0 .36.133.36.311v13.573h-.675V30.633c-.045-.178.135-.311.315-.311z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    stroke: color,
    strokeWidth: "0.75",
    d: "M20.93 33.402c0-.178.134-.356.36-.356.225 0 .36.134.36.357-.002 1.379 1.032 2.537 2.382 2.76v.668a3.445 3.445 0 01-3.103-3.43zM27.196 31.292a.353.353 0 00-.36-.356c-.226 0-.36.134-.36.357.001 1.38-1.033 2.537-2.383 2.761v.667a3.445 3.445 0 003.103-3.429zM38.145 38.554c-1.846 0-3.601-.845-4.727-2.27h-.27c-1.845 0-3.375-1.512-3.375-3.337 0-.534.135-1.023.36-1.468-1.216-.801-1.936-2.18-1.936-3.65 0-2.135 1.576-3.96 3.646-4.316.405-1.468 1.756-2.58 3.286-2.67.45-.934 1.395-1.513 2.476-1.513 1.035 0 1.98.579 2.43 1.469 2.386-.312 4.501 1.557 4.501 3.916 0 .4-.045.8-.18 1.157 1.62.712 2.7 2.27 2.7 4.05a4.416 4.416 0 01-3.06 4.182c-.675 2.581-3.106 4.45-5.851 4.45zm-4.411-2.981l.135.178c.99 1.335 2.61 2.136 4.32 2.136a5.33 5.33 0 005.222-4.183l.045-.178.18-.045c1.62-.445 2.79-1.913 2.79-3.604 0-1.602-1.035-2.982-2.565-3.516l-.36-.133.135-.312c.18-.4.225-.8.225-1.201 0-1.825-1.485-3.249-3.286-3.249-.225 0-.45 0-.63.045l-.27.044-.09-.267c-.315-.8-1.08-1.29-1.935-1.29-.856 0-1.62.534-1.936 1.335l-.135.222h-.225c-1.44 0-2.656.98-2.926 2.359l-.045.222-.225.045a3.72 3.72 0 00-3.286 3.693c0 1.335.72 2.581 1.89 3.204l.316.178-.225.312c-.27.445-.405.934-.405 1.424 0 1.468 1.215 2.67 2.7 2.67.135 0 .225 0 .36-.045l.226-.044z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    stroke: color,
    strokeWidth: "0.75",
    d: "M37.568 26.228c.18 0 .36.133.36.356v17.622h-.675V26.584c-.045-.223.135-.356.315-.356z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    stroke: color,
    strokeWidth: "0.75",
    d: "M37.604 29.788a.353.353 0 01-.36-.356c0-.223.18-.312.36-.312 1.306 0 2.386-1.068 2.386-2.358 0-.178.135-.356.36-.356.18 0 .36.133.36.356 0 1.646-1.395 3.026-3.106 3.026zM37.11 32.502c.18 0 .36-.134.36-.356 0-.223-.18-.312-.36-.312-1.305 0-2.385-1.068-2.385-2.358a.353.353 0 00-.36-.356c-.18 0-.36.133-.36.356 0 1.646 1.395 3.026 3.106 3.026z"
  }));
};

HollowTreesCircle.propTypes = {
  color: PropTypes__default.string
};
HollowTreesCircle.defaultProps = {
  color: '#00B085'
};

var HollowMapCircle = function HollowMapCircle(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64",
    height: "64",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    cx: "32",
    cy: "32",
    r: "32",
    fill: color,
    fillOpacity: "0.1"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: color,
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M28.272 33.32L16 39.896l4.955 3.52 7.641 1.018 4.26 3.844L48 40.22l-4.353-3.89-7.595-1.019-1.991-1.204M21.049 43.183l6.02-3.102M43.507 36.238l-10.142 5.696"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: color,
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M31.189 20.955c1.574 0 2.825 1.158 2.825 2.779 0 1.62-1.25 2.825-2.78 2.825-1.527 0-2.778-1.158-2.778-2.825-.046-1.621 1.204-2.779 2.733-2.779z"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: color,
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M31.188 16c4.214 0 7.641 3.427 7.641 7.641 0 1.806-.278 3.103-1.297 4.77-1.018 1.667-6.344 9.355-6.344 9.355s-5.326-7.688-6.345-9.355c-1.018-1.667-1.296-2.918-1.296-4.77 0-4.214 3.427-7.641 7.641-7.641z"
  }));
};

HollowMapCircle.propTypes = {
  color: PropTypes__default.string
};
HollowMapCircle.defaultProps = {
  color: '#00B085'
};

var HollowRecyclingCircle = function HollowRecyclingCircle(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64",
    height: "64",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), /*#__PURE__*/React__default.createElement("circle", {
    cx: "32",
    cy: "32",
    r: "32",
    fill: color,
    fillOpacity: "0.1"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M46.341 36.161s-.626 1.085-4.507 1.169l-4.967.25v-2.838l-4.09 6.302 3.798 6.553.042-2.671c1.336 0 2.796-.084 3.756-.125a1.891 1.891 0 001.503-.919l4.215-7.345c1.002-1.711 1.21-3.047.459-4.758l-1.753-3.506-6.135 3.465 1.795 3.422M29.228 17.966s1.21 0 3.255 3.297l2.672 4.173-2.463 1.42 7.513.375 3.756-6.594-2.337 1.293c-.668-1.168-1.461-2.42-2.004-3.171-.334-.543-.918-.835-1.544-.835h-8.43c-1.962 0-3.256.5-4.341 1.961l-2.17 3.256 6.093 3.63 2.045-3.255M22.008 41.88s-.626-1.085 1.21-4.466l2.338-4.423 2.462 1.419-3.422-6.678H17l2.295 1.377a71.728 71.728 0 00-1.752 3.297c-.293.543-.25 1.21.041 1.753l4.216 7.346c1.001 1.71 2.045 2.587 3.88 2.796l3.924.25.084-7.095-3.882-.167"
  }));
};

HollowRecyclingCircle.propTypes = {
  color: PropTypes__default.string
};
HollowRecyclingCircle.defaultProps = {
  color: '#00B085'
};

var Factory = function Factory(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "90",
    height: "90",
    fill: "none",
    viewBox: "0 0 90 90"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M35.61 30.83a8.16 8.16 0 00-3.53 6.7 8.27 8.27 0 008.25 8.26c.177.01.354.01.53 0a5.75 5.75 0 0011.49-.43c.004-.376-.03-.75-.1-1.12a10.11 10.11 0 005.42-16.9 13.37 13.37 0 006-11.11 12.74 12.74 0 00-24.92-3.79 10.12 10.12 0 00-3.17 18.42l.03-.03zm2.82-16.25a8.87 8.87 0 004.07 7.88.94.94 0 00.53.16 1 1 0 00.53-1.85 7.05 7.05 0 01-3-7.27 10.74 10.74 0 0121.14 2.7 11.4 11.4 0 01-6.17 10.05l-1.35.75 1.2 1a8.109 8.109 0 01-4.53 14.46l-1.49.1.64 1.26c.224.471.334.989.32 1.51a3.76 3.76 0 11-7.51 0v-1.65h-1a7.91 7.91 0 00-.87.06c-.213.01-.427.01-.64 0a6.23 6.23 0 01-2.23-12 4.63 4.63 0 015.36 2.81 1 1 0 001.3.57 1 1 0 00.57-1.3 6.56 6.56 0 00-7.54-4.06 8.13 8.13 0 01.6-15.17l.07-.01zm44.19 38.84H71.81v-5.74h-6.75v6.72H61.3a1 1 0 100 2h5.76v-6.72h2.75V80.42H62.3v-2a3.2 3.2 0 00-3.3-3.34c-.89-1.57-4.36-8.46-3.54-19.11a2.2 2.2 0 00-.46-1.75 2.348 2.348 0 00-1.77-.8H41.3A2.33 2.33 0 0039 55.9c.82 10.67-2.65 17.6-3.53 19.18a3.2 3.2 0 00-3.27 3.27v1.94h-7.74V60.81a.66.66 0 000-.15v-4a.697.697 0 000-.14v-5.75h2.76v6.71H33a1 1 0 000-2h-3.78v-6.71h-6.76v4.78H11.62V82.4h12.81v-.1H71.81v-.09h10.81V53.42zm-60.19 27h-8.81V55.55h8.81v24.87zM41 55.83c0-.2.11-.41.3-.41h11.89a.351.351 0 01.26.11.25.25 0 010 .22c-.75 9.81 1.88 16.54 3.26 19.33h-19A37.1 37.1 0 0041 55.83zm-6.81 22.52a1.221 1.221 0 011.27-1.27H59a1.21 1.21 0 011.27 1.27v2H34.19v-2zm46.43 1.92h-8.81V55.42h8.81v24.85z"
  }));
};

Factory.propTypes = {
  color: PropTypes__default.string
};
Factory.defaultProps = {
  color: "#F48503"
};

var LowerC02 = function LowerC02(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "90",
    height: "90",
    fill: "none",
    viewBox: "0 0 90 90"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M40 53.55c-.09 0-.18 0-.09-.08-.09 0-.09 0-.18.08a2.29 2.29 0 01-.53.44c-.18.08-.44.17-.62.26a2.238 2.238 0 01-.7.17c-.26.07-.53.098-.8.08a3.759 3.759 0 01-1.41-.25 3.66 3.66 0 01-1.15-.78 3.34 3.34 0 01-.79-1.3 4.94 4.94 0 01-.26-1.72 5.36 5.36 0 01.26-1.73 3.1 3.1 0 01.71-1.3c.322-.333.71-.596 1.14-.77a4.26 4.26 0 011.5-.26c.27-.015.54.016.8.09.21.042.418.099.62.17.17.08.26.17.44.26s.26.17.35.26c.09.09.18.08.26.17a.359.359 0 00.27.08.33.33 0 00.26-.08c.09-.09.18-.09.18-.17l.71-1A3.83 3.83 0 0039.32 45a6.002 6.002 0 00-2.32-.42 6.87 6.87 0 00-2.39.43 5.299 5.299 0 00-1.85 1.21 5.4 5.4 0 00-1.24 1.9 7.408 7.408 0 00-.44 2.41c.006.845.166 1.682.47 2.47.225.717.62 1.368 1.15 1.9a5.299 5.299 0 001.85 1.21 6.87 6.87 0 002.39.43 6 6 0 002.56-.43 4.73 4.73 0 001.76-1.38l-.88-1a.69.69 0 00-.38-.18z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M78.87 40.13c-.31-.62-1.17-1.66-3.55-1.66H63V8.07a2.68 2.68 0 00-2.75-2.58h-29a2.67 2.67 0 00-2.75 2.58v30.4H15.91c-2.39 0-3.25 1.08-3.56 1.72-.31.64-.57 1.91.81 3.6l28.73 35.83a4.789 4.789 0 003.72 1.87 4.79 4.79 0 003.73-1.87l28.73-35.83c1.38-1.79 1.09-3.06.8-3.66zm-2.37 2.41L47.79 78.36a2.71 2.71 0 01-4.35 0L14.71 42.53c-.49-.6-.7-1.17-.55-1.48.15-.31.66-.58 1.75-.58h14.54V8.07a.7.7 0 01.75-.58h29.05a.7.7 0 01.75.58v32.4h14.32c1.1 0 1.63.29 1.75.54.12.25.03.76-.57 1.53z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M60.67 55v.17h-1.41c-.18 0-.26.09-.44.09l1.06-1c.17-.18.26-.35.44-.52.18-.17.26-.35.35-.52l.27-.52c.08-.19.111-.396.09-.6a1.61 1.61 0 00-.09-.69 1.68 1.68 0 00-.36-.52 1.46 1.46 0 00-.61-.35 2.869 2.869 0 00-.89-.17 2.677 2.677 0 00-.88.09 1.7 1.7 0 00-.7.34 1.11 1.11 0 00-.53.61 3.866 3.866 0 00-.27.77l.8.09a.39.39 0 00.44 0l.26-.27c.09-.09.18-.26.27-.34a.64.64 0 01.44-.18.68.68 0 01.44.18.61.61 0 01.18.43.62.62 0 01-.09.34c0 .17-.09.26-.18.43-.09.17-.18.26-.26.44l-.36.34-1.76 1.64c-.09.09-.18.17-.18.26a.31.31 0 00-.09.26v.52h4.5v-.87c0-.17 0-.26-.08-.34-.08-.08-.18-.11-.36-.11zM54 47.43a5.733 5.733 0 00-.89-1.21 4.28 4.28 0 00-1.23-.95 8.109 8.109 0 00-1.5-.61c-.555-.1-1.116-.158-1.68-.17a7.81 7.81 0 00-2.47.43 4.929 4.929 0 00-1.94 1.21A5.409 5.409 0 0043 48a7.216 7.216 0 00-.45 2.42 6.798 6.798 0 00.45 2.44 4.64 4.64 0 001.23 1.9A5.67 5.67 0 0046.2 56a7.31 7.31 0 004.94 0 4.86 4.86 0 001.94-1.21 4.76 4.76 0 001.24-1.9c.28-.773.428-1.588.44-2.41a4.603 4.603 0 00-.26-1.56 4.332 4.332 0 00-.5-1.49zm-1.8 4.74c-.156.49-.427.936-.79 1.3a2.87 2.87 0 01-1.15.78 5.18 5.18 0 01-3.18 0 3.508 3.508 0 01-1.14-.78 3.25 3.25 0 01-.8-1.3 5.587 5.587 0 01-.26-1.72 5.648 5.648 0 01.26-1.73c.157-.489.432-.932.8-1.29a2.59 2.59 0 011.14-.78 5 5 0 013.18 0 3.36 3.36 0 011.15.78c.365.359.636.802.79 1.29.184.558.275 1.142.27 1.73a4.932 4.932 0 01-.27 1.72z"
  }));
};

LowerC02.propTypes = {
  color: PropTypes__default.string
};
LowerC02.defaultProps = {
  color: "#F48503"
};

var Truck = function Truck(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "90",
    height: "90",
    fill: "none",
    viewBox: "0 0 90 90"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M83.41 42.19h-1.18l-5.86-10.55a4.53 4.53 0 00-3.79-2H59.21V17H27.37v2h29.84v43.1H31.63a8.34 8.34 0 00-15.63 0H7.47v2h8.1v.76a8.3 8.3 0 0016.6 0 6.339 6.339 0 000-.76h32.27a6.339 6.339 0 000 .76 8.3 8.3 0 1016.6 0A8.634 8.634 0 0081 64h2.46a4.64 4.64 0 004.65-4.63v-12.2c-.05-3.44-2.38-4.98-4.7-4.98zM23.83 71a6.15 6.15 0 116.3-6.15 6.24 6.24 0 01-6.3 6.15zm48.87 0a6.15 6.15 0 116.3-6.14A6.23 6.23 0 0172.7 71zm13.36-11.65A2.639 2.639 0 0183.41 62h-3a8.34 8.34 0 00-15.55.12h-5.65V31.65h13.37a2.53 2.53 0 012.07 1l6.41 11.54h2.35c1.69 0 2.65 1.08 2.65 3v12.16zm-14.3-22.12l3.82 5.65v3.18H61.86v-2h11.72v-.57l-3.48-5.14 1.66-1.12zM32.9 40.67H2.05v-2H32.9v2zm-13.14-13h23.91v2H19.76v-2zM24.19 19H10.91v-2h13.28v2z"
  }));
};

Truck.propTypes = {
  color: PropTypes__default.string
};
Truck.defaultProps = {
  color: "#F48503"
};

var Filter = function Filter(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "10",
    fill: "none",
    viewBox: "0 0 16 10"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    stroke: color,
    strokeWidth: "2",
    d: "M0 1L16 1"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: color,
    strokeWidth: "2",
    d: "M4 5L12 5"
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: color,
    strokeWidth: "2",
    d: "M6.667 9L9.333 9"
  }));
};

Filter.propTypes = {
  color: PropTypes__default.string
};
Filter.defaultProps = {
  color: '#4A4A4A'
};

var ThumbsUp = function ThumbsUp(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: "14",
    height: "12",
    viewBox: "0 0 14 12"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M2.62 4.899h-.75v1.035h-.755V4.899h-.74A.37.37 0 000 5.273v5.99c0 .21.165.375.374.375h2.247a.37.37 0 00.374-.375v-5.99A.37.37 0 002.62 4.9zm10.832.668c0-.61-.42-1.228-1.219-1.228H8.606c.518-.927.67-2.23.31-3.184C8.652.453 8.146.044 7.492.002h-.01a.784.784 0 00-.83.717c-.094.947-.508 2.62-1.103 3.214-.5.5-.928.71-1.638 1.057l-.333.164a.922.922 0 01.003.078v5.929l.253.087c1.172.404 2.184.752 3.732.752h2.932c.8 0 1.219-.618 1.219-1.227 0-.182-.037-.363-.11-.53.267-.047.5-.175.673-.371.196-.223.304-.52.304-.835 0-.18-.036-.362-.109-.527.643-.111.977-.663.977-1.208 0-.316-.113-.634-.332-.867.219-.234.332-.552.332-.868z"
  }));
};

ThumbsUp.propTypes = {
  color: PropTypes__default.string
};
ThumbsUp.defaultProps = {
  color: TEXT_DARK_COLOR
};

var ThumbsUpCircle = function ThumbsUpCircle(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["backgroundColor", "color"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: "20",
    height: "20",
    viewBox: "0 0 23 23"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    fill: backgroundColor,
    d: "M11.5 23C17.851 23 23 17.851 23 11.5S17.851 0 11.5 0 0 5.149 0 11.5 5.149 23 11.5 23z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: color,
    d: "M8.622 10.312h-.557v.768h-.56v-.768h-.55a.275.275 0 00-.278.278v4.444c0 .156.123.278.278.278h1.667a.275.275 0 00.277-.278V10.59a.275.275 0 00-.277-.278zm8.036.496c0-.453-.311-.911-.905-.911h-2.69c.384-.688.497-1.655.23-2.363-.197-.52-.572-.824-1.057-.855h-.008a.582.582 0 00-.616.532c-.069.702-.376 1.944-.817 2.384-.371.372-.689.527-1.216.784l-.247.122a.672.672 0 01.002.058v4.399l.188.065c.87.3 1.62.558 2.768.558h2.176c.594 0 .905-.459.905-.911a.98.98 0 00-.082-.392.86.86 0 00.5-.277.933.933 0 00.225-.619.98.98 0 00-.08-.391c.476-.082.724-.491.724-.896a.941.941 0 00-.247-.644.943.943 0 00.247-.643z"
  }));
};

ThumbsUpCircle.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string
};
ThumbsUpCircle.defaultProps = {
  backgroundColor: SECONDARY_COLOR,
  color: WHITE_COLOR
};

var MOBILE_BREAKPOINT = 1256;
var MAX_MOBILE_BREAKPOINT = "".concat(MOBILE_BREAKPOINT, "px");
var MIN_MOBILE_BREAKPOINT = "".concat(MOBILE_BREAKPOINT + 1, "px");

var STATUSES = {
  REGISTRATION_COMPLETED: 'REGISTRATION_COMPLETED',
  AUTH_IN_PROGRESS: 'AUTH_IN_PROGRESS',
  REGISTERED_IN_PROGRESS: 'REGISTERED_IN_PROGRESS',
  ACTION_NEEDED: 'ACTION_NEEDED',
  CREDENTIAL_ERROR: 'CREDENTIAL_ERROR',
  REGISTRATION_FAILED: 'REGISTRATION_FAILED'
};
var STATUS_CODES = {
  UNEXPECTED_PRESENTATION: 'unexpected_presentation',
  TIMEOUT_SITE: 'timeout_site',
  TIMEOUT_AGENT: 'timeout_agent',
  SITE_ERROR: 'site_error',
  INCOMPLETE_PARAMETERS: 'incomplete_parameters',
  TERMINATED: 'terminated',
  AGENT_FAILURE: 'agent_failure',
  NO_AGENT: 'no_agent'
};

function _templateObject5$2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  text-align: center;\n  max-width: 600px;\n  margin: 0 auto;\n\n  > span {\n    margin-top: 30px;\n  }\n\n  > p:first-of-type {\n    display: none;\n    color: ", ";\n    font-size: 16px;\n    width: 300px;\n    margin: 0 auto 30px;\n\n    @media only screen and (min-width: ", ") {\n      display: block;\n    }\n  }\n"]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$5() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n\n  @media only screen and (min-width: ", ") {\n    display: block;\n    margin: 30px auto;\n  }\n"]);

  _templateObject4$5 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$6() {
  var data = _taggedTemplateLiteral(["\n  margin: 20px auto 10px;\n"]);

  _templateObject3$6 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$g() {
  var data = _taggedTemplateLiteral(["\n  background-color: rgba(233, 191, 190, 0.5);\n  padding: 30px;\n  margin: 0 -25px 50px;\n"]);

  _templateObject$g = function _templateObject() {
    return data;
  };

  return data;
}
var ErrorMessage = newStyled.div(_templateObject$g());
var IconContainer = newStyled.div(_templateObject2$7());
var StyledButton$2 = newStyled(Button)(_templateObject3$6());
var StyledHouse = newStyled(House)(_templateObject4$5(), MIN_MOBILE_BREAKPOINT);
var StyledContainer$2 = newStyled.div(_templateObject5$2(), TEXT_NEUTRAL_COLOR, MIN_MOBILE_BREAKPOINT);

var LinkUtilityErrorMessage = function LinkUtilityErrorMessage(_ref) {
  var wattzOnStatus = _ref.wattzOnStatus,
      wattzOnStatusCode = _ref.wattzOnStatusCode;
  var title = '';
  var message = '';

  switch (wattzOnStatus) {
    case STATUSES.ACTION_NEEDED:
      title = 'Action needed!';
      message = 'According to your utility, you must first take an action on the utility website before your account may be linked. Possible actions include agreeing to Terms & Conditions, updating your password, etc.'; // eslint-disable-line max-len

      break;

    case STATUSES.CREDENTIAL_ERROR:
      message = 'Oops! Please check your login details and try again.';
      break;

    case STATUSES.REGISTRATION_FAILED:
      switch (wattzOnStatusCode) {
        case STATUS_CODES.UNEXPECTED_PRESENTATION:
        case STATUS_CODES.TIMEOUT_SITE:
        case STATUS_CODES.TIMEOUT_AGENT:
        case STATUS_CODES.SITE_ERROR:
          title = 'Utility website temporarily unresponsive';
          message = 'Your utility\'s website is currently experiencing issues. These cases typically resolve themselves within a day. In the meantime, we will automatically retry linking on your behalf.'; // eslint-disable-line max-len

          break;

        case STATUS_CODES.INCOMPLETE_PARAMETERS:
          title = 'Utility connection failed';
          message = 'We were unable to connect to your utility account. Please try again, or check in with your solar consultant for more information.'; // eslint-disable-line max-len

          break;

        case STATUS_CODES.TERMINATED:
        case STATUS_CODES.AGENT_FAILURE:
          title = 'Unknown error occurred';
          message = 'The Sunrun team has been notified of this issue. Please check in with your solar consultant for more information, or try again below.'; // eslint-disable-line max-len

          break;

        case STATUS_CODES.NO_AGENT:
        default:
          title = 'Utility not currently supported';
          message = 'It seems your utility is not accepting account linkages at the moment. Please check in with your solar consultant for more information.'; // eslint-disable-line max-len

          break;
      }

      break;

    default:
      title = 'Something went wrong...';
      message = 'There was a problem connecting to your utility.';
  }

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(IconContainer, null, /*#__PURE__*/React__default.createElement(ExclamationmarkCircle, {
    backgroundColor: ERROR_COLOR
  })), /*#__PURE__*/React__default.createElement("h3", null, title), /*#__PURE__*/React__default.createElement(ErrorMessage, null, message));
};

LinkUtilityErrorMessage.propTypes = {
  wattzOnStatus: PropTypes__default.string.isRequired,
  wattzOnStatusCode: PropTypes__default.string
};

var LinkUtilityForm = function LinkUtilityForm(_ref2) {
  var buttonGroup = _ref2.buttonGroup,
      className = _ref2.className,
      onSubmit = _ref2.onSubmit,
      wattzOnStatus = _ref2.wattzOnStatus,
      wattzOnStatusCode = _ref2.wattzOnStatusCode;
  var initialValues = {
    userName: '',
    password: ''
  };
  var validationSchema = lib_9().shape({
    userName: lib_6().required('Please enter a username'),
    password: lib_6().required('Please enter a password')
  });
  var hideError = !wattzOnStatus || wattzOnStatus === 'UNREGISTERED';
  return /*#__PURE__*/React__default.createElement(StyledContainer$2, null, hideError && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("h3", null, "Connect Utility Account"), /*#__PURE__*/React__default.createElement("p", null, "Help us calculate your total energy usage by connecting your utility account."), /*#__PURE__*/React__default.createElement(StyledHouse, null)), !hideError && /*#__PURE__*/React__default.createElement(LinkUtilityErrorMessage, {
    wattzOnStatus: wattzOnStatus,
    wattzOnStatusCode: wattzOnStatusCode
  }), /*#__PURE__*/React__default.createElement(formik.Formik, {
    initialValues: initialValues,
    onSubmit: onSubmit,
    validationSchema: validationSchema,
    validateOnChange: true,
    validateOnBlur: true
  }, function () {
    return /*#__PURE__*/React__default.createElement(formik.Form, {
      className: className
    }, /*#__PURE__*/React__default.createElement(formik.Field, {
      component: FormikInput,
      label: "Username",
      name: "userName"
    }), /*#__PURE__*/React__default.createElement(formik.Field, {
      component: FormikInput,
      label: "Password",
      type: "password",
      name: "password"
    }), buttonGroup || /*#__PURE__*/React__default.createElement(StyledButton$2, {
      primary: true,
      type: "submit"
    }, "Share Energy Usage"));
  }), /*#__PURE__*/React__default.createElement(FinePrint, null));
};

LinkUtilityForm.propTypes = {
  /** Component to display button or buttons for the form */
  buttonGroup: PropTypes__default.oneOfType([PropTypes__default.node, PropTypes__default.object]),

  /** Class name to be applied to the form. */
  className: PropTypes__default.string,

  /** callback for form submission */
  onSubmit: PropTypes__default.func.isRequired,

  /** current status from wattzon */
  wattzOnStatus: PropTypes__default.string,

  /** current status code from wattzon */
  wattzOnStatusCode: PropTypes__default.string
};
LinkUtilityForm.defaultProps = {
  buttonGroup: null,
  className: null,
  wattzOnStatus: null
};

function _templateObject$h() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .content {\n    vertical-align: middle;\n    p {\n      color: ", ";\n      font-size: 18px;\n      margin-top: 30px;\n      font-family: Nunito;\n    }\n  }\n"]);

  _templateObject$h = function _templateObject() {
    return data;
  };

  return data;
}
var Loader = newStyled.div(_templateObject$h(), DARK_BLUE_COLOR);

var LinkUtilityLoading = function LinkUtilityLoading(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/React__default.createElement(Loader, null, /*#__PURE__*/React__default.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React__default.createElement(SunSpinner, null), typeof message === 'string' ? /*#__PURE__*/React__default.createElement("p", null, message) : message));
};

LinkUtilityLoading.propTypes = {
  message: PropTypes__default.oneOfType([PropTypes__default.node, PropTypes__default.string]).isRequired
};

function _templateObject3$7() {
  var data = _taggedTemplateLiteral(["\n  margin: 30px auto 15px;\n"]);

  _templateObject3$7 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$8() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n  padding: 15px 0;\n  background-color: #fff;\n"]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$i() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n"]);

  _templateObject$i = function _templateObject() {
    return data;
  };

  return data;
}
var StyledContainer$3 = newStyled.div(_templateObject$i());
var InfoBox = newStyled.p(_templateObject2$8());
var StyledHouse$1 = newStyled(House)(_templateObject3$7());

var LinkUtilityConnected = function LinkUtilityConnected() {
  return /*#__PURE__*/React__default.createElement(StyledContainer$3, null, /*#__PURE__*/React__default.createElement("h3", null, "Utility Account Connected "), /*#__PURE__*/React__default.createElement(StyledHouse$1, null), /*#__PURE__*/React__default.createElement(InfoBox, null, "Your utility account is already connected to", ' ', /*#__PURE__*/React__default.createElement("strong", null, "Sunrun")), /*#__PURE__*/React__default.createElement(InfoBox, null, "This connected account helps us calculate your total energy usage."), /*#__PURE__*/React__default.createElement(FinePrint, null));
};

var getWattzOnRegistrationEndpoint = function getWattzOnRegistrationEndpoint(envName) {
  switch (envName) {
    case 'local':
    case 'localhost':
      return 'https://gateway.sunrundev.com/local-wattzon-profile';

    case 'devmaj':
      return 'https://gateway.sunrundev.com/devmaj-wattzon-profile';

    case 'majstg':
      return 'https://gateway.sunrun.com/majstg-wattzon-profile';

    default:
      return 'https://gateway.sunrun.com/wattzon-profile';
  }
};
var getWattzOnBillingEndpoint = function getWattzOnBillingEndpoint(envName) {
  switch (envName) {
    case 'local':
    case 'localhost':
      return 'https://gateway.sunrundev.com/local-wattzon-usage';

    case 'devmaj':
      return 'https://gateway.sunrundev.com/devmaj-wattzon-usage';

    case 'majstg':
      return 'https://gateway.sunrun.com/majstg-wattzon-usage';

    default:
      return 'https://gateway.sunrun.com/wattzon-usage';
  }
};
var createProfile = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(envName, profilePayload) {
    var url;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = "".concat(getWattzOnRegistrationEndpoint(envName), "/profiles");
            return _context.abrupt("return", axios.post(url, profilePayload));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function createProfile(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var checkRegistrationStatus = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(envName, opptyId, customerToken) {
    var url, config, _yield$axios$get, _yield$axios$get$data, status, statusCode;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = "".concat(getWattzOnBillingEndpoint(envName), "/profiles/").concat(opptyId, "/registrationStatus");

            if (customerToken) {
              url = "".concat(getWattzOnBillingEndpoint(envName), "/registrationStatus");
              config = {
                headers: {
                  Authorization: "Bearer ".concat(customerToken)
                }
              };
            }

            _context2.prev = 2;
            _context2.next = 5;
            return axios.get(url, config);

          case 5:
            _yield$axios$get = _context2.sent;
            _yield$axios$get$data = _yield$axios$get.data;
            status = _yield$axios$get$data.status;
            statusCode = _yield$axios$get$data.statusCode;
            return _context2.abrupt("return", {
              status: status,
              statusCode: statusCode
            });

          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](2);
            return _context2.abrupt("return", {
              status: 'ERROR',
              error: _context2.t0
            });

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 12]]);
  }));

  return function checkRegistrationStatus(_x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();
var isRegistrationPending = function isRegistrationPending(status) {
  return status === STATUSES.AUTH_IN_PROGRESS || status === STATUSES.REGISTERED_IN_PROGRESS;
};
var isAuthInProgress = function isAuthInProgress(status) {
  return status === STATUSES.AUTH_IN_PROGRESS;
};
var isAuthError = function isAuthError(status) {
  return status === STATUSES.CREDENTIAL_ERROR;
};
var isNonAuthError = function isNonAuthError(status) {
  return status === STATUSES.REGISTRATION_FAILED || status === STATUSES.ACTION_NEEDED;
};
var isRegistrationComplete = function isRegistrationComplete(status) {
  return status === STATUSES.REGISTRATION_COMPLETED;
};
var pollRegistrationStatus = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(envName, opptyId, statusCallback, skipAuthError, customerToken) {
    var result;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return checkRegistrationStatus(envName, opptyId, customerToken);

          case 2:
            result = _context3.sent;

            if (statusCallback && (!skipAuthError || !isAuthError(result.status))) {
              statusCallback(result);
            }

            if (!isRegistrationPending(result.status)) {
              _context3.next = 8;
              break;
            }

            _context3.next = 7;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 2500);
            });

          case 7:
            return _context3.abrupt("return", pollRegistrationStatus(envName, opptyId, statusCallback, skipAuthError, customerToken));

          case 8:
            return _context3.abrupt("return", result);

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function pollRegistrationStatus(_x6, _x7, _x8, _x9, _x10) {
    return _ref3.apply(this, arguments);
  };
}();
/** Component to render form that allows an oppty to enter their engery provider creds and connect with Wattzon. */

var LinkUtility = function LinkUtility(props) {
  var buttonGroup = props.buttonGroup,
      className = props.className,
      customerToken = props.customerToken,
      envName = props.envName,
      email = props.email,
      loadingComponent = props.loadingComponent,
      onComplete = props.onComplete,
      onError = props.onError,
      onRegistrationStatusChange = props.onRegistrationStatusChange,
      opptyId = props.opptyId,
      utilityProviderId = props.utilityProviderId,
      zipCode = props.zipCode;

  var _useState = React.useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = React.useState({
    status: null,
    statusCode: null
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      registrationResult = _useState4[0],
      setRegistrationResult = _useState4[1];

  var _useCancelablePromise = useCancelablePromise(),
      cancelablePromise = _useCancelablePromise.cancelablePromise;

  var handleRegistrationStatusChange = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(result) {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (result && (result.status !== registrationResult.status || result.statusCode !== registrationResult.statusCode)) {
                setRegistrationResult(result);
                onRegistrationStatusChange(result);
              }

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleRegistrationStatusChange(_x11) {
      return _ref4.apply(this, arguments);
    };
  }();

  React.useEffect(function () {
    var getRegistrationStatus = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                setLoading(true);
                _context5.next = 4;
                return cancelablePromise(pollRegistrationStatus(envName, opptyId, handleRegistrationStatusChange, true, customerToken));

              case 4:
                setLoading(false);
                _context5.next = 13;
                break;

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](0);

                if (!(_context5.t0 && _context5.t0.message === 'PromiseCanceled')) {
                  _context5.next = 11;
                  break;
                }

                return _context5.abrupt("return");

              case 11:
                handleRegistrationStatusChange({
                  status: 'ERROR_CREATING_PROFILE'
                });
                setLoading(false);

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 7]]);
      }));

      return function getRegistrationStatus() {
        return _ref5.apply(this, arguments);
      };
    }();

    getRegistrationStatus();
  }, []);

  var onSubmit = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(input) {
      var userName, password, response, result, failureMessage;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              userName = input.userName, password = input.password;
              handleRegistrationStatusChange({
                status: STATUSES.AUTH_IN_PROGRESS
              });
              setLoading(true);
              _context6.prev = 3;
              _context6.next = 6;
              return createProfile(envName, {
                email: email,
                utilityProviderId: utilityProviderId,
                zipCode: zipCode,
                userName: userName,
                password: password,
                opptyId: opptyId
              });

            case 6:
              response = _context6.sent;
              _context6.next = 14;
              break;

            case 9:
              _context6.prev = 9;
              _context6.t0 = _context6["catch"](3);
              // Creating the profile failed, no need to continue
              setLoading(false);
              handleRegistrationStatusChange({
                status: 'ERROR_CREATING_PROFILE'
              });
              onError(_context6.t0);

            case 14:
              if (!(response.status === 200)) {
                _context6.next = 31;
                break;
              }

              _context6.prev = 15;
              _context6.next = 18;
              return cancelablePromise(pollRegistrationStatus(envName, opptyId, handleRegistrationStatusChange, false, customerToken));

            case 18:
              result = _context6.sent;
              setLoading(false);
              return _context6.abrupt("return", onComplete(result));

            case 23:
              _context6.prev = 23;
              _context6.t1 = _context6["catch"](15);

              if (!(_context6.t1 && _context6.t1.message === 'PromiseCanceled')) {
                _context6.next = 27;
                break;
              }

              return _context6.abrupt("return", null);

            case 27:
              setLoading(false);
              return _context6.abrupt("return", onError(_context6.t1));

            case 29:
              _context6.next = 34;
              break;

            case 31:
              failureMessage = 'Oops! Please check your login details and try again.';
              setLoading(false);
              return _context6.abrupt("return", onError(new Error(failureMessage)));

            case 34:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[3, 9], [15, 23]]);
    }));

    return function onSubmit(_x12) {
      return _ref6.apply(this, arguments);
    };
  }(); // If a custom loader is passed in, use it, otherwise use a default


  if (loading && loadingComponent) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, loadingComponent);
  }

  if (loading) {
    var message = 'One moment please...';

    if (isAuthInProgress(registrationResult.status)) {
      message = 'Checking your utility login details. This process can take a minute or so...';
    } else if (registrationResult.status) {
      message = /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", null, "Importing your energy usage\u2026"), /*#__PURE__*/React__default.createElement("p", null, "This process may take a few minutes."), /*#__PURE__*/React__default.createElement("p", null, "Feel free to leave this page \u2013 the import will not be interrupted."));
    }

    return /*#__PURE__*/React__default.createElement(LinkUtilityLoading, {
      message: message
    });
  }

  if (isRegistrationComplete(registrationResult.status)) {
    return /*#__PURE__*/React__default.createElement(LinkUtilityConnected, null);
  }

  return /*#__PURE__*/React__default.createElement(LinkUtilityForm, {
    buttonGroup: buttonGroup,
    className: className,
    onSubmit: onSubmit,
    wattzOnStatus: registrationResult.status,
    wattzOnStatusCode: registrationResult.statusCode
  });
};

LinkUtility.propTypes = {
  /** Component to display button or buttons for the form */
  buttonGroup: PropTypes__default.oneOfType([PropTypes__default.node, PropTypes__default.object]),

  /** Class name to be applied to the form. */
  className: PropTypes__default.string,

  /** Customer token */
  customerToken: PropTypes__default.string,

  /** Oppty's email address */
  email: PropTypes__default.string.isRequired,

  /** Current Environment. Used to determine endpoints.
   * Valid values: [devlocal, devmaj, majstg, prd].
   * Any unknown value will be treated as prd and hit the production endpoints. */
  envName: PropTypes__default.string,

  /** Component to render while loading */
  loadingComponent: PropTypes__default.oneOfType([PropTypes__default.node, PropTypes__default.object]),

  /** Callback for when registration is finished.
   * First param will be a success result */
  onComplete: PropTypes__default.func,

  /** Callback for when an error occurs during registration.
   * First param will be the error */
  onError: PropTypes__default.func,

  /** Callback for when registrationStatus changes */
  onRegistrationStatusChange: PropTypes__default.func,

  /** Opportunity Id */
  opptyId: PropTypes__default.string.isRequired,

  /** Utility Provider id */
  utilityProviderId: PropTypes__default.string.isRequired,

  /** Zip Code */
  zipCode: PropTypes__default.string.isRequired
};
LinkUtility.defaultProps = {
  buttonGroup: null,
  className: null,
  customerToken: null,
  envName: 'prd',
  loadingComponent: null,
  onComplete: function onComplete() {},
  onError: function onError() {},
  onRegistrationStatusChange: function onRegistrationStatusChange() {}
};

var LinkUtility$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getWattzOnRegistrationEndpoint: getWattzOnRegistrationEndpoint,
  getWattzOnBillingEndpoint: getWattzOnBillingEndpoint,
  createProfile: createProfile,
  checkRegistrationStatus: checkRegistrationStatus,
  isRegistrationPending: isRegistrationPending,
  isAuthInProgress: isAuthInProgress,
  isAuthError: isAuthError,
  isNonAuthError: isNonAuthError,
  isRegistrationComplete: isRegistrationComplete,
  pollRegistrationStatus: pollRegistrationStatus,
  'default': LinkUtility
});

function _templateObject$j() {
  var data = _taggedTemplateLiteral(["\n  line-height: 0.8125em;\n  position: absolute;\n  right: 0.8125em;\n  top: 0.8125em;\n"]);

  _templateObject$j = function _templateObject() {
    return data;
  };

  return data;
}

var modalStyles = function modalStyles(_ref) {
  var overlayColor = _ref.overlayColor,
      isScrollable = _ref.isScrollable,
      width = _ref.width,
      height = _ref.height;
  return {
    overlay: {
      alignItems: isScrollable ? 'flex-start' : 'center',
      backgroundColor: overlayColor,
      display: 'flex',
      justifyContent: 'center',
      overflowY: 'scroll',
      position: 'fixed',
      zIndex: 100,
      // giving it a high index value indicating it should be on top most always
      // keep top/left/right/bottom together instead of alphabetized
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    },
    content: {
      background: WHITE_COLOR,
      border: 'none',
      borderRadius: 0,
      boxShadow: BOX_SHADOW_COLOR,
      boxSizing: 'border-box',
      height: height || 'auto',
      margin: isScrollable ? '1em 0' : '0',
      overflow: 'auto',
      outline: 'none',
      padding: '1.5em 1.25em',
      position: 'absolute',
      WebkitOverflowScrolling: 'touch',
      width: width,
      maxWidth: 'calc(100% - 2em)',
      // keep top/left/right/bottom together instead of alphabetized
      top: 'auto',
      left: 'auto',
      right: 'auto',
      bottom: 'auto'
    }
  };
};

var StyledCloseLink = newStyled(Link)(_templateObject$j());

var Modal = function Modal(_ref2) {
  var children = _ref2.children,
      closeOnClickOverlay = _ref2.closeOnClickOverlay,
      hasCloseButton = _ref2.hasCloseButton,
      height = _ref2.height,
      isOpen = _ref2.isOpen,
      isScrollable = _ref2.isScrollable,
      onClose = _ref2.onClose,
      overlayColor = _ref2.overlayColor,
      rootId = _ref2.rootId,
      width = _ref2.width,
      props = _objectWithoutProperties(_ref2, ["children", "closeOnClickOverlay", "hasCloseButton", "height", "isOpen", "isScrollable", "onClose", "overlayColor", "rootId", "width"]);

  // Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
  if (rootId) ReactModal.setAppElement("#".concat(rootId)); // TL;DR: All these next lines do is set the overlay's scrollTop to 0 after the modal opens.
  //
  // For some reason, the scroll height of the ReactModal overlay will be set to
  // the top of the modal's content instead of "0" when the content is
  // long enough to overflow the overlay.
  //
  // ReactModal opens and closes itself via a function in its componentDidUpdate method.
  // Because of that, this component's useEffect hook will fire _before_
  // the modal is actually rendered as open.
  // Thankfully, ReactModal has an overlayRef prop and an onAfterOpen prop that
  // let us access the overlay DOM element _after_ the modal is finished
  // rendering open.

  var overlayRef = React.useRef(null); // overlay.scrollTop is always 0 in this callback.
  // Save the overlay ref to something we can use in the onAfterOpen function.

  var overlayCallbackRef = React.useCallback(function (overlay) {
    overlayRef.current = overlay;
  }); // scroll the overlay to the top once it is open

  var onAfterOpen = function onAfterOpen() {
    var current = overlayRef.current;

    if (current) {
      current.scrollTop = 0;
    }
  };

  return /*#__PURE__*/React__default.createElement(ReactModal, _extends({
    isOpen: isOpen,
    onRequestClose: onClose,
    shouldCloseOnOverlayClick: closeOnClickOverlay,
    style: modalStyles({
      overlayColor: overlayColor,
      isScrollable: isScrollable,
      width: width,
      height: height
    }),
    overlayRef: overlayCallbackRef,
    onAfterOpen: onAfterOpen
  }, props), hasCloseButton && /*#__PURE__*/React__default.createElement(StyledCloseLink, {
    onClick: onClose
  }, /*#__PURE__*/React__default.createElement(Clear, {
    color: TEXT_DARK_COLOR
  })), children);
};

Modal.propTypes = {
  /** Content of the modal */
  children: PropTypes__default.node.isRequired,

  /** Boolean indicating if the modal should be closed when the user clicks outside of it */
  closeOnClickOverlay: PropTypes__default.bool,

  /** Boolean indicating whether an X appears at the top of the modal */
  hasCloseButton: PropTypes__default.bool,

  /** Allow for a custom modal height */
  height: PropTypes__default.string,

  /** Boolean indicating if the modal is open or not */
  isOpen: PropTypes__default.bool,

  /** Top aligns the modal and allows the content to be scrollable */
  isScrollable: PropTypes__default.bool,

  /** Function to be called when the modal is requested to be closed */
  onClose: PropTypes__default.func.isRequired,

  /** Color of the background overlay */
  overlayColor: PropTypes__default.string,

  /** Root element for react project */
  rootId: PropTypes__default.string,

  /** Allow for a custom modal width */
  width: PropTypes__default.string
};
Modal.defaultProps = {
  closeOnClickOverlay: true,
  hasCloseButton: true,
  height: 'auto',
  isOpen: false,
  isScrollable: false,
  overlayColor: DARK_BLUE_COLOR_LOW_TRANSPARENCY,
  rootId: null,
  width: '21.25em'
};

function _templateObject$k() {
  var data = _taggedTemplateLiteral(["\n  font-family: 'Nunito';\n  font-size: 1.25em;\n  font-weight: bold;\n  text-align: center;\n  margin: 0.75em 0;\n"]);

  _templateObject$k = function _templateObject() {
    return data;
  };

  return data;
}
var StyledHeading = newStyled.div(_templateObject$k());

var Heading = function Heading(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement(StyledHeading, null, children);
};

Heading.propTypes = {
  children: PropTypes__default.node.isRequired
};

function _templateObject$l() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  font-family: 'Untitled Sans';\n  font-size: 1em;\n  font-weight: normal;\n  text-align: center;\n"]);

  _templateObject$l = function _templateObject() {
    return data;
  };

  return data;
}
var StyledBody = newStyled.div(_templateObject$l());

var Body = function Body(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement(StyledBody, null, children);
};

Body.propTypes = {
  children: PropTypes__default.node.isRequired
};

function _templateObject$m() {
  var data = _taggedTemplateLiteral(["\n  padding: 1em 2em;\n\n  & button, & a {\n    width: 100%;\n  }\n\n  & > * {\n    display: inline-block;\n    margin-bottom: 1em;\n  };\n\n  & > :last-child {\n    margin-bottom: 0;\n  }\n"]);

  _templateObject$m = function _templateObject() {
    return data;
  };

  return data;
}
// Tested with <Link />s and <Button />s as direct children.

var StyledButtons = newStyled.div(_templateObject$m());

var Buttons = function Buttons(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement(StyledButtons, null, children);
};

Buttons.propTypes = {
  children: PropTypes__default.node.isRequired
};



var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Body: Body,
  Buttons: Buttons,
  Heading: Heading,
  Modal: Modal
});

function _templateObject3$8() {
  var data = _taggedTemplateLiteral(["\n  vertical-align: middle;\n  line-height: 1.5em;\n  color: ", ";\n  flex-grow: 1;\n"]);

  _templateObject3$8 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$9() {
  var data = _taggedTemplateLiteral(["\n  vertical-align: middle;\n  margin-right: 0.5em;\n  position: relative;\n  display: inline-block;\n  height: 1.75em;\n  &:before {\n    content: \"\";\n    display: inline-block;\n    height: 1.75em;\n    width: 1.75em;\n    border: 2px solid ", ";\n    border-radius: 50%;\n    box-sizing: border-box;\n  }\n"]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$n() {
  var data = _taggedTemplateLiteral(["\n  label {\n    display: flex;\n  }\n\n  input:not(:disabled) ~ span {\n    cursor: pointer;\n  }\n\n  &:hover input:not(:disabled):not(:checked) + span:before {\n    cursor: pointer;\n    border: 2px solid ", ";\n    background-color: ", ";\n    box-shadow: inset 0 0 0 0.25em ", ";\n  }\n\n  // style input inside container so it applies to custom input, too\n  label > input {\n    position: absolute;\n    left: -9999px;\n    &:checked {\n      background-color: red;\n    }\n\n    &:checked + span:before {\n      background-image: url(\n        ", "\n      );\n      background-size: cover;\n      border: none;\n    }\n\n    &:disabled + span:before {\n      border: 2px solid ", ";\n    }\n\n    &:checked:disabled + span:before {\n      background-image: url(", ");\n      background-size: cover;\n      border: none;\n    }\n  }\n"]);

  _templateObject$n = function _templateObject() {
    return data;
  };

  return data;
}
var StyledContainer$4 = newStyled.div(_templateObject$n(), function (_ref) {
  var error = _ref.error;
  return error ? ERROR_COLOR : PRIMARY_COLOR;
}, function (_ref2) {
  var error = _ref2.error;
  return error ? ERROR_COLOR : PRIMARY_COLOR;
}, WHITE_COLOR, function (_ref3) {
  var error = _ref3.error;
  var icon = error ? ExclamationmarkCircle : CheckmarkCircle;
  var color = error ? ERROR_COLOR : PRIMARY_COLOR;
  return svgComponentAsDataUri(icon, {
    backgroundColor: color
  });
}, NEUTRAL_COLOR_LEVEL_2, svgComponentAsDataUri(CheckmarkCircle, {
  backgroundColor: NEUTRAL_COLOR_LEVEL_2
}));
var FakeRadioButton = newStyled.span(_templateObject2$9(), NEUTRAL_COLOR_LEVEL_1); // Smaller line height bumps the text up enough to appear vertically centered

var StyledLabelText$1 = newStyled.span(_templateObject3$8(), TEXT_DARK_COLOR);

var RadioButton = function RadioButton(_ref4) {
  var id = _ref4.id,
      label = _ref4.label,
      error = _ref4.error,
      CustomInput = _ref4.customInput,
      rest = _objectWithoutProperties(_ref4, ["id", "label", "error", "customInput"]);

  var htmlId = id || uuid.v4();
  return /*#__PURE__*/React__default.createElement(StyledContainer$4, {
    error: error
  }, /*#__PURE__*/React__default.createElement(Label, {
    htmlFor: htmlId
  }, CustomInput && /*#__PURE__*/React__default.createElement(CustomInput, _extends({
    id: htmlId,
    error: error
  }, rest)), !CustomInput && /*#__PURE__*/React__default.createElement("input", _extends({
    type: "radio",
    id: htmlId,
    error: error
  }, rest)), /*#__PURE__*/React__default.createElement(FakeRadioButton, null), /*#__PURE__*/React__default.createElement(StyledLabelText$1, null, label)));
};

RadioButton.propTypes = {
  /** The ID string of the element which is associated with the label */
  // htmlFor: PropTypes.string.isRequired,

  /** The text color for the label. Defaults to the dark text color */
  // color: PropTypes.string,

  /** Label to display after the checkbox, accepts text or node */
  label: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.node]),

  /** An optional id for the checkbox. If not supplied, a UUID is generated internally */
  id: PropTypes__default.string,

  /** An optional custom input, must be an html input tag with type of radio */
  customInput: PropTypes__default.elementType,

  /** error state to change the icon and color, boolean value */
  error: PropTypes__default.bool
};

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize$1(string) {
  if (typeof string !== 'string') {
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: capitalize(string) expects a string argument." : formatMuiErrorMessage(7));
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: theme.typography.pxToRem(24),
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(35)
    }
  };
};
var SvgIcon = /*#__PURE__*/React.forwardRef(function SvgIcon(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'inherit' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'svg' : _props$component,
      _props$fontSize = props.fontSize,
      fontSize = _props$fontSize === void 0 ? 'default' : _props$fontSize,
      htmlColor = props.htmlColor,
      titleAccess = props.titleAccess,
      _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
      other = _objectWithoutProperties$1(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);

  return /*#__PURE__*/React.createElement(Component, _extends$1({
    className: clsx(classes.root, className, color !== 'inherit' && classes["color".concat(capitalize$1(color))], fontSize !== 'default' && classes["fontSize".concat(capitalize$1(fontSize))]),
    focusable: "false",
    viewBox: viewBox,
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, other), children, titleAccess ? /*#__PURE__*/React.createElement("title", null, titleAccess) : null);
});
process.env.NODE_ENV !== "production" ? SvgIcon.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Node passed into the SVG element.
   */
  children: PropTypes__default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes__default.object,

  /**
   * @ignore
   */
  className: PropTypes__default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   */
  color: PropTypes__default.oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes__default
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: PropTypes__default.oneOf(['default', 'inherit', 'large', 'small']),

  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: PropTypes__default.string,

  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this property.
   */
  shapeRendering: PropTypes__default.string,

  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: PropTypes__default.string,

  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: PropTypes__default.string
} : void 0;
SvgIcon.muiName = 'SvgIcon';
var SvgIcon$1 = withStyles$1(styles, {
  name: 'MuiSvgIcon'
})(SvgIcon);

/**
 * Private module reserved for @material-ui/x packages.
 */

function createSvgIcon(path, displayName) {
  var Component = function Component(props, ref) {
    return /*#__PURE__*/React__default.createElement(SvgIcon$1, _extends$1({
      ref: ref
    }, props), path);
  };

  if (process.env.NODE_ENV !== 'production') {
    // Need to set `displayName` on the inner component for React.memo.
    // React prior to 16.14 ignores `displayName` on the wrapper.
    Component.displayName = "".concat(displayName, "Icon");
  }

  Component.muiName = SvgIcon$1.muiName;
  return /*#__PURE__*/React__default.memo( /*#__PURE__*/React__default.forwardRef(Component));
}

// TODO v5: consider to make it private
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
function useControlled(_ref) {
  var controlled = _ref.controlled,
      defaultProp = _ref.default,
      name = _ref.name,
      _ref$state = _ref.state,
      state = _ref$state === void 0 ? 'value' : _ref$state;

  var _React$useRef = React.useRef(controlled !== undefined),
      isControlled = _React$useRef.current;

  var _React$useState = React.useState(defaultProp),
      valueState = _React$useState[0],
      setValue = _React$useState[1];

  var value = isControlled ? controlled : valueState;

  if (process.env.NODE_ENV !== 'production') {
    React.useEffect(function () {
      if (isControlled !== (controlled !== undefined)) {
        console.error(["Material-UI: A component is changing the ".concat(isControlled ? '' : 'un', "controlled ").concat(state, " state of ").concat(name, " to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', "Decide between using a controlled or uncontrolled ".concat(name, " ") + 'element for the lifetime of the component.', "The nature of the state is determined during the first render, it's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
    }, [controlled]);

    var _React$useRef2 = React.useRef(defaultProp),
        defaultValue = _React$useRef2.current;

    React.useEffect(function () {
      if (!isControlled && defaultValue !== defaultProp) {
        console.error(["Material-UI: A component is changing the default ".concat(state, " state of an uncontrolled ").concat(name, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(name, ".")].join('\n'));
      }
    }, [JSON.stringify(defaultProp)]);
  }

  var setValueIfUncontrolled = React.useCallback(function (newValue) {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}

function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */
  return React.useMemo(function () {
    if (refA == null && refB == null) {
      return null;
    }

    return function (refValue) {
      setRef(refA, refValue);
      setRef(refB, refValue);
    };
  }, [refA, refB]);
}

/**
 * Private module reserved for @material-ui/x packages.
 */

function useId(idOverride) {
  var _React$useState = React.useState(idOverride),
      defaultId = _React$useState[0],
      setDefaultId = _React$useState[1];

  var id = idOverride || defaultId;
  React.useEffect(function () {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the random value for client-side rendering only.
      // We can't use it server-side.
      setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }
  }, [defaultId]);
  return id;
}

// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
var hadKeyboardEvent = true;
var hadFocusVisibleRecently = false;
var hadFocusVisibleRecentlyTimeout = null;
var inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */

function focusTriggersKeyboardModality(node) {
  var type = node.type,
      tagName = node.tagName;

  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }

  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }

  if (node.isContentEditable) {
    return true;
  }

  return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */


function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }

  hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */


function handlePointerDown() {
  hadKeyboardEvent = false;
}

function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}

function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}

function isFocusVisible(event) {
  var target = event.target;

  try {
    return target.matches(':focus-visible');
  } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
  // we use our own heuristic for those browsers
  // rethrow might be better if it's not the expected error but do we really
  // want to crash if focus-visible malfunctioned?
  // no need for validFocusTarget check. the user does that by attaching it to
  // focusable events only


  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */


function handleBlurVisible() {
  // To detect a tab/window switch, we look for a blur event followed
  // rapidly by a visibility change.
  // If we don't see a visibility change within 100ms, it's probably a
  // regular focus change.
  hadFocusVisibleRecently = true;
  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
  hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
    hadFocusVisibleRecently = false;
  }, 100);
}

function useIsFocusVisible() {
  var ref = React.useCallback(function (instance) {
    var node = ReactDOM.findDOMNode(instance);

    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue(isFocusVisible);
  }

  return {
    isFocusVisible: isFocusVisible,
    onBlurVisible: handleBlurVisible,
    ref: ref
  };
}

/**
 * @ignore - internal component.
 */

var Star = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'Star');

function clamp$1(value, min, max) {
  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }

  return value;
}

function getDecimalPrecision(num) {
  var decimalPart = num.toString().split('.')[1];
  return decimalPart ? decimalPart.length : 0;
}

function roundValueToPrecision(value, precision) {
  if (value == null) {
    return value;
  }

  var nearest = Math.round(value / precision) * precision;
  return Number(nearest.toFixed(getDecimalPrecision(precision)));
}

var styles$1 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      position: 'relative',
      fontSize: theme.typography.pxToRem(24),
      color: '#ffb400',
      cursor: 'pointer',
      textAlign: 'left',
      WebkitTapHighlightColor: 'transparent',
      '&$disabled': {
        opacity: 0.5,
        pointerEvents: 'none'
      },
      '&$focusVisible $iconActive': {
        outline: '1px solid #999'
      }
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      fontSize: theme.typography.pxToRem(18)
    },

    /* Styles applied to the root element if `size="large"`. */
    sizeLarge: {
      fontSize: theme.typography.pxToRem(30)
    },

    /* Styles applied to the root element if `readOnly={true}`. */
    readOnly: {
      pointerEvents: 'none'
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if keyboard focused. */
    focusVisible: {},

    /* Visually hide an element. */
    visuallyhidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      color: '#000',
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1
    },

    /* Styles applied to the pristine label. */
    pristine: {
      'input:focus + &': {
        top: 0,
        bottom: 0,
        position: 'absolute',
        outline: '1px solid #999',
        width: '100%'
      }
    },

    /* Styles applied to the label elements. */
    label: {
      cursor: 'inherit'
    },

    /* Styles applied to the icon wrapping elements. */
    icon: {
      display: 'flex',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      }),
      // Fix mouseLeave issue.
      // https://github.com/facebook/react/issues/4492
      pointerEvents: 'none'
    },

    /* Styles applied to the icon wrapping elements when empty. */
    iconEmpty: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the icon wrapping elements when filled. */
    iconFilled: {},

    /* Styles applied to the icon wrapping elements when hover. */
    iconHover: {},

    /* Styles applied to the icon wrapping elements when focus. */
    iconFocus: {},

    /* Styles applied to the icon wrapping elements when active. */
    iconActive: {
      transform: 'scale(1.2)'
    },

    /* Styles applied to the icon wrapping elements when decimals are necessary. */
    decimal: {
      position: 'relative'
    }
  };
};

function IconContainer$1(props) {
  var value = props.value,
      other = _objectWithoutProperties$1(props, ["value"]);

  return /*#__PURE__*/React.createElement("span", other);
}

process.env.NODE_ENV !== "production" ? IconContainer$1.propTypes = {
  value: PropTypes__default.number.isRequired
} : void 0;
var defaultIcon = /*#__PURE__*/React.createElement(Star, {
  fontSize: "inherit"
});

function defaultLabelText(value) {
  return "".concat(value, " Star").concat(value !== 1 ? 's' : '');
}

var Rating = /*#__PURE__*/React.forwardRef(function Rating(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$defaultValue = props.defaultValue,
      defaultValue = _props$defaultValue === void 0 ? null : _props$defaultValue,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      emptyIcon = props.emptyIcon,
      _props$emptyLabelText = props.emptyLabelText,
      emptyLabelText = _props$emptyLabelText === void 0 ? 'Empty' : _props$emptyLabelText,
      _props$getLabelText = props.getLabelText,
      getLabelText = _props$getLabelText === void 0 ? defaultLabelText : _props$getLabelText,
      _props$icon = props.icon,
      icon = _props$icon === void 0 ? defaultIcon : _props$icon,
      _props$IconContainerC = props.IconContainerComponent,
      IconContainerComponent = _props$IconContainerC === void 0 ? IconContainer$1 : _props$IconContainerC,
      _props$max = props.max,
      max = _props$max === void 0 ? 5 : _props$max,
      nameProp = props.name,
      onChange = props.onChange,
      onChangeActive = props.onChangeActive,
      onMouseLeave = props.onMouseLeave,
      onMouseMove = props.onMouseMove,
      _props$precision = props.precision,
      precision = _props$precision === void 0 ? 1 : _props$precision,
      _props$readOnly = props.readOnly,
      readOnly = _props$readOnly === void 0 ? false : _props$readOnly,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      valueProp = props.value,
      other = _objectWithoutProperties$1(props, ["classes", "className", "defaultValue", "disabled", "emptyIcon", "emptyLabelText", "getLabelText", "icon", "IconContainerComponent", "max", "name", "onChange", "onChangeActive", "onMouseLeave", "onMouseMove", "precision", "readOnly", "size", "value"]);

  var name = useId(nameProp);

  var _useControlled = useControlled({
    controlled: valueProp,
    default: defaultValue,
    name: 'Rating'
  }),
      _useControlled2 = _slicedToArray$1(_useControlled, 2),
      valueDerived = _useControlled2[0],
      setValueState = _useControlled2[1];

  var valueRounded = roundValueToPrecision(valueDerived, precision);
  var theme = useTheme$1();

  var _React$useState = React.useState({
    hover: -1,
    focus: -1
  }),
      _React$useState$ = _React$useState[0],
      hover = _React$useState$.hover,
      focus = _React$useState$.focus,
      setState = _React$useState[1];

  var value = valueRounded;

  if (hover !== -1) {
    value = hover;
  }

  if (focus !== -1) {
    value = focus;
  }

  var _useIsFocusVisible = useIsFocusVisible(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  var _React$useState2 = React.useState(false),
      focusVisible = _React$useState2[0],
      setFocusVisible = _React$useState2[1];

  var rootRef = React.useRef();
  var handleFocusRef = useForkRef(focusVisibleRef, rootRef);
  var handleRef = useForkRef(handleFocusRef, ref);

  var handleMouseMove = function handleMouseMove(event) {
    if (onMouseMove) {
      onMouseMove(event);
    }

    var rootNode = rootRef.current;

    var _rootNode$getBounding = rootNode.getBoundingClientRect(),
        right = _rootNode$getBounding.right,
        left = _rootNode$getBounding.left;

    var _rootNode$firstChild$ = rootNode.firstChild.getBoundingClientRect(),
        width = _rootNode$firstChild$.width;

    var percent;

    if (theme.direction === 'rtl') {
      percent = (right - event.clientX) / (width * max);
    } else {
      percent = (event.clientX - left) / (width * max);
    }

    var newHover = roundValueToPrecision(max * percent + precision / 2, precision);
    newHover = clamp$1(newHover, precision, max);
    setState(function (prev) {
      return prev.hover === newHover && prev.focus === newHover ? prev : {
        hover: newHover,
        focus: newHover
      };
    });
    setFocusVisible(false);

    if (onChangeActive && hover !== newHover) {
      onChangeActive(event, newHover);
    }
  };

  var handleMouseLeave = function handleMouseLeave(event) {
    if (onMouseLeave) {
      onMouseLeave(event);
    }

    var newHover = -1;
    setState({
      hover: newHover,
      focus: newHover
    });

    if (onChangeActive && hover !== newHover) {
      onChangeActive(event, newHover);
    }
  };

  var handleChange = function handleChange(event) {
    var newValue = parseFloat(event.target.value);
    setValueState(newValue);

    if (onChange) {
      onChange(event, newValue);
    }
  };

  var handleClear = function handleClear(event) {
    // Ignore keyboard events
    // https://github.com/facebook/react/issues/7407
    if (event.clientX === 0 && event.clientY === 0) {
      return;
    }

    setState({
      hover: -1,
      focus: -1
    });
    setValueState(null);

    if (onChange && parseFloat(event.target.value) === valueRounded) {
      onChange(event, null);
    }
  };

  var handleFocus = function handleFocus(event) {
    if (isFocusVisible(event)) {
      setFocusVisible(true);
    }

    var newFocus = parseFloat(event.target.value);
    setState(function (prev) {
      return {
        hover: prev.hover,
        focus: newFocus
      };
    });

    if (onChangeActive && focus !== newFocus) {
      onChangeActive(event, newFocus);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (hover !== -1) {
      return;
    }

    if (focusVisible !== false) {
      setFocusVisible(false);
      onBlurVisible();
    }

    var newFocus = -1;
    setState(function (prev) {
      return {
        hover: prev.hover,
        focus: newFocus
      };
    });

    if (onChangeActive && focus !== newFocus) {
      onChangeActive(event, newFocus);
    }
  };

  var item = function item(state, labelProps) {
    var id = "".concat(name, "-").concat(String(state.value).replace('.', '-'));
    var container = /*#__PURE__*/React.createElement(IconContainerComponent, {
      value: state.value,
      className: clsx(classes.icon, state.filled ? classes.iconFilled : classes.iconEmpty, state.hover && classes.iconHover, state.focus && classes.iconFocus, state.active && classes.iconActive)
    }, emptyIcon && !state.filled ? emptyIcon : icon);

    if (readOnly) {
      return /*#__PURE__*/React.createElement("span", _extends$1({
        key: state.value
      }, labelProps), container);
    }

    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: state.value
    }, /*#__PURE__*/React.createElement("label", _extends$1({
      className: classes.label,
      htmlFor: id
    }, labelProps), container, /*#__PURE__*/React.createElement("span", {
      className: classes.visuallyhidden
    }, getLabelText(state.value))), /*#__PURE__*/React.createElement("input", {
      onFocus: handleFocus,
      onBlur: handleBlur,
      onChange: handleChange,
      onClick: handleClear,
      disabled: disabled,
      value: state.value,
      id: id,
      type: "radio",
      name: name,
      checked: state.checked,
      className: classes.visuallyhidden
    }));
  };

  return /*#__PURE__*/React.createElement("span", _extends$1({
    ref: handleRef,
    onMouseMove: handleMouseMove,
    onMouseLeave: handleMouseLeave,
    className: clsx(classes.root, className, size !== 'medium' && classes["size".concat(capitalize$1(size))], disabled && classes.disabled, focusVisible && classes.focusVisible, readOnly && classes.readOnly),
    role: readOnly ? 'img' : null,
    "aria-label": readOnly ? getLabelText(value) : null
  }, other), Array.from(new Array(max)).map(function (_, index) {
    var itemValue = index + 1;

    if (precision < 1) {
      var items = Array.from(new Array(1 / precision));
      return /*#__PURE__*/React.createElement("span", {
        key: itemValue,
        className: clsx(classes.decimal, itemValue === Math.ceil(value) && (hover !== -1 || focus !== -1) && classes.iconActive)
      }, items.map(function ($, indexDecimal) {
        var itemDecimalValue = roundValueToPrecision(itemValue - 1 + (indexDecimal + 1) * precision, precision);
        return item({
          value: itemDecimalValue,
          filled: itemDecimalValue <= value,
          hover: itemDecimalValue <= hover,
          focus: itemDecimalValue <= focus,
          checked: itemDecimalValue === valueRounded
        }, {
          style: items.length - 1 === indexDecimal ? {} : {
            width: itemDecimalValue === value ? "".concat((indexDecimal + 1) * precision * 100, "%") : '0%',
            overflow: 'hidden',
            zIndex: 1,
            position: 'absolute'
          }
        });
      }));
    }

    return item({
      value: itemValue,
      active: itemValue === value && (hover !== -1 || focus !== -1),
      filled: itemValue <= value,
      hover: itemValue <= hover,
      focus: itemValue <= focus,
      checked: itemValue === valueRounded
    });
  }), !readOnly && !disabled && valueRounded == null && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    value: "",
    id: "".concat(name, "-empty"),
    type: "radio",
    name: name,
    defaultChecked: true,
    className: classes.visuallyhidden
  }), /*#__PURE__*/React.createElement("label", {
    className: classes.pristine,
    htmlFor: "".concat(name, "-empty")
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.visuallyhidden
  }, emptyLabelText))));
});
process.env.NODE_ENV !== "production" ? Rating.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes__default.object,

  /**
   * @ignore
   */
  className: PropTypes__default.string,

  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes__default.number,

  /**
   * If `true`, the rating will be disabled.
   */
  disabled: PropTypes__default.bool,

  /**
   * The icon to display when empty.
   */
  emptyIcon: PropTypes__default.node,

  /**
   * The label read when the rating input is empty.
   */
  emptyLabelText: PropTypes__default.node,

  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the rating.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   *
   * @param {number} value The rating label's value to format.
   * @returns {string}
   */
  getLabelText: PropTypes__default.func,

  /**
   * The icon to display.
   */
  icon: PropTypes__default.node,

  /**
   * The component containing the icon.
   */
  IconContainerComponent: PropTypes__default.elementType,

  /**
   * Maximum rating.
   */
  max: PropTypes__default.number,

  /**
   * The name attribute of the radio `input` elements.
   * If `readOnly` is false, the prop is required,
   * this input name`should be unique within the parent form.
   */
  name: chainPropTypes(PropTypes__default.string, function (props) {
    if (!props.readOnly && !props.name) {
      return new Error(['Material-UI: The prop `name` is required (when `readOnly` is false).', 'Additionally, the input name should be unique within the parent form.'].join('\n'));
    }

    return null;
  }),

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback.
   * @param {number} value The new value.
   */
  onChange: PropTypes__default.func,

  /**
   * Callback function that is fired when the hover state changes.
   *
   * @param {object} event The event source of the callback.
   * @param {number} value The new value.
   */
  onChangeActive: PropTypes__default.func,

  /**
   * @ignore
   */
  onMouseLeave: PropTypes__default.func,

  /**
   * @ignore
   */
  onMouseMove: PropTypes__default.func,

  /**
   * The minimum increment value change allowed.
   */
  precision: chainPropTypes(PropTypes__default.number, function (props) {
    if (props.precision < 0.1) {
      return new Error(['Material-UI: The prop `precision` should be above 0.1.', 'A value below this limit has an imperceptible impact.'].join('\n'));
    }

    return null;
  }),

  /**
   * Removes all hover effects and pointer events.
   */
  readOnly: PropTypes__default.bool,

  /**
   * The size of the rating.
   */
  size: PropTypes__default.oneOf(['large', 'medium', 'small']),

  /**
   * The rating value.
   */
  value: PropTypes__default.number
} : void 0;
var Rating$1 = withStyles$1(styles$1, {
  name: 'MuiRating'
})(Rating);

var RatingComponent = function RatingComponent(_ref) {
  var name = _ref.name,
      _onChange = _ref.onChange,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, ["name", "onChange", "value"]);

  return /*#__PURE__*/React__default.createElement(Rating$1, _extends({
    name: name,
    value: value,
    onChange: function onChange(event, newValue) {
      _onChange(newValue);
    }
  }, rest));
};

RatingComponent.propTypes = {
  name: PropTypes__default.string,
  onChange: PropTypes__default.func.isRequired,
  value: PropTypes__default.number
};
RatingComponent.defaultProps = {
  name: 'rating-component',
  value: 0
};

var customStyles$1 = {
  container: function container(provided) {
    return _objectSpread2(_objectSpread2({}, provided), {}, {
      padding: '10px 0',
      fontFamily: 'Nunito'
    });
  },
  control: function control(provided, state) {
    return _objectSpread2(_objectSpread2({}, provided), {}, {
      backgroundColor: state.selectProps.darkBackground ? state.selectProps.darkBackground : WHITE_COLOR,
      padding: '8px 10px',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.14)',
      borderColor: state.selectProps.darkBackground ? WHITE_COLOR : NEUTRAL_COLOR_LEVEL_2,
      '&:hover': {
        borderColor: state.selectProps.darkBackground ? WHITE_COLOR : NEUTRAL_COLOR_LEVEL_2
      }
    });
  },
  option: function option(provided, state) {
    return _objectSpread2(_objectSpread2({}, provided), {}, {
      padding: '15px 20px',
      backgroundColor: state.isSelected ? LIGHT_BLUE_OPAQUE : WHITE_COLOR,
      '&:hover, &:focus': {
        backgroundColor: LIGHT_BLUE_OPAQUE
      },
      color: BLACK_COLOR
    });
  },
  indicatorSeparator: function indicatorSeparator() {
    return {
      display: 'none'
    };
  },
  menuList: function menuList(provided, state) {
    return _objectSpread2(_objectSpread2({}, provided), {}, {
      maxHeight: state.selectProps.menuHeight,
      overflowY: 'scroll'
    });
  },
  menu: function menu(provided) {
    return _objectSpread2(_objectSpread2({}, provided), {}, {
      marginTop: '-5px',
      // move dropdown items closer to main select component
      borderRadius: '0px'
    });
  },
  placeholder: function placeholder(provided, state) {
    return _objectSpread2(_objectSpread2({}, provided), {}, {
      color: state.selectProps.darkBackground ? WHITE_COLOR : BLACK_COLOR,
      // removes absolute positioning and lets the content fill the space
      position: 'relative',
      transform: 'none'
    });
  },
  singleValue: function singleValue(provided, state) {
    return _objectSpread2(_objectSpread2({}, provided), {}, {
      color: state.selectProps.darkBackground ? WHITE_COLOR : BLACK_COLOR,
      // same as the placeholder, so it doesn't change when selecting a value
      position: 'relative',
      transform: 'none'
    });
  },
  input: function input(provided) {
    return _objectSpread2(_objectSpread2({}, provided), {}, {
      // absolutely positions the invisible input field, it was creating extra
      // space in the dropdown when the placeholder or value was very long
      position: 'absolute',
      right: '0'
    });
  }
};

var DropdownIndicator = function DropdownIndicator(props) {
  var selectProps = props.selectProps;
  return /*#__PURE__*/React__default.createElement(Select.components.DropdownIndicator, props, /*#__PURE__*/React__default.createElement("svg", {
    width: "14",
    height: "8",
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M1 1L7 7L13 1",
    stroke: selectProps.darkBackground ? WHITE_COLOR : DARK_BLUE_COLOR,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

DropdownIndicator.propTypes = {
  selectProps: PropTypes__default.shape({
    darkBackground: PropTypes__default.string
  }).isRequired
};

var SelectDropdown = function SelectDropdown(_ref) {
  var options = _ref.options,
      rest = _objectWithoutProperties(_ref, ["options"]);

  return /*#__PURE__*/React__default.createElement(Select__default, _extends({
    styles: customStyles$1,
    components: {
      DropdownIndicator: DropdownIndicator
    },
    options: options
  }, rest));
};

SelectDropdown.propTypes = {
  darkBackground: PropTypes__default.string,

  /** Specify the dropdown options the user can select from */
  options: PropTypes__default.arrayOf(PropTypes__default.shape({
    value: PropTypes__default.string.isRequired,
    label: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.node]).isRequired
  })).isRequired,
  menuHeight: PropTypes__default.string
};
SelectDropdown.defaultProps = {
  darkBackground: null,
  menuHeight: 'none'
};

function _templateObject3$9() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  ", "\n\n  > div {\n    ", "\n  }\n"]);

  _templateObject3$9 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$a() {
  var data = _taggedTemplateLiteral(["\n  padding: ", "px;\n"]);

  _templateObject2$a = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$o() {
  var data = _taggedTemplateLiteral(["\n  width: calc(100% * (1/", ") - 2px - ", "px);\n  margin: ", "px;\n"]);

  _templateObject$o = function _templateObject() {
    return data;
  };

  return data;
}

var tileSize = function tileSize(props) {
  return css(_templateObject$o(), props.perRow, props.margin, props.margin / 2);
};

var tileContainerPadding = function tileContainerPadding(props) {
  return css(_templateObject2$a(), props.margin / 2);
};

var TileContainer = newStyled.div(_templateObject3$9(), tileContainerPadding, tileSize);

var Tiles = function Tiles(props) {
  var perRow = props.perRow,
      margin = props.margin,
      children = props.children,
      rest = _objectWithoutProperties(props, ["perRow", "margin", "children"]);

  return /*#__PURE__*/React__default.createElement(TileContainer, _extends({
    perRow: perRow,
    margin: margin
  }, rest), children);
};

Tiles.propTypes = {
  /** Number of tiles per row */
  perRow: PropTypes__default.number,

  /** space between each tile */
  margin: PropTypes__default.number,

  /** Tile components to display */
  children: PropTypes__default.node.isRequired
};
Tiles.defaultProps = {
  perRow: 2,
  margin: 10
};

function _templateObject4$6() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  right: 10px;\n  bottom: 10px;\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject4$6 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$a() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 100%;\n"]);

  _templateObject3$a = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$b() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 5px;\n  text-align: center;\n  position: relative;\n  display: inline-block;\n  ", "\n"]);

  _templateObject2$b = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$p() {
  var data = _taggedTemplateLiteral(["\n  border: 1px solid ", "\n"]);

  _templateObject$p = function _templateObject() {
    return data;
  };

  return data;
}

var border = function border(props) {
  return css(_templateObject$p(), props.borderColor);
};

var TileContainer$1 = newStyled.div(_templateObject2$b(), border);
var AspectRatio = newStyled.div(_templateObject3$a());
var TileContent = newStyled.div(_templateObject4$6());

var Tile = function Tile(props) {
  var title = props.title,
      borderColor = props.borderColor,
      icon = props.icon,
      rest = _objectWithoutProperties(props, ["title", "borderColor", "icon"]);

  return /*#__PURE__*/React__default.createElement(TileContainer$1, _extends({
    borderColor: borderColor
  }, rest), /*#__PURE__*/React__default.createElement(AspectRatio, null), /*#__PURE__*/React__default.createElement(TileContent, null, icon && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("img", {
    src: icon,
    alt: title
  })), /*#__PURE__*/React__default.createElement("div", null, title)));
};

Tile.propTypes = {
  /** Color of tile outline */
  borderColor: PropTypes__default.string,

  /** Text to be displayed  */
  title: PropTypes__default.string.isRequired,

  /** img src of the icon to display. If null, no icon will be displayed */
  icon: PropTypes__default.string
};
Tile.defaultProps = {
  borderColor: '#1787E0',
  icon: null
};

function _templateObject3$b() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject3$b = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$c() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject2$c = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$q() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  position: relative;\n  padding-top: 1em;\n\n  & label {\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n"]);

  _templateObject$q = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * Color helper functions
* */

var borderColor$1 = function borderColor(_ref) {
  var hasError = _ref.hasError;

  if (hasError) {
    return ERROR_COLOR;
  }

  return TEXT_DARK_COLOR;
};

var labelColor$1 = function labelColor(_ref2) {
  var hasError = _ref2.hasError;

  if (hasError) {
    return ERROR_COLOR;
  }

  return TEXT_DARK_COLOR;
};

var focusedColor = function focusedColor(_ref3) {
  var hasError = _ref3.hasError;

  if (hasError) {
    return ERROR_COLOR;
  }

  return SECONDARY_COLOR;
};
/**
 * Container component
 */
// Place the label after the textarea in the markup and move it above via CSS
// so that it can be colored based when the textarea receives focus


var Container$2 = newStyled('span')(_templateObject$q());
/**
 * Character Limit Text
 */

var characterLimitStyles = function characterLimitStyles(props) {
  return "\n  color: ".concat(props.hasError ? ERROR_COLOR : TEXT_DARK_COLOR, ";\n  display: block;\n  font-family: 'Nunito';\n  font-weight: normal;\n  font-size: 0.875em;\n  text-align: right;\n  ");
};

var StyledCharacterLimit = newStyled('span')(_templateObject2$c(), function (props) {
  return characterLimitStyles(props);
});
/**
 * Textarea
 */
// Necessary so the ref can be forwarded and enabling a re-render upon mount

var WrappedTexareaAutosize = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(TextareaAutosize, _extends({}, props, {
    ref: ref
  }));
});

var TextareaStyles = function TextareaStyles(props) {
  return "\n  width: 100%;\n  border: none;\n  border-bottom: 1px solid ".concat(borderColor$1(props), ";\n  padding: .5em 0;\n  font-size: 1em;\n  font-family: 'Nunito';\n  font-weight: bold;\n  color: ").concat(TEXT_DARK_COLOR, ";\n  resize: none;\n\n  &:focus {\n    outline: none;\n    border-bottom: 1px solid ").concat(focusedColor(props), "\n  }\n\n  &:disabled, &:disabled:focus {\n    color: ").concat(TEXT_NEUTRAL_COLOR, ";\n    border-bottom: 1px solid ").concat(NEUTRAL_COLOR_LEVEL_1, ";\n  }\n\n  &:focus + label {\n    color: ").concat(focusedColor(props), ";\n  }\n");
};

var StyledTextarea = newStyled(WrappedTexareaAutosize, {
  // If we were using a regular DOM element here, we could use emotion's
  // isPropValid method to avoid React complaints about setting hasError on
  // a <textarea />, but because TextareaAutosize uses some "non-valid" props,
  // we just filter out the ones used for styling only.
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['hasError'].includes(prop);
  }
})(_templateObject3$b(), function (props) {
  return TextareaStyles(props);
});

var Textarea = function Textarea(props) {
  var label = props.label,
      value = props.value,
      maxLength = props.maxLength,
      defaultValue = props.defaultValue,
      id = props.id;

  var userSuppliedOnChange = props.onChange,
      rest = _objectWithoutProperties(props, ["onChange"]);

  var initialLength;
  var uniqueId = id || uuid.v4();
  /**
   * Since styles are applied in the browser _after_ the JavaScript has rendered,
   * The react-textarea-autosize component will occasionally calculate an
   * incorrect height on the intial render, leading to visible scrollbars in
   * the textarea. This issue:
   * https://github.com/andreypopp/react-textarea-autosize/issues/93
   * indicates that adding width: 100% may be the actual trigger, but we want the
   * textarea to fill its container so we need that width.
   * Other people have fixed the issue by setting overflow-y to hidden, but that
   * will lead to issues if someone sets the maxRows prop for TextareaAutosize.
   * The solution here is based on this workaround:
   * https://github.com/andreypopp/react-textarea-autosize/issues/93#issuecomment-242477519
   * We wait for the styles to be applied when the component mounts, then resize.
   * This has some obvious drawbacks... we are calling a private method, and the
   * delay required will depend on both the page this is used in and the
   * processing speed of the browser. In dev testing in Storybook on a highly
   * spec'd Mac, the styles took around 100ms to be applied. 150ms is used here
   * as a buffer above that value. Using a higher value has the drawback of a
   * noticeable delay for the user between "textarea with scrollbars" and
   * "textarea without scrollbars." In the worst case scenario, the user will
   * see scrollbars until the next render of the component, at which point they
   * will disappear.
   *
   * As a sidenote, it appears that emotion is not the only CSS-in-JS library
   * dealing with this sort of thing:
   * https://github.com/Khan/aphrodite/issues/76
   *
   */

  var textareaAutosizeEl = React.useRef(null);
  /* eslint-disable no-underscore-dangle */

  React.useEffect(function () {
    window.setTimeout(function () {
      if (textareaAutosizeEl.current._resizeComponent) {
        textareaAutosizeEl.current._resizeComponent();
      }
    }, 150);
  }, []);
  /* eslint-enable no-underscore-dangle */

  if (value) {
    initialLength = value.length;
  } else if (defaultValue) {
    initialLength = defaultValue.length;
  } else {
    initialLength = 0;
  }

  var _useState = React.useState(initialLength),
      _useState2 = _slicedToArray(_useState, 2),
      currentLength = _useState2[0],
      setCurrentLength = _useState2[1];

  var handleTextChange = function handleTextChange(e) {
    setCurrentLength(e.target.value.length);

    if (userSuppliedOnChange) {
      userSuppliedOnChange(e);
    }
  };

  var content = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledTextarea, _extends({
    id: uniqueId,
    onChange: handleTextChange,
    ref: textareaAutosizeEl
  }, rest)), label && /*#__PURE__*/React__default.createElement(Label, _extends({
    htmlFor: uniqueId,
    color: labelColor$1(props)
  }, rest), label), maxLength && /*#__PURE__*/React__default.createElement(StyledCharacterLimit, rest, currentLength, '/', maxLength)); // Only return a containing span if we have more than one element returned

  return label || maxLength ? /*#__PURE__*/React__default.createElement(Container$2, null, content) : content;
}; // just added this for documentation in storybook


Textarea.propTypes = {
  /** Optional prop to override a generated unique ID for each input */
  id: PropTypes__default.string,

  /** Text for a label above the textarea */
  label: PropTypes__default.string,

  /** Specifies the value of an input element.
   * For this component, it defines the initial value of the field.
   * */
  value: PropTypes__default.string,

  /** While "value" should be used if the component is controlled,
   * defaultValue should be used if React will not be controlling the value.
   * */
  defaultValue: PropTypes__default.string,

  /** Show styling to indicate an error */
  hasError: PropTypes__default.bool,

  /** Set a limit on the number of characters that the user can type.
   * A character counter will be shown to the user if this option is set.
   * */
  maxLength: PropTypes__default.number,

  /** A handler for when the user changes the textarea's value. This should be
   * used in conjunction with the "value" prop.
   * */
  onChange: PropTypes__default.func
};
Textarea.defaultProps = {
  label: undefined,
  value: undefined,
  hasError: false,
  maxLength: undefined,
  defaultValue: undefined
};

function _templateObject$r() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  border-radius: 2px;\n  padding: 16px;\n\n  .tooltip-arrow[data-placement*='top']::after {\n    border-color: ", " transparent;\n  }\n\n  .tooltip-arrow[data-placement*='right']::after {\n    border-color: transparent ", " transparent transparent;\n  }\n\n  .tooltip-arrow[data-placement*='bottom']::after {\n    border-color: transparent transparent ", ";\n  }\n\n  .tooltip-arrow[data-placement*='left']::after {\n    border-color: transparent transparent transparent ", ";\n  }\n"]);

  _templateObject$r = function _templateObject() {
    return data;
  };

  return data;
}
var StyledTooltip = newStyled.div(_templateObject$r(), DARK_BLUE_COLOR, WHITE_COLOR, DARK_BLUE_COLOR, DARK_BLUE_COLOR, DARK_BLUE_COLOR, DARK_BLUE_COLOR);

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      _tooltip = _ref.tooltip,
      hideArrow = _ref.hideArrow,
      tooltipClassname = _ref.tooltipClassname,
      props = _objectWithoutProperties(_ref, ["children", "tooltip", "hideArrow", "tooltipClassname"]);

  return /*#__PURE__*/React__default.createElement(TooltipTrigger, _extends({}, props, {
    tooltip: function tooltip(_ref2) {
      var arrowRef = _ref2.arrowRef,
          tooltipRef = _ref2.tooltipRef,
          getArrowProps = _ref2.getArrowProps,
          getTooltipProps = _ref2.getTooltipProps,
          placement = _ref2.placement;
      return /*#__PURE__*/React__default.createElement(StyledTooltip, _extends({
        className: tooltipClassname
      }, getTooltipProps({
        ref: tooltipRef
      })), !hideArrow && /*#__PURE__*/React__default.createElement("div", getArrowProps({
        ref: arrowRef,
        className: 'tooltip-arrow',
        'data-placement': placement
      })), _tooltip);
    }
  }), function (_ref3) {
    var getTriggerProps = _ref3.getTriggerProps,
        triggerRef = _ref3.triggerRef;
    return /*#__PURE__*/React__default.createElement("span", getTriggerProps({
      ref: triggerRef,
      className: 'trigger'
    }), children);
  });
};

Tooltip.propTypes = {
  children: PropTypes__default.node.isRequired,
  tooltip: PropTypes__default.node.isRequired,
  hideArrow: PropTypes__default.bool,
  tooltipClassname: PropTypes__default.string
};
Tooltip.defaultProps = {
  hideArrow: true,
  tooltipClassname: ''
};

function _templateObject$s() {
  var data = _taggedTemplateLiteral(["\n  position: ", ";\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background-color: ", ";\n  z-index: 20;\n"]);

  _templateObject$s = function _templateObject() {
    return data;
  };

  return data;
}
var StyledBackdrop = newStyled.div(_templateObject$s(), function (_ref) {
  var fixed = _ref.fixed;
  return fixed ? 'fixed' : 'absolute';
}, DARK_BLUE_COLOR_HIGH_TRANSPARENCY);

var Backdrop = function Backdrop(_ref2) {
  var fixed = _ref2.fixed,
      isOpen = _ref2.isOpen,
      onClick = _ref2.onClick;
  return isOpen ? /*#__PURE__*/React__default.createElement(StyledBackdrop, {
    fixed: fixed,
    onClick: onClick
  }) : null;
};

Backdrop.propTypes = {
  isOpen: PropTypes__default.bool,
  fixed: PropTypes__default.bool,
  onClick: PropTypes__default.func
};
Backdrop.defaultProps = {
  isOpen: false,
  fixed: false,
  onClick: noop
};

function _templateObject2$d() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  cursor: pointer;\n  background-color: transparent;\n  border: none;\n  padding: 1em 1.25em;\n  padding-top: ", ";\n  text-align: left;\n  font-size: 1.125em;\n\n  svg {\n    width: 1.25em;\n    height: 1.25em;\n  }\n"]);

  _templateObject2$d = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$t() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  position: relative;\n  background-color: ", ";\n  color: ", ";\n  @media only screen and (min-width: ", ") {\n    width: 250px;\n    min-width: 250px; /* for flexbox layouts */\n    ", "\n  }\n  font-family: 'Nunito';\n  @media only screen and (max-width: ", ") {\n    width: 310px;\n    min-width: 310px;\n    ", "\n  }\n  transition: margin-left 0.25s ease-in;\n  font-size: 1.125em;\n  z-index: 30;\n  display: flex;\n  flex-direction: column;\n  ", "\n\n  & > nav:first-of-type {\n    padding-top: 1em;\n  }\n\n  /**\n   * Clicking on the close button will show the button's outline after the\n   * menu is closed. This hides the focus outline\n   * */\n  ", "\n\n  /*\n   * Backdrop has a z-index of 20. This ensures that elements in the container\n   * are clickable\n   */\n  & > * {\n    z-index: 30;\n  }\n\n"]);

  _templateObject$t = function _templateObject() {
    return data;
  };

  return data;
}
var StyledContainer$5 = newStyled.div(_templateObject$t(), DARK_BLUE_COLOR, WHITE_COLOR, MIN_MOBILE_BREAKPOINT, function (_ref) {
  var isOpen = _ref.isOpen,
      isCloseableOnDesktop = _ref.isCloseableOnDesktop;
  return isOpen || !isCloseableOnDesktop ? '' : 'margin-left: -250px;';
}, MAX_MOBILE_BREAKPOINT, function (_ref2) {
  var isOpen = _ref2.isOpen;
  return isOpen ? '' : 'margin-left: -310px;';
}, function (_ref3) {
  var fixed = _ref3.fixed;
  return "\n    ".concat(fixed ? "\n      position: fixed;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      height: 100vh;\n      " : '', "\n\n  ");
}, function (_ref4) {
  var isOpen = _ref4.isOpen;
  return isOpen ? '' : "\n    @media only screen and (max-width: ".concat(MAX_MOBILE_BREAKPOINT, ") {\n      & > button:first-of-type:focus {\n        outline: none;\n      }\n    }\n  ");
});
var StyledCloseButton = newStyled.button(_templateObject2$d(), function (_ref5) {
  var isCloseableOnDesktop = _ref5.isCloseableOnDesktop;
  return isCloseableOnDesktop ? '' : "\n    @media only screen and (min-width: ".concat(MIN_MOBILE_BREAKPOINT, ") {\n      display: none;\n    }\n  ");
}, function (_ref6) {
  var nativeAppTopInset = _ref6.nativeAppTopInset;
  return "".concat(nativeAppTopInset, "px") || '1em';
});

var Container$3 = function Container(_ref7) {
  var children = _ref7.children,
      fixed = _ref7.fixed,
      isOpen = _ref7.isOpen,
      onClickClose = _ref7.onClickClose,
      isCloseableOnDesktop = _ref7.isCloseableOnDesktop;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Backdrop, {
    isOpen: isOpen,
    fixed: fixed,
    onClick: onClickClose
  }), /*#__PURE__*/React__default.createElement(StyledContainer$5, {
    fixed: fixed,
    isOpen: isOpen,
    isCloseableOnDesktop: isCloseableOnDesktop
  }, /*#__PURE__*/React__default.createElement(StyledCloseButton, {
    type: "button",
    onClick: onClickClose,
    isCloseableOnDesktop: isCloseableOnDesktop,
    nativeAppTopInset: window.nativeAppTopInset
  }, /*#__PURE__*/React__default.createElement(Clear, {
    color: WHITE_COLOR
  })), children));
};

Container$3.propTypes = {
  children: PropTypes__default.node.isRequired,
  isOpen: PropTypes__default.bool.isRequired,

  /** A function to handle when the user clicks close,
   * either via the "x" button or by clicking the backdrop
  * */
  onClickClose: PropTypes__default.func.isRequired,

  /** If true, the Container will used fixed positioning.
   * Use false if using within a flexbox or equivalent layout
  * */
  fixed: PropTypes__default.bool,

  /** By default, the menu will always be open on desktop.
   * This option allows the menu to be hideable on desktop as well
  * */
  isCloseableOnDesktop: PropTypes__default.bool
};
Container$3.defaultProps = {
  fixed: true,
  isCloseableOnDesktop: false
};

function _templateObject2$e() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  list-style-type: none;\n  padding-left: 0;\n"]);

  _templateObject2$e = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$u() {
  var data = _taggedTemplateLiteral(["\n  overflow-y: auto;\n  flex-grow: 1;\n\n  & > ul {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n  }\n\n  & > ul > li:last-child {\n    margin-bottom: 0.5em;\n  }\n"]);

  _templateObject$u = function _templateObject() {
    return data;
  };

  return data;
}
var StyledNav = newStyled.nav(_templateObject$u());
var StyledUl$1 = newStyled.ul(_templateObject2$e());

var MenuGroup = function MenuGroup(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement(StyledNav, null, /*#__PURE__*/React__default.createElement(StyledUl$1, null, children));
};

MenuGroup.propTypes = {
  children: PropTypes__default.node.isRequired
};

function _templateObject3$c() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  ", "\n  color: ", ";\n  display: block;\n  text-align: center;\n  width: 100%;\n  height: 100%;\n"]);

  _templateObject3$c = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$f() {
  var data = _taggedTemplateLiteral(["\n  height: 1.875em;\n  min-height: 1.875em;\n  width: 1.875em;\n  min-width: 1.875em;\n  line-height: 1.875em;\n  margin-right: 0.5em;\n\n  svg {\n    width: 1.875em;\n    height: 1.875em;\n  }\n"]);

  _templateObject2$f = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$v() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  ", "\n\n  & > button {\n    width: 100%;\n  }\n\n  & > a, & > button {\n    cursor: pointer; /* Links w onClick & wo href don't show pointer by default */\n    display: flex;\n    align-items: center;\n    padding: 0.75em 1.25em;\n    color: ", ";\n    text-decoration: none;\n    text-align: left;\n    font-weight: normal;\n\n    &:hover {\n      color: ", ";\n      text-decoration: none;\n    }\n\n    &:focus {\n      color: ", ";\n    }\n\n    ", "\n\n    ", "\n    \n  }\n\n  ", "\n\n  & > a:hover, & > button:hover {\n    background-color: ", ";\n  }\n"]);

  _templateObject$v = function _templateObject() {
    return data;
  };

  return data;
}
var StyledLi$1 = newStyled.li(_templateObject$v(), function (_ref) {
  var isBottomAligned = _ref.isBottomAligned;
  return isBottomAligned ? 'margin-top: auto;' : '';
}, WHITE_COLOR, WHITE_COLOR, WHITE_COLOR, function (_ref2) {
  var isOpen = _ref2.isOpen;
  return isOpen ? "background-color: ".concat(WHITE_TINTED_DARK_BLUE_COLOR_1, ";") : '';
}, function (_ref3) {
  var active = _ref3.active;
  return active ? "background-color: ".concat(WHITE_TINTED_DARK_BLUE_COLOR_2, ";") : '';
}, function (_ref4) {
  var active = _ref4.active;
  var activeStyles = '';

  if (active) {
    activeStyles = "\n      & > a, & > button {\n        font-weight: bold;\n      }\n\n      & > a:after, & > button:after {\n        content: \"\";\n        display: block;\n        position: absolute;\n        top: 0;\n        right: 0;\n        height: 100%;\n        width: 0.5em;\n        background-color: ".concat(WHITE_COLOR, ";\n      }\n      ");
  }

  return activeStyles;
}, SECONDARY_COLOR);
var StyledIconContainer = newStyled.span(_templateObject2$f());
var StyledFallbackIcon = newStyled.span(_templateObject3$c(), function (_ref5) {
  var hovered = _ref5.hovered,
      active = _ref5.active,
      isOpen = _ref5.isOpen;
  return hovered || active || isOpen ? "background-color: ".concat(WHITE_COLOR, ";") : "background-color: ".concat(WHITE_TINTED_DARK_BLUE_COLOR_2, ";");
}, WHITE_COLOR);

var MenuItem = function MenuItem(_ref6) {
  var text = _ref6.text,
      icon = _ref6.icon,
      href = _ref6.href,
      to = _ref6.to,
      active = _ref6.active,
      onClick = _ref6.onClick,
      children = _ref6.children,
      isOpen = _ref6.isOpen,
      isBottomAligned = _ref6.isBottomAligned,
      rest = _objectWithoutProperties(_ref6, ["text", "icon", "href", "to", "active", "onClick", "children", "isOpen", "isBottomAligned"]);

  var element = function element(hovered) {
    var Icon = icon;
    var backgroundColor = hovered || active || isOpen ? WHITE_COLOR : WHITE_TINTED_DARK_BLUE_COLOR_2;
    var iconTextColor = hovered || active || isOpen ? TEXT_DARK_COLOR : WHITE_COLOR;
    var iconWithFallback = Icon ? /*#__PURE__*/React__default.createElement(Icon, {
      color: iconTextColor,
      backgroundColor: backgroundColor
    }) : /*#__PURE__*/React__default.createElement(StyledFallbackIcon, {
      hovered: hovered,
      active: active,
      isOpen: isOpen
    });
    return /*#__PURE__*/React__default.createElement(StyledLi$1, {
      active: active,
      isOpen: isOpen,
      isBottomAligned: isBottomAligned
    }, /*#__PURE__*/React__default.createElement(Link, _extends({
      href: href,
      to: to,
      onClick: onClick
    }, rest), /*#__PURE__*/React__default.createElement(StyledIconContainer, null, iconWithFallback), /*#__PURE__*/React__default.createElement("span", null, text)), isOpen && children);
  };

  var _useHover = useHover(element),
      _useHover2 = _slicedToArray(_useHover, 1),
      hoverable = _useHover2[0];

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, hoverable);
};

MenuItem.propTypes = {
  /** The text to display for the MenuItem link */
  text: PropTypes__default.string.isRequired,

  /** A reference to an icon component.
   * The MenuItem component will set color and backgroundColor props on the icon
   * to create consistent styling on hover. It is up to the developer to ensure
   * that the icon has those properties available */
  icon: PropTypes__default.func,

  /** Specifies the path for the html anchor tag. Forwarded to a Link component. */
  href: PropTypes__default.string,

  /** Specifies the router for the react-router link. Forwarded to a Link component */
  to: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.shape({
    pathname: PropTypes__default.string,
    state: PropTypes__default.shape()
  })]),

  /** Forwarded to the Link component */
  onClick: PropTypes__default.func,

  /** Specifies if the menu item is currently selected */
  active: PropTypes__default.bool,

  /** Used when the MenuItem has children (like a Submenu) */
  isOpen: PropTypes__default.bool,

  /** Children are only rendered if isOpen is true */
  children: PropTypes__default.node,

  /** Used to push menu items to the bottom of a MenuGroup.
   * Note that this will push any menu items after the item to the bottom as well.
   */
  isBottomAligned: PropTypes__default.bool
};
MenuItem.defaultProps = {
  icon: undefined,
  href: undefined,
  to: undefined,
  active: false,
  isOpen: false,
  onClick: undefined,
  children: undefined,
  isBottomAligned: false
};

function _templateObject$w() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  list-style-type: none;\n  padding-left: 0;\n\n  @media only screen and (max-width: ", ") {\n    display: none;\n  }\n"]);

  _templateObject$w = function _templateObject() {
    return data;
  };

  return data;
}
var StyledUl$2 = newStyled.ul(_templateObject$w(), MAX_MOBILE_BREAKPOINT);

var Submenu = function Submenu(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement(StyledUl$2, null, children);
};

Submenu.propTypes = {
  children: PropTypes__default.node.isRequired
};

function _templateObject$x() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  line-height: 1.875em;\n\n  & > button {\n    width: 100%;\n  }\n\n  & > a, & > button {\n    display: block;\n    background-color: ", ";\n    padding: 0.75em 1.25em;\n    padding-left: 3.625em; \n    color: ", ";\n    text-decoration: none;\n    text-align: left;\n    font-weight: normal;\n\n    &:hover {\n      color: ", ";\n      text-decoration: none;\n    }\n\n    &:focus {\n      color: ", ";\n    }\n\n    ", "\n  }\n\n  ", "\n\n  &:hover > a, & > button:hover {\n    background-color: ", ";\n  }\n"]);

  _templateObject$x = function _templateObject() {
    return data;
  };

  return data;
}
var StyledLi$2 = newStyled.li(_templateObject$x(), WHITE_TINTED_DARK_BLUE_COLOR_1, WHITE_COLOR, WHITE_COLOR, WHITE_COLOR, function (_ref) {
  var active = _ref.active;
  return active ? "\n      font-weight: bold;\n      background-color: ".concat(WHITE_TINTED_DARK_BLUE_COLOR_2, ";\n      ") : '';
}, function (_ref2) {
  var active = _ref2.active;
  var activeStyles = '';

  if (active) {
    activeStyles = "\n        &:after {\n          content: \"\";\n          display: block;\n          position: absolute;\n          top: 0;\n          right: 0;\n          height: 100%;\n          width: 0.5em;\n          background-color: ".concat(WHITE_COLOR, ";\n        }\n      ");
  }

  return activeStyles;
}, SECONDARY_COLOR);

var SubmenuItem = function SubmenuItem(_ref3) {
  var text = _ref3.text,
      href = _ref3.href,
      to = _ref3.to,
      active = _ref3.active,
      onClick = _ref3.onClick,
      children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, ["text", "href", "to", "active", "onClick", "children"]);

  return /*#__PURE__*/React__default.createElement(StyledLi$2, {
    active: active
  }, /*#__PURE__*/React__default.createElement(Link, _extends({
    href: href,
    to: to,
    onClick: onClick
  }, rest), /*#__PURE__*/React__default.createElement("span", null, text)), children);
};

SubmenuItem.propTypes = {
  /** The main text displayed in the MenuItem */
  text: PropTypes__default.string.isRequired,

  /** Specifies the path for the html anchor tag. Forwarded to a Link component */
  href: PropTypes__default.string,

  /** Specifies the router for the react-router link. Forwarded to a Link component
  * Accepts string for the pathname, or object to include passed props, too */
  to: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.object]),

  /** Forwarded to a Link component */
  onClick: PropTypes__default.func,

  /** Specified whether this item is currently selected by the user */
  active: PropTypes__default.bool,
  children: PropTypes__default.node
};
SubmenuItem.defaultProps = {
  href: undefined,
  to: undefined,
  active: false,
  onClick: undefined,
  children: undefined
};

function _templateObject3$d() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 0;\n  font-weight: normal;\n  color: ", ";\n"]);

  _templateObject3$d = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$g() {
  var data = _taggedTemplateLiteral(["\n  font-size: 1em;\n  font-weight: bold;\n  margin: 0;\n"]);

  _templateObject2$g = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$y() {
  var data = _taggedTemplateLiteral(["\n  padding: 1em;\n  color: ", ";\n  background-color: ", ";\n  font-family: Nunito;\n  text-align: center;\n\n  & > svg {\n    width: 2em;\n    height: 2em;\n    margin: 0.5em 0;\n  }\n"]);

  _templateObject$y = function _templateObject() {
    return data;
  };

  return data;
}
var StyledContainer$6 = newStyled.div(_templateObject$y(), function (_ref) {
  var color = _ref.color;
  return color;
}, function (_ref2) {
  var backgroundColor = _ref2.backgroundColor;
  return backgroundColor;
});
var StyledH4 = newStyled.h4(_templateObject2$g());
var StyledMessage = newStyled.p(_templateObject3$d(), function (_ref3) {
  var color = _ref3.color;
  return color;
});

var Banner = function Banner(_ref4) {
  var icon = _ref4.icon,
      heading = _ref4.heading,
      message = _ref4.message,
      color = _ref4.color,
      backgroundColor = _ref4.backgroundColor,
      children = _ref4.children;
  return /*#__PURE__*/React__default.createElement(StyledContainer$6, {
    color: color,
    backgroundColor: backgroundColor
  }, icon, heading && /*#__PURE__*/React__default.createElement(StyledH4, null, heading), message && /*#__PURE__*/React__default.createElement(StyledMessage, {
    color: color
  }, message), children);
};

Banner.propTypes = {
  icon: PropTypes__default.node,
  heading: PropTypes__default.string,
  message: PropTypes__default.string,
  color: PropTypes__default.string,
  backgroundColor: PropTypes__default.string,
  children: PropTypes__default.node
};
Banner.defaultProps = {
  icon: undefined,
  heading: undefined,
  message: undefined,
  color: WHITE_COLOR,
  backgroundColor: SECONDARY_COLOR,
  children: undefined
};

function _templateObject$z() {
  var data = _taggedTemplateLiteral(["\n  margin-top: auto;\n"]);

  _templateObject$z = function _templateObject() {
    return data;
  };

  return data;
}
var StyledFooter = newStyled.div(_templateObject$z());

var Footer = function Footer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement(StyledFooter, null, children);
};

Footer.propTypes = {
  children: PropTypes__default.node.isRequired
};



var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Container: Container$3,
  MenuGroup: MenuGroup,
  MenuItem: MenuItem,
  Submenu: Submenu,
  SubmenuItem: SubmenuItem,
  Banner: Banner,
  Footer: Footer
});

function _templateObject2$h() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n"]);

  _templateObject2$h = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$A() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  box-sizing: border-box;\n  width: 100vw;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  font-family: 'Nunito';\n  border-top: 1px solid ", ";\n  background-color: ", ";\n\n  @media only screen and (min-width: ", ") {\n    display: none; /* hide this on desktop */\n  }\n\n"]);

  _templateObject$A = function _templateObject() {
    return data;
  };

  return data;
}
var StyledContainer$7 = newStyled.div(_templateObject$A(), NEUTRAL_COLOR_LEVEL_2, WHITE_COLOR, MIN_MOBILE_BREAKPOINT);
var StyledUl$3 = newStyled.ul(_templateObject2$h());

var Menu = function Menu(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement(StyledContainer$7, null, /*#__PURE__*/React__default.createElement(StyledUl$3, null, children));
};

Menu.propTypes = {
  /** These should be <BottomNavbar.MenuItem />s */
  children: PropTypes__default.node.isRequired
};

function _templateObject3$e() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  ", "\n  display: block;\n  width: 100%;\n  height: 100%;\n"]);

  _templateObject3$e = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$i() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  height: 1.4375em;\n  min-height: 1.4375em;\n  width: 1.4375em;\n  min-width: 1.4375em;\n  line-height: 1.4375em;\n  margin-bottom: 0.5em;\n\n  svg {\n    width: 1.4375em;\n    height: 1.4375em;\n  }\n"]);

  _templateObject2$i = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$B() {
  var data = _taggedTemplateLiteral(["\n  font-weight: normal;\n  padding: 1em;\n  cursor: pointer;\n\n  & > a, & > button {\n    font-family: 'Untitled Sans';\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    \n    color: ", ";\n  }\n"]);

  _templateObject$B = function _templateObject() {
    return data;
  };

  return data;
}
var StyledLi$3 = newStyled.li(_templateObject$B(), function (_ref) {
  var hovered = _ref.hovered,
      active = _ref.active;
  return hovered || active ? "".concat(SECONDARY_COLOR) : "".concat(TEXT_DARK_COLOR);
});
var StyledIconContainer$1 = newStyled.span(_templateObject2$i());
var StyledFallbackIcon$1 = newStyled.span(_templateObject3$e(), function (_ref2) {
  var hovered = _ref2.hovered,
      active = _ref2.active,
      isOpen = _ref2.isOpen;
  return hovered || active || isOpen ? "background-color: ".concat(SECONDARY_COLOR, ";") : "background-color: ".concat(NEUTRAL_COLOR_LEVEL_1, ";");
});

var MenuItem$1 = function MenuItem(_ref3) {
  var text = _ref3.text,
      icon = _ref3.icon,
      active = _ref3.active,
      rest = _objectWithoutProperties(_ref3, ["text", "icon", "active"]);

  var element = function element(hovered) {
    var Icon = icon;
    var iconColor = WHITE_COLOR;
    var iconBackgroundColor = hovered || active ? SECONDARY_COLOR : NEUTRAL_COLOR_LEVEL_1;
    var iconElement = Icon ? /*#__PURE__*/React__default.createElement(Icon, {
      color: iconColor,
      backgroundColor: iconBackgroundColor
    }) : /*#__PURE__*/React__default.createElement(StyledFallbackIcon$1, {
      hovered: hovered,
      active: active
    });
    return /*#__PURE__*/React__default.createElement(StyledLi$3, {
      hovered: hovered,
      active: active
    }, /*#__PURE__*/React__default.createElement(Link, rest, /*#__PURE__*/React__default.createElement(StyledIconContainer$1, null, iconElement), text));
  };

  var _useHover = useHover(element),
      _useHover2 = _slicedToArray(_useHover, 1),
      hoverable = _useHover2[0];

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, hoverable);
};

MenuItem$1.propTypes = {
  /** Required text to display for the button */
  text: PropTypes__default.string.isRequired,

  /** A reference to an SVG icon.
   * The component provides color and backgroundColor props to this,
   * so the icon needs to have those as props
   */
  icon: PropTypes__default.func,

  /** Whether the icon is currently selected */
  active: PropTypes__default.bool
};
MenuItem$1.defaultProps = {
  icon: undefined,
  active: false
};



var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Menu: Menu,
  MenuItem: MenuItem$1
});

function _templateObject$C() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  box-sizing: border-box;\n  display: flex;\n  padding: 1.5em 2em;\n  padding-top: ", ";\n  background-color: ", ";\n  min-height: 6em;\n\n  @media only screen and (max-width: ", ") {\n    min-height: 5em;\n  }  \n  \n"]);

  _templateObject$C = function _templateObject() {
    return data;
  };

  return data;
}
var StyledHeader = newStyled.div(_templateObject$C(), function (_ref) {
  var nativeAppTopInset = _ref.nativeAppTopInset;
  return "".concat(nativeAppTopInset, "px") || '1.5em';
}, function (_ref2) {
  var backgroundColor = _ref2.backgroundColor;
  return backgroundColor;
}, MAX_MOBILE_BREAKPOINT);

var Header = function Header(_ref3) {
  var backgroundColor = _ref3.backgroundColor,
      children = _ref3.children;
  return /*#__PURE__*/React__default.createElement(StyledHeader, {
    backgroundColor: backgroundColor,
    nativeAppTopInset: window.nativeAppTopInset
  }, children);
};

Header.propTypes = {
  children: PropTypes__default.node.isRequired,
  backgroundColor: PropTypes__default.string
};
Header.defaultProps = {
  backgroundColor: WHITE_COLOR
};

function _templateObject2$j() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 1.5em;\n  \n  ", "\n  svg {\n    position: relative;\n    bottom: -4px; // align with right side content\n    width: 3em;\n    height: 3em;\n    min-width: 3em;\n    min-height: 3em;\n\n    @media only screen and (max-width: ", ") {\n      width: 2em;\n      height: 2em;\n      min-width: 2em;\n      min-height: 2em;\n    }  \n  }\n"]);

  _templateObject2$j = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$D() {
  var data = _taggedTemplateLiteral(["\n  width: 3em;\n  height: 3em;\n  min-width: 3em;\n  min-height: 3em;\n  margin-right: 1.5em;\n\n  svg {\n    position: relative;\n    bottom: -4px; // align with right side content\n    width: 3em;\n    height: 3em;\n    min-width: 3em;\n    min-height: 3em;\n\n    @media only screen and (max-width: ", ") {\n      width: 2em;\n      height: 2em;\n      min-width: 2em;\n      min-height: 2em;\n    }\n    \n  }\n\n  @media only screen and (max-width: ", ") {\n    width: 2em;\n    height: 2em;\n    min-width: 2em;\n    min-height: 2em;\n    line-height: 1em;\n  }  \n"]);

  _templateObject$D = function _templateObject() {
    return data;
  };

  return data;
}
var StyledLogoContainer = newStyled.span(_templateObject$D(), MAX_MOBILE_BREAKPOINT, MAX_MOBILE_BREAKPOINT);
var StyledLink$2 = newStyled(Link)(_templateObject2$j(), function (_ref) {
  var onClick = _ref.onClick,
      to = _ref.to,
      href = _ref.href;
  return onClick || to || href ? 'cursor: pointer;' : '';
}, MAX_MOBILE_BREAKPOINT);

var BrandLogo = function BrandLogo(_ref2) {
  var rest = _extends({}, _ref2);

  var _rest = _objectSpread2({}, rest),
      onClick = _rest.onClick,
      to = _rest.to,
      href = _rest.href,
      showMobileIcon = _rest.showMobileIcon;

  var ContainingComponent = onClick || to || href ? StyledLink$2 : StyledLogoContainer;
  return /*#__PURE__*/React__default.createElement(ContainingComponent, rest, window.innerWidth < MOBILE_BREAKPOINT && showMobileIcon ? /*#__PURE__*/React__default.createElement(HamburgerMenu, null) : /*#__PURE__*/React__default.createElement(MainLogo, null));
};

function _templateObject$E() {
  var data = _taggedTemplateLiteral(["\n  font-size: 1.75em; /* to get 28px, assuming 1em = 16px */ \n  font-family: 'Nunito';\n  font-weight: normal;\n  ", "\n\n  @media only screen and (max-width: ", ") {\n    font-size: 1em;\n    line-height: 2em;\n  }\n"]);

  _templateObject$E = function _templateObject() {
    return data;
  };

  return data;
}
var StyledContentBlock = newStyled.div(_templateObject$E(), function (_ref) {
  var isRightAligned = _ref.isRightAligned;
  return isRightAligned ? 'margin-left: auto;' : '';
}, MAX_MOBILE_BREAKPOINT);

var ContentBlock = function ContentBlock(_ref2) {
  var isRightAligned = _ref2.isRightAligned,
      children = _ref2.children;
  return /*#__PURE__*/React__default.createElement(StyledContentBlock, {
    isRightAligned: isRightAligned
  }, children);
};

ContentBlock.propTypes = {
  children: PropTypes__default.node.isRequired,
  isRightAligned: PropTypes__default.bool
};
ContentBlock.defaultProps = {
  isRightAligned: false
};



var index$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  BrandLogo: BrandLogo,
  ContentBlock: ContentBlock,
  Header: Header
});

function _templateObject5$3() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 0.25em;\n  svg {\n    width: 0.875em;\n    height: 0.875em;\n  }\n"]);

  _templateObject5$3 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  ", "\n  @media only screen and (max-width: ", ") {\n    justify-content: center;\n  }\n"]);

  _templateObject4$7 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$f() {
  var data = _taggedTemplateLiteral(["\n  font-family: 'Untitled Sans';\n  font-weight: normal;\n  color: ", ";\n  font-size: 0.875em; /* 14px if base font-size is 16px */\n"]);

  _templateObject3$f = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$k() {
  var data = _taggedTemplateLiteral(["\n  font-family: 'Untitled Sans';\n  font-weight: bold;\n  letter-spacing: 0.15px;\n  line-height: ", ";\n  font-size: 1.25em; /* 20px if base font-size is 16px */\n  color: ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  &:hover {\n    overflow: visible; \n    white-space: normal;\n  }\n"]);

  _templateObject2$k = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$F() {
  var data = _taggedTemplateLiteral(["\n  min-width: 0; /* So the text will truncate */\n  padding: ", ";\n\n  ", "\n\n  @media only screen and (max-width: ", ") {\n    flex-grow: 1;\n    text-align: center;\n  }\n\n"]);

  _templateObject$F = function _templateObject() {
    return data;
  };

  return data;
}
var StyledContainer$8 = newStyled.div(_templateObject$F(), function (_ref) {
  var subtitle = _ref.subtitle;
  return subtitle ? '0 0.5em' : '0.5em';
}, function (_ref2) {
  var isCenteredOnDesktop = _ref2.isCenteredOnDesktop;
  return isCenteredOnDesktop ? 'flex-grow: 1; text-align: center;' : '';
}, MAX_MOBILE_BREAKPOINT);
var StyledTitle = newStyled.div(_templateObject2$k(), function (_ref3) {
  var subtitle = _ref3.subtitle;
  return subtitle ? '1.5em' : '1.875em';
}, function (_ref4) {
  var color = _ref4.color;
  return color;
});
var StyledSubtitle = newStyled.div(_templateObject3$f(), function (_ref5) {
  var subtitleColor = _ref5.subtitleColor;
  return subtitleColor;
});
var StyledSubtitleContainer = newStyled.div(_templateObject4$7(), function (_ref6) {
  var isCenteredOnDesktop = _ref6.isCenteredOnDesktop;
  return isCenteredOnDesktop ? 'justify-content: center;' : '';
}, MAX_MOBILE_BREAKPOINT);
var StyledIconContainer$2 = newStyled.div(_templateObject5$3());

var Title = function Title(_ref7) {
  var text = _ref7.text,
      color = _ref7.color,
      subtitle = _ref7.subtitle,
      subtitleColor = _ref7.subtitleColor,
      subtitleHasInfoIcon = _ref7.subtitleHasInfoIcon,
      isCenteredOnDesktop = _ref7.isCenteredOnDesktop;
  return /*#__PURE__*/React__default.createElement(StyledContainer$8, {
    subtitle: subtitle,
    isCenteredOnDesktop: isCenteredOnDesktop
  }, /*#__PURE__*/React__default.createElement(StyledTitle, {
    color: color,
    subtitle: subtitle
  }, text), subtitle && /*#__PURE__*/React__default.createElement(StyledSubtitleContainer, null, /*#__PURE__*/React__default.createElement(StyledSubtitle, {
    subtitleColor: subtitleColor
  }, subtitle), subtitleHasInfoIcon && /*#__PURE__*/React__default.createElement(StyledIconContainer$2, null, /*#__PURE__*/React__default.createElement(InformationCircle, {
    backgroundColor: subtitleColor
  }))));
};

Title.propTypes = {
  text: PropTypes__default.string.isRequired,
  color: PropTypes__default.string,
  subtitleColor: PropTypes__default.string,
  subtitle: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.node]),
  subtitleHasInfoIcon: PropTypes__default.bool,
  isCenteredOnDesktop: PropTypes__default.bool
};
Title.defaultProps = {
  color: TEXT_DARK_COLOR,
  subtitle: undefined,
  subtitleColor: TEXT_NEUTRAL_COLOR,
  subtitleHasInfoIcon: true,
  isCenteredOnDesktop: false
};

function _templateObject4$8() {
  var data = _taggedTemplateLiteral(["\n  min-width: 0;\n  @media only screen and (max-width: ", ") {\n    padding: 0 2.5em;\n    width: 100%;\n  }\n"]);

  _templateObject4$8 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$g() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  margin-right: 0.5em;\n\n  @media only screen and (max-width: ", ") {\n    position: absolute;\n    left: 1em;\n  }\n"]);

  _templateObject3$g = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$l() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 1em;\n  width: 2em;\n  height: 2em;\n  min-width: 2em;\n  min-height: 2em;\n  line-height: 1em;\n  \n  margin-right: 1.5em;\n\n  @media only screen and (min-width: ", ") {\n    display: none;\n  }  \n  \n  ", "\n  svg {\n    width: 2em;\n    height: 2em;\n    min-width: 2em;\n    min-height: 2em;\n    line-height: 1em;\n  }\n"]);

  _templateObject2$l = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$G() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 1em;\n  background-color: ", ";\n  align-items: center;\n  position: relative;\n  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.12);\n  z-index: 1; // adding this so the box-shadow shows even if another element below the header has a background-color declared\n\n  /* CSS specific to iOS devices */ \n  /* Adds padding only if on touch device and within react-native app */\n  @supports (-webkit-overflow-scrolling: touch) {\n    padding-top: ", ";\n  }\n\n  @media only screen and (min-width: ", ") {\n    padding-left: 1.5em;\n  }\n"]);

  _templateObject$G = function _templateObject() {
    return data;
  };

  return data;
}
var StyledHeader$1 = newStyled.div(_templateObject$G(), function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, function (_ref2) {
  var nativeAppTopInset = _ref2.nativeAppTopInset;
  return "".concat(nativeAppTopInset, "px") || '0.5em';
}, MIN_MOBILE_BREAKPOINT);
var StyledBrandLogo = newStyled(Link)(_templateObject2$l(), MIN_MOBILE_BREAKPOINT, function (_ref3) {
  var onClick = _ref3.onClick,
      to = _ref3.to,
      href = _ref3.href;
  return onClick || to || href ? 'cursor: pointer;' : '';
});
var StyledBackLink = newStyled(Link)(_templateObject3$g(), MAX_MOBILE_BREAKPOINT);
var StyledTitleContainer = newStyled.div(_templateObject4$8(), MAX_MOBILE_BREAKPOINT);

var MainSection = function MainSection(_ref4) {
  var backgroundColor = _ref4.backgroundColor,
      onClickLogo = _ref4.onClickLogo,
      onClickBack = _ref4.onClickBack,
      title = _ref4.title,
      color = _ref4.color,
      subtitle = _ref4.subtitle,
      subtitleColor = _ref4.subtitleColor,
      subtitleHasInfoIcon = _ref4.subtitleHasInfoIcon;
  return /*#__PURE__*/React__default.createElement(StyledHeader$1, {
    backgroundColor: backgroundColor,
    nativeAppTopInset: window.nativeAppTopInset
  }, onClickLogo && /*#__PURE__*/React__default.createElement(StyledBrandLogo, {
    onClick: onClickLogo
  }, /*#__PURE__*/React__default.createElement(HamburgerMenu, null)), onClickBack && /*#__PURE__*/React__default.createElement(StyledBackLink, {
    onClick: onClickBack
  }, /*#__PURE__*/React__default.createElement(ArrowLeft, {
    color: color
  })), /*#__PURE__*/React__default.createElement(StyledTitleContainer, null, /*#__PURE__*/React__default.createElement(Title, {
    text: title,
    color: color,
    subtitle: subtitle,
    subtitleColor: subtitleColor,
    subtitleHasInfoIcon: subtitleHasInfoIcon
  })));
};

MainSection.propTypes = {
  title: PropTypes__default.string.isRequired,
  color: PropTypes__default.string,
  subtitle: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.node]),
  subtitleColor: PropTypes__default.string,
  subtitleHasInfoIcon: PropTypes__default.bool,
  backgroundColor: PropTypes__default.string,
  onClickLogo: PropTypes__default.func,
  onClickBack: PropTypes__default.func
};
MainSection.defaultProps = {
  color: TEXT_DARK_COLOR,
  backgroundColor: WHITE_COLOR,
  subtitle: undefined,
  subtitleColor: undefined,
  subtitleHasInfoIcon: true,
  onClickLogo: undefined,
  onClickBack: undefined
};

function _templateObject4$9() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  position: absolute;\n  right: 1.5em;\n\n  @media only screen and (max-width: ", ") {\n    display: none;\n  }\n"]);

  _templateObject4$9 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$h() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  position: absolute;\n  left: 1em;\n\n  ", "\n"]);

  _templateObject3$h = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$m() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 0 2.5em;\n"]);

  _templateObject2$m = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$H() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0.5em;\n  background-color: ", ";\n  align-items: center;\n  position: relative;\n\n  /* CSS specific to iOS devices */ \n  /* Adds padding only if on touch device and within react-native app */\n  @supports (-webkit-overflow-scrolling: touch) {\n    padding-top: ", ";\n  }\n\n  ", "\n"]);

  _templateObject$H = function _templateObject() {
    return data;
  };

  return data;
}
var StyledHeader$2 = newStyled.div(_templateObject$H(), function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, function (_ref2) {
  var nativeAppTopInset = _ref2.nativeAppTopInset;
  return "".concat(nativeAppTopInset, "px") || '0.5em';
}, function (_ref3) {
  var isHiddenOnDesktop = _ref3.isHiddenOnDesktop;
  return isHiddenOnDesktop ? "\n        @media only screen and (min-width: ".concat(MIN_MOBILE_BREAKPOINT, ") {\n          display: none;\n        }\n        ") : '';
});
var StyledTitleContainer$1 = newStyled.div(_templateObject2$m());
var StyledBackLink$1 = newStyled(Link)(_templateObject3$h(), function (_ref4) {
  var isClickBackHiddenOnDesktop = _ref4.isClickBackHiddenOnDesktop;
  return isClickBackHiddenOnDesktop ? "\n        @media only screen and (min-width: ".concat(MIN_MOBILE_BREAKPOINT, ") {\n          display: none;\n        }\n        ") : '';
});
var StyledCloseLink$1 = newStyled(Link)(_templateObject4$9(), MAX_MOBILE_BREAKPOINT);

var SubSection = function SubSection(_ref5) {
  var backgroundColor = _ref5.backgroundColor,
      onClickBack = _ref5.onClickBack,
      onClickClose = _ref5.onClickClose,
      color = _ref5.color,
      title = _ref5.title,
      isHiddenOnDesktop = _ref5.isHiddenOnDesktop,
      isClickBackHiddenOnDesktop = _ref5.isClickBackHiddenOnDesktop;
  return /*#__PURE__*/React__default.createElement(StyledHeader$2, {
    backgroundColor: backgroundColor,
    isHiddenOnDesktop: isHiddenOnDesktop,
    nativeAppTopInset: window.nativeAppTopInset
  }, onClickBack && /*#__PURE__*/React__default.createElement(StyledBackLink$1, {
    onClick: onClickBack,
    isClickBackHiddenOnDesktop: isClickBackHiddenOnDesktop
  }, /*#__PURE__*/React__default.createElement(ArrowLeft, {
    color: color
  })), /*#__PURE__*/React__default.createElement(StyledTitleContainer$1, null, /*#__PURE__*/React__default.createElement(Title, {
    color: color,
    text: title,
    isCenteredOnDesktop: true
  })), onClickClose && /*#__PURE__*/React__default.createElement(StyledCloseLink$1, {
    onClick: onClickClose
  }, /*#__PURE__*/React__default.createElement(Clear, {
    color: color
  })));
};

SubSection.propTypes = {
  backgroundColor: PropTypes__default.string,
  onClickBack: PropTypes__default.func,
  onClickClose: PropTypes__default.func,
  color: PropTypes__default.string,
  title: PropTypes__default.string,
  isHiddenOnDesktop: PropTypes__default.bool,
  isClickBackHiddenOnDesktop: PropTypes__default.bool
};
SubSection.defaultProps = {
  title: PropTypes__default.string.isRequired,
  backgroundColor: WHITE_COLOR,
  onClickBack: undefined,
  onClickClose: undefined,
  color: TEXT_DARK_COLOR,
  isHiddenOnDesktop: false,
  isClickBackHiddenOnDesktop: false
};



var index$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MainSection: MainSection,
  SubSection: SubSection
});

var getBoundingClientRect = function getBoundingClientRect(element) {
  var _element$getBoundingC = element.getBoundingClientRect(),
      top = _element$getBoundingC.top,
      right = _element$getBoundingC.right,
      bottom = _element$getBoundingC.bottom,
      left = _element$getBoundingC.left,
      width = _element$getBoundingC.width,
      height = _element$getBoundingC.height,
      x = _element$getBoundingC.x,
      y = _element$getBoundingC.y;

  return {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: width,
    height: height,
    x: x,
    y: y
  };
};

var useDimensions = function useDimensions() {
  var ref = React.useRef();

  var _useState = React.useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      dimensions = _useState2[0],
      setDimensions = _useState2[1];

  React.useLayoutEffect(function () {
    setDimensions(getBoundingClientRect(ref.current)); // handleResize will work in any browser, but it has the drawback that it only
    // detects changes when you resize the page.
    // When a sibling or parent element causes the element to change size, the resize
    // listener will miss it.
    // For example, a hidden sibling element that is revealed on hover.
    // ResizeObserver catches that change, but not all browsers will have it.
    // Polyfills are CPU intensive, so if ResizeObserver doesn't exist, this
    // will compromise and only account for changes on window resizing.

    var resizeObserver;
    var handleResize;

    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === ref.current) {
            setDimensions(getBoundingClientRect(ref.current));
          }
        });
      });
      resizeObserver.observe(ref.current);
    } else {
      handleResize = throttle(function () {
        setDimensions(getBoundingClientRect(ref.current));
      }, 100);
      window.addEventListener('resize', handleResize);
    }

    return function () {
      if (handleResize) {
        window.removeEventListener('resize', handleResize);
      }

      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, [ref.current]);
  return [ref, dimensions];
};

var Circle = newStyled('div')(function (_ref) {
  var dotSizeInPixels = _ref.dotSizeInPixels,
      color = _ref.color;
  return {
    width: "".concat(dotSizeInPixels, "px"),
    height: "".concat(dotSizeInPixels, "px"),
    backgroundColor: color,
    borderRadius: '50%'
  };
});
var CircleRow = newStyled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'space-between',
  justifyContent: 'space-between'
});
var Container$4 = newStyled('div')(function (_ref2) {
  var userWidth = _ref2.userWidth;
  return {
    height: 'auto',
    // flexbox needs this
    minHeight: '100%',
    // non-flexbox needs this
    width: userWidth,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'space-between',
    justifyContent: 'space-between',
    alignSelf: 'stretch'
  };
});

var calculateRowColQuantity = function calculateRowColQuantity(_ref3) {
  var rows = _ref3.rows,
      cols = _ref3.cols,
      containerHeight = _ref3.containerHeight,
      containerWidth = _ref3.containerWidth,
      dotSizeInPixels = _ref3.dotSizeInPixels;
  var spacing = 0;
  var dimensions = {
    rowQuantity: 0,
    colQuantity: 0
  };

  if (rows) {
    // "Remove" a row when caculating spacing so that, with flexbox's space between,
    // dots are pushed the edge of the container.
    spacing = containerHeight / (rows - 1) - dotSizeInPixels; // Need an extra column to form the right "edge" of the pattern

    var colQuantity = spacing + dotSizeInPixels > 0 ? Math.round(containerWidth / spacing) + 1 : 0;
    dimensions = {
      rowQuantity: rows,
      colQuantity: colQuantity
    };
  }

  if (cols) {
    // "Remove" a column when caculating spacing so that, with flexbox's space between,
    // dots are pushed the edge of the container.
    spacing = containerWidth / (cols - 1) - dotSizeInPixels; // Need an extra row to form the bottom "edge" of the pattern

    var rowQuantity = spacing + dotSizeInPixels > 0 ? Math.floor(containerHeight / spacing) + 1 : 0;
    dimensions = {
      rowQuantity: rowQuantity,
      colQuantity: cols
    };
  }

  return dimensions;
};

var CircleGrid = function CircleGrid(_ref4) {
  var rows = _ref4.rows,
      cols = _ref4.cols,
      color = _ref4.color,
      dotSizeInPixels = _ref4.dotSizeInPixels,
      userWidth = _ref4.width,
      rest = _objectWithoutProperties(_ref4, ["rows", "cols", "color", "dotSizeInPixels", "width"]);

  var _useDimensions = useDimensions(),
      _useDimensions2 = _slicedToArray(_useDimensions, 2),
      ref = _useDimensions2[0],
      _useDimensions2$ = _useDimensions2[1],
      width = _useDimensions2$.width,
      height = _useDimensions2$.height;

  var _useState = React.useState(height),
      _useState2 = _slicedToArray(_useState, 2),
      containerHeight = _useState2[0],
      setContainerHeight = _useState2[1];

  var _useState3 = React.useState(width),
      _useState4 = _slicedToArray(_useState3, 2),
      containerWidth = _useState4[0],
      setContainerWidth = _useState4[1];

  React.useEffect(function () {
    setContainerHeight(height);
  }, [height]);
  React.useEffect(function () {
    setContainerWidth(width);
  }, [width]);

  var _calculateRowColQuant = calculateRowColQuantity({
    rows: rows,
    cols: cols,
    containerHeight: containerHeight,
    containerWidth: containerWidth,
    dotSizeInPixels: dotSizeInPixels
  }),
      rowQuantity = _calculateRowColQuant.rowQuantity,
      colQuantity = _calculateRowColQuant.colQuantity;

  return /*#__PURE__*/React__default.createElement(Container$4, _extends({
    ref: ref,
    userWidth: userWidth
  }, rest), _toConsumableArray(Array(rowQuantity)).map(function (row, x) {
    return /*#__PURE__*/React__default.createElement(CircleRow, {
      key: "circle-row-".concat(x)
    }, _toConsumableArray(Array(colQuantity)).map(function (col, y) {
      return /*#__PURE__*/React__default.createElement(Circle, {
        key: "circlr-col=".concat(y),
        color: color,
        dotSizeInPixels: dotSizeInPixels
      });
    }));
  }));
};

CircleGrid.propTypes = {
  rows: PropTypes__default.number,
  cols: PropTypes__default.number,
  color: PropTypes__default.string,
  dotSizeInPixels: PropTypes__default.number,
  width: PropTypes__default.string
};
CircleGrid.defaultProps = {
  width: '100%',
  rows: undefined,
  cols: undefined,
  color: WHITE_COLOR,
  dotSizeInPixels: 3
};

function _templateObject6$1() {
  var data = _taggedTemplateLiteral(["\n  font-family: 'Nunito';\n  font-weight: ", ";\n  color: ", ";\n  text-align: center;\n  margin: 0;\n  padding: 0 0.5em;\n\n  @media only screen and (max-width: ", ") {\n    line-height: 1.2em;\n  }\n"]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$4() {
  var data = _taggedTemplateLiteral(["\n  width: 59%;\n  padding-top: 59%;\n  display: block;\n  border-radius: 50%;\n  background-color: ", ";\n"]);

  _templateObject5$4 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$a() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 12.25% 0;\n  justify-content: center;\n\n  & > svg {\n    width: 59%;\n    height: 59%;\n  }\n"]);

  _templateObject4$a = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$i() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  width: 100%;\n"]);

  _templateObject3$i = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$n() {
  var data = _taggedTemplateLiteral(["\n  padding-top: ", ";\n  position: relative;\n"]);

  _templateObject2$n = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$I() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: ", ";\n  background-color: ", ";\n  cursor: pointer;\n  vertical-align: top;\n\n  ", "\n"]);

  _templateObject$I = function _templateObject() {
    return data;
  };

  return data;
}
var StyledToggle = newStyled.div(_templateObject$I(), function (_ref) {
  var width = _ref.width;
  return width;
}, function (_ref2) {
  var active = _ref2.active;
  return active ? WHITE_COLOR : NEUTRAL_COLOR_LEVEL_4;
}, function (_ref3) {
  var active = _ref3.active;
  return active ? "\n        box-shadow: 0px 15px 18px rgba(178, 173, 166, 0.21);\n        " : '';
});
var StyledScaledHeightContainer = newStyled.div(_templateObject2$n(), function (_ref4) {
  var active = _ref4.active;
  return active ? '135%' : '123%';
});
var StyledContentContainer$1 = newStyled.div(_templateObject3$i());
var IconContainer$2 = newStyled.div(_templateObject4$a());
var FallbackIcon = newStyled.span(_templateObject5$4(), function (_ref5) {
  var active = _ref5.active,
      iconBackgroundColor = _ref5.iconBackgroundColor,
      hovered = _ref5.hovered;
  return active || hovered ? iconBackgroundColor : NEUTRAL_COLOR_LEVEL_2;
});
var StyledText = newStyled.p(_templateObject6$1(), function (_ref6) {
  var active = _ref6.active;
  return active ? 'bold' : 'normal';
}, function (_ref7) {
  var disabled = _ref7.disabled;
  return disabled ? DISABLED_TOGGLE_TEXT_COLOR : 'inherit';
}, MAX_MOBILE_BREAKPOINT);

var calculateBackgroundColor = function calculateBackgroundColor(active, hovered, disabled, defaultColor) {
  if (disabled) {
    return DISABLED_TOGGLE_BACKGROUND_COLOR;
  }

  if (active || hovered) {
    return defaultColor;
  }

  return NEUTRAL_COLOR_LEVEL_2;
};

var calculateTextColor = function calculateTextColor(active, hovered, disabled) {
  if (disabled) {
    return DISABLED_TOGGLE_TEXT_COLOR;
  }

  if (active || hovered) {
    return WHITE_COLOR;
  }

  return TEXT_DARK_COLOR;
};

var computedProps = function computedProps(_ref8) {
  var type = _ref8.type,
      text = _ref8.text,
      iconBackgroundColor = _ref8.iconBackgroundColor,
      active = _ref8.active,
      icon = _ref8.icon,
      hovered = _ref8.hovered,
      disabled = _ref8.disabled;
  var props = {};

  switch (type) {
    case 'totalEnergyUsed':
      {
        props = {
          text: 'Total Energy Used',
          icon: LargeHouse,
          iconColor: calculateTextColor(active, hovered, disabled),
          iconBackgroundColor: calculateBackgroundColor(active, hovered, disabled, SECONDARY_COLOR)
        };
        break;
      }

    case 'produced':
      {
        props = {
          text: 'Produced',
          icon: LargePanels,
          iconColor: calculateTextColor(active, hovered, disabled),
          iconBackgroundColor: calculateBackgroundColor(active, hovered, disabled, IMPORTANT_COLOR)
        };
        break;
      }

    case 'batteryActivity':
      {
        props = {
          text: 'Battery Activity',
          icon: LargeBattery,
          iconColor: calculateTextColor(active, hovered, disabled),
          iconBackgroundColor: calculateBackgroundColor(active, hovered, disabled, PRIMARY_COLOR)
        };
        break;
      }

    case 'toGrid':
      {
        props = {
          text: 'To Grid',
          icon: LargeElectricPole,
          iconColor: calculateTextColor(active, hovered, disabled),
          iconBackgroundColor: calculateBackgroundColor(active, hovered, disabled, DARK_BLUE_COLOR)
        };
        break;
      }

    case 'inverter':
      {
        props = {
          text: 'Inverter',
          icon: LargeInverter,
          iconColor: calculateTextColor(active, hovered, disabled),
          iconBackgroundColor: calculateBackgroundColor(active, hovered, disabled, DARK_BLUE_COLOR)
        };
        break;
      }

    default:
      {
        props = {
          iconColor: calculateTextColor(active, hovered, disabled),
          iconBackgroundColor: calculateBackgroundColor(active, hovered, disabled, SECONDARY_COLOR)
        };
      }
  } // Override any "type" props


  if (text) {
    props.text = text;
  }

  if (icon) {
    props.icon = icon;
  }

  if (iconBackgroundColor) {
    props.iconBackgroundColor = iconBackgroundColor;
  }

  return props;
};

var Toggle = function Toggle(_ref9) {
  var type = _ref9.type,
      text = _ref9.text,
      iconBackgroundColor = _ref9.iconBackgroundColor,
      active = _ref9.active,
      icon = _ref9.icon,
      onClick = _ref9.onClick,
      disabled = _ref9.disabled,
      width = _ref9.width;

  var element = function element(hovered) {
    var _computedProps = computedProps({
      type: type,
      text: text,
      iconBackgroundColor: iconBackgroundColor,
      active: active,
      icon: icon,
      hovered: hovered,
      disabled: disabled
    }),
        computedText = _computedProps.text,
        computedIcon = _computedProps.icon,
        computedIconColor = _computedProps.iconColor,
        computedIconBackgroundColor = _computedProps.iconBackgroundColor;

    var Icon = computedIcon;
    var iconComponent = Icon ? /*#__PURE__*/React__default.createElement(Icon, {
      color: computedIconColor,
      backgroundColor: computedIconBackgroundColor
    }) : /*#__PURE__*/React__default.createElement(FallbackIcon, {
      active: active,
      iconBackgroundColor: computedIconBackgroundColor,
      hovered: hovered
    });
    return /*#__PURE__*/React__default.createElement(StyledToggle, {
      onClick: onClick,
      active: active,
      width: width
    }, /*#__PURE__*/React__default.createElement(StyledScaledHeightContainer, {
      active: active
    }, /*#__PURE__*/React__default.createElement(StyledContentContainer$1, null, /*#__PURE__*/React__default.createElement(IconContainer$2, null, iconComponent), /*#__PURE__*/React__default.createElement(StyledText, {
      active: active,
      disabled: disabled
    }, computedText))));
  };

  var _useHover = useHover(element),
      _useHover2 = _slicedToArray(_useHover, 1),
      hoverable = _useHover2[0];

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, hoverable);
};

Toggle.propTypes = {
  active: PropTypes__default.bool,
  disabled: PropTypes__default.bool,
  icon: PropTypes__default.func,
  iconBackgroundColor: PropTypes__default.string,
  onClick: PropTypes__default.func,
  text: PropTypes__default.string,
  type: PropTypes__default.string,
  width: PropTypes__default.string
};
Toggle.defaultProps = {
  active: false,
  disabled: false,
  icon: undefined,
  iconBackgroundColor: undefined,
  onClick: undefined,
  text: undefined,
  type: undefined,
  width: '10.625em'
};

function _templateObject5$5() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 1.25em;\n  cursor: pointer;\n"]);

  _templateObject5$5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$b() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n"]);

  _templateObject4$b = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$j() {
  var data = _taggedTemplateLiteral(["\n  font-size: 1.125em;\n  padding: .75em;\n  flex-grow: 1;\n"]);

  _templateObject3$j = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$o() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 0 0.75em;\n  background-color: ", ";\n"]);

  _templateObject2$o = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$J() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n  font-family: 'Untitled Sans';\n  font-weight: normal;\n  color: ", ";\n  background-color: ", ";\n\n"]);

  _templateObject$J = function _templateObject() {
    return data;
  };

  return data;
}
var StyledAlert = newStyled.div(_templateObject$J(), TEXT_DARK_COLOR, function (_ref) {
  var type = _ref.type;
  return type === 'warning' ? IMPORTANT_COLOR_LEVEL_4 : ERROR_COLOR_LEVEL_2;
});
var StyledIconContainer$3 = newStyled.div(_templateObject2$o(), function (_ref2) {
  var type = _ref2.type;
  return type === 'warning' ? IMPORTANT_COLOR : ERROR_COLOR;
});
var StyledText$1 = newStyled.div(_templateObject3$j());
var StyledLinkContainer = newStyled.div(_templateObject4$b());
var StyledLink$3 = newStyled(Link)(_templateObject5$5());

var Alert = function Alert(_ref3) {
  var text = _ref3.text,
      type = _ref3.type,
      onClickClose = _ref3.onClickClose;
  return /*#__PURE__*/React__default.createElement(StyledAlert, {
    type: type
  }, /*#__PURE__*/React__default.createElement(StyledIconContainer$3, {
    type: type
  }, /*#__PURE__*/React__default.createElement(ExclamationmarkCircle, {
    backgroundColor: WHITE_COLOR,
    color: "transparent"
  })), /*#__PURE__*/React__default.createElement(StyledText$1, null, text), onClickClose && /*#__PURE__*/React__default.createElement(StyledLinkContainer, null, /*#__PURE__*/React__default.createElement(StyledLink$3, {
    onClick: onClickClose
  }, /*#__PURE__*/React__default.createElement(Clear, {
    color: TEXT_DARK_COLOR
  }))));
};

Alert.propTypes = {
  text: PropTypes__default.string.isRequired,
  type: PropTypes__default.oneOf(['warning', 'error']),
  onClickClose: PropTypes__default.func
};
Alert.defaultProps = {
  type: 'error',
  onClickClose: undefined
};

function _templateObject3$k() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  flex-grow: 1;\n  font-family: 'Nunito';\n  font-weight: normal;\n  font-size: 1.125em;\n"]);

  _templateObject3$k = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$p() {
  var data = _taggedTemplateLiteral(["\n  flex-shrink: 1;\n\n  width: 3.45em;\n  height: 3.45em;\n  margin-right: 1.25em;\n  \n  svg {\n    width: 3.45em;\n    height: 3.45em;\n  }\n"]);

  _templateObject2$p = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$K() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  padding: 1em 1.25em;\n"]);

  _templateObject$K = function _templateObject() {
    return data;
  };

  return data;
}
var StyledContainer$9 = newStyled.div(_templateObject$K(), function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
});
var StyledIconContainer$4 = newStyled.div(_templateObject2$p());
var StyledContent = newStyled.div(_templateObject3$k(), function (_ref2) {
  var color = _ref2.color;
  return color;
});

var Banner$1 = function Banner(_ref3) {
  var icon = _ref3.icon,
      backgroundColor = _ref3.backgroundColor,
      color = _ref3.color,
      children = _ref3.children;
  var Icon = icon;
  return /*#__PURE__*/React__default.createElement(StyledContainer$9, {
    backgroundColor: backgroundColor
  }, Icon && /*#__PURE__*/React__default.createElement(StyledIconContainer$4, null, /*#__PURE__*/React__default.createElement(Icon, {
    backgroundColor: SECONDARY_COLOR,
    color: WHITE_COLOR
  })), /*#__PURE__*/React__default.createElement(StyledContent, {
    color: color
  }, children));
};

Banner$1.propTypes = {
  backgroundColor: PropTypes__default.string,
  color: PropTypes__default.string,
  children: PropTypes__default.node.isRequired,
  icon: PropTypes__default.func
};
Banner$1.defaultProps = {
  backgroundColor: DARK_BLUE_COLOR,
  color: WHITE_COLOR,
  icon: undefined
};

var _global = createCommonjsModule(function (module) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var _core = createCommonjsModule(function (module) {
var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});
var _core_1 = _core.version;

var _aFunction = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding

var _ctx = function (fn, that, length) {
  _aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var _isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject = function (it) {
  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var _descriptors = !_fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var document$1 = _global.document;
// typeof document.createElement is 'object' in old IE
var is = _isObject(document$1) && _isObject(document$1.createElement);
var _domCreate = function (it) {
  return is ? document$1.createElement(it) : {};
};

var _ie8DomDefine = !_descriptors && !_fails(function () {
  return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
});

// 7.1.1 ToPrimitive(input [, PreferredType])

// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var _toPrimitive = function (it, S) {
  if (!_isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP = Object.defineProperty;

var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject(O);
  P = _toPrimitive(P, true);
  _anObject(Attributes);
  if (_ie8DomDefine) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var _objectDp = {
	f: f
};

var _propertyDesc = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide = _descriptors ? function (object, key, value) {
  return _objectDp.f(object, key, _propertyDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty$e = {}.hasOwnProperty;
var _has = function (it, key) {
  return hasOwnProperty$e.call(it, key);
};

var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] : (_global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && _has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? _ctx(out, _global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) _hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
var _export = $export;

// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
_export(_export.S + _export.F * !_descriptors, 'Object', { defineProperty: _objectDp.f });

var $Object = _core.Object;
var defineProperty$3 = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};

var defineProperty$4 = createCommonjsModule(function (module) {
module.exports = { "default": defineProperty$3, __esModule: true };
});

unwrapExports(defineProperty$4);

var defineProperty$5 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _defineProperty2 = _interopRequireDefault(defineProperty$4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};
});

unwrapExports(defineProperty$5);

// 7.2.1 RequireObjectCoercible(argument)
var _defined = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

// 7.1.13 ToObject(argument)

var _toObject = function (it) {
  return Object(_defined(it));
};

var _library = true;

var _shared = createCommonjsModule(function (module) {
var SHARED = '__core-js_shared__';
var store = _global[SHARED] || (_global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: _core.version,
  mode:  'pure' ,
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});
});

var id = 0;
var px$1 = Math.random();
var _uid = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px$1).toString(36));
};

var shared = _shared('keys');

var _sharedKey = function (key) {
  return shared[key] || (shared[key] = _uid(key));
};

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


var IE_PROTO = _sharedKey('IE_PROTO');
var ObjectProto = Object.prototype;

var _objectGpo = Object.getPrototypeOf || function (O) {
  O = _toObject(O);
  if (_has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

// most Object methods by ES6 should accept primitives



var _objectSap = function (KEY, exec) {
  var fn = (_core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  _export(_export.S + _export.F * _fails(function () { fn(1); }), 'Object', exp);
};

// 19.1.2.9 Object.getPrototypeOf(O)



_objectSap('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return _objectGpo(_toObject(it));
  };
});

var getPrototypeOf$1 = _core.Object.getPrototypeOf;

var getPrototypeOf$2 = createCommonjsModule(function (module) {
module.exports = { "default": getPrototypeOf$1, __esModule: true };
});

unwrapExports(getPrototypeOf$2);

var classCallCheck = createCommonjsModule(function (module, exports) {

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
});

unwrapExports(classCallCheck);

var createClass = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _defineProperty2 = _interopRequireDefault(defineProperty$4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
});

unwrapExports(createClass);

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
var _toInteger = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

// true  -> String#at
// false -> String#codePointAt
var _stringAt = function (TO_STRING) {
  return function (that, pos) {
    var s = String(_defined(that));
    var i = _toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

var _redefine = _hide;

var toString$1 = {}.toString;

var _cof = function (it) {
  return toString$1.call(it).slice(8, -1);
};

// fallback for non-array-like ES3 and non-enumerable old V8 strings

// eslint-disable-next-line no-prototype-builtins
var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof(it) == 'String' ? it.split('') : Object(it);
};

// to indexed object, toObject with fallback for non-array-like ES3 strings


var _toIobject = function (it) {
  return _iobject(_defined(it));
};

// 7.1.15 ToLength

var min = Math.min;
var _toLength = function (it) {
  return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;
var _toAbsoluteIndex = function (index, length) {
  index = _toInteger(index);
  return index < 0 ? max(index + length, 0) : min$1(index, length);
};

// false -> Array#indexOf
// true  -> Array#includes



var _arrayIncludes = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = _toIobject($this);
    var length = _toLength(O.length);
    var index = _toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIndexOf = _arrayIncludes(false);
var IE_PROTO$1 = _sharedKey('IE_PROTO');

var _objectKeysInternal = function (object, names) {
  var O = _toIobject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO$1) _has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (_has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

// IE 8- don't enum bug keys
var _enumBugKeys = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

// 19.1.2.14 / 15.2.3.14 Object.keys(O)



var _objectKeys = Object.keys || function keys(O) {
  return _objectKeysInternal(O, _enumBugKeys);
};

var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  _anObject(O);
  var keys = _objectKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) _objectDp.f(O, P = keys[i++], Properties[P]);
  return O;
};

var document$2 = _global.document;
var _html = document$2 && document$2.documentElement;

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])



var IE_PROTO$2 = _sharedKey('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE$1 = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = _domCreate('iframe');
  var i = _enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  _html.appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE$1][_enumBugKeys[i]];
  return createDict();
};

var _objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE$1] = _anObject(O);
    result = new Empty();
    Empty[PROTOTYPE$1] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$2] = O;
  } else result = createDict();
  return Properties === undefined ? result : _objectDps(result, Properties);
};

var _wks = createCommonjsModule(function (module) {
var store = _shared('wks');

var Symbol = _global.Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
};

$exports.store = store;
});

var def = _objectDp.f;

var TAG = _wks('toStringTag');

var _setToStringTag = function (it, tag, stat) {
  if (it && !_has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
_hide(IteratorPrototype, _wks('iterator'), function () { return this; });

var _iterCreate = function (Constructor, NAME, next) {
  Constructor.prototype = _objectCreate(IteratorPrototype, { next: _propertyDesc(1, next) });
  _setToStringTag(Constructor, NAME + ' Iterator');
};

var ITERATOR = _wks('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var _iterDefine = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  _iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = _objectGpo($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      _setToStringTag(IteratorPrototype, TAG, true);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if (( FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    _hide(proto, ITERATOR, $default);
  }
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) _redefine(proto, key, methods[key]);
    } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

var $at = _stringAt(true);

// 21.1.3.27 String.prototype[@@iterator]()
_iterDefine(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

var _iterStep = function (done, value) {
  return { value: value, done: !!done };
};

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
var es6_array_iterator = _iterDefine(Array, 'Array', function (iterated, kind) {
  this._t = _toIobject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return _iterStep(1);
  }
  if (kind == 'keys') return _iterStep(0, index);
  if (kind == 'values') return _iterStep(0, O[index]);
  return _iterStep(0, [index, O[index]]);
}, 'values');

var TO_STRING_TAG = _wks('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = _global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) _hide(proto, TO_STRING_TAG, NAME);
}

var f$1 = _wks;

var _wksExt = {
	f: f$1
};

var iterator = _wksExt.f('iterator');

var iterator$1 = createCommonjsModule(function (module) {
module.exports = { "default": iterator, __esModule: true };
});

unwrapExports(iterator$1);

var _meta = createCommonjsModule(function (module) {
var META = _uid('meta');


var setDesc = _objectDp.f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !_fails(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!_isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!_has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!_has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !_has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};
});
var _meta_1 = _meta.KEY;
var _meta_2 = _meta.NEED;
var _meta_3 = _meta.fastKey;
var _meta_4 = _meta.getWeak;
var _meta_5 = _meta.onFreeze;

var defineProperty$6 = _objectDp.f;
var _wksDefine = function (name) {
  var $Symbol = _core.Symbol || (_core.Symbol =  {} );
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty$6($Symbol, name, { value: _wksExt.f(name) });
};

var f$2 = Object.getOwnPropertySymbols;

var _objectGops = {
	f: f$2
};

var f$3 = {}.propertyIsEnumerable;

var _objectPie = {
	f: f$3
};

// all enumerable object keys, includes symbols



var _enumKeys = function (it) {
  var result = _objectKeys(it);
  var getSymbols = _objectGops.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = _objectPie.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

// 7.2.2 IsArray(argument)

var _isArray = Array.isArray || function isArray(arg) {
  return _cof(arg) == 'Array';
};

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)

var hiddenKeys = _enumBugKeys.concat('length', 'prototype');

var f$4 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return _objectKeysInternal(O, hiddenKeys);
};

var _objectGopn = {
	f: f$4
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window

var gOPN = _objectGopn.f;
var toString$2 = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

var f$5 = function getOwnPropertyNames(it) {
  return windowNames && toString$2.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(_toIobject(it));
};

var _objectGopnExt = {
	f: f$5
};

var gOPD = Object.getOwnPropertyDescriptor;

var f$6 = _descriptors ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = _toIobject(O);
  P = _toPrimitive(P, true);
  if (_ie8DomDefine) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (_has(O, P)) return _propertyDesc(!_objectPie.f.call(O, P), O[P]);
};

var _objectGopd = {
	f: f$6
};

// ECMAScript 6 symbols shim





var META = _meta.KEY;





















var gOPD$1 = _objectGopd.f;
var dP$1 = _objectDp.f;
var gOPN$1 = _objectGopnExt.f;
var $Symbol = _global.Symbol;
var $JSON = _global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE$2 = 'prototype';
var HIDDEN = _wks('_hidden');
var TO_PRIMITIVE = _wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = _shared('symbol-registry');
var AllSymbols = _shared('symbols');
var OPSymbols = _shared('op-symbols');
var ObjectProto$1 = Object[PROTOTYPE$2];
var USE_NATIVE = typeof $Symbol == 'function' && !!_objectGops.f;
var QObject = _global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE$2] || !QObject[PROTOTYPE$2].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = _descriptors && _fails(function () {
  return _objectCreate(dP$1({}, 'a', {
    get: function () { return dP$1(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD$1(ObjectProto$1, key);
  if (protoDesc) delete ObjectProto$1[key];
  dP$1(it, key, D);
  if (protoDesc && it !== ObjectProto$1) dP$1(ObjectProto$1, key, protoDesc);
} : dP$1;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _objectCreate($Symbol[PROTOTYPE$2]);
  sym._k = tag;
  return sym;
};

var isSymbol$1 = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto$1) $defineProperty(OPSymbols, key, D);
  _anObject(it);
  key = _toPrimitive(key, true);
  _anObject(D);
  if (_has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!_has(it, HIDDEN)) dP$1(it, HIDDEN, _propertyDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (_has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _objectCreate(D, { enumerable: _propertyDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP$1(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  _anObject(it);
  var keys = _enumKeys(P = _toIobject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _objectCreate(it) : $defineProperties(_objectCreate(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = _toPrimitive(key, true));
  if (this === ObjectProto$1 && _has(AllSymbols, key) && !_has(OPSymbols, key)) return false;
  return E || !_has(this, key) || !_has(AllSymbols, key) || _has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = _toIobject(it);
  key = _toPrimitive(key, true);
  if (it === ObjectProto$1 && _has(AllSymbols, key) && !_has(OPSymbols, key)) return;
  var D = gOPD$1(it, key);
  if (D && _has(AllSymbols, key) && !(_has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN$1(_toIobject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!_has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto$1;
  var names = gOPN$1(IS_OP ? OPSymbols : _toIobject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (_has(AllSymbols, key = names[i++]) && (IS_OP ? _has(ObjectProto$1, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = _uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto$1) $set.call(OPSymbols, value);
      if (_has(this, HIDDEN) && _has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, _propertyDesc(1, value));
    };
    if (_descriptors && setter) setSymbolDesc(ObjectProto$1, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  _redefine($Symbol[PROTOTYPE$2], 'toString', function toString() {
    return this._k;
  });

  _objectGopd.f = $getOwnPropertyDescriptor;
  _objectDp.f = $defineProperty;
  _objectGopn.f = _objectGopnExt.f = $getOwnPropertyNames;
  _objectPie.f = $propertyIsEnumerable;
  _objectGops.f = $getOwnPropertySymbols;

  if (_descriptors && !_library) {
    _redefine(ObjectProto$1, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  _wksExt.f = function (name) {
    return wrap(_wks(name));
  };
}

_export(_export.G + _export.W + _export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)_wks(es6Symbols[j++]);

for (var wellKnownSymbols = _objectKeys(_wks.store), k = 0; wellKnownSymbols.length > k;) _wksDefine(wellKnownSymbols[k++]);

_export(_export.S + _export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return _has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol$1(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

_export(_export.S + _export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = _fails(function () { _objectGops.f(1); });

_export(_export.S + _export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return _objectGops.f(_toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && _export(_export.S + _export.F * (!USE_NATIVE || _fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!_isObject(replacer) && it === undefined || isSymbol$1(it)) return; // IE8 returns string on undefined
    if (!_isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol$1(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE$2][TO_PRIMITIVE] || _hide($Symbol[PROTOTYPE$2], TO_PRIMITIVE, $Symbol[PROTOTYPE$2].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
_setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
_setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
_setToStringTag(_global.JSON, 'JSON', true);

_wksDefine('asyncIterator');

_wksDefine('observable');

var symbol = _core.Symbol;

var symbol$1 = createCommonjsModule(function (module) {
module.exports = { "default": symbol, __esModule: true };
});

unwrapExports(symbol$1);

var _typeof_1$1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _iterator2 = _interopRequireDefault(iterator$1);



var _symbol2 = _interopRequireDefault(symbol$1);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};
});

unwrapExports(_typeof_1$1);

var possibleConstructorReturn = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _typeof3 = _interopRequireDefault(_typeof_1$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};
});

unwrapExports(possibleConstructorReturn);

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */


var check = function (O, proto) {
  _anObject(O);
  if (!_isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
var _setProto = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = _ctx(Function.call, _objectGopd.f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

// 19.1.3.19 Object.setPrototypeOf(O, proto)

_export(_export.S, 'Object', { setPrototypeOf: _setProto.set });

var setPrototypeOf = _core.Object.setPrototypeOf;

var setPrototypeOf$1 = createCommonjsModule(function (module) {
module.exports = { "default": setPrototypeOf, __esModule: true };
});

unwrapExports(setPrototypeOf$1);

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
_export(_export.S, 'Object', { create: _objectCreate });

var $Object$1 = _core.Object;
var create$1 = function create(P, D) {
  return $Object$1.create(P, D);
};

var create$2 = createCommonjsModule(function (module) {
module.exports = { "default": create$1, __esModule: true };
});

unwrapExports(create$2);

var inherits = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _setPrototypeOf2 = _interopRequireDefault(setPrototypeOf$1);



var _create2 = _interopRequireDefault(create$2);



var _typeof3 = _interopRequireDefault(_typeof_1$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};
});

unwrapExports(inherits);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var NODE_ENV = process.env.NODE_ENV;

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

var invariant_1 = invariant;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

var _overRest = overRest;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !_defineProperty$3 ? identity_1 : function(func, string) {
  return _defineProperty$3(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant_1(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString;

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = _shortOut(_baseSetToString);

var _setToString = setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return _setToString(_overRest(func, start, identity_1), func + '');
}

var _baseRest = baseRest;

/** Used to store function metadata. */
var metaMap = _WeakMap && new _WeakMap;

var _metaMap = metaMap;

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !_metaMap ? identity_1 : function(func, data) {
  _metaMap.set(func, data);
  return func;
};

var _baseSetData = baseSetData;

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = _baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject_1(result) ? result : thisBinding;
  };
}

var _createCtor = createCtor;

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = _createCtor(func);

  function wrapper() {
    var fn = (this && this !== _root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

var _createBind = createBind;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax$1(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

var _composeArgs = composeArgs;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$2 = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax$2(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

var _composeArgsRight = composeArgsRight;

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

var _countHolders = countHolders;

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

var _baseLodash = baseLodash;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = _baseCreate(_baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

var _LazyWrapper = LazyWrapper;

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop$1() {
  // No operation performed.
}

var noop_1 = noop$1;

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !_metaMap ? noop_1 : function(func) {
  return _metaMap.get(func);
};

var _getData = getData;

/** Used to lookup unminified function names. */
var realNames = {};

var _realNames = realNames;

/** Used for built-in method references. */
var objectProto$g = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$f = objectProto$g.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = _realNames[result],
      length = hasOwnProperty$f.call(_realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

var _getFuncName = getFuncName;

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = _baseCreate(_baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

var _LodashWrapper = LodashWrapper;

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof _LazyWrapper) {
    return wrapper.clone();
  }
  var result = new _LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = _copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

var _wrapperClone = wrapperClone;

/** Used for built-in method references. */
var objectProto$h = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$g = objectProto$h.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike_1(value) && !isArray_1(value) && !(value instanceof _LazyWrapper)) {
    if (value instanceof _LodashWrapper) {
      return value;
    }
    if (hasOwnProperty$g.call(value, '__wrapped__')) {
      return _wrapperClone(value);
    }
  }
  return new _LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = _baseLodash.prototype;
lodash.prototype.constructor = lodash;

var wrapperLodash = lodash;

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = _getFuncName(func),
      other = wrapperLodash[funcName];

  if (typeof other != 'function' || !(funcName in _LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = _getData(other);
  return !!data && func === data[0];
}

var _isLaziable = isLaziable;

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = _shortOut(_baseSetData);

var _setData = setData;

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

var _getWrapDetails = getWrapDetails;

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

var _insertWrapDetails = insertWrapDetails;

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

var _baseFindIndex = baseFindIndex;

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

var _baseIsNaN = baseIsNaN;

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

var _strictIndexOf = strictIndexOf;

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? _strictIndexOf(array, value, fromIndex)
    : _baseFindIndex(array, _baseIsNaN, fromIndex);
}

var _baseIndexOf = baseIndexOf;

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && _baseIndexOf(array, value, 0) > -1;
}

var _arrayIncludes$1 = arrayIncludes;

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$1 = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG$1],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  _arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !_arrayIncludes$1(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

var _updateWrapDetails = updateWrapDetails;

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return _setToString(wrapper, _insertWrapDetails(source, _updateWrapDetails(_getWrapDetails(source), bitmask)));
}

var _setWrapToString = setWrapToString;

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$2 = 1,
    WRAP_BIND_KEY_FLAG$1 = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG$1 = 8,
    WRAP_PARTIAL_FLAG$1 = 32,
    WRAP_PARTIAL_RIGHT_FLAG$1 = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG$1,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG$1 : WRAP_PARTIAL_RIGHT_FLAG$1);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG$1 : WRAP_PARTIAL_FLAG$1);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG$2 | WRAP_BIND_KEY_FLAG$1);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (_isLaziable(func)) {
    _setData(result, newData);
  }
  result.placeholder = placeholder;
  return _setWrapToString(result, func, bitmask);
}

var _createRecurry = createRecurry;

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

var _getHolder = getHolder;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = _copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = _isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

var _reorder = reorder;

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

var _replaceHolders = replaceHolders;

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$3 = 1,
    WRAP_BIND_KEY_FLAG$2 = 2,
    WRAP_CURRY_FLAG$2 = 8,
    WRAP_CURRY_RIGHT_FLAG$1 = 16,
    WRAP_ARY_FLAG$1 = 128,
    WRAP_FLIP_FLAG$1 = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG$1,
      isBind = bitmask & WRAP_BIND_FLAG$3,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG$2,
      isCurried = bitmask & (WRAP_CURRY_FLAG$2 | WRAP_CURRY_RIGHT_FLAG$1),
      isFlip = bitmask & WRAP_FLIP_FLAG$1,
      Ctor = isBindKey ? undefined : _createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = _getHolder(wrapper),
          holdersCount = _countHolders(args, placeholder);
    }
    if (partials) {
      args = _composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = _composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = _replaceHolders(args, placeholder);
      return _createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = _reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== _root && this instanceof wrapper) {
      fn = Ctor || _createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

var _createHybrid = createHybrid;

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = _createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = _getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : _replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return _createRecurry(
        func, bitmask, _createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== _root && this instanceof wrapper) ? Ctor : func;
    return _apply(fn, this, args);
  }
  return wrapper;
}

var _createCurry = createCurry;

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$4 = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG$4,
      Ctor = _createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== _root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return _apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

var _createPartial = createPartial;

/** Used as the internal argument placeholder. */
var PLACEHOLDER$1 = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$5 = 1,
    WRAP_BIND_KEY_FLAG$3 = 2,
    WRAP_CURRY_BOUND_FLAG$1 = 4,
    WRAP_CURRY_FLAG$3 = 8,
    WRAP_ARY_FLAG$2 = 128,
    WRAP_REARG_FLAG$1 = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin$1 = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG$5 | WRAP_BIND_KEY_FLAG$3 | WRAP_ARY_FLAG$2);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG$2) && (bitmask == WRAP_CURRY_FLAG$3)) ||
    ((srcBitmask == WRAP_ARY_FLAG$2) && (bitmask == WRAP_REARG_FLAG$1) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG$2 | WRAP_REARG_FLAG$1)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG$3));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG$5) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG$5 ? 0 : WRAP_CURRY_BOUND_FLAG$1;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? _composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? _replaceHolders(data[3], PLACEHOLDER$1) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? _composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? _replaceHolders(data[5], PLACEHOLDER$1) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG$2) {
    data[8] = data[8] == null ? source[8] : nativeMin$1(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

var _mergeData = mergeData;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol_1(value)) {
    return NAN;
  }
  if (isObject_1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject_1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var toNumber_1 = toNumber;

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber_1(value);
  if (value === INFINITY$2 || value === -INFINITY$2) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

var toFinite_1 = toFinite;

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite_1(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

var toInteger_1 = toInteger;

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$6 = 1,
    WRAP_BIND_KEY_FLAG$4 = 2,
    WRAP_CURRY_FLAG$4 = 8,
    WRAP_CURRY_RIGHT_FLAG$2 = 16,
    WRAP_PARTIAL_FLAG$2 = 32,
    WRAP_PARTIAL_RIGHT_FLAG$2 = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$3 = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG$4;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG$2 | WRAP_PARTIAL_RIGHT_FLAG$2);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax$3(toInteger_1(ary), 0);
  arity = arity === undefined ? arity : toInteger_1(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG$2) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : _getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    _mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax$3(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG$4 | WRAP_CURRY_RIGHT_FLAG$2)) {
    bitmask &= ~(WRAP_CURRY_FLAG$4 | WRAP_CURRY_RIGHT_FLAG$2);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG$6) {
    var result = _createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG$4 || bitmask == WRAP_CURRY_RIGHT_FLAG$2) {
    result = _createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG$2 || bitmask == (WRAP_BIND_FLAG$6 | WRAP_PARTIAL_FLAG$2)) && !holders.length) {
    result = _createPartial(func, bitmask, thisArg, partials);
  } else {
    result = _createHybrid.apply(undefined, newData);
  }
  var setter = data ? _baseSetData : _setData;
  return _setWrapToString(setter(result, newData), func, bitmask);
}

var _createWrap = createWrap;

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$7 = 1,
    WRAP_PARTIAL_FLAG$3 = 32;

/**
 * Creates a function that invokes `func` with the `this` binding of `thisArg`
 * and `partials` prepended to the arguments it receives.
 *
 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for partially applied arguments.
 *
 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
 * property of bound functions.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * function greet(greeting, punctuation) {
 *   return greeting + ' ' + this.user + punctuation;
 * }
 *
 * var object = { 'user': 'fred' };
 *
 * var bound = _.bind(greet, object, 'hi');
 * bound('!');
 * // => 'hi fred!'
 *
 * // Bound with placeholders.
 * var bound = _.bind(greet, object, _, '!');
 * bound('hi');
 * // => 'hi fred!'
 */
var bind = _baseRest(function(func, thisArg, partials) {
  var bitmask = WRAP_BIND_FLAG$7;
  if (partials.length) {
    var holders = _replaceHolders(partials, _getHolder(bind));
    bitmask |= WRAP_PARTIAL_FLAG$3;
  }
  return _createWrap(func, bitmask, thisArg, partials, holders);
});

// Assign default placeholders.
bind.placeholder = {};

var bind_1 = bind;

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike_1(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

var _createBaseEach = createBaseEach;

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = _createBaseEach(_baseForOwn);

var _baseEach = baseEach;

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

var _baseReduce = baseReduce;

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray_1(collection) ? _arrayReduce : _baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, _baseIteratee(iteratee), accumulator, initAccum, _baseEach);
}

var reduce_1 = reduce;

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity_1;
}

var _castFunction = castFunction;

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach$1(collection, iteratee) {
  var func = isArray_1(collection) ? _arrayEach : _baseEach;
  return func(collection, _castFunction(iteratee));
}

var forEach_1 = forEach$1;

/**
 * Converts the first character of `string` to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.lowerFirst('Fred');
 * // => 'fred'
 *
 * _.lowerFirst('FRED');
 * // => 'fRED'
 */
var lowerFirst = _createCaseFirst('toLowerCase');

var lowerFirst_1 = lowerFirst;

var MapChildHelper = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true,
});



var _bind3 = _interopRequireDefault(bind_1);



var _isFunction3 = _interopRequireDefault(isFunction_1);



var _reduce4 = _interopRequireDefault(reduce_1);



var _forEach3 = _interopRequireDefault(forEach_1);



var _lowerFirst3 = _interopRequireDefault(lowerFirst_1);



var _has3 = _interopRequireDefault(has_1);

exports.construct = construct;
exports.componentDidMount = componentDidMount;
exports.componentDidUpdate = componentDidUpdate;
exports.componentWillUnmount = componentWillUnmount;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/* global google */
/* eslint-disable no-param-reassign */
function rdcUncontrolledAndControlledProps(acc, value, key) {
  if ((0, _has3.default)(acc.prevProps, key)) {
    var match = key.match(/^default(\S+)/);
    if (match) {
      var unprefixedKey = (0, _lowerFirst3.default)(match[1]);
      if (!(0, _has3.default)(acc.nextProps, unprefixedKey)) {
        acc.nextProps[unprefixedKey] = acc.prevProps[key];
      }
    } else {
      acc.nextProps[key] = acc.prevProps[key];
    }
  }
  return acc
}

function applyUpdaterToNextProps(updaterMap, prevProps, nextProps, instance) {
(0, _forEach3.default)(updaterMap, function(fn, key) {
    var nextValue = nextProps[key];
    if (nextValue !== prevProps[key]) {
      fn(instance, nextValue);
    }
  });
}

function construct(propTypes, updaterMap, prevProps, instance) {
  var _reduce2 = (0, _reduce4.default)(
      propTypes,
      rdcUncontrolledAndControlledProps,
      {
        nextProps: {},
        prevProps: prevProps,
      }
    ),
    nextProps = _reduce2.nextProps;

  applyUpdaterToNextProps(
    updaterMap,
    {
      /* empty prevProps for construct */
    },
    nextProps,
    instance
  );
}

function componentDidMount(component, instance, eventMap) {
  registerEvents(component, instance, eventMap);
}

function componentDidUpdate(
  component,
  instance,
  eventMap,
  updaterMap,
  prevProps
) {
  component.unregisterAllEvents();
  applyUpdaterToNextProps(updaterMap, prevProps, component.props, instance);
  registerEvents(component, instance, eventMap);
}

function componentWillUnmount(component) {
  component.unregisterAllEvents();
}

function registerEvents(component, instance, eventMap) {
  var registeredList = (0, _reduce4.default)(
    eventMap,
    function(acc, googleEventName, onEventName) {
      if ((0, _isFunction3.default)(component.props[onEventName])) {
        acc.push(
          google.maps.event.addListener(
            instance,
            googleEventName,
            component.props[onEventName]
          )
        );
      }
      return acc
    },
    []
  );

  component.unregisterAllEvents = (0, _bind3.default)(
    _forEach3.default,
    null,
    registeredList,
    unregisterEvent
  );
}

function unregisterEvent(registered) {
  google.maps.event.removeListener(registered);
}
});

unwrapExports(MapChildHelper);
var MapChildHelper_1 = MapChildHelper.construct;
var MapChildHelper_2 = MapChildHelper.componentDidMount;
var MapChildHelper_3 = MapChildHelper.componentDidUpdate;
var MapChildHelper_4 = MapChildHelper.componentWillUnmount;

var constants = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true,
});
var MAP = (exports.MAP = "__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED");

// export const SKELETON = `__SECRET_SKELETON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED`;

var MARKER = (exports.MARKER =
  "__SECRET_MARKER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED");

var MARKER_WITH_LABEL = (exports.MARKER_WITH_LABEL =
  "__SECRET_MARKER_WITH_LABEL_DO_NOT_USE_OR_YOU_WILL_BE_FIRED");

var RECTANGLE = (exports.RECTANGLE =
  "__SECRET_RECTANGLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED");

var POLYLINE = (exports.POLYLINE =
  "__SECRET_POLYLINE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED");

var POLYGON = (exports.POLYGON =
  "__SECRET_POLYGON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED");

var CIRCLE = (exports.CIRCLE =
  "__SECRET_CIRCLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED");

var KML_LAYER = (exports.KML_LAYER =
  "__SECRET_KML_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED");

var DIRECTIONS_RENDERER = (exports.DIRECTIONS_RENDERER =
  "__SECRET_DIRECTIONS_RENDERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED");

var HEATMAP_LAYER = (exports.HEATMAP_LAYER =
  "__SECRET_HEATMAP_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED");

var FUSION_TABLES_LAYER = (exports.FUSION_TABLES_LAYER =
  "__SECRET_FUSION_TABLES_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED");

var ANCHOR = (exports.ANCHOR =
  "__SECRET_ANCHOR_DO_NOT_USE_OR_YOU_WILL_BE_FIRED");

var INFO_WINDOW = (exports.INFO_WINDOW =
  "__SECRET_INFO_WINDOW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED");

var OVERLAY_VIEW = (exports.OVERLAY_VIEW =
  "__SECRET_OVERLAY_VIEW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED");

var GROUND_LAYER = (exports.GROUND_LAYER =
  "__SECRET_GROUND_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED");

var DRAWING_MANAGER = (exports.DRAWING_MANAGER =
  "__SECRET_DRAWING_MANAGER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED");

var SEARCH_BOX = (exports.SEARCH_BOX =
  "__SECRET_SEARCH_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED");

var MARKER_CLUSTERER = (exports.MARKER_CLUSTERER =
  "__SECRET_MARKER_CLUSTERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED");

var INFO_BOX = (exports.INFO_BOX =
  "__SECRET_INFO_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED");

var TRAFFIC_LAYER = (exports.TRAFFIC_LAYER =
  "__SECRET_TRAFFIC_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED");

var STREET_VIEW_PANORAMA = (exports.STREET_VIEW_PANORAMA =
  "__SECRET_STREET_VIEW_PANORAMA_DO_NOT_USE_OR_YOU_WILL_BE_FIRED");

var BICYCLING_LAYER = (exports.BICYCLING_LAYER =
  "__SECRET_BICYCLING_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED");
});

unwrapExports(constants);
var constants_1 = constants.MAP;
var constants_2 = constants.MARKER;
var constants_3 = constants.MARKER_WITH_LABEL;
var constants_4 = constants.RECTANGLE;
var constants_5 = constants.POLYLINE;
var constants_6 = constants.POLYGON;
var constants_7 = constants.CIRCLE;
var constants_8 = constants.KML_LAYER;
var constants_9 = constants.DIRECTIONS_RENDERER;
var constants_10 = constants.HEATMAP_LAYER;
var constants_11 = constants.FUSION_TABLES_LAYER;
var constants_12 = constants.ANCHOR;
var constants_13 = constants.INFO_WINDOW;
var constants_14 = constants.OVERLAY_VIEW;
var constants_15 = constants.GROUND_LAYER;
var constants_16 = constants.DRAWING_MANAGER;
var constants_17 = constants.SEARCH_BOX;
var constants_18 = constants.MARKER_CLUSTERER;
var constants_19 = constants.INFO_BOX;
var constants_20 = constants.TRAFFIC_LAYER;
var constants_21 = constants.STREET_VIEW_PANORAMA;
var constants_22 = constants.BICYCLING_LAYER;

var StandaloneSearchBox_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true,
});
exports.StandaloneSearchBox = undefined;



var _defineProperty3 = _interopRequireDefault(defineProperty$5);



var _getPrototypeOf2 = _interopRequireDefault(getPrototypeOf$2);



var _classCallCheck3 = _interopRequireDefault(classCallCheck);



var _createClass3 = _interopRequireDefault(createClass);



var _possibleConstructorReturn3 = _interopRequireDefault(
  possibleConstructorReturn
);



var _inherits3 = _interopRequireDefault(inherits);



var _invariant2 = _interopRequireDefault(invariant_1);



var _react2 = _interopRequireDefault(React__default);



var _reactDom2 = _interopRequireDefault(ReactDOM__default);



var _propTypes2 = _interopRequireDefault(PropTypes__default);





function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.places.SearchBox` without the map
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#SearchBox
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var SearchBox = (function(_React$PureComponent) {
(0, _inherits3.default)(SearchBox, _React$PureComponent);

  function SearchBox() {
    var _ref;

    var _temp, _this, _ret

    ;(0, _classCallCheck3.default)(this, SearchBox);

    for (
      var _len = arguments.length, args = Array(_len), _key = 0;
      _key < _len;
      _key++
    ) {
      args[_key] = arguments[_key];
    }

    return (
      (_ret = ((_temp = ((_this = (0, _possibleConstructorReturn3.default)(
        this,
        (_ref =
          SearchBox.__proto__ ||
          (0, _getPrototypeOf2.default)(SearchBox)).call.apply(
          _ref,
          [this].concat(args)
        )
      )),
      _this)),
      (_this.state = (0, _defineProperty3.default)(
        {},
        constants.SEARCH_BOX,
        null
      )),
      _temp)),
      (0, _possibleConstructorReturn3.default)(_this, _ret)
    )
  }
(0, _createClass3.default)(SearchBox, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
(0, _invariant2.default)(
          google.maps.places,
          'Did you include "libraries=places" in the URL?'
        );
        var element = _reactDom2.default.findDOMNode(this);
        /*
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#SearchBox
       */
        var searchBox = new google.maps.places.SearchBox(
          element.querySelector("input") || element
        )
        ;(0, MapChildHelper.construct)(
          SearchBox.propTypes,
          updaterMap,
          this.props,
          searchBox
        )

        ;(0, MapChildHelper.componentDidMount)(this, searchBox, eventMap);
        this.setState(
          (0, _defineProperty3.default)({}, constants.SEARCH_BOX, searchBox)
        );
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
(0, MapChildHelper.componentDidUpdate)(
          this,
          this.state[constants.SEARCH_BOX],
          eventMap,
          updaterMap,
          prevProps
        );
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
(0, MapChildHelper.componentWillUnmount)(this);
      },
    },
    {
      key: "render",
      value: function render() {
        return _react2.default.Children.only(this.props.children)
      },

      /**
       * Returns the bounds to which query predictions are biased.
       * @type LatLngBounds
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.state[constants.SEARCH_BOX].getBounds()
      },

      /**
       * Returns the query selected by the user, or `null` if no places have been found yet, to be used with `places_changed` event.
       * @type Array<PlaceResult>nullplaces_changed
       * @public
       */
    },
    {
      key: "getPlaces",
      value: function getPlaces() {
        return this.state[constants.SEARCH_BOX].getPlaces()
      },
    },
  ]);
  return SearchBox
})(_react2.default.PureComponent);

SearchBox.displayName = "StandaloneSearchBox";
SearchBox.propTypes = {
  /**
   * @type LatLngBounds|LatLngBoundsLiteral
   */
  defaultBounds: _propTypes2.default.any,

  /**
   * @type LatLngBounds|LatLngBoundsLiteral
   */
  bounds: _propTypes2.default.any,

  /**
   * function
   */
  onPlacesChanged: _propTypes2.default.func,
};
var StandaloneSearchBox = (exports.StandaloneSearchBox = SearchBox);

exports.default = StandaloneSearchBox;

var eventMap = {
  onPlacesChanged: "places_changed",
};

var updaterMap = {
  bounds: function bounds(instance, _bounds) {
    instance.setBounds(_bounds);
  },
};
});

unwrapExports(StandaloneSearchBox_1);
var StandaloneSearchBox_2 = StandaloneSearchBox_1.StandaloneSearchBox;

var GooglePlacesSearchBox = reactGoogleMaps.withScriptjs(function (_ref) {
  var children = _ref.children,
      setSearchRef = _ref.setSearchRef,
      onLocationChange = _ref.onLocationChange;
  return /*#__PURE__*/React__default.createElement(StandaloneSearchBox_2, {
    ref: function ref(node) {
      return setSearchRef(node);
    },
    onPlacesChanged: onLocationChange,
    bounds: {
      south: 18.5,
      west: -161,
      north: 49.5,
      east: -67
    }
  }, children);
});

var WrappedGooglePlacesSearchBox = function WrappedGooglePlacesSearchBox(_ref2) {
  var mapApiKey = _ref2.mapApiKey,
      mapUrl = _ref2.mapUrl,
      onLocationChange = _ref2.onLocationChange,
      props = _objectWithoutProperties(_ref2, ["mapApiKey", "mapUrl", "onLocationChange"]);

  var _useState = React.useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      searchRef = _useState2[0],
      setSearchRef = _useState2[1];

  var url = "".concat(mapUrl, "?key=").concat(mapApiKey, "&v=3.exp&libraries=geometry,drawing,places");

  var localChange = function localChange() {
    onLocationChange(searchRef.getPlaces());
  };

  return /*#__PURE__*/React__default.createElement(GooglePlacesSearchBox, _extends({
    googleMapURL: url,
    mapUrl: url,
    loadingElement: /*#__PURE__*/React__default.createElement("div", null),
    setSearchRef: setSearchRef,
    onLocationChange: localChange
  }, props));
};

WrappedGooglePlacesSearchBox.propTypes = {
  mapApiKey: PropTypes__default.string.isRequired,
  mapUrl: PropTypes__default.string.isRequired,
  onLocationChange: PropTypes__default.func.isRequired
};
GooglePlacesSearchBox.propTypes = {
  children: PropTypes__default.shape({}),
  onLocationChange: PropTypes__default.func,
  mapUrl: PropTypes__default.string.isRequired
};
GooglePlacesSearchBox.defaultProps = {
  children: [],
  onLocationChange: function onLocationChange() {
    return null;
  }
};

var AddressSelector = function AddressSelector(_ref) {
  var customInput = _ref.customInput,
      disabled = _ref.disabled,
      mapApiKey = _ref.mapApiKey,
      mapUrl = _ref.mapUrl,
      name = _ref.name,
      onLocationChange = _ref.onLocationChange,
      placeholder = _ref.placeholder,
      props = _objectWithoutProperties(_ref, ["customInput", "disabled", "mapApiKey", "mapUrl", "name", "onLocationChange", "placeholder"]);

  return /*#__PURE__*/React__default.createElement(WrappedGooglePlacesSearchBox, {
    onLocationChange: onLocationChange,
    mapApiKey: mapApiKey,
    mapUrl: mapUrl
  }, /*#__PURE__*/React__default.createElement(formik.Field, _extends({
    type: "text",
    component: customInput || Input,
    name: name,
    placeholder: placeholder,
    disabled: disabled // disable autofill vs autocomplete for chome: https://stackoverflow.com/questions/47775041/disable-autofill-in-chrome-63#answer-47822599
    ,
    autoComplete: "new-password"
  }, props)));
};

AddressSelector.propTypes = {
  customInput: PropTypes__default.elementType,
  disabled: PropTypes__default.bool,
  mapApiKey: PropTypes__default.string.isRequired,
  mapUrl: PropTypes__default.string.isRequired,
  name: PropTypes__default.string.isRequired,
  onLocationChange: PropTypes__default.func.isRequired,
  placeholder: PropTypes__default.string
};
AddressSelector.defaultProps = {
  customInput: null,
  disabled: false,
  placeholder: ''
};

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.shape({
  enter: PropTypes__default.number,
  exit: PropTypes__default.number,
  appear: PropTypes__default.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.shape({
  enter: PropTypes__default.string,
  exit: PropTypes__default.string,
  active: PropTypes__default.string
}), PropTypes__default.shape({
  enter: PropTypes__default.string,
  enterDone: PropTypes__default.string,
  enterActive: PropTypes__default.string,
  exit: PropTypes__default.string,
  exitDone: PropTypes__default.string,
  exitActive: PropTypes__default.string
})]) : null;

var TransitionGroupContext = React__default.createContext(null);

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM__default.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM__default.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = _objectWithoutPropertiesLoose$1(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React__default.cloneElement(React__default.Children.only(children), childProps))
    );
  };

  return Transition;
}(React__default.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes__default.shape({
    current: typeof Element === 'undefined' ? PropTypes__default.any : PropTypes__default.instanceOf(Element)
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes__default.oneOfType([PropTypes__default.func.isRequired, PropTypes__default.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes__default.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes__default.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes__default.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes__default.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes__default.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes__default.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes__default.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes__default.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes__default.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes__default.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes__default.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes__default.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes__default.func
} : {}; // Name the function so it is clearer in the documentation

function noop$2() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop$2,
  onEntering: noop$2,
  onEntered: noop$2,
  onExit: noop$2,
  onExiting: noop$2,
  onExited: noop$2
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;

function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    delay: style.transitionDelay
  };
}

var styles$2 = function styles(theme) {
  return {
    /* Styles applied to the container element. */
    container: {
      height: 0,
      overflow: 'hidden',
      transition: theme.transitions.create('height')
    },

    /* Styles applied to the container element when the transition has entered. */
    entered: {
      height: 'auto',
      overflow: 'visible'
    },

    /* Styles applied to the container element when the transition has exited and `collapsedHeight` != 0px. */
    hidden: {
      visibility: 'hidden'
    },

    /* Styles applied to the outer wrapper element. */
    wrapper: {
      // Hack to get children with a negative margin to not falsify the height computation.
      display: 'flex'
    },

    /* Styles applied to the inner wrapper element. */
    wrapperInner: {
      width: '100%'
    }
  };
};
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/components/steppers/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Collapse = /*#__PURE__*/React.forwardRef(function Collapse(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$collapsedHeigh = props.collapsedHeight,
      collapsedHeightProp = _props$collapsedHeigh === void 0 ? '0px' : _props$collapsedHeigh,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? duration.standard : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Transition : _props$TransitionComp,
      other = _objectWithoutProperties$1(props, ["children", "classes", "className", "collapsedHeight", "component", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var theme = useTheme$1();
  var timer = React.useRef();
  var wrapperRef = React.useRef(null);
  var autoTransitionDuration = React.useRef();
  var collapsedHeight = typeof collapsedHeightProp === 'number' ? "".concat(collapsedHeightProp, "px") : collapsedHeightProp;
  React.useEffect(function () {
    return function () {
      clearTimeout(timer.current);
    };
  }, []);
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = React.useRef(null);
  var handleRef = useForkRef(ref, enableStrictModeCompat ? nodeRef : undefined);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = _slicedToArray$1(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    node.style.height = collapsedHeight;

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntering = normalizedTransitionCallback(function (node, isAppearing) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;

    var _getTransitionProps = getTransitionProps({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    }),
        transitionDuration = _getTransitionProps.duration;

    if (timeout === 'auto') {
      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
      node.style.transitionDuration = "".concat(duration2, "ms");
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
    }

    node.style.height = "".concat(wrapperHeight, "px");

    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(function (node, isAppearing) {
    node.style.height = 'auto';

    if (onEntered) {
      onEntered(node, isAppearing);
    }
  });
  var handleExit = normalizedTransitionCallback(function (node) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
    node.style.height = "".concat(wrapperHeight, "px");

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  var handleExiting = normalizedTransitionCallback(function (node) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;

    var _getTransitionProps2 = getTransitionProps({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    }),
        transitionDuration = _getTransitionProps2.duration;

    if (timeout === 'auto') {
      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
      node.style.transitionDuration = "".concat(duration2, "ms");
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
    }

    node.style.height = collapsedHeight;

    if (onExiting) {
      onExiting(node);
    }
  });

  var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
    var next = enableStrictModeCompat ? nodeOrNext : maybeNext;

    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTransitionDuration.current || 0);
    }
  };

  return /*#__PURE__*/React.createElement(TransitionComponent, _extends$1({
    in: inProp,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: addEndListener,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    timeout: timeout === 'auto' ? null : timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/React.createElement(Component, _extends$1({
      className: clsx(classes.container, className, {
        'entered': classes.entered,
        'exited': !inProp && collapsedHeight === '0px' && classes.hidden
      }[state]),
      style: _extends$1({
        minHeight: collapsedHeight
      }, style),
      ref: handleRef
    }, childProps), /*#__PURE__*/React.createElement("div", {
      className: classes.wrapper,
      ref: wrapperRef
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.wrapperInner
    }, children)));
  });
});
process.env.NODE_ENV !== "production" ? Collapse.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content node to be collapsed.
   */
  children: PropTypes__default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes__default.object,

  /**
   * @ignore
   */
  className: PropTypes__default.string,

  /**
   * The height of the container when collapsed.
   */
  collapsedHeight: PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.string]),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes__default
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Enable this prop if you encounter 'Function components cannot be given refs',
   * use `unstable_createStrictModeTheme`,
   * and can't forward the ref in the passed `Component`.
   */
  disableStrictModeCompat: PropTypes__default.bool,

  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes__default.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes__default.func,

  /**
   * @ignore
   */
  onEntered: PropTypes__default.func,

  /**
   * @ignore
   */
  onEntering: PropTypes__default.func,

  /**
   * @ignore
   */
  onExit: PropTypes__default.func,

  /**
   * @ignore
   */
  onExited: PropTypes__default.func,

  /**
   * @ignore
   */
  onExiting: PropTypes__default.func,

  /**
   * @ignore
   */
  style: PropTypes__default.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: PropTypes__default.oneOfType([PropTypes__default.oneOf(['auto']), PropTypes__default.number, PropTypes__default.shape({
    appear: PropTypes__default.number,
    enter: PropTypes__default.number,
    exit: PropTypes__default.number
  })])
} : void 0;
Collapse.muiSupportAuto = true;
var Collapse$1 = withStyles$1(styles$2, {
  name: 'MuiCollapse'
})(Collapse);

function _templateObject2$q() {
  var data = _taggedTemplateLiteral(["\n  min-height: 30px;\n"]);

  _templateObject2$q = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$L() {
  var data = _taggedTemplateLiteral(["\n  color: white;\n  margin-bottom: 0;\n"]);

  _templateObject$L = function _templateObject() {
    return data;
  };

  return data;
}
var CenteredMessage = newStyled.p(_templateObject$L());
var Container$5 = newStyled.div(_templateObject2$q());

var getMostRelevantFSDispatch = function getMostRelevantFSDispatch(fsDispatchList) {
  if (!fsDispatchList) return null;

  for (var i = 0; i < fsDispatchList.length; i += 1) {
    var _dispatchItem$reason, _dispatchItem$reason2, _dispatchItem$reason3;

    var dispatchItem = fsDispatchList[i];

    if ((dispatchItem === null || dispatchItem === void 0 ? void 0 : (_dispatchItem$reason = dispatchItem.reason) === null || _dispatchItem$reason === void 0 ? void 0 : _dispatchItem$reason.toLowerCase()) === 'system failure') {
      return {
        type: 'error',
        status: 'System Error',
        helpText: 'We’re aware of the issue, and help is on the way. Sunrun will contact you directly w/updates. Thanks for your patience.'
      };
    }

    if ((dispatchItem === null || dispatchItem === void 0 ? void 0 : (_dispatchItem$reason2 = dispatchItem.reason) === null || _dispatchItem$reason2 === void 0 ? void 0 : _dispatchItem$reason2.toLowerCase()) === 'metering') {
      return {
        type: 'warning',
        status: 'Connection Lost',
        helpText: 'We’re having trouble collecting data from your system. As soon as the connection is restored, we’ll refresh your solar history.'
      };
    }

    if ((dispatchItem === null || dispatchItem === void 0 ? void 0 : (_dispatchItem$reason3 = dispatchItem.reason) === null || _dispatchItem$reason3 === void 0 ? void 0 : _dispatchItem$reason3.toLowerCase()) === 'system under-performance') {
      return {
        type: 'error',
        status: 'Known System Issue',
        helpText: 'We’re aware of the issue, and help is on the way. Sunrun will contact you directly w/updates. Thanks for your patience.'
      };
    }
  }

  return null;
};

var SystemStatus = function SystemStatus(_ref) {
  var fsDispatchList = _ref.fsDispatchList,
      hideIfUnhealthy = _ref.hideIfUnhealthy,
      loading = _ref.loading,
      onClick = _ref.onClick,
      visible = _ref.visible,
      rest = _objectWithoutProperties(_ref, ["fsDispatchList", "hideIfUnhealthy", "loading", "onClick", "visible"]);

  var relevantFSDispatchStatus = getMostRelevantFSDispatch(fsDispatchList);
  var isVisible = !(hideIfUnhealthy && !loading && relevantFSDispatchStatus); // if visible is set to false, it takes priority

  if (!visible) {
    isVisible = false;
  }

  return /*#__PURE__*/React__default.createElement(Collapse$1, {
    "in": isVisible
  }, /*#__PURE__*/React__default.createElement(Container$5, _extends({
    onClick: onClick
  }, rest), loading && /*#__PURE__*/React__default.createElement(Badge, {
    type: "loading",
    copy: "Loading..."
  }, /*#__PURE__*/React__default.createElement(CenteredMessage, null, "System status is loading")), !loading && relevantFSDispatchStatus && /*#__PURE__*/React__default.createElement(Badge, {
    type: relevantFSDispatchStatus.type,
    copy: relevantFSDispatchStatus.status
  }, /*#__PURE__*/React__default.createElement(CenteredMessage, null, relevantFSDispatchStatus.helpText)), !loading && !relevantFSDispatchStatus && /*#__PURE__*/React__default.createElement(Badge, {
    type: "success",
    copy: "NO KNOWN ISSUES"
  })));
};

SystemStatus.propTypes = {
  fsDispatchList: PropTypes__default.arrayOf(PropTypes__default.shape({
    reason: PropTypes__default.string
  })).isRequired,
  hideIfUnhealthy: PropTypes__default.bool,
  loading: PropTypes__default.bool.isRequired,
  onClick: PropTypes__default.func,
  visible: PropTypes__default.bool
};
SystemStatus.defaultProps = {
  hideIfUnhealthy: false,
  visible: true
};

exports.AddressSelector = AddressSelector;
exports.Alert = Alert;
exports.Badge = Badge;
exports.Banner = Banner$1;
exports.BottomNavbar = index$3;
exports.Button = Button;
exports.Card = Card;
exports.Checkbox = Checkbox;
exports.CircleGrid = CircleGrid;
exports.DatePicker = DatePickerContainer;
exports.HorizontalScrollingGroup = HorizontalScrollingGroup;
exports.Input = Input;
exports.InputGroup = InputGroup;
exports.InputMasked = InputMasked;
exports.KeyboardDatePicker = KeyboardDatePickerContainer;
exports.Label = Label;
exports.Link = Link;
exports.LinkUtility = LinkUtility;
exports.LinkUtilityFunctions = LinkUtility$1;
exports.List = List;
exports.ListItem = ListItem;
exports.Modal = index$1;
exports.RadioButton = RadioButton;
exports.Rating = RatingComponent;
exports.SectionNavbar = index$5;
exports.SelectDropdown = SelectDropdown;
exports.SelectInput = SelectInput;
exports.SideNavbar = index$2;
exports.Spinner = Spinner;
exports.SunSpinner = SunSpinner;
exports.SystemStatus = SystemStatus;
exports.Textarea = Textarea;
exports.Tile = Tile;
exports.Tiles = Tiles;
exports.Toggle = Toggle;
exports.Tooltip = Tooltip;
exports.TopNavbar = index$4;
